// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../asset/font/PremierLeagueW01-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../asset/font/PremierLeagueW01-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../asset/font/PremierLeagueW01-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../asset/font/PremierLeagueW01-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../asset/font/PremierLeagueW01-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../asset/font/PremierLeagueW01-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../asset/font/PremierLeagueW01-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../asset/font/PremierLeagueW01-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../asset/font/PremierLeagueW01-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../asset/font/PremierLeagueW01-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../asset/font/PremierLeagueW01-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../asset/font/PremierLeagueW01-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../asset/font/PremierLeagueW01-Condensed.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../asset/font/PremierLeagueW01-Condensed.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../asset/font/PremierLeagueW01-Condensed.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../asset/font/PremierLeagueW01-Condensed.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../asset/font/PremierLeagueW01-CondBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../asset/font/PremierLeagueW01-CondBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../asset/font/PremierLeagueW01-CondBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../asset/font/PremierLeagueW01-CondBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../asset/font/PremierLeagueW01-Italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../asset/font/PremierLeagueW01-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../asset/font/PremierLeagueW01-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../asset/font/PremierLeagueW01-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../asset/font/PremierLeagueW01-LightIt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../asset/font/PremierLeagueW01-LightIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../asset/font/PremierLeagueW01-LightIt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../asset/font/PremierLeagueW01-LightIt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../asset/font/PremierLeagueW01-Heavy.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../asset/font/PremierLeagueW01-Heavy.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../asset/font/PremierLeagueW01-Heavy.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../asset/font/PremierLeagueW01-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%280, 0, 0, 0%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../asset/img/login_bg@2x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../asset/img/login-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "PremierLeague-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Condensed";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-CondBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-LightIt";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Heavy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-HeavyIt";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("truetype");
}
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}

.fas,
.far,
.fab,
.fa-solid,
.fa-regular,
.fa-brands,
.fa {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fas::before,
.far::before,
.fab::before,
.fa-solid::before,
.fa-regular::before,
.fa-brands::before,
.fa::before {
  content: var(--fa);
}

.fa-classic,
.fas,
.fa-solid,
.far,
.fa-regular {
  font-family: "Font Awesome 6 Free";
}

.fa-brands,
.fab {
  font-family: "Font Awesome 6 Brands";
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0 {
  --fa: "\\30 ";
}

.fa-1 {
  --fa: "\\31 ";
}

.fa-2 {
  --fa: "\\32 ";
}

.fa-3 {
  --fa: "\\33 ";
}

.fa-4 {
  --fa: "\\34 ";
}

.fa-5 {
  --fa: "\\35 ";
}

.fa-6 {
  --fa: "\\36 ";
}

.fa-7 {
  --fa: "\\37 ";
}

.fa-8 {
  --fa: "\\38 ";
}

.fa-9 {
  --fa: "\\39 ";
}

.fa-fill-drip {
  --fa: "\\f576";
}

.fa-arrows-to-circle {
  --fa: "\\e4bd";
}

.fa-circle-chevron-right {
  --fa: "\\f138";
}

.fa-chevron-circle-right {
  --fa: "\\f138";
}

.fa-at {
  --fa: "\\@";
}

.fa-trash-can {
  --fa: "\\f2ed";
}

.fa-trash-alt {
  --fa: "\\f2ed";
}

.fa-text-height {
  --fa: "\\f034";
}

.fa-user-xmark {
  --fa: "\\f235";
}

.fa-user-times {
  --fa: "\\f235";
}

.fa-stethoscope {
  --fa: "\\f0f1";
}

.fa-message {
  --fa: "\\f27a";
}

.fa-comment-alt {
  --fa: "\\f27a";
}

.fa-info {
  --fa: "\\f129";
}

.fa-down-left-and-up-right-to-center {
  --fa: "\\f422";
}

.fa-compress-alt {
  --fa: "\\f422";
}

.fa-explosion {
  --fa: "\\e4e9";
}

.fa-file-lines {
  --fa: "\\f15c";
}

.fa-file-alt {
  --fa: "\\f15c";
}

.fa-file-text {
  --fa: "\\f15c";
}

.fa-wave-square {
  --fa: "\\f83e";
}

.fa-ring {
  --fa: "\\f70b";
}

.fa-building-un {
  --fa: "\\e4d9";
}

.fa-dice-three {
  --fa: "\\f527";
}

.fa-calendar-days {
  --fa: "\\f073";
}

.fa-calendar-alt {
  --fa: "\\f073";
}

.fa-anchor-circle-check {
  --fa: "\\e4aa";
}

.fa-building-circle-arrow-right {
  --fa: "\\e4d1";
}

.fa-volleyball {
  --fa: "\\f45f";
}

.fa-volleyball-ball {
  --fa: "\\f45f";
}

.fa-arrows-up-to-line {
  --fa: "\\e4c2";
}

.fa-sort-down {
  --fa: "\\f0dd";
}

.fa-sort-desc {
  --fa: "\\f0dd";
}

.fa-circle-minus {
  --fa: "\\f056";
}

.fa-minus-circle {
  --fa: "\\f056";
}

.fa-door-open {
  --fa: "\\f52b";
}

.fa-right-from-bracket {
  --fa: "\\f2f5";
}

.fa-sign-out-alt {
  --fa: "\\f2f5";
}

.fa-atom {
  --fa: "\\f5d2";
}

.fa-soap {
  --fa: "\\e06e";
}

.fa-icons {
  --fa: "\\f86d";
}

.fa-heart-music-camera-bolt {
  --fa: "\\f86d";
}

.fa-microphone-lines-slash {
  --fa: "\\f539";
}

.fa-microphone-alt-slash {
  --fa: "\\f539";
}

.fa-bridge-circle-check {
  --fa: "\\e4c9";
}

.fa-pump-medical {
  --fa: "\\e06a";
}

.fa-fingerprint {
  --fa: "\\f577";
}

.fa-hand-point-right {
  --fa: "\\f0a4";
}

.fa-magnifying-glass-location {
  --fa: "\\f689";
}

.fa-search-location {
  --fa: "\\f689";
}

.fa-forward-step {
  --fa: "\\f051";
}

.fa-step-forward {
  --fa: "\\f051";
}

.fa-face-smile-beam {
  --fa: "\\f5b8";
}

.fa-smile-beam {
  --fa: "\\f5b8";
}

.fa-flag-checkered {
  --fa: "\\f11e";
}

.fa-football {
  --fa: "\\f44e";
}

.fa-football-ball {
  --fa: "\\f44e";
}

.fa-school-circle-exclamation {
  --fa: "\\e56c";
}

.fa-crop {
  --fa: "\\f125";
}

.fa-angles-down {
  --fa: "\\f103";
}

.fa-angle-double-down {
  --fa: "\\f103";
}

.fa-users-rectangle {
  --fa: "\\e594";
}

.fa-people-roof {
  --fa: "\\e537";
}

.fa-people-line {
  --fa: "\\e534";
}

.fa-beer-mug-empty {
  --fa: "\\f0fc";
}

.fa-beer {
  --fa: "\\f0fc";
}

.fa-diagram-predecessor {
  --fa: "\\e477";
}

.fa-arrow-up-long {
  --fa: "\\f176";
}

.fa-long-arrow-up {
  --fa: "\\f176";
}

.fa-fire-flame-simple {
  --fa: "\\f46a";
}

.fa-burn {
  --fa: "\\f46a";
}

.fa-person {
  --fa: "\\f183";
}

.fa-male {
  --fa: "\\f183";
}

.fa-laptop {
  --fa: "\\f109";
}

.fa-file-csv {
  --fa: "\\f6dd";
}

.fa-menorah {
  --fa: "\\f676";
}

.fa-truck-plane {
  --fa: "\\e58f";
}

.fa-record-vinyl {
  --fa: "\\f8d9";
}

.fa-face-grin-stars {
  --fa: "\\f587";
}

.fa-grin-stars {
  --fa: "\\f587";
}

.fa-bong {
  --fa: "\\f55c";
}

.fa-spaghetti-monster-flying {
  --fa: "\\f67b";
}

.fa-pastafarianism {
  --fa: "\\f67b";
}

.fa-arrow-down-up-across-line {
  --fa: "\\e4af";
}

.fa-spoon {
  --fa: "\\f2e5";
}

.fa-utensil-spoon {
  --fa: "\\f2e5";
}

.fa-jar-wheat {
  --fa: "\\e517";
}

.fa-envelopes-bulk {
  --fa: "\\f674";
}

.fa-mail-bulk {
  --fa: "\\f674";
}

.fa-file-circle-exclamation {
  --fa: "\\e4eb";
}

.fa-circle-h {
  --fa: "\\f47e";
}

.fa-hospital-symbol {
  --fa: "\\f47e";
}

.fa-pager {
  --fa: "\\f815";
}

.fa-address-book {
  --fa: "\\f2b9";
}

.fa-contact-book {
  --fa: "\\f2b9";
}

.fa-strikethrough {
  --fa: "\\f0cc";
}

.fa-k {
  --fa: "K";
}

.fa-landmark-flag {
  --fa: "\\e51c";
}

.fa-pencil {
  --fa: "\\f303";
}

.fa-pencil-alt {
  --fa: "\\f303";
}

.fa-backward {
  --fa: "\\f04a";
}

.fa-caret-right {
  --fa: "\\f0da";
}

.fa-comments {
  --fa: "\\f086";
}

.fa-paste {
  --fa: "\\f0ea";
}

.fa-file-clipboard {
  --fa: "\\f0ea";
}

.fa-code-pull-request {
  --fa: "\\e13c";
}

.fa-clipboard-list {
  --fa: "\\f46d";
}

.fa-truck-ramp-box {
  --fa: "\\f4de";
}

.fa-truck-loading {
  --fa: "\\f4de";
}

.fa-user-check {
  --fa: "\\f4fc";
}

.fa-vial-virus {
  --fa: "\\e597";
}

.fa-sheet-plastic {
  --fa: "\\e571";
}

.fa-blog {
  --fa: "\\f781";
}

.fa-user-ninja {
  --fa: "\\f504";
}

.fa-person-arrow-up-from-line {
  --fa: "\\e539";
}

.fa-scroll-torah {
  --fa: "\\f6a0";
}

.fa-torah {
  --fa: "\\f6a0";
}

.fa-broom-ball {
  --fa: "\\f458";
}

.fa-quidditch {
  --fa: "\\f458";
}

.fa-quidditch-broom-ball {
  --fa: "\\f458";
}

.fa-toggle-off {
  --fa: "\\f204";
}

.fa-box-archive {
  --fa: "\\f187";
}

.fa-archive {
  --fa: "\\f187";
}

.fa-person-drowning {
  --fa: "\\e545";
}

.fa-arrow-down-9-1 {
  --fa: "\\f886";
}

.fa-sort-numeric-desc {
  --fa: "\\f886";
}

.fa-sort-numeric-down-alt {
  --fa: "\\f886";
}

.fa-face-grin-tongue-squint {
  --fa: "\\f58a";
}

.fa-grin-tongue-squint {
  --fa: "\\f58a";
}

.fa-spray-can {
  --fa: "\\f5bd";
}

.fa-truck-monster {
  --fa: "\\f63b";
}

.fa-w {
  --fa: "W";
}

.fa-earth-africa {
  --fa: "\\f57c";
}

.fa-globe-africa {
  --fa: "\\f57c";
}

.fa-rainbow {
  --fa: "\\f75b";
}

.fa-circle-notch {
  --fa: "\\f1ce";
}

.fa-tablet-screen-button {
  --fa: "\\f3fa";
}

.fa-tablet-alt {
  --fa: "\\f3fa";
}

.fa-paw {
  --fa: "\\f1b0";
}

.fa-cloud {
  --fa: "\\f0c2";
}

.fa-trowel-bricks {
  --fa: "\\e58a";
}

.fa-face-flushed {
  --fa: "\\f579";
}

.fa-flushed {
  --fa: "\\f579";
}

.fa-hospital-user {
  --fa: "\\f80d";
}

.fa-tent-arrow-left-right {
  --fa: "\\e57f";
}

.fa-gavel {
  --fa: "\\f0e3";
}

.fa-legal {
  --fa: "\\f0e3";
}

.fa-binoculars {
  --fa: "\\f1e5";
}

.fa-microphone-slash {
  --fa: "\\f131";
}

.fa-box-tissue {
  --fa: "\\e05b";
}

.fa-motorcycle {
  --fa: "\\f21c";
}

.fa-bell-concierge {
  --fa: "\\f562";
}

.fa-concierge-bell {
  --fa: "\\f562";
}

.fa-pen-ruler {
  --fa: "\\f5ae";
}

.fa-pencil-ruler {
  --fa: "\\f5ae";
}

.fa-people-arrows {
  --fa: "\\e068";
}

.fa-people-arrows-left-right {
  --fa: "\\e068";
}

.fa-mars-and-venus-burst {
  --fa: "\\e523";
}

.fa-square-caret-right {
  --fa: "\\f152";
}

.fa-caret-square-right {
  --fa: "\\f152";
}

.fa-scissors {
  --fa: "\\f0c4";
}

.fa-cut {
  --fa: "\\f0c4";
}

.fa-sun-plant-wilt {
  --fa: "\\e57a";
}

.fa-toilets-portable {
  --fa: "\\e584";
}

.fa-hockey-puck {
  --fa: "\\f453";
}

.fa-table {
  --fa: "\\f0ce";
}

.fa-magnifying-glass-arrow-right {
  --fa: "\\e521";
}

.fa-tachograph-digital {
  --fa: "\\f566";
}

.fa-digital-tachograph {
  --fa: "\\f566";
}

.fa-users-slash {
  --fa: "\\e073";
}

.fa-clover {
  --fa: "\\e139";
}

.fa-reply {
  --fa: "\\f3e5";
}

.fa-mail-reply {
  --fa: "\\f3e5";
}

.fa-star-and-crescent {
  --fa: "\\f699";
}

.fa-house-fire {
  --fa: "\\e50c";
}

.fa-square-minus {
  --fa: "\\f146";
}

.fa-minus-square {
  --fa: "\\f146";
}

.fa-helicopter {
  --fa: "\\f533";
}

.fa-compass {
  --fa: "\\f14e";
}

.fa-square-caret-down {
  --fa: "\\f150";
}

.fa-caret-square-down {
  --fa: "\\f150";
}

.fa-file-circle-question {
  --fa: "\\e4ef";
}

.fa-laptop-code {
  --fa: "\\f5fc";
}

.fa-swatchbook {
  --fa: "\\f5c3";
}

.fa-prescription-bottle {
  --fa: "\\f485";
}

.fa-bars {
  --fa: "\\f0c9";
}

.fa-navicon {
  --fa: "\\f0c9";
}

.fa-people-group {
  --fa: "\\e533";
}

.fa-hourglass-end {
  --fa: "\\f253";
}

.fa-hourglass-3 {
  --fa: "\\f253";
}

.fa-heart-crack {
  --fa: "\\f7a9";
}

.fa-heart-broken {
  --fa: "\\f7a9";
}

.fa-square-up-right {
  --fa: "\\f360";
}

.fa-external-link-square-alt {
  --fa: "\\f360";
}

.fa-face-kiss-beam {
  --fa: "\\f597";
}

.fa-kiss-beam {
  --fa: "\\f597";
}

.fa-film {
  --fa: "\\f008";
}

.fa-ruler-horizontal {
  --fa: "\\f547";
}

.fa-people-robbery {
  --fa: "\\e536";
}

.fa-lightbulb {
  --fa: "\\f0eb";
}

.fa-caret-left {
  --fa: "\\f0d9";
}

.fa-circle-exclamation {
  --fa: "\\f06a";
}

.fa-exclamation-circle {
  --fa: "\\f06a";
}

.fa-school-circle-xmark {
  --fa: "\\e56d";
}

.fa-arrow-right-from-bracket {
  --fa: "\\f08b";
}

.fa-sign-out {
  --fa: "\\f08b";
}

.fa-circle-chevron-down {
  --fa: "\\f13a";
}

.fa-chevron-circle-down {
  --fa: "\\f13a";
}

.fa-unlock-keyhole {
  --fa: "\\f13e";
}

.fa-unlock-alt {
  --fa: "\\f13e";
}

.fa-cloud-showers-heavy {
  --fa: "\\f740";
}

.fa-headphones-simple {
  --fa: "\\f58f";
}

.fa-headphones-alt {
  --fa: "\\f58f";
}

.fa-sitemap {
  --fa: "\\f0e8";
}

.fa-circle-dollar-to-slot {
  --fa: "\\f4b9";
}

.fa-donate {
  --fa: "\\f4b9";
}

.fa-memory {
  --fa: "\\f538";
}

.fa-road-spikes {
  --fa: "\\e568";
}

.fa-fire-burner {
  --fa: "\\e4f1";
}

.fa-flag {
  --fa: "\\f024";
}

.fa-hanukiah {
  --fa: "\\f6e6";
}

.fa-feather {
  --fa: "\\f52d";
}

.fa-volume-low {
  --fa: "\\f027";
}

.fa-volume-down {
  --fa: "\\f027";
}

.fa-comment-slash {
  --fa: "\\f4b3";
}

.fa-cloud-sun-rain {
  --fa: "\\f743";
}

.fa-compress {
  --fa: "\\f066";
}

.fa-wheat-awn {
  --fa: "\\e2cd";
}

.fa-wheat-alt {
  --fa: "\\e2cd";
}

.fa-ankh {
  --fa: "\\f644";
}

.fa-hands-holding-child {
  --fa: "\\e4fa";
}

.fa-asterisk {
  --fa: "\\*";
}

.fa-square-check {
  --fa: "\\f14a";
}

.fa-check-square {
  --fa: "\\f14a";
}

.fa-peseta-sign {
  --fa: "\\e221";
}

.fa-heading {
  --fa: "\\f1dc";
}

.fa-header {
  --fa: "\\f1dc";
}

.fa-ghost {
  --fa: "\\f6e2";
}

.fa-list {
  --fa: "\\f03a";
}

.fa-list-squares {
  --fa: "\\f03a";
}

.fa-square-phone-flip {
  --fa: "\\f87b";
}

.fa-phone-square-alt {
  --fa: "\\f87b";
}

.fa-cart-plus {
  --fa: "\\f217";
}

.fa-gamepad {
  --fa: "\\f11b";
}

.fa-circle-dot {
  --fa: "\\f192";
}

.fa-dot-circle {
  --fa: "\\f192";
}

.fa-face-dizzy {
  --fa: "\\f567";
}

.fa-dizzy {
  --fa: "\\f567";
}

.fa-egg {
  --fa: "\\f7fb";
}

.fa-house-medical-circle-xmark {
  --fa: "\\e513";
}

.fa-campground {
  --fa: "\\f6bb";
}

.fa-folder-plus {
  --fa: "\\f65e";
}

.fa-futbol {
  --fa: "\\f1e3";
}

.fa-futbol-ball {
  --fa: "\\f1e3";
}

.fa-soccer-ball {
  --fa: "\\f1e3";
}

.fa-paintbrush {
  --fa: "\\f1fc";
}

.fa-paint-brush {
  --fa: "\\f1fc";
}

.fa-lock {
  --fa: "\\f023";
}

.fa-gas-pump {
  --fa: "\\f52f";
}

.fa-hot-tub-person {
  --fa: "\\f593";
}

.fa-hot-tub {
  --fa: "\\f593";
}

.fa-map-location {
  --fa: "\\f59f";
}

.fa-map-marked {
  --fa: "\\f59f";
}

.fa-house-flood-water {
  --fa: "\\e50e";
}

.fa-tree {
  --fa: "\\f1bb";
}

.fa-bridge-lock {
  --fa: "\\e4cc";
}

.fa-sack-dollar {
  --fa: "\\f81d";
}

.fa-pen-to-square {
  --fa: "\\f044";
}

.fa-edit {
  --fa: "\\f044";
}

.fa-car-side {
  --fa: "\\f5e4";
}

.fa-share-nodes {
  --fa: "\\f1e0";
}

.fa-share-alt {
  --fa: "\\f1e0";
}

.fa-heart-circle-minus {
  --fa: "\\e4ff";
}

.fa-hourglass-half {
  --fa: "\\f252";
}

.fa-hourglass-2 {
  --fa: "\\f252";
}

.fa-microscope {
  --fa: "\\f610";
}

.fa-sink {
  --fa: "\\e06d";
}

.fa-bag-shopping {
  --fa: "\\f290";
}

.fa-shopping-bag {
  --fa: "\\f290";
}

.fa-arrow-down-z-a {
  --fa: "\\f881";
}

.fa-sort-alpha-desc {
  --fa: "\\f881";
}

.fa-sort-alpha-down-alt {
  --fa: "\\f881";
}

.fa-mitten {
  --fa: "\\f7b5";
}

.fa-person-rays {
  --fa: "\\e54d";
}

.fa-users {
  --fa: "\\f0c0";
}

.fa-eye-slash {
  --fa: "\\f070";
}

.fa-flask-vial {
  --fa: "\\e4f3";
}

.fa-hand {
  --fa: "\\f256";
}

.fa-hand-paper {
  --fa: "\\f256";
}

.fa-om {
  --fa: "\\f679";
}

.fa-worm {
  --fa: "\\e599";
}

.fa-house-circle-xmark {
  --fa: "\\e50b";
}

.fa-plug {
  --fa: "\\f1e6";
}

.fa-chevron-up {
  --fa: "\\f077";
}

.fa-hand-spock {
  --fa: "\\f259";
}

.fa-stopwatch {
  --fa: "\\f2f2";
}

.fa-face-kiss {
  --fa: "\\f596";
}

.fa-kiss {
  --fa: "\\f596";
}

.fa-bridge-circle-xmark {
  --fa: "\\e4cb";
}

.fa-face-grin-tongue {
  --fa: "\\f589";
}

.fa-grin-tongue {
  --fa: "\\f589";
}

.fa-chess-bishop {
  --fa: "\\f43a";
}

.fa-face-grin-wink {
  --fa: "\\f58c";
}

.fa-grin-wink {
  --fa: "\\f58c";
}

.fa-ear-deaf {
  --fa: "\\f2a4";
}

.fa-deaf {
  --fa: "\\f2a4";
}

.fa-deafness {
  --fa: "\\f2a4";
}

.fa-hard-of-hearing {
  --fa: "\\f2a4";
}

.fa-road-circle-check {
  --fa: "\\e564";
}

.fa-dice-five {
  --fa: "\\f523";
}

.fa-square-rss {
  --fa: "\\f143";
}

.fa-rss-square {
  --fa: "\\f143";
}

.fa-land-mine-on {
  --fa: "\\e51b";
}

.fa-i-cursor {
  --fa: "\\f246";
}

.fa-stamp {
  --fa: "\\f5bf";
}

.fa-stairs {
  --fa: "\\e289";
}

.fa-i {
  --fa: "I";
}

.fa-hryvnia-sign {
  --fa: "\\f6f2";
}

.fa-hryvnia {
  --fa: "\\f6f2";
}

.fa-pills {
  --fa: "\\f484";
}

.fa-face-grin-wide {
  --fa: "\\f581";
}

.fa-grin-alt {
  --fa: "\\f581";
}

.fa-tooth {
  --fa: "\\f5c9";
}

.fa-v {
  --fa: "V";
}

.fa-bangladeshi-taka-sign {
  --fa: "\\e2e6";
}

.fa-bicycle {
  --fa: "\\f206";
}

.fa-staff-snake {
  --fa: "\\e579";
}

.fa-rod-asclepius {
  --fa: "\\e579";
}

.fa-rod-snake {
  --fa: "\\e579";
}

.fa-staff-aesculapius {
  --fa: "\\e579";
}

.fa-head-side-cough-slash {
  --fa: "\\e062";
}

.fa-truck-medical {
  --fa: "\\f0f9";
}

.fa-ambulance {
  --fa: "\\f0f9";
}

.fa-wheat-awn-circle-exclamation {
  --fa: "\\e598";
}

.fa-snowman {
  --fa: "\\f7d0";
}

.fa-mortar-pestle {
  --fa: "\\f5a7";
}

.fa-road-barrier {
  --fa: "\\e562";
}

.fa-school {
  --fa: "\\f549";
}

.fa-igloo {
  --fa: "\\f7ae";
}

.fa-joint {
  --fa: "\\f595";
}

.fa-angle-right {
  --fa: "\\f105";
}

.fa-horse {
  --fa: "\\f6f0";
}

.fa-q {
  --fa: "Q";
}

.fa-g {
  --fa: "G";
}

.fa-notes-medical {
  --fa: "\\f481";
}

.fa-temperature-half {
  --fa: "\\f2c9";
}

.fa-temperature-2 {
  --fa: "\\f2c9";
}

.fa-thermometer-2 {
  --fa: "\\f2c9";
}

.fa-thermometer-half {
  --fa: "\\f2c9";
}

.fa-dong-sign {
  --fa: "\\e169";
}

.fa-capsules {
  --fa: "\\f46b";
}

.fa-poo-storm {
  --fa: "\\f75a";
}

.fa-poo-bolt {
  --fa: "\\f75a";
}

.fa-face-frown-open {
  --fa: "\\f57a";
}

.fa-frown-open {
  --fa: "\\f57a";
}

.fa-hand-point-up {
  --fa: "\\f0a6";
}

.fa-money-bill {
  --fa: "\\f0d6";
}

.fa-bookmark {
  --fa: "\\f02e";
}

.fa-align-justify {
  --fa: "\\f039";
}

.fa-umbrella-beach {
  --fa: "\\f5ca";
}

.fa-helmet-un {
  --fa: "\\e503";
}

.fa-bullseye {
  --fa: "\\f140";
}

.fa-bacon {
  --fa: "\\f7e5";
}

.fa-hand-point-down {
  --fa: "\\f0a7";
}

.fa-arrow-up-from-bracket {
  --fa: "\\e09a";
}

.fa-folder {
  --fa: "\\f07b";
}

.fa-folder-blank {
  --fa: "\\f07b";
}

.fa-file-waveform {
  --fa: "\\f478";
}

.fa-file-medical-alt {
  --fa: "\\f478";
}

.fa-radiation {
  --fa: "\\f7b9";
}

.fa-chart-simple {
  --fa: "\\e473";
}

.fa-mars-stroke {
  --fa: "\\f229";
}

.fa-vial {
  --fa: "\\f492";
}

.fa-gauge {
  --fa: "\\f624";
}

.fa-dashboard {
  --fa: "\\f624";
}

.fa-gauge-med {
  --fa: "\\f624";
}

.fa-tachometer-alt-average {
  --fa: "\\f624";
}

.fa-wand-magic-sparkles {
  --fa: "\\e2ca";
}

.fa-magic-wand-sparkles {
  --fa: "\\e2ca";
}

.fa-e {
  --fa: "E";
}

.fa-pen-clip {
  --fa: "\\f305";
}

.fa-pen-alt {
  --fa: "\\f305";
}

.fa-bridge-circle-exclamation {
  --fa: "\\e4ca";
}

.fa-user {
  --fa: "\\f007";
}

.fa-school-circle-check {
  --fa: "\\e56b";
}

.fa-dumpster {
  --fa: "\\f793";
}

.fa-van-shuttle {
  --fa: "\\f5b6";
}

.fa-shuttle-van {
  --fa: "\\f5b6";
}

.fa-building-user {
  --fa: "\\e4da";
}

.fa-square-caret-left {
  --fa: "\\f191";
}

.fa-caret-square-left {
  --fa: "\\f191";
}

.fa-highlighter {
  --fa: "\\f591";
}

.fa-key {
  --fa: "\\f084";
}

.fa-bullhorn {
  --fa: "\\f0a1";
}

.fa-globe {
  --fa: "\\f0ac";
}

.fa-synagogue {
  --fa: "\\f69b";
}

.fa-person-half-dress {
  --fa: "\\e548";
}

.fa-road-bridge {
  --fa: "\\e563";
}

.fa-location-arrow {
  --fa: "\\f124";
}

.fa-c {
  --fa: "C";
}

.fa-tablet-button {
  --fa: "\\f10a";
}

.fa-building-lock {
  --fa: "\\e4d6";
}

.fa-pizza-slice {
  --fa: "\\f818";
}

.fa-money-bill-wave {
  --fa: "\\f53a";
}

.fa-chart-area {
  --fa: "\\f1fe";
}

.fa-area-chart {
  --fa: "\\f1fe";
}

.fa-house-flag {
  --fa: "\\e50d";
}

.fa-person-circle-minus {
  --fa: "\\e540";
}

.fa-ban {
  --fa: "\\f05e";
}

.fa-cancel {
  --fa: "\\f05e";
}

.fa-camera-rotate {
  --fa: "\\e0d8";
}

.fa-spray-can-sparkles {
  --fa: "\\f5d0";
}

.fa-air-freshener {
  --fa: "\\f5d0";
}

.fa-star {
  --fa: "\\f005";
}

.fa-repeat {
  --fa: "\\f363";
}

.fa-cross {
  --fa: "\\f654";
}

.fa-box {
  --fa: "\\f466";
}

.fa-venus-mars {
  --fa: "\\f228";
}

.fa-arrow-pointer {
  --fa: "\\f245";
}

.fa-mouse-pointer {
  --fa: "\\f245";
}

.fa-maximize {
  --fa: "\\f31e";
}

.fa-expand-arrows-alt {
  --fa: "\\f31e";
}

.fa-charging-station {
  --fa: "\\f5e7";
}

.fa-shapes {
  --fa: "\\f61f";
}

.fa-triangle-circle-square {
  --fa: "\\f61f";
}

.fa-shuffle {
  --fa: "\\f074";
}

.fa-random {
  --fa: "\\f074";
}

.fa-person-running {
  --fa: "\\f70c";
}

.fa-running {
  --fa: "\\f70c";
}

.fa-mobile-retro {
  --fa: "\\e527";
}

.fa-grip-lines-vertical {
  --fa: "\\f7a5";
}

.fa-spider {
  --fa: "\\f717";
}

.fa-hands-bound {
  --fa: "\\e4f9";
}

.fa-file-invoice-dollar {
  --fa: "\\f571";
}

.fa-plane-circle-exclamation {
  --fa: "\\e556";
}

.fa-x-ray {
  --fa: "\\f497";
}

.fa-spell-check {
  --fa: "\\f891";
}

.fa-slash {
  --fa: "\\f715";
}

.fa-computer-mouse {
  --fa: "\\f8cc";
}

.fa-mouse {
  --fa: "\\f8cc";
}

.fa-arrow-right-to-bracket {
  --fa: "\\f090";
}

.fa-sign-in {
  --fa: "\\f090";
}

.fa-shop-slash {
  --fa: "\\e070";
}

.fa-store-alt-slash {
  --fa: "\\e070";
}

.fa-server {
  --fa: "\\f233";
}

.fa-virus-covid-slash {
  --fa: "\\e4a9";
}

.fa-shop-lock {
  --fa: "\\e4a5";
}

.fa-hourglass-start {
  --fa: "\\f251";
}

.fa-hourglass-1 {
  --fa: "\\f251";
}

.fa-blender-phone {
  --fa: "\\f6b6";
}

.fa-building-wheat {
  --fa: "\\e4db";
}

.fa-person-breastfeeding {
  --fa: "\\e53a";
}

.fa-right-to-bracket {
  --fa: "\\f2f6";
}

.fa-sign-in-alt {
  --fa: "\\f2f6";
}

.fa-venus {
  --fa: "\\f221";
}

.fa-passport {
  --fa: "\\f5ab";
}

.fa-thumbtack-slash {
  --fa: "\\e68f";
}

.fa-thumb-tack-slash {
  --fa: "\\e68f";
}

.fa-heart-pulse {
  --fa: "\\f21e";
}

.fa-heartbeat {
  --fa: "\\f21e";
}

.fa-people-carry-box {
  --fa: "\\f4ce";
}

.fa-people-carry {
  --fa: "\\f4ce";
}

.fa-temperature-high {
  --fa: "\\f769";
}

.fa-microchip {
  --fa: "\\f2db";
}

.fa-crown {
  --fa: "\\f521";
}

.fa-weight-hanging {
  --fa: "\\f5cd";
}

.fa-xmarks-lines {
  --fa: "\\e59a";
}

.fa-file-prescription {
  --fa: "\\f572";
}

.fa-weight-scale {
  --fa: "\\f496";
}

.fa-weight {
  --fa: "\\f496";
}

.fa-user-group {
  --fa: "\\f500";
}

.fa-user-friends {
  --fa: "\\f500";
}

.fa-arrow-up-a-z {
  --fa: "\\f15e";
}

.fa-sort-alpha-up {
  --fa: "\\f15e";
}

.fa-chess-knight {
  --fa: "\\f441";
}

.fa-face-laugh-squint {
  --fa: "\\f59b";
}

.fa-laugh-squint {
  --fa: "\\f59b";
}

.fa-wheelchair {
  --fa: "\\f193";
}

.fa-circle-arrow-up {
  --fa: "\\f0aa";
}

.fa-arrow-circle-up {
  --fa: "\\f0aa";
}

.fa-toggle-on {
  --fa: "\\f205";
}

.fa-person-walking {
  --fa: "\\f554";
}

.fa-walking {
  --fa: "\\f554";
}

.fa-l {
  --fa: "L";
}

.fa-fire {
  --fa: "\\f06d";
}

.fa-bed-pulse {
  --fa: "\\f487";
}

.fa-procedures {
  --fa: "\\f487";
}

.fa-shuttle-space {
  --fa: "\\f197";
}

.fa-space-shuttle {
  --fa: "\\f197";
}

.fa-face-laugh {
  --fa: "\\f599";
}

.fa-laugh {
  --fa: "\\f599";
}

.fa-folder-open {
  --fa: "\\f07c";
}

.fa-heart-circle-plus {
  --fa: "\\e500";
}

.fa-code-fork {
  --fa: "\\e13b";
}

.fa-city {
  --fa: "\\f64f";
}

.fa-microphone-lines {
  --fa: "\\f3c9";
}

.fa-microphone-alt {
  --fa: "\\f3c9";
}

.fa-pepper-hot {
  --fa: "\\f816";
}

.fa-unlock {
  --fa: "\\f09c";
}

.fa-colon-sign {
  --fa: "\\e140";
}

.fa-headset {
  --fa: "\\f590";
}

.fa-store-slash {
  --fa: "\\e071";
}

.fa-road-circle-xmark {
  --fa: "\\e566";
}

.fa-user-minus {
  --fa: "\\f503";
}

.fa-mars-stroke-up {
  --fa: "\\f22a";
}

.fa-mars-stroke-v {
  --fa: "\\f22a";
}

.fa-champagne-glasses {
  --fa: "\\f79f";
}

.fa-glass-cheers {
  --fa: "\\f79f";
}

.fa-clipboard {
  --fa: "\\f328";
}

.fa-house-circle-exclamation {
  --fa: "\\e50a";
}

.fa-file-arrow-up {
  --fa: "\\f574";
}

.fa-file-upload {
  --fa: "\\f574";
}

.fa-wifi {
  --fa: "\\f1eb";
}

.fa-wifi-3 {
  --fa: "\\f1eb";
}

.fa-wifi-strong {
  --fa: "\\f1eb";
}

.fa-bath {
  --fa: "\\f2cd";
}

.fa-bathtub {
  --fa: "\\f2cd";
}

.fa-underline {
  --fa: "\\f0cd";
}

.fa-user-pen {
  --fa: "\\f4ff";
}

.fa-user-edit {
  --fa: "\\f4ff";
}

.fa-signature {
  --fa: "\\f5b7";
}

.fa-stroopwafel {
  --fa: "\\f551";
}

.fa-bold {
  --fa: "\\f032";
}

.fa-anchor-lock {
  --fa: "\\e4ad";
}

.fa-building-ngo {
  --fa: "\\e4d7";
}

.fa-manat-sign {
  --fa: "\\e1d5";
}

.fa-not-equal {
  --fa: "\\f53e";
}

.fa-border-top-left {
  --fa: "\\f853";
}

.fa-border-style {
  --fa: "\\f853";
}

.fa-map-location-dot {
  --fa: "\\f5a0";
}

.fa-map-marked-alt {
  --fa: "\\f5a0";
}

.fa-jedi {
  --fa: "\\f669";
}

.fa-square-poll-vertical {
  --fa: "\\f681";
}

.fa-poll {
  --fa: "\\f681";
}

.fa-mug-hot {
  --fa: "\\f7b6";
}

.fa-car-battery {
  --fa: "\\f5df";
}

.fa-battery-car {
  --fa: "\\f5df";
}

.fa-gift {
  --fa: "\\f06b";
}

.fa-dice-two {
  --fa: "\\f528";
}

.fa-chess-queen {
  --fa: "\\f445";
}

.fa-glasses {
  --fa: "\\f530";
}

.fa-chess-board {
  --fa: "\\f43c";
}

.fa-building-circle-check {
  --fa: "\\e4d2";
}

.fa-person-chalkboard {
  --fa: "\\e53d";
}

.fa-mars-stroke-right {
  --fa: "\\f22b";
}

.fa-mars-stroke-h {
  --fa: "\\f22b";
}

.fa-hand-back-fist {
  --fa: "\\f255";
}

.fa-hand-rock {
  --fa: "\\f255";
}

.fa-square-caret-up {
  --fa: "\\f151";
}

.fa-caret-square-up {
  --fa: "\\f151";
}

.fa-cloud-showers-water {
  --fa: "\\e4e4";
}

.fa-chart-bar {
  --fa: "\\f080";
}

.fa-bar-chart {
  --fa: "\\f080";
}

.fa-hands-bubbles {
  --fa: "\\e05e";
}

.fa-hands-wash {
  --fa: "\\e05e";
}

.fa-less-than-equal {
  --fa: "\\f537";
}

.fa-train {
  --fa: "\\f238";
}

.fa-eye-low-vision {
  --fa: "\\f2a8";
}

.fa-low-vision {
  --fa: "\\f2a8";
}

.fa-crow {
  --fa: "\\f520";
}

.fa-sailboat {
  --fa: "\\e445";
}

.fa-window-restore {
  --fa: "\\f2d2";
}

.fa-square-plus {
  --fa: "\\f0fe";
}

.fa-plus-square {
  --fa: "\\f0fe";
}

.fa-torii-gate {
  --fa: "\\f6a1";
}

.fa-frog {
  --fa: "\\f52e";
}

.fa-bucket {
  --fa: "\\e4cf";
}

.fa-image {
  --fa: "\\f03e";
}

.fa-microphone {
  --fa: "\\f130";
}

.fa-cow {
  --fa: "\\f6c8";
}

.fa-caret-up {
  --fa: "\\f0d8";
}

.fa-screwdriver {
  --fa: "\\f54a";
}

.fa-folder-closed {
  --fa: "\\e185";
}

.fa-house-tsunami {
  --fa: "\\e515";
}

.fa-square-nfi {
  --fa: "\\e576";
}

.fa-arrow-up-from-ground-water {
  --fa: "\\e4b5";
}

.fa-martini-glass {
  --fa: "\\f57b";
}

.fa-glass-martini-alt {
  --fa: "\\f57b";
}

.fa-square-binary {
  --fa: "\\e69b";
}

.fa-rotate-left {
  --fa: "\\f2ea";
}

.fa-rotate-back {
  --fa: "\\f2ea";
}

.fa-rotate-backward {
  --fa: "\\f2ea";
}

.fa-undo-alt {
  --fa: "\\f2ea";
}

.fa-table-columns {
  --fa: "\\f0db";
}

.fa-columns {
  --fa: "\\f0db";
}

.fa-lemon {
  --fa: "\\f094";
}

.fa-head-side-mask {
  --fa: "\\e063";
}

.fa-handshake {
  --fa: "\\f2b5";
}

.fa-gem {
  --fa: "\\f3a5";
}

.fa-dolly {
  --fa: "\\f472";
}

.fa-dolly-box {
  --fa: "\\f472";
}

.fa-smoking {
  --fa: "\\f48d";
}

.fa-minimize {
  --fa: "\\f78c";
}

.fa-compress-arrows-alt {
  --fa: "\\f78c";
}

.fa-monument {
  --fa: "\\f5a6";
}

.fa-snowplow {
  --fa: "\\f7d2";
}

.fa-angles-right {
  --fa: "\\f101";
}

.fa-angle-double-right {
  --fa: "\\f101";
}

.fa-cannabis {
  --fa: "\\f55f";
}

.fa-circle-play {
  --fa: "\\f144";
}

.fa-play-circle {
  --fa: "\\f144";
}

.fa-tablets {
  --fa: "\\f490";
}

.fa-ethernet {
  --fa: "\\f796";
}

.fa-euro-sign {
  --fa: "\\f153";
}

.fa-eur {
  --fa: "\\f153";
}

.fa-euro {
  --fa: "\\f153";
}

.fa-chair {
  --fa: "\\f6c0";
}

.fa-circle-check {
  --fa: "\\f058";
}

.fa-check-circle {
  --fa: "\\f058";
}

.fa-circle-stop {
  --fa: "\\f28d";
}

.fa-stop-circle {
  --fa: "\\f28d";
}

.fa-compass-drafting {
  --fa: "\\f568";
}

.fa-drafting-compass {
  --fa: "\\f568";
}

.fa-plate-wheat {
  --fa: "\\e55a";
}

.fa-icicles {
  --fa: "\\f7ad";
}

.fa-person-shelter {
  --fa: "\\e54f";
}

.fa-neuter {
  --fa: "\\f22c";
}

.fa-id-badge {
  --fa: "\\f2c1";
}

.fa-marker {
  --fa: "\\f5a1";
}

.fa-face-laugh-beam {
  --fa: "\\f59a";
}

.fa-laugh-beam {
  --fa: "\\f59a";
}

.fa-helicopter-symbol {
  --fa: "\\e502";
}

.fa-universal-access {
  --fa: "\\f29a";
}

.fa-circle-chevron-up {
  --fa: "\\f139";
}

.fa-chevron-circle-up {
  --fa: "\\f139";
}

.fa-lari-sign {
  --fa: "\\e1c8";
}

.fa-volcano {
  --fa: "\\f770";
}

.fa-person-walking-dashed-line-arrow-right {
  --fa: "\\e553";
}

.fa-sterling-sign {
  --fa: "\\f154";
}

.fa-gbp {
  --fa: "\\f154";
}

.fa-pound-sign {
  --fa: "\\f154";
}

.fa-viruses {
  --fa: "\\e076";
}

.fa-square-person-confined {
  --fa: "\\e577";
}

.fa-user-tie {
  --fa: "\\f508";
}

.fa-arrow-down-long {
  --fa: "\\f175";
}

.fa-long-arrow-down {
  --fa: "\\f175";
}

.fa-tent-arrow-down-to-line {
  --fa: "\\e57e";
}

.fa-certificate {
  --fa: "\\f0a3";
}

.fa-reply-all {
  --fa: "\\f122";
}

.fa-mail-reply-all {
  --fa: "\\f122";
}

.fa-suitcase {
  --fa: "\\f0f2";
}

.fa-person-skating {
  --fa: "\\f7c5";
}

.fa-skating {
  --fa: "\\f7c5";
}

.fa-filter-circle-dollar {
  --fa: "\\f662";
}

.fa-funnel-dollar {
  --fa: "\\f662";
}

.fa-camera-retro {
  --fa: "\\f083";
}

.fa-circle-arrow-down {
  --fa: "\\f0ab";
}

.fa-arrow-circle-down {
  --fa: "\\f0ab";
}

.fa-file-import {
  --fa: "\\f56f";
}

.fa-arrow-right-to-file {
  --fa: "\\f56f";
}

.fa-square-arrow-up-right {
  --fa: "\\f14c";
}

.fa-external-link-square {
  --fa: "\\f14c";
}

.fa-box-open {
  --fa: "\\f49e";
}

.fa-scroll {
  --fa: "\\f70e";
}

.fa-spa {
  --fa: "\\f5bb";
}

.fa-location-pin-lock {
  --fa: "\\e51f";
}

.fa-pause {
  --fa: "\\f04c";
}

.fa-hill-avalanche {
  --fa: "\\e507";
}

.fa-temperature-empty {
  --fa: "\\f2cb";
}

.fa-temperature-0 {
  --fa: "\\f2cb";
}

.fa-thermometer-0 {
  --fa: "\\f2cb";
}

.fa-thermometer-empty {
  --fa: "\\f2cb";
}

.fa-bomb {
  --fa: "\\f1e2";
}

.fa-registered {
  --fa: "\\f25d";
}

.fa-address-card {
  --fa: "\\f2bb";
}

.fa-contact-card {
  --fa: "\\f2bb";
}

.fa-vcard {
  --fa: "\\f2bb";
}

.fa-scale-unbalanced-flip {
  --fa: "\\f516";
}

.fa-balance-scale-right {
  --fa: "\\f516";
}

.fa-subscript {
  --fa: "\\f12c";
}

.fa-diamond-turn-right {
  --fa: "\\f5eb";
}

.fa-directions {
  --fa: "\\f5eb";
}

.fa-burst {
  --fa: "\\e4dc";
}

.fa-house-laptop {
  --fa: "\\e066";
}

.fa-laptop-house {
  --fa: "\\e066";
}

.fa-face-tired {
  --fa: "\\f5c8";
}

.fa-tired {
  --fa: "\\f5c8";
}

.fa-money-bills {
  --fa: "\\e1f3";
}

.fa-smog {
  --fa: "\\f75f";
}

.fa-crutch {
  --fa: "\\f7f7";
}

.fa-cloud-arrow-up {
  --fa: "\\f0ee";
}

.fa-cloud-upload {
  --fa: "\\f0ee";
}

.fa-cloud-upload-alt {
  --fa: "\\f0ee";
}

.fa-palette {
  --fa: "\\f53f";
}

.fa-arrows-turn-right {
  --fa: "\\e4c0";
}

.fa-vest {
  --fa: "\\e085";
}

.fa-ferry {
  --fa: "\\e4ea";
}

.fa-arrows-down-to-people {
  --fa: "\\e4b9";
}

.fa-seedling {
  --fa: "\\f4d8";
}

.fa-sprout {
  --fa: "\\f4d8";
}

.fa-left-right {
  --fa: "\\f337";
}

.fa-arrows-alt-h {
  --fa: "\\f337";
}

.fa-boxes-packing {
  --fa: "\\e4c7";
}

.fa-circle-arrow-left {
  --fa: "\\f0a8";
}

.fa-arrow-circle-left {
  --fa: "\\f0a8";
}

.fa-group-arrows-rotate {
  --fa: "\\e4f6";
}

.fa-bowl-food {
  --fa: "\\e4c6";
}

.fa-candy-cane {
  --fa: "\\f786";
}

.fa-arrow-down-wide-short {
  --fa: "\\f160";
}

.fa-sort-amount-asc {
  --fa: "\\f160";
}

.fa-sort-amount-down {
  --fa: "\\f160";
}

.fa-cloud-bolt {
  --fa: "\\f76c";
}

.fa-thunderstorm {
  --fa: "\\f76c";
}

.fa-text-slash {
  --fa: "\\f87d";
}

.fa-remove-format {
  --fa: "\\f87d";
}

.fa-face-smile-wink {
  --fa: "\\f4da";
}

.fa-smile-wink {
  --fa: "\\f4da";
}

.fa-file-word {
  --fa: "\\f1c2";
}

.fa-file-powerpoint {
  --fa: "\\f1c4";
}

.fa-arrows-left-right {
  --fa: "\\f07e";
}

.fa-arrows-h {
  --fa: "\\f07e";
}

.fa-house-lock {
  --fa: "\\e510";
}

.fa-cloud-arrow-down {
  --fa: "\\f0ed";
}

.fa-cloud-download {
  --fa: "\\f0ed";
}

.fa-cloud-download-alt {
  --fa: "\\f0ed";
}

.fa-children {
  --fa: "\\e4e1";
}

.fa-chalkboard {
  --fa: "\\f51b";
}

.fa-blackboard {
  --fa: "\\f51b";
}

.fa-user-large-slash {
  --fa: "\\f4fa";
}

.fa-user-alt-slash {
  --fa: "\\f4fa";
}

.fa-envelope-open {
  --fa: "\\f2b6";
}

.fa-handshake-simple-slash {
  --fa: "\\e05f";
}

.fa-handshake-alt-slash {
  --fa: "\\e05f";
}

.fa-mattress-pillow {
  --fa: "\\e525";
}

.fa-guarani-sign {
  --fa: "\\e19a";
}

.fa-arrows-rotate {
  --fa: "\\f021";
}

.fa-refresh {
  --fa: "\\f021";
}

.fa-sync {
  --fa: "\\f021";
}

.fa-fire-extinguisher {
  --fa: "\\f134";
}

.fa-cruzeiro-sign {
  --fa: "\\e152";
}

.fa-greater-than-equal {
  --fa: "\\f532";
}

.fa-shield-halved {
  --fa: "\\f3ed";
}

.fa-shield-alt {
  --fa: "\\f3ed";
}

.fa-book-atlas {
  --fa: "\\f558";
}

.fa-atlas {
  --fa: "\\f558";
}

.fa-virus {
  --fa: "\\e074";
}

.fa-envelope-circle-check {
  --fa: "\\e4e8";
}

.fa-layer-group {
  --fa: "\\f5fd";
}

.fa-arrows-to-dot {
  --fa: "\\e4be";
}

.fa-archway {
  --fa: "\\f557";
}

.fa-heart-circle-check {
  --fa: "\\e4fd";
}

.fa-house-chimney-crack {
  --fa: "\\f6f1";
}

.fa-house-damage {
  --fa: "\\f6f1";
}

.fa-file-zipper {
  --fa: "\\f1c6";
}

.fa-file-archive {
  --fa: "\\f1c6";
}

.fa-square {
  --fa: "\\f0c8";
}

.fa-martini-glass-empty {
  --fa: "\\f000";
}

.fa-glass-martini {
  --fa: "\\f000";
}

.fa-couch {
  --fa: "\\f4b8";
}

.fa-cedi-sign {
  --fa: "\\e0df";
}

.fa-italic {
  --fa: "\\f033";
}

.fa-table-cells-column-lock {
  --fa: "\\e678";
}

.fa-church {
  --fa: "\\f51d";
}

.fa-comments-dollar {
  --fa: "\\f653";
}

.fa-democrat {
  --fa: "\\f747";
}

.fa-z {
  --fa: "Z";
}

.fa-person-skiing {
  --fa: "\\f7c9";
}

.fa-skiing {
  --fa: "\\f7c9";
}

.fa-road-lock {
  --fa: "\\e567";
}

.fa-a {
  --fa: "A";
}

.fa-temperature-arrow-down {
  --fa: "\\e03f";
}

.fa-temperature-down {
  --fa: "\\e03f";
}

.fa-feather-pointed {
  --fa: "\\f56b";
}

.fa-feather-alt {
  --fa: "\\f56b";
}

.fa-p {
  --fa: "P";
}

.fa-snowflake {
  --fa: "\\f2dc";
}

.fa-newspaper {
  --fa: "\\f1ea";
}

.fa-rectangle-ad {
  --fa: "\\f641";
}

.fa-ad {
  --fa: "\\f641";
}

.fa-circle-arrow-right {
  --fa: "\\f0a9";
}

.fa-arrow-circle-right {
  --fa: "\\f0a9";
}

.fa-filter-circle-xmark {
  --fa: "\\e17b";
}

.fa-locust {
  --fa: "\\e520";
}

.fa-sort {
  --fa: "\\f0dc";
}

.fa-unsorted {
  --fa: "\\f0dc";
}

.fa-list-ol {
  --fa: "\\f0cb";
}

.fa-list-1-2 {
  --fa: "\\f0cb";
}

.fa-list-numeric {
  --fa: "\\f0cb";
}

.fa-person-dress-burst {
  --fa: "\\e544";
}

.fa-money-check-dollar {
  --fa: "\\f53d";
}

.fa-money-check-alt {
  --fa: "\\f53d";
}

.fa-vector-square {
  --fa: "\\f5cb";
}

.fa-bread-slice {
  --fa: "\\f7ec";
}

.fa-language {
  --fa: "\\f1ab";
}

.fa-face-kiss-wink-heart {
  --fa: "\\f598";
}

.fa-kiss-wink-heart {
  --fa: "\\f598";
}

.fa-filter {
  --fa: "\\f0b0";
}

.fa-question {
  --fa: "\\?";
}

.fa-file-signature {
  --fa: "\\f573";
}

.fa-up-down-left-right {
  --fa: "\\f0b2";
}

.fa-arrows-alt {
  --fa: "\\f0b2";
}

.fa-house-chimney-user {
  --fa: "\\e065";
}

.fa-hand-holding-heart {
  --fa: "\\f4be";
}

.fa-puzzle-piece {
  --fa: "\\f12e";
}

.fa-money-check {
  --fa: "\\f53c";
}

.fa-star-half-stroke {
  --fa: "\\f5c0";
}

.fa-star-half-alt {
  --fa: "\\f5c0";
}

.fa-code {
  --fa: "\\f121";
}

.fa-whiskey-glass {
  --fa: "\\f7a0";
}

.fa-glass-whiskey {
  --fa: "\\f7a0";
}

.fa-building-circle-exclamation {
  --fa: "\\e4d3";
}

.fa-magnifying-glass-chart {
  --fa: "\\e522";
}

.fa-arrow-up-right-from-square {
  --fa: "\\f08e";
}

.fa-external-link {
  --fa: "\\f08e";
}

.fa-cubes-stacked {
  --fa: "\\e4e6";
}

.fa-won-sign {
  --fa: "\\f159";
}

.fa-krw {
  --fa: "\\f159";
}

.fa-won {
  --fa: "\\f159";
}

.fa-virus-covid {
  --fa: "\\e4a8";
}

.fa-austral-sign {
  --fa: "\\e0a9";
}

.fa-f {
  --fa: "F";
}

.fa-leaf {
  --fa: "\\f06c";
}

.fa-road {
  --fa: "\\f018";
}

.fa-taxi {
  --fa: "\\f1ba";
}

.fa-cab {
  --fa: "\\f1ba";
}

.fa-person-circle-plus {
  --fa: "\\e541";
}

.fa-chart-pie {
  --fa: "\\f200";
}

.fa-pie-chart {
  --fa: "\\f200";
}

.fa-bolt-lightning {
  --fa: "\\e0b7";
}

.fa-sack-xmark {
  --fa: "\\e56a";
}

.fa-file-excel {
  --fa: "\\f1c3";
}

.fa-file-contract {
  --fa: "\\f56c";
}

.fa-fish-fins {
  --fa: "\\e4f2";
}

.fa-building-flag {
  --fa: "\\e4d5";
}

.fa-face-grin-beam {
  --fa: "\\f582";
}

.fa-grin-beam {
  --fa: "\\f582";
}

.fa-object-ungroup {
  --fa: "\\f248";
}

.fa-poop {
  --fa: "\\f619";
}

.fa-location-pin {
  --fa: "\\f041";
}

.fa-map-marker {
  --fa: "\\f041";
}

.fa-kaaba {
  --fa: "\\f66b";
}

.fa-toilet-paper {
  --fa: "\\f71e";
}

.fa-helmet-safety {
  --fa: "\\f807";
}

.fa-hard-hat {
  --fa: "\\f807";
}

.fa-hat-hard {
  --fa: "\\f807";
}

.fa-eject {
  --fa: "\\f052";
}

.fa-circle-right {
  --fa: "\\f35a";
}

.fa-arrow-alt-circle-right {
  --fa: "\\f35a";
}

.fa-plane-circle-check {
  --fa: "\\e555";
}

.fa-face-rolling-eyes {
  --fa: "\\f5a5";
}

.fa-meh-rolling-eyes {
  --fa: "\\f5a5";
}

.fa-object-group {
  --fa: "\\f247";
}

.fa-chart-line {
  --fa: "\\f201";
}

.fa-line-chart {
  --fa: "\\f201";
}

.fa-mask-ventilator {
  --fa: "\\e524";
}

.fa-arrow-right {
  --fa: "\\f061";
}

.fa-signs-post {
  --fa: "\\f277";
}

.fa-map-signs {
  --fa: "\\f277";
}

.fa-cash-register {
  --fa: "\\f788";
}

.fa-person-circle-question {
  --fa: "\\e542";
}

.fa-h {
  --fa: "H";
}

.fa-tarp {
  --fa: "\\e57b";
}

.fa-screwdriver-wrench {
  --fa: "\\f7d9";
}

.fa-tools {
  --fa: "\\f7d9";
}

.fa-arrows-to-eye {
  --fa: "\\e4bf";
}

.fa-plug-circle-bolt {
  --fa: "\\e55b";
}

.fa-heart {
  --fa: "\\f004";
}

.fa-mars-and-venus {
  --fa: "\\f224";
}

.fa-house-user {
  --fa: "\\e1b0";
}

.fa-home-user {
  --fa: "\\e1b0";
}

.fa-dumpster-fire {
  --fa: "\\f794";
}

.fa-house-crack {
  --fa: "\\e3b1";
}

.fa-martini-glass-citrus {
  --fa: "\\f561";
}

.fa-cocktail {
  --fa: "\\f561";
}

.fa-face-surprise {
  --fa: "\\f5c2";
}

.fa-surprise {
  --fa: "\\f5c2";
}

.fa-bottle-water {
  --fa: "\\e4c5";
}

.fa-circle-pause {
  --fa: "\\f28b";
}

.fa-pause-circle {
  --fa: "\\f28b";
}

.fa-toilet-paper-slash {
  --fa: "\\e072";
}

.fa-apple-whole {
  --fa: "\\f5d1";
}

.fa-apple-alt {
  --fa: "\\f5d1";
}

.fa-kitchen-set {
  --fa: "\\e51a";
}

.fa-r {
  --fa: "R";
}

.fa-temperature-quarter {
  --fa: "\\f2ca";
}

.fa-temperature-1 {
  --fa: "\\f2ca";
}

.fa-thermometer-1 {
  --fa: "\\f2ca";
}

.fa-thermometer-quarter {
  --fa: "\\f2ca";
}

.fa-cube {
  --fa: "\\f1b2";
}

.fa-bitcoin-sign {
  --fa: "\\e0b4";
}

.fa-shield-dog {
  --fa: "\\e573";
}

.fa-solar-panel {
  --fa: "\\f5ba";
}

.fa-lock-open {
  --fa: "\\f3c1";
}

.fa-elevator {
  --fa: "\\e16d";
}

.fa-money-bill-transfer {
  --fa: "\\e528";
}

.fa-money-bill-trend-up {
  --fa: "\\e529";
}

.fa-house-flood-water-circle-arrow-right {
  --fa: "\\e50f";
}

.fa-square-poll-horizontal {
  --fa: "\\f682";
}

.fa-poll-h {
  --fa: "\\f682";
}

.fa-circle {
  --fa: "\\f111";
}

.fa-backward-fast {
  --fa: "\\f049";
}

.fa-fast-backward {
  --fa: "\\f049";
}

.fa-recycle {
  --fa: "\\f1b8";
}

.fa-user-astronaut {
  --fa: "\\f4fb";
}

.fa-plane-slash {
  --fa: "\\e069";
}

.fa-trademark {
  --fa: "\\f25c";
}

.fa-basketball {
  --fa: "\\f434";
}

.fa-basketball-ball {
  --fa: "\\f434";
}

.fa-satellite-dish {
  --fa: "\\f7c0";
}

.fa-circle-up {
  --fa: "\\f35b";
}

.fa-arrow-alt-circle-up {
  --fa: "\\f35b";
}

.fa-mobile-screen-button {
  --fa: "\\f3cd";
}

.fa-mobile-alt {
  --fa: "\\f3cd";
}

.fa-volume-high {
  --fa: "\\f028";
}

.fa-volume-up {
  --fa: "\\f028";
}

.fa-users-rays {
  --fa: "\\e593";
}

.fa-wallet {
  --fa: "\\f555";
}

.fa-clipboard-check {
  --fa: "\\f46c";
}

.fa-file-audio {
  --fa: "\\f1c7";
}

.fa-burger {
  --fa: "\\f805";
}

.fa-hamburger {
  --fa: "\\f805";
}

.fa-wrench {
  --fa: "\\f0ad";
}

.fa-bugs {
  --fa: "\\e4d0";
}

.fa-rupee-sign {
  --fa: "\\f156";
}

.fa-rupee {
  --fa: "\\f156";
}

.fa-file-image {
  --fa: "\\f1c5";
}

.fa-circle-question {
  --fa: "\\f059";
}

.fa-question-circle {
  --fa: "\\f059";
}

.fa-plane-departure {
  --fa: "\\f5b0";
}

.fa-handshake-slash {
  --fa: "\\e060";
}

.fa-book-bookmark {
  --fa: "\\e0bb";
}

.fa-code-branch {
  --fa: "\\f126";
}

.fa-hat-cowboy {
  --fa: "\\f8c0";
}

.fa-bridge {
  --fa: "\\e4c8";
}

.fa-phone-flip {
  --fa: "\\f879";
}

.fa-phone-alt {
  --fa: "\\f879";
}

.fa-truck-front {
  --fa: "\\e2b7";
}

.fa-cat {
  --fa: "\\f6be";
}

.fa-anchor-circle-exclamation {
  --fa: "\\e4ab";
}

.fa-truck-field {
  --fa: "\\e58d";
}

.fa-route {
  --fa: "\\f4d7";
}

.fa-clipboard-question {
  --fa: "\\e4e3";
}

.fa-panorama {
  --fa: "\\e209";
}

.fa-comment-medical {
  --fa: "\\f7f5";
}

.fa-teeth-open {
  --fa: "\\f62f";
}

.fa-file-circle-minus {
  --fa: "\\e4ed";
}

.fa-tags {
  --fa: "\\f02c";
}

.fa-wine-glass {
  --fa: "\\f4e3";
}

.fa-forward-fast {
  --fa: "\\f050";
}

.fa-fast-forward {
  --fa: "\\f050";
}

.fa-face-meh-blank {
  --fa: "\\f5a4";
}

.fa-meh-blank {
  --fa: "\\f5a4";
}

.fa-square-parking {
  --fa: "\\f540";
}

.fa-parking {
  --fa: "\\f540";
}

.fa-house-signal {
  --fa: "\\e012";
}

.fa-bars-progress {
  --fa: "\\f828";
}

.fa-tasks-alt {
  --fa: "\\f828";
}

.fa-faucet-drip {
  --fa: "\\e006";
}

.fa-cart-flatbed {
  --fa: "\\f474";
}

.fa-dolly-flatbed {
  --fa: "\\f474";
}

.fa-ban-smoking {
  --fa: "\\f54d";
}

.fa-smoking-ban {
  --fa: "\\f54d";
}

.fa-terminal {
  --fa: "\\f120";
}

.fa-mobile-button {
  --fa: "\\f10b";
}

.fa-house-medical-flag {
  --fa: "\\e514";
}

.fa-basket-shopping {
  --fa: "\\f291";
}

.fa-shopping-basket {
  --fa: "\\f291";
}

.fa-tape {
  --fa: "\\f4db";
}

.fa-bus-simple {
  --fa: "\\f55e";
}

.fa-bus-alt {
  --fa: "\\f55e";
}

.fa-eye {
  --fa: "\\f06e";
}

.fa-face-sad-cry {
  --fa: "\\f5b3";
}

.fa-sad-cry {
  --fa: "\\f5b3";
}

.fa-audio-description {
  --fa: "\\f29e";
}

.fa-person-military-to-person {
  --fa: "\\e54c";
}

.fa-file-shield {
  --fa: "\\e4f0";
}

.fa-user-slash {
  --fa: "\\f506";
}

.fa-pen {
  --fa: "\\f304";
}

.fa-tower-observation {
  --fa: "\\e586";
}

.fa-file-code {
  --fa: "\\f1c9";
}

.fa-signal {
  --fa: "\\f012";
}

.fa-signal-5 {
  --fa: "\\f012";
}

.fa-signal-perfect {
  --fa: "\\f012";
}

.fa-bus {
  --fa: "\\f207";
}

.fa-heart-circle-xmark {
  --fa: "\\e501";
}

.fa-house-chimney {
  --fa: "\\e3af";
}

.fa-home-lg {
  --fa: "\\e3af";
}

.fa-window-maximize {
  --fa: "\\f2d0";
}

.fa-face-frown {
  --fa: "\\f119";
}

.fa-frown {
  --fa: "\\f119";
}

.fa-prescription {
  --fa: "\\f5b1";
}

.fa-shop {
  --fa: "\\f54f";
}

.fa-store-alt {
  --fa: "\\f54f";
}

.fa-floppy-disk {
  --fa: "\\f0c7";
}

.fa-save {
  --fa: "\\f0c7";
}

.fa-vihara {
  --fa: "\\f6a7";
}

.fa-scale-unbalanced {
  --fa: "\\f515";
}

.fa-balance-scale-left {
  --fa: "\\f515";
}

.fa-sort-up {
  --fa: "\\f0de";
}

.fa-sort-asc {
  --fa: "\\f0de";
}

.fa-comment-dots {
  --fa: "\\f4ad";
}

.fa-commenting {
  --fa: "\\f4ad";
}

.fa-plant-wilt {
  --fa: "\\e5aa";
}

.fa-diamond {
  --fa: "\\f219";
}

.fa-face-grin-squint {
  --fa: "\\f585";
}

.fa-grin-squint {
  --fa: "\\f585";
}

.fa-hand-holding-dollar {
  --fa: "\\f4c0";
}

.fa-hand-holding-usd {
  --fa: "\\f4c0";
}

.fa-chart-diagram {
  --fa: "\\e695";
}

.fa-bacterium {
  --fa: "\\e05a";
}

.fa-hand-pointer {
  --fa: "\\f25a";
}

.fa-drum-steelpan {
  --fa: "\\f56a";
}

.fa-hand-scissors {
  --fa: "\\f257";
}

.fa-hands-praying {
  --fa: "\\f684";
}

.fa-praying-hands {
  --fa: "\\f684";
}

.fa-arrow-rotate-right {
  --fa: "\\f01e";
}

.fa-arrow-right-rotate {
  --fa: "\\f01e";
}

.fa-arrow-rotate-forward {
  --fa: "\\f01e";
}

.fa-redo {
  --fa: "\\f01e";
}

.fa-biohazard {
  --fa: "\\f780";
}

.fa-location-crosshairs {
  --fa: "\\f601";
}

.fa-location {
  --fa: "\\f601";
}

.fa-mars-double {
  --fa: "\\f227";
}

.fa-child-dress {
  --fa: "\\e59c";
}

.fa-users-between-lines {
  --fa: "\\e591";
}

.fa-lungs-virus {
  --fa: "\\e067";
}

.fa-face-grin-tears {
  --fa: "\\f588";
}

.fa-grin-tears {
  --fa: "\\f588";
}

.fa-phone {
  --fa: "\\f095";
}

.fa-calendar-xmark {
  --fa: "\\f273";
}

.fa-calendar-times {
  --fa: "\\f273";
}

.fa-child-reaching {
  --fa: "\\e59d";
}

.fa-head-side-virus {
  --fa: "\\e064";
}

.fa-user-gear {
  --fa: "\\f4fe";
}

.fa-user-cog {
  --fa: "\\f4fe";
}

.fa-arrow-up-1-9 {
  --fa: "\\f163";
}

.fa-sort-numeric-up {
  --fa: "\\f163";
}

.fa-door-closed {
  --fa: "\\f52a";
}

.fa-shield-virus {
  --fa: "\\e06c";
}

.fa-dice-six {
  --fa: "\\f526";
}

.fa-mosquito-net {
  --fa: "\\e52c";
}

.fa-file-fragment {
  --fa: "\\e697";
}

.fa-bridge-water {
  --fa: "\\e4ce";
}

.fa-person-booth {
  --fa: "\\f756";
}

.fa-text-width {
  --fa: "\\f035";
}

.fa-hat-wizard {
  --fa: "\\f6e8";
}

.fa-pen-fancy {
  --fa: "\\f5ac";
}

.fa-person-digging {
  --fa: "\\f85e";
}

.fa-digging {
  --fa: "\\f85e";
}

.fa-trash {
  --fa: "\\f1f8";
}

.fa-gauge-simple {
  --fa: "\\f629";
}

.fa-gauge-simple-med {
  --fa: "\\f629";
}

.fa-tachometer-average {
  --fa: "\\f629";
}

.fa-book-medical {
  --fa: "\\f7e6";
}

.fa-poo {
  --fa: "\\f2fe";
}

.fa-quote-right {
  --fa: "\\f10e";
}

.fa-quote-right-alt {
  --fa: "\\f10e";
}

.fa-shirt {
  --fa: "\\f553";
}

.fa-t-shirt {
  --fa: "\\f553";
}

.fa-tshirt {
  --fa: "\\f553";
}

.fa-cubes {
  --fa: "\\f1b3";
}

.fa-divide {
  --fa: "\\f529";
}

.fa-tenge-sign {
  --fa: "\\f7d7";
}

.fa-tenge {
  --fa: "\\f7d7";
}

.fa-headphones {
  --fa: "\\f025";
}

.fa-hands-holding {
  --fa: "\\f4c2";
}

.fa-hands-clapping {
  --fa: "\\e1a8";
}

.fa-republican {
  --fa: "\\f75e";
}

.fa-arrow-left {
  --fa: "\\f060";
}

.fa-person-circle-xmark {
  --fa: "\\e543";
}

.fa-ruler {
  --fa: "\\f545";
}

.fa-align-left {
  --fa: "\\f036";
}

.fa-dice-d6 {
  --fa: "\\f6d1";
}

.fa-restroom {
  --fa: "\\f7bd";
}

.fa-j {
  --fa: "J";
}

.fa-users-viewfinder {
  --fa: "\\e595";
}

.fa-file-video {
  --fa: "\\f1c8";
}

.fa-up-right-from-square {
  --fa: "\\f35d";
}

.fa-external-link-alt {
  --fa: "\\f35d";
}

.fa-table-cells {
  --fa: "\\f00a";
}

.fa-th {
  --fa: "\\f00a";
}

.fa-file-pdf {
  --fa: "\\f1c1";
}

.fa-book-bible {
  --fa: "\\f647";
}

.fa-bible {
  --fa: "\\f647";
}

.fa-o {
  --fa: "O";
}

.fa-suitcase-medical {
  --fa: "\\f0fa";
}

.fa-medkit {
  --fa: "\\f0fa";
}

.fa-user-secret {
  --fa: "\\f21b";
}

.fa-otter {
  --fa: "\\f700";
}

.fa-person-dress {
  --fa: "\\f182";
}

.fa-female {
  --fa: "\\f182";
}

.fa-comment-dollar {
  --fa: "\\f651";
}

.fa-business-time {
  --fa: "\\f64a";
}

.fa-briefcase-clock {
  --fa: "\\f64a";
}

.fa-table-cells-large {
  --fa: "\\f009";
}

.fa-th-large {
  --fa: "\\f009";
}

.fa-book-tanakh {
  --fa: "\\f827";
}

.fa-tanakh {
  --fa: "\\f827";
}

.fa-phone-volume {
  --fa: "\\f2a0";
}

.fa-volume-control-phone {
  --fa: "\\f2a0";
}

.fa-hat-cowboy-side {
  --fa: "\\f8c1";
}

.fa-clipboard-user {
  --fa: "\\f7f3";
}

.fa-child {
  --fa: "\\f1ae";
}

.fa-lira-sign {
  --fa: "\\f195";
}

.fa-satellite {
  --fa: "\\f7bf";
}

.fa-plane-lock {
  --fa: "\\e558";
}

.fa-tag {
  --fa: "\\f02b";
}

.fa-comment {
  --fa: "\\f075";
}

.fa-cake-candles {
  --fa: "\\f1fd";
}

.fa-birthday-cake {
  --fa: "\\f1fd";
}

.fa-cake {
  --fa: "\\f1fd";
}

.fa-envelope {
  --fa: "\\f0e0";
}

.fa-angles-up {
  --fa: "\\f102";
}

.fa-angle-double-up {
  --fa: "\\f102";
}

.fa-paperclip {
  --fa: "\\f0c6";
}

.fa-arrow-right-to-city {
  --fa: "\\e4b3";
}

.fa-ribbon {
  --fa: "\\f4d6";
}

.fa-lungs {
  --fa: "\\f604";
}

.fa-arrow-up-9-1 {
  --fa: "\\f887";
}

.fa-sort-numeric-up-alt {
  --fa: "\\f887";
}

.fa-litecoin-sign {
  --fa: "\\e1d3";
}

.fa-border-none {
  --fa: "\\f850";
}

.fa-circle-nodes {
  --fa: "\\e4e2";
}

.fa-parachute-box {
  --fa: "\\f4cd";
}

.fa-indent {
  --fa: "\\f03c";
}

.fa-truck-field-un {
  --fa: "\\e58e";
}

.fa-hourglass {
  --fa: "\\f254";
}

.fa-hourglass-empty {
  --fa: "\\f254";
}

.fa-mountain {
  --fa: "\\f6fc";
}

.fa-user-doctor {
  --fa: "\\f0f0";
}

.fa-user-md {
  --fa: "\\f0f0";
}

.fa-circle-info {
  --fa: "\\f05a";
}

.fa-info-circle {
  --fa: "\\f05a";
}

.fa-cloud-meatball {
  --fa: "\\f73b";
}

.fa-camera {
  --fa: "\\f030";
}

.fa-camera-alt {
  --fa: "\\f030";
}

.fa-square-virus {
  --fa: "\\e578";
}

.fa-meteor {
  --fa: "\\f753";
}

.fa-car-on {
  --fa: "\\e4dd";
}

.fa-sleigh {
  --fa: "\\f7cc";
}

.fa-arrow-down-1-9 {
  --fa: "\\f162";
}

.fa-sort-numeric-asc {
  --fa: "\\f162";
}

.fa-sort-numeric-down {
  --fa: "\\f162";
}

.fa-hand-holding-droplet {
  --fa: "\\f4c1";
}

.fa-hand-holding-water {
  --fa: "\\f4c1";
}

.fa-water {
  --fa: "\\f773";
}

.fa-calendar-check {
  --fa: "\\f274";
}

.fa-braille {
  --fa: "\\f2a1";
}

.fa-prescription-bottle-medical {
  --fa: "\\f486";
}

.fa-prescription-bottle-alt {
  --fa: "\\f486";
}

.fa-landmark {
  --fa: "\\f66f";
}

.fa-truck {
  --fa: "\\f0d1";
}

.fa-crosshairs {
  --fa: "\\f05b";
}

.fa-person-cane {
  --fa: "\\e53c";
}

.fa-tent {
  --fa: "\\e57d";
}

.fa-vest-patches {
  --fa: "\\e086";
}

.fa-check-double {
  --fa: "\\f560";
}

.fa-arrow-down-a-z {
  --fa: "\\f15d";
}

.fa-sort-alpha-asc {
  --fa: "\\f15d";
}

.fa-sort-alpha-down {
  --fa: "\\f15d";
}

.fa-money-bill-wheat {
  --fa: "\\e52a";
}

.fa-cookie {
  --fa: "\\f563";
}

.fa-arrow-rotate-left {
  --fa: "\\f0e2";
}

.fa-arrow-left-rotate {
  --fa: "\\f0e2";
}

.fa-arrow-rotate-back {
  --fa: "\\f0e2";
}

.fa-arrow-rotate-backward {
  --fa: "\\f0e2";
}

.fa-undo {
  --fa: "\\f0e2";
}

.fa-hard-drive {
  --fa: "\\f0a0";
}

.fa-hdd {
  --fa: "\\f0a0";
}

.fa-face-grin-squint-tears {
  --fa: "\\f586";
}

.fa-grin-squint-tears {
  --fa: "\\f586";
}

.fa-dumbbell {
  --fa: "\\f44b";
}

.fa-rectangle-list {
  --fa: "\\f022";
}

.fa-list-alt {
  --fa: "\\f022";
}

.fa-tarp-droplet {
  --fa: "\\e57c";
}

.fa-house-medical-circle-check {
  --fa: "\\e511";
}

.fa-person-skiing-nordic {
  --fa: "\\f7ca";
}

.fa-skiing-nordic {
  --fa: "\\f7ca";
}

.fa-calendar-plus {
  --fa: "\\f271";
}

.fa-plane-arrival {
  --fa: "\\f5af";
}

.fa-circle-left {
  --fa: "\\f359";
}

.fa-arrow-alt-circle-left {
  --fa: "\\f359";
}

.fa-train-subway {
  --fa: "\\f239";
}

.fa-subway {
  --fa: "\\f239";
}

.fa-chart-gantt {
  --fa: "\\e0e4";
}

.fa-indian-rupee-sign {
  --fa: "\\e1bc";
}

.fa-indian-rupee {
  --fa: "\\e1bc";
}

.fa-inr {
  --fa: "\\e1bc";
}

.fa-crop-simple {
  --fa: "\\f565";
}

.fa-crop-alt {
  --fa: "\\f565";
}

.fa-money-bill-1 {
  --fa: "\\f3d1";
}

.fa-money-bill-alt {
  --fa: "\\f3d1";
}

.fa-left-long {
  --fa: "\\f30a";
}

.fa-long-arrow-alt-left {
  --fa: "\\f30a";
}

.fa-dna {
  --fa: "\\f471";
}

.fa-virus-slash {
  --fa: "\\e075";
}

.fa-minus {
  --fa: "\\f068";
}

.fa-subtract {
  --fa: "\\f068";
}

.fa-chess {
  --fa: "\\f439";
}

.fa-arrow-left-long {
  --fa: "\\f177";
}

.fa-long-arrow-left {
  --fa: "\\f177";
}

.fa-plug-circle-check {
  --fa: "\\e55c";
}

.fa-street-view {
  --fa: "\\f21d";
}

.fa-franc-sign {
  --fa: "\\e18f";
}

.fa-volume-off {
  --fa: "\\f026";
}

.fa-hands-asl-interpreting {
  --fa: "\\f2a3";
}

.fa-american-sign-language-interpreting {
  --fa: "\\f2a3";
}

.fa-asl-interpreting {
  --fa: "\\f2a3";
}

.fa-hands-american-sign-language-interpreting {
  --fa: "\\f2a3";
}

.fa-gear {
  --fa: "\\f013";
}

.fa-cog {
  --fa: "\\f013";
}

.fa-droplet-slash {
  --fa: "\\f5c7";
}

.fa-tint-slash {
  --fa: "\\f5c7";
}

.fa-mosque {
  --fa: "\\f678";
}

.fa-mosquito {
  --fa: "\\e52b";
}

.fa-star-of-david {
  --fa: "\\f69a";
}

.fa-person-military-rifle {
  --fa: "\\e54b";
}

.fa-cart-shopping {
  --fa: "\\f07a";
}

.fa-shopping-cart {
  --fa: "\\f07a";
}

.fa-vials {
  --fa: "\\f493";
}

.fa-plug-circle-plus {
  --fa: "\\e55f";
}

.fa-place-of-worship {
  --fa: "\\f67f";
}

.fa-grip-vertical {
  --fa: "\\f58e";
}

.fa-hexagon-nodes {
  --fa: "\\e699";
}

.fa-arrow-turn-up {
  --fa: "\\f148";
}

.fa-level-up {
  --fa: "\\f148";
}

.fa-u {
  --fa: "U";
}

.fa-square-root-variable {
  --fa: "\\f698";
}

.fa-square-root-alt {
  --fa: "\\f698";
}

.fa-clock {
  --fa: "\\f017";
}

.fa-clock-four {
  --fa: "\\f017";
}

.fa-backward-step {
  --fa: "\\f048";
}

.fa-step-backward {
  --fa: "\\f048";
}

.fa-pallet {
  --fa: "\\f482";
}

.fa-faucet {
  --fa: "\\e005";
}

.fa-baseball-bat-ball {
  --fa: "\\f432";
}

.fa-s {
  --fa: "S";
}

.fa-timeline {
  --fa: "\\e29c";
}

.fa-keyboard {
  --fa: "\\f11c";
}

.fa-caret-down {
  --fa: "\\f0d7";
}

.fa-house-chimney-medical {
  --fa: "\\f7f2";
}

.fa-clinic-medical {
  --fa: "\\f7f2";
}

.fa-temperature-three-quarters {
  --fa: "\\f2c8";
}

.fa-temperature-3 {
  --fa: "\\f2c8";
}

.fa-thermometer-3 {
  --fa: "\\f2c8";
}

.fa-thermometer-three-quarters {
  --fa: "\\f2c8";
}

.fa-mobile-screen {
  --fa: "\\f3cf";
}

.fa-mobile-android-alt {
  --fa: "\\f3cf";
}

.fa-plane-up {
  --fa: "\\e22d";
}

.fa-piggy-bank {
  --fa: "\\f4d3";
}

.fa-battery-half {
  --fa: "\\f242";
}

.fa-battery-3 {
  --fa: "\\f242";
}

.fa-mountain-city {
  --fa: "\\e52e";
}

.fa-coins {
  --fa: "\\f51e";
}

.fa-khanda {
  --fa: "\\f66d";
}

.fa-sliders {
  --fa: "\\f1de";
}

.fa-sliders-h {
  --fa: "\\f1de";
}

.fa-folder-tree {
  --fa: "\\f802";
}

.fa-network-wired {
  --fa: "\\f6ff";
}

.fa-map-pin {
  --fa: "\\f276";
}

.fa-hamsa {
  --fa: "\\f665";
}

.fa-cent-sign {
  --fa: "\\e3f5";
}

.fa-flask {
  --fa: "\\f0c3";
}

.fa-person-pregnant {
  --fa: "\\e31e";
}

.fa-wand-sparkles {
  --fa: "\\f72b";
}

.fa-ellipsis-vertical {
  --fa: "\\f142";
}

.fa-ellipsis-v {
  --fa: "\\f142";
}

.fa-ticket {
  --fa: "\\f145";
}

.fa-power-off {
  --fa: "\\f011";
}

.fa-right-long {
  --fa: "\\f30b";
}

.fa-long-arrow-alt-right {
  --fa: "\\f30b";
}

.fa-flag-usa {
  --fa: "\\f74d";
}

.fa-laptop-file {
  --fa: "\\e51d";
}

.fa-tty {
  --fa: "\\f1e4";
}

.fa-teletype {
  --fa: "\\f1e4";
}

.fa-diagram-next {
  --fa: "\\e476";
}

.fa-person-rifle {
  --fa: "\\e54e";
}

.fa-house-medical-circle-exclamation {
  --fa: "\\e512";
}

.fa-closed-captioning {
  --fa: "\\f20a";
}

.fa-person-hiking {
  --fa: "\\f6ec";
}

.fa-hiking {
  --fa: "\\f6ec";
}

.fa-venus-double {
  --fa: "\\f226";
}

.fa-images {
  --fa: "\\f302";
}

.fa-calculator {
  --fa: "\\f1ec";
}

.fa-people-pulling {
  --fa: "\\e535";
}

.fa-n {
  --fa: "N";
}

.fa-cable-car {
  --fa: "\\f7da";
}

.fa-tram {
  --fa: "\\f7da";
}

.fa-cloud-rain {
  --fa: "\\f73d";
}

.fa-building-circle-xmark {
  --fa: "\\e4d4";
}

.fa-ship {
  --fa: "\\f21a";
}

.fa-arrows-down-to-line {
  --fa: "\\e4b8";
}

.fa-download {
  --fa: "\\f019";
}

.fa-face-grin {
  --fa: "\\f580";
}

.fa-grin {
  --fa: "\\f580";
}

.fa-delete-left {
  --fa: "\\f55a";
}

.fa-backspace {
  --fa: "\\f55a";
}

.fa-eye-dropper {
  --fa: "\\f1fb";
}

.fa-eye-dropper-empty {
  --fa: "\\f1fb";
}

.fa-eyedropper {
  --fa: "\\f1fb";
}

.fa-file-circle-check {
  --fa: "\\e5a0";
}

.fa-forward {
  --fa: "\\f04e";
}

.fa-mobile {
  --fa: "\\f3ce";
}

.fa-mobile-android {
  --fa: "\\f3ce";
}

.fa-mobile-phone {
  --fa: "\\f3ce";
}

.fa-face-meh {
  --fa: "\\f11a";
}

.fa-meh {
  --fa: "\\f11a";
}

.fa-align-center {
  --fa: "\\f037";
}

.fa-book-skull {
  --fa: "\\f6b7";
}

.fa-book-dead {
  --fa: "\\f6b7";
}

.fa-id-card {
  --fa: "\\f2c2";
}

.fa-drivers-license {
  --fa: "\\f2c2";
}

.fa-outdent {
  --fa: "\\f03b";
}

.fa-dedent {
  --fa: "\\f03b";
}

.fa-heart-circle-exclamation {
  --fa: "\\e4fe";
}

.fa-house {
  --fa: "\\f015";
}

.fa-home {
  --fa: "\\f015";
}

.fa-home-alt {
  --fa: "\\f015";
}

.fa-home-lg-alt {
  --fa: "\\f015";
}

.fa-calendar-week {
  --fa: "\\f784";
}

.fa-laptop-medical {
  --fa: "\\f812";
}

.fa-b {
  --fa: "B";
}

.fa-file-medical {
  --fa: "\\f477";
}

.fa-dice-one {
  --fa: "\\f525";
}

.fa-kiwi-bird {
  --fa: "\\f535";
}

.fa-arrow-right-arrow-left {
  --fa: "\\f0ec";
}

.fa-exchange {
  --fa: "\\f0ec";
}

.fa-rotate-right {
  --fa: "\\f2f9";
}

.fa-redo-alt {
  --fa: "\\f2f9";
}

.fa-rotate-forward {
  --fa: "\\f2f9";
}

.fa-utensils {
  --fa: "\\f2e7";
}

.fa-cutlery {
  --fa: "\\f2e7";
}

.fa-arrow-up-wide-short {
  --fa: "\\f161";
}

.fa-sort-amount-up {
  --fa: "\\f161";
}

.fa-mill-sign {
  --fa: "\\e1ed";
}

.fa-bowl-rice {
  --fa: "\\e2eb";
}

.fa-skull {
  --fa: "\\f54c";
}

.fa-tower-broadcast {
  --fa: "\\f519";
}

.fa-broadcast-tower {
  --fa: "\\f519";
}

.fa-truck-pickup {
  --fa: "\\f63c";
}

.fa-up-long {
  --fa: "\\f30c";
}

.fa-long-arrow-alt-up {
  --fa: "\\f30c";
}

.fa-stop {
  --fa: "\\f04d";
}

.fa-code-merge {
  --fa: "\\f387";
}

.fa-upload {
  --fa: "\\f093";
}

.fa-hurricane {
  --fa: "\\f751";
}

.fa-mound {
  --fa: "\\e52d";
}

.fa-toilet-portable {
  --fa: "\\e583";
}

.fa-compact-disc {
  --fa: "\\f51f";
}

.fa-file-arrow-down {
  --fa: "\\f56d";
}

.fa-file-download {
  --fa: "\\f56d";
}

.fa-caravan {
  --fa: "\\f8ff";
}

.fa-shield-cat {
  --fa: "\\e572";
}

.fa-bolt {
  --fa: "\\f0e7";
}

.fa-zap {
  --fa: "\\f0e7";
}

.fa-glass-water {
  --fa: "\\e4f4";
}

.fa-oil-well {
  --fa: "\\e532";
}

.fa-vault {
  --fa: "\\e2c5";
}

.fa-mars {
  --fa: "\\f222";
}

.fa-toilet {
  --fa: "\\f7d8";
}

.fa-plane-circle-xmark {
  --fa: "\\e557";
}

.fa-yen-sign {
  --fa: "\\f157";
}

.fa-cny {
  --fa: "\\f157";
}

.fa-jpy {
  --fa: "\\f157";
}

.fa-rmb {
  --fa: "\\f157";
}

.fa-yen {
  --fa: "\\f157";
}

.fa-ruble-sign {
  --fa: "\\f158";
}

.fa-rouble {
  --fa: "\\f158";
}

.fa-rub {
  --fa: "\\f158";
}

.fa-ruble {
  --fa: "\\f158";
}

.fa-sun {
  --fa: "\\f185";
}

.fa-guitar {
  --fa: "\\f7a6";
}

.fa-face-laugh-wink {
  --fa: "\\f59c";
}

.fa-laugh-wink {
  --fa: "\\f59c";
}

.fa-horse-head {
  --fa: "\\f7ab";
}

.fa-bore-hole {
  --fa: "\\e4c3";
}

.fa-industry {
  --fa: "\\f275";
}

.fa-circle-down {
  --fa: "\\f358";
}

.fa-arrow-alt-circle-down {
  --fa: "\\f358";
}

.fa-arrows-turn-to-dots {
  --fa: "\\e4c1";
}

.fa-florin-sign {
  --fa: "\\e184";
}

.fa-arrow-down-short-wide {
  --fa: "\\f884";
}

.fa-sort-amount-desc {
  --fa: "\\f884";
}

.fa-sort-amount-down-alt {
  --fa: "\\f884";
}

.fa-less-than {
  --fa: "\\<";
}

.fa-angle-down {
  --fa: "\\f107";
}

.fa-car-tunnel {
  --fa: "\\e4de";
}

.fa-head-side-cough {
  --fa: "\\e061";
}

.fa-grip-lines {
  --fa: "\\f7a4";
}

.fa-thumbs-down {
  --fa: "\\f165";
}

.fa-user-lock {
  --fa: "\\f502";
}

.fa-arrow-right-long {
  --fa: "\\f178";
}

.fa-long-arrow-right {
  --fa: "\\f178";
}

.fa-anchor-circle-xmark {
  --fa: "\\e4ac";
}

.fa-ellipsis {
  --fa: "\\f141";
}

.fa-ellipsis-h {
  --fa: "\\f141";
}

.fa-chess-pawn {
  --fa: "\\f443";
}

.fa-kit-medical {
  --fa: "\\f479";
}

.fa-first-aid {
  --fa: "\\f479";
}

.fa-person-through-window {
  --fa: "\\e5a9";
}

.fa-toolbox {
  --fa: "\\f552";
}

.fa-hands-holding-circle {
  --fa: "\\e4fb";
}

.fa-bug {
  --fa: "\\f188";
}

.fa-credit-card {
  --fa: "\\f09d";
}

.fa-credit-card-alt {
  --fa: "\\f09d";
}

.fa-car {
  --fa: "\\f1b9";
}

.fa-automobile {
  --fa: "\\f1b9";
}

.fa-hand-holding-hand {
  --fa: "\\e4f7";
}

.fa-book-open-reader {
  --fa: "\\f5da";
}

.fa-book-reader {
  --fa: "\\f5da";
}

.fa-mountain-sun {
  --fa: "\\e52f";
}

.fa-arrows-left-right-to-line {
  --fa: "\\e4ba";
}

.fa-dice-d20 {
  --fa: "\\f6cf";
}

.fa-truck-droplet {
  --fa: "\\e58c";
}

.fa-file-circle-xmark {
  --fa: "\\e5a1";
}

.fa-temperature-arrow-up {
  --fa: "\\e040";
}

.fa-temperature-up {
  --fa: "\\e040";
}

.fa-medal {
  --fa: "\\f5a2";
}

.fa-bed {
  --fa: "\\f236";
}

.fa-square-h {
  --fa: "\\f0fd";
}

.fa-h-square {
  --fa: "\\f0fd";
}

.fa-podcast {
  --fa: "\\f2ce";
}

.fa-temperature-full {
  --fa: "\\f2c7";
}

.fa-temperature-4 {
  --fa: "\\f2c7";
}

.fa-thermometer-4 {
  --fa: "\\f2c7";
}

.fa-thermometer-full {
  --fa: "\\f2c7";
}

.fa-bell {
  --fa: "\\f0f3";
}

.fa-superscript {
  --fa: "\\f12b";
}

.fa-plug-circle-xmark {
  --fa: "\\e560";
}

.fa-star-of-life {
  --fa: "\\f621";
}

.fa-phone-slash {
  --fa: "\\f3dd";
}

.fa-paint-roller {
  --fa: "\\f5aa";
}

.fa-handshake-angle {
  --fa: "\\f4c4";
}

.fa-hands-helping {
  --fa: "\\f4c4";
}

.fa-location-dot {
  --fa: "\\f3c5";
}

.fa-map-marker-alt {
  --fa: "\\f3c5";
}

.fa-file {
  --fa: "\\f15b";
}

.fa-greater-than {
  --fa: "\\>";
}

.fa-person-swimming {
  --fa: "\\f5c4";
}

.fa-swimmer {
  --fa: "\\f5c4";
}

.fa-arrow-down {
  --fa: "\\f063";
}

.fa-droplet {
  --fa: "\\f043";
}

.fa-tint {
  --fa: "\\f043";
}

.fa-eraser {
  --fa: "\\f12d";
}

.fa-earth-americas {
  --fa: "\\f57d";
}

.fa-earth {
  --fa: "\\f57d";
}

.fa-earth-america {
  --fa: "\\f57d";
}

.fa-globe-americas {
  --fa: "\\f57d";
}

.fa-person-burst {
  --fa: "\\e53b";
}

.fa-dove {
  --fa: "\\f4ba";
}

.fa-battery-empty {
  --fa: "\\f244";
}

.fa-battery-0 {
  --fa: "\\f244";
}

.fa-socks {
  --fa: "\\f696";
}

.fa-inbox {
  --fa: "\\f01c";
}

.fa-section {
  --fa: "\\e447";
}

.fa-gauge-high {
  --fa: "\\f625";
}

.fa-tachometer-alt {
  --fa: "\\f625";
}

.fa-tachometer-alt-fast {
  --fa: "\\f625";
}

.fa-envelope-open-text {
  --fa: "\\f658";
}

.fa-hospital {
  --fa: "\\f0f8";
}

.fa-hospital-alt {
  --fa: "\\f0f8";
}

.fa-hospital-wide {
  --fa: "\\f0f8";
}

.fa-wine-bottle {
  --fa: "\\f72f";
}

.fa-chess-rook {
  --fa: "\\f447";
}

.fa-bars-staggered {
  --fa: "\\f550";
}

.fa-reorder {
  --fa: "\\f550";
}

.fa-stream {
  --fa: "\\f550";
}

.fa-dharmachakra {
  --fa: "\\f655";
}

.fa-hotdog {
  --fa: "\\f80f";
}

.fa-person-walking-with-cane {
  --fa: "\\f29d";
}

.fa-blind {
  --fa: "\\f29d";
}

.fa-drum {
  --fa: "\\f569";
}

.fa-ice-cream {
  --fa: "\\f810";
}

.fa-heart-circle-bolt {
  --fa: "\\e4fc";
}

.fa-fax {
  --fa: "\\f1ac";
}

.fa-paragraph {
  --fa: "\\f1dd";
}

.fa-check-to-slot {
  --fa: "\\f772";
}

.fa-vote-yea {
  --fa: "\\f772";
}

.fa-star-half {
  --fa: "\\f089";
}

.fa-boxes-stacked {
  --fa: "\\f468";
}

.fa-boxes {
  --fa: "\\f468";
}

.fa-boxes-alt {
  --fa: "\\f468";
}

.fa-link {
  --fa: "\\f0c1";
}

.fa-chain {
  --fa: "\\f0c1";
}

.fa-ear-listen {
  --fa: "\\f2a2";
}

.fa-assistive-listening-systems {
  --fa: "\\f2a2";
}

.fa-tree-city {
  --fa: "\\e587";
}

.fa-play {
  --fa: "\\f04b";
}

.fa-font {
  --fa: "\\f031";
}

.fa-table-cells-row-lock {
  --fa: "\\e67a";
}

.fa-rupiah-sign {
  --fa: "\\e23d";
}

.fa-magnifying-glass {
  --fa: "\\f002";
}

.fa-search {
  --fa: "\\f002";
}

.fa-table-tennis-paddle-ball {
  --fa: "\\f45d";
}

.fa-ping-pong-paddle-ball {
  --fa: "\\f45d";
}

.fa-table-tennis {
  --fa: "\\f45d";
}

.fa-person-dots-from-line {
  --fa: "\\f470";
}

.fa-diagnoses {
  --fa: "\\f470";
}

.fa-trash-can-arrow-up {
  --fa: "\\f82a";
}

.fa-trash-restore-alt {
  --fa: "\\f82a";
}

.fa-naira-sign {
  --fa: "\\e1f6";
}

.fa-cart-arrow-down {
  --fa: "\\f218";
}

.fa-walkie-talkie {
  --fa: "\\f8ef";
}

.fa-file-pen {
  --fa: "\\f31c";
}

.fa-file-edit {
  --fa: "\\f31c";
}

.fa-receipt {
  --fa: "\\f543";
}

.fa-square-pen {
  --fa: "\\f14b";
}

.fa-pen-square {
  --fa: "\\f14b";
}

.fa-pencil-square {
  --fa: "\\f14b";
}

.fa-suitcase-rolling {
  --fa: "\\f5c1";
}

.fa-person-circle-exclamation {
  --fa: "\\e53f";
}

.fa-chevron-down {
  --fa: "\\f078";
}

.fa-battery-full {
  --fa: "\\f240";
}

.fa-battery {
  --fa: "\\f240";
}

.fa-battery-5 {
  --fa: "\\f240";
}

.fa-skull-crossbones {
  --fa: "\\f714";
}

.fa-code-compare {
  --fa: "\\e13a";
}

.fa-list-ul {
  --fa: "\\f0ca";
}

.fa-list-dots {
  --fa: "\\f0ca";
}

.fa-school-lock {
  --fa: "\\e56f";
}

.fa-tower-cell {
  --fa: "\\e585";
}

.fa-down-long {
  --fa: "\\f309";
}

.fa-long-arrow-alt-down {
  --fa: "\\f309";
}

.fa-ranking-star {
  --fa: "\\e561";
}

.fa-chess-king {
  --fa: "\\f43f";
}

.fa-person-harassing {
  --fa: "\\e549";
}

.fa-brazilian-real-sign {
  --fa: "\\e46c";
}

.fa-landmark-dome {
  --fa: "\\f752";
}

.fa-landmark-alt {
  --fa: "\\f752";
}

.fa-arrow-up {
  --fa: "\\f062";
}

.fa-tv {
  --fa: "\\f26c";
}

.fa-television {
  --fa: "\\f26c";
}

.fa-tv-alt {
  --fa: "\\f26c";
}

.fa-shrimp {
  --fa: "\\e448";
}

.fa-list-check {
  --fa: "\\f0ae";
}

.fa-tasks {
  --fa: "\\f0ae";
}

.fa-jug-detergent {
  --fa: "\\e519";
}

.fa-circle-user {
  --fa: "\\f2bd";
}

.fa-user-circle {
  --fa: "\\f2bd";
}

.fa-user-shield {
  --fa: "\\f505";
}

.fa-wind {
  --fa: "\\f72e";
}

.fa-car-burst {
  --fa: "\\f5e1";
}

.fa-car-crash {
  --fa: "\\f5e1";
}

.fa-y {
  --fa: "Y";
}

.fa-person-snowboarding {
  --fa: "\\f7ce";
}

.fa-snowboarding {
  --fa: "\\f7ce";
}

.fa-truck-fast {
  --fa: "\\f48b";
}

.fa-shipping-fast {
  --fa: "\\f48b";
}

.fa-fish {
  --fa: "\\f578";
}

.fa-user-graduate {
  --fa: "\\f501";
}

.fa-circle-half-stroke {
  --fa: "\\f042";
}

.fa-adjust {
  --fa: "\\f042";
}

.fa-clapperboard {
  --fa: "\\e131";
}

.fa-circle-radiation {
  --fa: "\\f7ba";
}

.fa-radiation-alt {
  --fa: "\\f7ba";
}

.fa-baseball {
  --fa: "\\f433";
}

.fa-baseball-ball {
  --fa: "\\f433";
}

.fa-jet-fighter-up {
  --fa: "\\e518";
}

.fa-diagram-project {
  --fa: "\\f542";
}

.fa-project-diagram {
  --fa: "\\f542";
}

.fa-copy {
  --fa: "\\f0c5";
}

.fa-volume-xmark {
  --fa: "\\f6a9";
}

.fa-volume-mute {
  --fa: "\\f6a9";
}

.fa-volume-times {
  --fa: "\\f6a9";
}

.fa-hand-sparkles {
  --fa: "\\e05d";
}

.fa-grip {
  --fa: "\\f58d";
}

.fa-grip-horizontal {
  --fa: "\\f58d";
}

.fa-share-from-square {
  --fa: "\\f14d";
}

.fa-share-square {
  --fa: "\\f14d";
}

.fa-child-combatant {
  --fa: "\\e4e0";
}

.fa-child-rifle {
  --fa: "\\e4e0";
}

.fa-gun {
  --fa: "\\e19b";
}

.fa-square-phone {
  --fa: "\\f098";
}

.fa-phone-square {
  --fa: "\\f098";
}

.fa-plus {
  --fa: "\\+";
}

.fa-add {
  --fa: "\\+";
}

.fa-expand {
  --fa: "\\f065";
}

.fa-computer {
  --fa: "\\e4e5";
}

.fa-xmark {
  --fa: "\\f00d";
}

.fa-close {
  --fa: "\\f00d";
}

.fa-multiply {
  --fa: "\\f00d";
}

.fa-remove {
  --fa: "\\f00d";
}

.fa-times {
  --fa: "\\f00d";
}

.fa-arrows-up-down-left-right {
  --fa: "\\f047";
}

.fa-arrows {
  --fa: "\\f047";
}

.fa-chalkboard-user {
  --fa: "\\f51c";
}

.fa-chalkboard-teacher {
  --fa: "\\f51c";
}

.fa-peso-sign {
  --fa: "\\e222";
}

.fa-building-shield {
  --fa: "\\e4d8";
}

.fa-baby {
  --fa: "\\f77c";
}

.fa-users-line {
  --fa: "\\e592";
}

.fa-quote-left {
  --fa: "\\f10d";
}

.fa-quote-left-alt {
  --fa: "\\f10d";
}

.fa-tractor {
  --fa: "\\f722";
}

.fa-trash-arrow-up {
  --fa: "\\f829";
}

.fa-trash-restore {
  --fa: "\\f829";
}

.fa-arrow-down-up-lock {
  --fa: "\\e4b0";
}

.fa-lines-leaning {
  --fa: "\\e51e";
}

.fa-ruler-combined {
  --fa: "\\f546";
}

.fa-copyright {
  --fa: "\\f1f9";
}

.fa-equals {
  --fa: "\\=";
}

.fa-blender {
  --fa: "\\f517";
}

.fa-teeth {
  --fa: "\\f62e";
}

.fa-shekel-sign {
  --fa: "\\f20b";
}

.fa-ils {
  --fa: "\\f20b";
}

.fa-shekel {
  --fa: "\\f20b";
}

.fa-sheqel {
  --fa: "\\f20b";
}

.fa-sheqel-sign {
  --fa: "\\f20b";
}

.fa-map {
  --fa: "\\f279";
}

.fa-rocket {
  --fa: "\\f135";
}

.fa-photo-film {
  --fa: "\\f87c";
}

.fa-photo-video {
  --fa: "\\f87c";
}

.fa-folder-minus {
  --fa: "\\f65d";
}

.fa-hexagon-nodes-bolt {
  --fa: "\\e69a";
}

.fa-store {
  --fa: "\\f54e";
}

.fa-arrow-trend-up {
  --fa: "\\e098";
}

.fa-plug-circle-minus {
  --fa: "\\e55e";
}

.fa-sign-hanging {
  --fa: "\\f4d9";
}

.fa-sign {
  --fa: "\\f4d9";
}

.fa-bezier-curve {
  --fa: "\\f55b";
}

.fa-bell-slash {
  --fa: "\\f1f6";
}

.fa-tablet {
  --fa: "\\f3fb";
}

.fa-tablet-android {
  --fa: "\\f3fb";
}

.fa-school-flag {
  --fa: "\\e56e";
}

.fa-fill {
  --fa: "\\f575";
}

.fa-angle-up {
  --fa: "\\f106";
}

.fa-drumstick-bite {
  --fa: "\\f6d7";
}

.fa-holly-berry {
  --fa: "\\f7aa";
}

.fa-chevron-left {
  --fa: "\\f053";
}

.fa-bacteria {
  --fa: "\\e059";
}

.fa-hand-lizard {
  --fa: "\\f258";
}

.fa-notdef {
  --fa: "\\e1fe";
}

.fa-disease {
  --fa: "\\f7fa";
}

.fa-briefcase-medical {
  --fa: "\\f469";
}

.fa-genderless {
  --fa: "\\f22d";
}

.fa-chevron-right {
  --fa: "\\f054";
}

.fa-retweet {
  --fa: "\\f079";
}

.fa-car-rear {
  --fa: "\\f5de";
}

.fa-car-alt {
  --fa: "\\f5de";
}

.fa-pump-soap {
  --fa: "\\e06b";
}

.fa-video-slash {
  --fa: "\\f4e2";
}

.fa-battery-quarter {
  --fa: "\\f243";
}

.fa-battery-2 {
  --fa: "\\f243";
}

.fa-radio {
  --fa: "\\f8d7";
}

.fa-baby-carriage {
  --fa: "\\f77d";
}

.fa-carriage-baby {
  --fa: "\\f77d";
}

.fa-traffic-light {
  --fa: "\\f637";
}

.fa-thermometer {
  --fa: "\\f491";
}

.fa-vr-cardboard {
  --fa: "\\f729";
}

.fa-hand-middle-finger {
  --fa: "\\f806";
}

.fa-percent {
  --fa: "\\%";
}

.fa-percentage {
  --fa: "\\%";
}

.fa-truck-moving {
  --fa: "\\f4df";
}

.fa-glass-water-droplet {
  --fa: "\\e4f5";
}

.fa-display {
  --fa: "\\e163";
}

.fa-face-smile {
  --fa: "\\f118";
}

.fa-smile {
  --fa: "\\f118";
}

.fa-thumbtack {
  --fa: "\\f08d";
}

.fa-thumb-tack {
  --fa: "\\f08d";
}

.fa-trophy {
  --fa: "\\f091";
}

.fa-person-praying {
  --fa: "\\f683";
}

.fa-pray {
  --fa: "\\f683";
}

.fa-hammer {
  --fa: "\\f6e3";
}

.fa-hand-peace {
  --fa: "\\f25b";
}

.fa-rotate {
  --fa: "\\f2f1";
}

.fa-sync-alt {
  --fa: "\\f2f1";
}

.fa-spinner {
  --fa: "\\f110";
}

.fa-robot {
  --fa: "\\f544";
}

.fa-peace {
  --fa: "\\f67c";
}

.fa-gears {
  --fa: "\\f085";
}

.fa-cogs {
  --fa: "\\f085";
}

.fa-warehouse {
  --fa: "\\f494";
}

.fa-arrow-up-right-dots {
  --fa: "\\e4b7";
}

.fa-splotch {
  --fa: "\\f5bc";
}

.fa-face-grin-hearts {
  --fa: "\\f584";
}

.fa-grin-hearts {
  --fa: "\\f584";
}

.fa-dice-four {
  --fa: "\\f524";
}

.fa-sim-card {
  --fa: "\\f7c4";
}

.fa-transgender {
  --fa: "\\f225";
}

.fa-transgender-alt {
  --fa: "\\f225";
}

.fa-mercury {
  --fa: "\\f223";
}

.fa-arrow-turn-down {
  --fa: "\\f149";
}

.fa-level-down {
  --fa: "\\f149";
}

.fa-person-falling-burst {
  --fa: "\\e547";
}

.fa-award {
  --fa: "\\f559";
}

.fa-ticket-simple {
  --fa: "\\f3ff";
}

.fa-ticket-alt {
  --fa: "\\f3ff";
}

.fa-building {
  --fa: "\\f1ad";
}

.fa-angles-left {
  --fa: "\\f100";
}

.fa-angle-double-left {
  --fa: "\\f100";
}

.fa-qrcode {
  --fa: "\\f029";
}

.fa-clock-rotate-left {
  --fa: "\\f1da";
}

.fa-history {
  --fa: "\\f1da";
}

.fa-face-grin-beam-sweat {
  --fa: "\\f583";
}

.fa-grin-beam-sweat {
  --fa: "\\f583";
}

.fa-file-export {
  --fa: "\\f56e";
}

.fa-arrow-right-from-file {
  --fa: "\\f56e";
}

.fa-shield {
  --fa: "\\f132";
}

.fa-shield-blank {
  --fa: "\\f132";
}

.fa-arrow-up-short-wide {
  --fa: "\\f885";
}

.fa-sort-amount-up-alt {
  --fa: "\\f885";
}

.fa-comment-nodes {
  --fa: "\\e696";
}

.fa-house-medical {
  --fa: "\\e3b2";
}

.fa-golf-ball-tee {
  --fa: "\\f450";
}

.fa-golf-ball {
  --fa: "\\f450";
}

.fa-circle-chevron-left {
  --fa: "\\f137";
}

.fa-chevron-circle-left {
  --fa: "\\f137";
}

.fa-house-chimney-window {
  --fa: "\\e00d";
}

.fa-pen-nib {
  --fa: "\\f5ad";
}

.fa-tent-arrow-turn-left {
  --fa: "\\e580";
}

.fa-tents {
  --fa: "\\e582";
}

.fa-wand-magic {
  --fa: "\\f0d0";
}

.fa-magic {
  --fa: "\\f0d0";
}

.fa-dog {
  --fa: "\\f6d3";
}

.fa-carrot {
  --fa: "\\f787";
}

.fa-moon {
  --fa: "\\f186";
}

.fa-wine-glass-empty {
  --fa: "\\f5ce";
}

.fa-wine-glass-alt {
  --fa: "\\f5ce";
}

.fa-cheese {
  --fa: "\\f7ef";
}

.fa-yin-yang {
  --fa: "\\f6ad";
}

.fa-music {
  --fa: "\\f001";
}

.fa-code-commit {
  --fa: "\\f386";
}

.fa-temperature-low {
  --fa: "\\f76b";
}

.fa-person-biking {
  --fa: "\\f84a";
}

.fa-biking {
  --fa: "\\f84a";
}

.fa-broom {
  --fa: "\\f51a";
}

.fa-shield-heart {
  --fa: "\\e574";
}

.fa-gopuram {
  --fa: "\\f664";
}

.fa-earth-oceania {
  --fa: "\\e47b";
}

.fa-globe-oceania {
  --fa: "\\e47b";
}

.fa-square-xmark {
  --fa: "\\f2d3";
}

.fa-times-square {
  --fa: "\\f2d3";
}

.fa-xmark-square {
  --fa: "\\f2d3";
}

.fa-hashtag {
  --fa: "\\#";
}

.fa-up-right-and-down-left-from-center {
  --fa: "\\f424";
}

.fa-expand-alt {
  --fa: "\\f424";
}

.fa-oil-can {
  --fa: "\\f613";
}

.fa-t {
  --fa: "T";
}

.fa-hippo {
  --fa: "\\f6ed";
}

.fa-chart-column {
  --fa: "\\e0e3";
}

.fa-infinity {
  --fa: "\\f534";
}

.fa-vial-circle-check {
  --fa: "\\e596";
}

.fa-person-arrow-down-to-line {
  --fa: "\\e538";
}

.fa-voicemail {
  --fa: "\\f897";
}

.fa-fan {
  --fa: "\\f863";
}

.fa-person-walking-luggage {
  --fa: "\\e554";
}

.fa-up-down {
  --fa: "\\f338";
}

.fa-arrows-alt-v {
  --fa: "\\f338";
}

.fa-cloud-moon-rain {
  --fa: "\\f73c";
}

.fa-calendar {
  --fa: "\\f133";
}

.fa-trailer {
  --fa: "\\e041";
}

.fa-bahai {
  --fa: "\\f666";
}

.fa-haykal {
  --fa: "\\f666";
}

.fa-sd-card {
  --fa: "\\f7c2";
}

.fa-dragon {
  --fa: "\\f6d5";
}

.fa-shoe-prints {
  --fa: "\\f54b";
}

.fa-circle-plus {
  --fa: "\\f055";
}

.fa-plus-circle {
  --fa: "\\f055";
}

.fa-face-grin-tongue-wink {
  --fa: "\\f58b";
}

.fa-grin-tongue-wink {
  --fa: "\\f58b";
}

.fa-hand-holding {
  --fa: "\\f4bd";
}

.fa-plug-circle-exclamation {
  --fa: "\\e55d";
}

.fa-link-slash {
  --fa: "\\f127";
}

.fa-chain-broken {
  --fa: "\\f127";
}

.fa-chain-slash {
  --fa: "\\f127";
}

.fa-unlink {
  --fa: "\\f127";
}

.fa-clone {
  --fa: "\\f24d";
}

.fa-person-walking-arrow-loop-left {
  --fa: "\\e551";
}

.fa-arrow-up-z-a {
  --fa: "\\f882";
}

.fa-sort-alpha-up-alt {
  --fa: "\\f882";
}

.fa-fire-flame-curved {
  --fa: "\\f7e4";
}

.fa-fire-alt {
  --fa: "\\f7e4";
}

.fa-tornado {
  --fa: "\\f76f";
}

.fa-file-circle-plus {
  --fa: "\\e494";
}

.fa-book-quran {
  --fa: "\\f687";
}

.fa-quran {
  --fa: "\\f687";
}

.fa-anchor {
  --fa: "\\f13d";
}

.fa-border-all {
  --fa: "\\f84c";
}

.fa-face-angry {
  --fa: "\\f556";
}

.fa-angry {
  --fa: "\\f556";
}

.fa-cookie-bite {
  --fa: "\\f564";
}

.fa-arrow-trend-down {
  --fa: "\\e097";
}

.fa-rss {
  --fa: "\\f09e";
}

.fa-feed {
  --fa: "\\f09e";
}

.fa-draw-polygon {
  --fa: "\\f5ee";
}

.fa-scale-balanced {
  --fa: "\\f24e";
}

.fa-balance-scale {
  --fa: "\\f24e";
}

.fa-gauge-simple-high {
  --fa: "\\f62a";
}

.fa-tachometer {
  --fa: "\\f62a";
}

.fa-tachometer-fast {
  --fa: "\\f62a";
}

.fa-shower {
  --fa: "\\f2cc";
}

.fa-desktop {
  --fa: "\\f390";
}

.fa-desktop-alt {
  --fa: "\\f390";
}

.fa-m {
  --fa: "M";
}

.fa-table-list {
  --fa: "\\f00b";
}

.fa-th-list {
  --fa: "\\f00b";
}

.fa-comment-sms {
  --fa: "\\f7cd";
}

.fa-sms {
  --fa: "\\f7cd";
}

.fa-book {
  --fa: "\\f02d";
}

.fa-user-plus {
  --fa: "\\f234";
}

.fa-check {
  --fa: "\\f00c";
}

.fa-battery-three-quarters {
  --fa: "\\f241";
}

.fa-battery-4 {
  --fa: "\\f241";
}

.fa-house-circle-check {
  --fa: "\\e509";
}

.fa-angle-left {
  --fa: "\\f104";
}

.fa-diagram-successor {
  --fa: "\\e47a";
}

.fa-truck-arrow-right {
  --fa: "\\e58b";
}

.fa-arrows-split-up-and-left {
  --fa: "\\e4bc";
}

.fa-hand-fist {
  --fa: "\\f6de";
}

.fa-fist-raised {
  --fa: "\\f6de";
}

.fa-cloud-moon {
  --fa: "\\f6c3";
}

.fa-briefcase {
  --fa: "\\f0b1";
}

.fa-person-falling {
  --fa: "\\e546";
}

.fa-image-portrait {
  --fa: "\\f3e0";
}

.fa-portrait {
  --fa: "\\f3e0";
}

.fa-user-tag {
  --fa: "\\f507";
}

.fa-rug {
  --fa: "\\e569";
}

.fa-earth-europe {
  --fa: "\\f7a2";
}

.fa-globe-europe {
  --fa: "\\f7a2";
}

.fa-cart-flatbed-suitcase {
  --fa: "\\f59d";
}

.fa-luggage-cart {
  --fa: "\\f59d";
}

.fa-rectangle-xmark {
  --fa: "\\f410";
}

.fa-rectangle-times {
  --fa: "\\f410";
}

.fa-times-rectangle {
  --fa: "\\f410";
}

.fa-window-close {
  --fa: "\\f410";
}

.fa-baht-sign {
  --fa: "\\e0ac";
}

.fa-book-open {
  --fa: "\\f518";
}

.fa-book-journal-whills {
  --fa: "\\f66a";
}

.fa-journal-whills {
  --fa: "\\f66a";
}

.fa-handcuffs {
  --fa: "\\e4f8";
}

.fa-triangle-exclamation {
  --fa: "\\f071";
}

.fa-exclamation-triangle {
  --fa: "\\f071";
}

.fa-warning {
  --fa: "\\f071";
}

.fa-database {
  --fa: "\\f1c0";
}

.fa-share {
  --fa: "\\f064";
}

.fa-mail-forward {
  --fa: "\\f064";
}

.fa-bottle-droplet {
  --fa: "\\e4c4";
}

.fa-mask-face {
  --fa: "\\e1d7";
}

.fa-hill-rockslide {
  --fa: "\\e508";
}

.fa-right-left {
  --fa: "\\f362";
}

.fa-exchange-alt {
  --fa: "\\f362";
}

.fa-paper-plane {
  --fa: "\\f1d8";
}

.fa-road-circle-exclamation {
  --fa: "\\e565";
}

.fa-dungeon {
  --fa: "\\f6d9";
}

.fa-align-right {
  --fa: "\\f038";
}

.fa-money-bill-1-wave {
  --fa: "\\f53b";
}

.fa-money-bill-wave-alt {
  --fa: "\\f53b";
}

.fa-life-ring {
  --fa: "\\f1cd";
}

.fa-hands {
  --fa: "\\f2a7";
}

.fa-sign-language {
  --fa: "\\f2a7";
}

.fa-signing {
  --fa: "\\f2a7";
}

.fa-calendar-day {
  --fa: "\\f783";
}

.fa-water-ladder {
  --fa: "\\f5c5";
}

.fa-ladder-water {
  --fa: "\\f5c5";
}

.fa-swimming-pool {
  --fa: "\\f5c5";
}

.fa-arrows-up-down {
  --fa: "\\f07d";
}

.fa-arrows-v {
  --fa: "\\f07d";
}

.fa-face-grimace {
  --fa: "\\f57f";
}

.fa-grimace {
  --fa: "\\f57f";
}

.fa-wheelchair-move {
  --fa: "\\e2ce";
}

.fa-wheelchair-alt {
  --fa: "\\e2ce";
}

.fa-turn-down {
  --fa: "\\f3be";
}

.fa-level-down-alt {
  --fa: "\\f3be";
}

.fa-person-walking-arrow-right {
  --fa: "\\e552";
}

.fa-square-envelope {
  --fa: "\\f199";
}

.fa-envelope-square {
  --fa: "\\f199";
}

.fa-dice {
  --fa: "\\f522";
}

.fa-bowling-ball {
  --fa: "\\f436";
}

.fa-brain {
  --fa: "\\f5dc";
}

.fa-bandage {
  --fa: "\\f462";
}

.fa-band-aid {
  --fa: "\\f462";
}

.fa-calendar-minus {
  --fa: "\\f272";
}

.fa-circle-xmark {
  --fa: "\\f057";
}

.fa-times-circle {
  --fa: "\\f057";
}

.fa-xmark-circle {
  --fa: "\\f057";
}

.fa-gifts {
  --fa: "\\f79c";
}

.fa-hotel {
  --fa: "\\f594";
}

.fa-earth-asia {
  --fa: "\\f57e";
}

.fa-globe-asia {
  --fa: "\\f57e";
}

.fa-id-card-clip {
  --fa: "\\f47f";
}

.fa-id-card-alt {
  --fa: "\\f47f";
}

.fa-magnifying-glass-plus {
  --fa: "\\f00e";
}

.fa-search-plus {
  --fa: "\\f00e";
}

.fa-thumbs-up {
  --fa: "\\f164";
}

.fa-user-clock {
  --fa: "\\f4fd";
}

.fa-hand-dots {
  --fa: "\\f461";
}

.fa-allergies {
  --fa: "\\f461";
}

.fa-file-invoice {
  --fa: "\\f570";
}

.fa-window-minimize {
  --fa: "\\f2d1";
}

.fa-mug-saucer {
  --fa: "\\f0f4";
}

.fa-coffee {
  --fa: "\\f0f4";
}

.fa-brush {
  --fa: "\\f55d";
}

.fa-file-half-dashed {
  --fa: "\\e698";
}

.fa-mask {
  --fa: "\\f6fa";
}

.fa-magnifying-glass-minus {
  --fa: "\\f010";
}

.fa-search-minus {
  --fa: "\\f010";
}

.fa-ruler-vertical {
  --fa: "\\f548";
}

.fa-user-large {
  --fa: "\\f406";
}

.fa-user-alt {
  --fa: "\\f406";
}

.fa-train-tram {
  --fa: "\\e5b4";
}

.fa-user-nurse {
  --fa: "\\f82f";
}

.fa-syringe {
  --fa: "\\f48e";
}

.fa-cloud-sun {
  --fa: "\\f6c4";
}

.fa-stopwatch-20 {
  --fa: "\\e06f";
}

.fa-square-full {
  --fa: "\\f45c";
}

.fa-magnet {
  --fa: "\\f076";
}

.fa-jar {
  --fa: "\\e516";
}

.fa-note-sticky {
  --fa: "\\f249";
}

.fa-sticky-note {
  --fa: "\\f249";
}

.fa-bug-slash {
  --fa: "\\e490";
}

.fa-arrow-up-from-water-pump {
  --fa: "\\e4b6";
}

.fa-bone {
  --fa: "\\f5d7";
}

.fa-table-cells-row-unlock {
  --fa: "\\e691";
}

.fa-user-injured {
  --fa: "\\f728";
}

.fa-face-sad-tear {
  --fa: "\\f5b4";
}

.fa-sad-tear {
  --fa: "\\f5b4";
}

.fa-plane {
  --fa: "\\f072";
}

.fa-tent-arrows-down {
  --fa: "\\e581";
}

.fa-exclamation {
  --fa: "\\!";
}

.fa-arrows-spin {
  --fa: "\\e4bb";
}

.fa-print {
  --fa: "\\f02f";
}

.fa-turkish-lira-sign {
  --fa: "\\e2bb";
}

.fa-try {
  --fa: "\\e2bb";
}

.fa-turkish-lira {
  --fa: "\\e2bb";
}

.fa-dollar-sign {
  --fa: "\\\$";
}

.fa-dollar {
  --fa: "\\\$";
}

.fa-usd {
  --fa: "\\\$";
}

.fa-x {
  --fa: "X";
}

.fa-magnifying-glass-dollar {
  --fa: "\\f688";
}

.fa-search-dollar {
  --fa: "\\f688";
}

.fa-users-gear {
  --fa: "\\f509";
}

.fa-users-cog {
  --fa: "\\f509";
}

.fa-person-military-pointing {
  --fa: "\\e54a";
}

.fa-building-columns {
  --fa: "\\f19c";
}

.fa-bank {
  --fa: "\\f19c";
}

.fa-institution {
  --fa: "\\f19c";
}

.fa-museum {
  --fa: "\\f19c";
}

.fa-university {
  --fa: "\\f19c";
}

.fa-umbrella {
  --fa: "\\f0e9";
}

.fa-trowel {
  --fa: "\\e589";
}

.fa-d {
  --fa: "D";
}

.fa-stapler {
  --fa: "\\e5af";
}

.fa-masks-theater {
  --fa: "\\f630";
}

.fa-theater-masks {
  --fa: "\\f630";
}

.fa-kip-sign {
  --fa: "\\e1c4";
}

.fa-hand-point-left {
  --fa: "\\f0a5";
}

.fa-handshake-simple {
  --fa: "\\f4c6";
}

.fa-handshake-alt {
  --fa: "\\f4c6";
}

.fa-jet-fighter {
  --fa: "\\f0fb";
}

.fa-fighter-jet {
  --fa: "\\f0fb";
}

.fa-square-share-nodes {
  --fa: "\\f1e1";
}

.fa-share-alt-square {
  --fa: "\\f1e1";
}

.fa-barcode {
  --fa: "\\f02a";
}

.fa-plus-minus {
  --fa: "\\e43c";
}

.fa-video {
  --fa: "\\f03d";
}

.fa-video-camera {
  --fa: "\\f03d";
}

.fa-graduation-cap {
  --fa: "\\f19d";
}

.fa-mortar-board {
  --fa: "\\f19d";
}

.fa-hand-holding-medical {
  --fa: "\\e05c";
}

.fa-person-circle-check {
  --fa: "\\e53e";
}

.fa-turn-up {
  --fa: "\\f3bf";
}

.fa-level-up-alt {
  --fa: "\\f3bf";
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-classic: 'Font Awesome 6 Free';
  --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Free';
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("truetype");
}
.far,
.fa-regular {
  font-weight: 400;
}

/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-classic: 'Font Awesome 6 Free';
  --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Free';
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("truetype");
}
.fas,
.fa-solid {
  font-weight: 900;
}

/*!
 * Bootstrap  v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: rgba(0, 0, 0, 0);
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(2.0392156863%, 17.2549019608%, 39.6862745098%);
  --bs-secondary-text-emphasis: rgb(16.9411764706%, 18.3529411765%, 19.6078431373%);
  --bs-success-text-emphasis: rgb(3.9215686275%, 21.1764705882%, 13.1764705882%);
  --bs-info-text-emphasis: rgb(2.0392156863%, 31.6862745098%, 37.6470588235%);
  --bs-warning-text-emphasis: rgb(40%, 30.2745098039%, 1.0980392157%);
  --bs-danger-text-emphasis: rgb(34.5098039216%, 8.3137254902%, 10.8235294118%);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);
  --bs-secondary-bg-subtle: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-success-bg-subtle: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);
  --bs-info-bg-subtle: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);
  --bs-warning-bg-subtle: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-danger-bg-subtle: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);
  --bs-light-bg-subtle: rgb(98.6274509804%, 98.8235294118%, 99.0196078431%);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(62.0392156863%, 77.2549019608%, 99.6862745098%);
  --bs-secondary-border-subtle: rgb(76.9411764706%, 78.3529411765%, 79.6078431373%);
  --bs-success-border-subtle: rgb(63.9215686275%, 81.1764705882%, 73.1764705882%);
  --bs-info-border-subtle: rgb(62.0392156863%, 91.6862745098%, 97.6470588235%);
  --bs-warning-border-subtle: rgb(100%, 90.2745098039%, 61.0980392157%);
  --bs-danger-border-subtle: rgb(94.5098039216%, 68.3137254902%, 70.8235294118%);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #f7f7f7;
  --bs-body-bg-rgb: 247, 247, 247;
  --bs-emphasis-color: rgba(0, 0, 0, 0);
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(16.6666666667%, 18.6274509804%, 20.5882352941%);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);
  --bs-secondary-text-emphasis: rgb(65.4117647059%, 67.5294117647%, 69.4117647059%);
  --bs-success-text-emphasis: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-info-text-emphasis: rgb(43.0588235294%, 87.5294117647%, 96.4705882353%);
  --bs-warning-text-emphasis: rgb(100%, 85.4117647059%, 41.6470588235%);
  --bs-danger-text-emphasis: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(1.0196078431%, 8.6274509804%, 19.8431372549%);
  --bs-secondary-bg-subtle: rgb(8.4705882353%, 9.1764705882%, 9.8039215686%);
  --bs-success-bg-subtle: rgb(1.9607843137%, 10.5882352941%, 6.5882352941%);
  --bs-info-bg-subtle: rgb(1.0196078431%, 15.8431372549%, 18.8235294118%);
  --bs-warning-bg-subtle: rgb(20%, 15.137254902%, 0.5490196078%);
  --bs-danger-bg-subtle: rgb(17.2549019608%, 4.1568627451%, 5.4117647059%);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: rgba(52, 58, 64, 0.5);
  --bs-primary-border-subtle: rgb(3.0588235294%, 25.8823529412%, 59.5294117647%);
  --bs-secondary-border-subtle: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  --bs-success-border-subtle: rgb(5.8823529412%, 31.7647058824%, 19.7647058824%);
  --bs-info-border-subtle: rgb(3.0588235294%, 47.5294117647%, 56.4705882353%);
  --bs-warning-border-subtle: rgb(60%, 45.4117647059%, 1.6470588235%);
  --bs-danger-border-subtle: rgb(51.7647058824%, 12.4705882353%, 16.2352941176%);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);
  --bs-link-hover-color: rgb(54.4470588235%, 72.7058823529%, 99.6235294118%);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(90.3529411765%, 52%, 71.0588235294%);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(40%, 30.2745098039%, 1.0980392157%);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-form-valid-border-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-form-invalid-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --bs-form-invalid-border-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #fff;
  --bs-table-bg: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);
  --bs-table-border-color: rgb(84.8156862745%, 90.9019607843%, 99.8745098039%);
  --bs-table-striped-bg: rgb(81.968627451%, 89.1960784314%, 99.8509803922%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(82.9176470588%, 89.7647058824%, 99.8588235294%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(82.4431372549%, 89.4803921569%, 99.8549019608%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #fff;
  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-table-border-color: rgb(90.7764705882%, 91.3411764706%, 91.8431372549%);
  --bs-table-striped-bg: rgb(89.0470588235%, 89.7176470588%, 90.3137254902%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(89.6235294118%, 90.2588235294%, 90.8235294118%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(89.3352941176%, 89.9882352941%, 90.568627451%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #fff;
  --bs-table-bg: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);
  --bs-table-border-color: rgb(85.568627451%, 92.4705882353%, 89.2705882353%);
  --bs-table-striped-bg: rgb(82.862745098%, 91.0588235294%, 87.2588235294%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(83.7647058824%, 91.5294117647%, 87.9294117647%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(83.3137254902%, 91.2941176471%, 87.5941176471%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #fff;
  --bs-table-bg: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);
  --bs-table-border-color: rgb(84.8156862745%, 96.6745098039%, 99.0588235294%);
  --bs-table-striped-bg: rgb(81.968627451%, 96.0509803922%, 98.8823529412%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(82.9176470588%, 96.2588235294%, 98.9411764706%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(82.4431372549%, 96.1549019608%, 98.9117647059%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #fff;
  --bs-table-bg: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-table-border-color: rgb(100%, 96.1098039216%, 84.4392156863%);
  --bs-table-striped-bg: rgb(100%, 95.3803921569%, 81.5215686275%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(100%, 95.6235294118%, 82.4941176471%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(100%, 95.5019607843%, 82.0078431373%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #fff;
  --bs-table-bg: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);
  --bs-table-border-color: rgb(97.8039215686%, 87.3254901961%, 88.3294117647%);
  --bs-table-striped-bg: rgb(97.3921568627%, 84.9490196078%, 86.1411764706%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(97.5294117647%, 85.7411764706%, 86.8705882353%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(97.4607843137%, 85.3450980392%, 86.5058823529%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #fff;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(97.8039215686%, 98.1176470588%, 98.431372549%);
  --bs-table-striped-bg: rgb(97.3921568627%, 97.7647058824%, 98.137254902%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(97.4607843137%, 97.8235294118%, 98.1862745098%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(30.3529411765%, 31.6078431373%, 32.862745098%);
  --bs-table-striped-bg: rgb(17.2941176471%, 18.7843137255%, 20.2745098039%);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(19.4705882353%, 20.9215686275%, 22.3725490196%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(52.5490196078%, 71.568627451%, 99.6078431373%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%2852.5490196078%, 71.568627451%, 99.6078431373%%29'/%3e%3c/svg%3e");
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f7f7f7, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f7f7f7, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(71.5294117647%, 82.9411764706%, 99.7647058824%);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(71.5294117647%, 82.9411764706%, 99.7647058824%);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(4.3333333333%, 36.6666666667%, 84.3333333333%);
  --bs-btn-hover-border-color: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(4.0784313725%, 34.5098039216%, 79.3725490196%);
  --bs-btn-active-border-color: rgb(3.8235294118%, 32.3529411765%, 74.4117647059%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(36%, 39%, 41.6666666667%);
  --bs-btn-hover-border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --bs-btn-active-border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(8.3333333333%, 45%, 28%);
  --bs-btn-hover-border-color: rgb(7.8431372549%, 42.3529411765%, 26.3529411765%);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(7.8431372549%, 42.3529411765%, 26.3529411765%);
  --bs-btn-active-border-color: rgb(7.3529411765%, 39.7058823529%, 24.7058823529%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(4.3333333333%, 67.3333333333%, 80%);
  --bs-btn-hover-border-color: rgb(4.0784313725%, 63.3725490196%, 75.2941176471%);
  --bs-btn-focus-shadow-rgb: 49, 210, 242;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(4.0784313725%, 63.3725490196%, 75.2941176471%);
  --bs-btn-active-border-color: rgb(3.8235294118%, 59.4117647059%, 70.5882352941%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(85%, 64.3333333333%, 2.3333333333%);
  --bs-btn-hover-border-color: rgb(80%, 60.5490196078%, 2.1960784314%);
  --bs-btn-focus-shadow-rgb: 255, 202, 44;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(80%, 60.5490196078%, 2.1960784314%);
  --bs-btn-active-border-color: rgb(75%, 56.7647058824%, 2.0588235294%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(73.3333333333%, 17.6666666667%, 23%);
  --bs-btn-hover-border-color: rgb(69.0196078431%, 16.6274509804%, 21.6470588235%);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(69.0196078431%, 16.6274509804%, 21.6470588235%);
  --bs-btn-active-border-color: rgb(64.7058823529%, 15.5882352941%, 20.2941176471%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(82.6666666667%, 83%, 83.3333333333%);
  --bs-btn-hover-border-color: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);
  --bs-btn-focus-shadow-rgb: 249, 250, 251;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.8039215686%, 78.1176470588%, 78.431372549%);
  --bs-btn-active-border-color: rgb(72.9411764706%, 73.2352941176%, 73.5294117647%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(26%, 27.3333333333%, 28.6666666667%);
  --bs-btn-hover-border-color: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(30.3529411765%, 31.6078431373%, 32.862745098%);
  --bs-btn-active-border-color: rgb(21.6470588235%, 23.0588235294%, 24.4705882353%);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgb%282.0392156863%, 17.2549019608%, 39.6862745098%%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e");
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e");
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: rgba(0, 0, 0, 0);
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: rgba(0, 0, 0, 0);
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: rgba(0, 0, 0, 0);
  --bs-carousel-caption-color: rgba(0, 0, 0, 0);
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: rgba(0, 0, 0, 0);
  --bs-carousel-caption-color: rgba(0, 0, 0, 0);
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, rgba(0, 0, 0, 0) 55%, rgba(0, 0, 0, 0.8) 75%, rgba(0, 0, 0, 0) 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #fff !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(10, 162, 192, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 162, 192, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(204, 154, 6, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 154, 6, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(198, 199, 200, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(198, 199, 200, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
* {
  font-family: "PremierLeague-Regular", serif;
}

iframe ::-webkit-scrollbar {
  width: 16px;
  background: transparent;
}

iframe::-webkit-scrollbar-track {
  background: transparent;
}

iframe::-webkit-scrollbar-thumb {
  background-color: #787878;
  border: 3px solid #f7f7f7;
  border-radius: 10px;
}

a {
  color: #000 !important;
  text-decoration: none !important;
}
a .anticon {
  vertical-align: middle;
}

.text-white {
  color: #fff;
}

.text-pink {
  color: #e2407e !important;
}

body,
html {
  height: 100vh;
  overflow-x: hidden;
  background: #f7f7f7 !important;
}

.full-height {
  height: 100vh;
}

.nav-logo {
  float: left;
}

.nav-bar {
  height: 130px;
  padding: 0 140px;
}

.ant-col {
  width: 100%;
}

.about-scrollable {
  height: 400px;
  padding-top: 24px;
  overflow-y: auto;
}

.login-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}), #37033c;
  background-repeat: no-repeat, no-repeat;
  background-position: right center;
  background-size: auto 75%;
}
.login-bg .logo {
  width: 200px;
  height: auto;
}
.login-bg h1, .login-bg .h1 {
  color: #fff;
  font-size: 34px;
  font-family: "PremierLeague-BoldItalic", serif;
  line-height: 46px;
  text-align: center;
}
.login-bg p {
  max-width: 480px;
  margin-bottom: 0 !important;
  color: #fff;
  font-size: 16px;
  font-family: "PremierLeague-Regular", serif;
  line-height: 22px;
  text-align: center;
}
.login-bg p a {
  color: #e2407e;
}
.login-bg .login_button_container {
  width: 56%;
}
.login-bg small, .login-bg .small {
  color: #fff;
  font-size: 12px;
  font-family: "PremierLeague-Regular", serif;
  line-height: 22px;
}

@media only screen and (max-width: 576px) {
  .login-bg .logo {
    width: 150px;
    height: auto;
  }
  .login-bg h1, .login-bg .h1 {
    font-size: 28px;
  }
  .login-bg p {
    font-size: 14px;
  }
  .login-bg .login_button_container {
    width: 89%;
  }
}
@media only screen and (min-width: 577px) and (max-width: 768px) {
  .login-bg .login_button_container {
    width: 64%;
  }
}
@media only screen and (max-width: 992px) {
  .login-bg {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_61___}), linear-gradient(140deg, #37033c 0%, #e2407e 100%) 0% 0%;
    background-repeat: no-repeat, no-repeat;
    background-position: bottom right;
    background-size: cover, contain;
  }
}
.card_shadow {
  width: 100%;
  margin-bottom: 32px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}

.card_shadow_posts {
  height: calc(100vh - 390px);
  margin-bottom: 16px;
  overflow: auto;
}
@media (max-width: 991.98px) {
  .card_shadow_posts {
    height: calc(50vh - 140px);
  }
}

h4, .h4 {
  font-size: 12px !important;
  font-family: PremierLeague-Bold, sans-serif;
}

.bold {
  font-weight: bold;
  font-family: PremierLeague-Bold, sans-serif;
}

.avatar-insight {
  float: right;
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
}

.avatar {
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.avatar .anticon {
  vertical-align: middle !important;
}

.anticon {
  vertical-align: 0 !important;
}

.avatar-initials {
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
  transition: 0.3s ease-in-out;
}
.avatar-initials .anticon {
  vertical-align: middle !important;
}

.ant-menu .anticon {
  width: 14px;
  height: 14px;
  vertical-align: middle;
}

.avatar:hover {
  transform: scale(1.02);
  opacity: 0.8;
  transition: 0.3s ease-in-out;
}

.avatar-insight:hover {
  transform: scale(1.02);
  opacity: 0.8;
  transition: 0.3s ease-in-out;
}

.first-avatar {
  margin-right: 5px !important;
}

@media only screen and (max-width: 1305px) {
  .first-avatar {
    margin-right: 0 !important;
    margin-bottom: 5px !important;
  }
}
@media (max-width: 991.98px) {
  .first-avatar {
    margin-right: 5px !important;
    margin-bottom: 0 !important;
  }
}
.text-right {
  text-align: right;
}

p:last-child {
  margin-bottom: 0 !important;
}

.font-fourteen {
  font-size: 12px;
}

.flex-flow {
  flex-direction: row !important;
  flex-flow: nowrap !important;
  justify-content: space-between;
}

.ant-row *::-webkit-scrollbar-track {
  background: white;
  border-radius: 10px;
}
.ant-row *::-webkit-scrollbar-thumb {
  border: 3px solid white;
  border-radius: 10px;
}

@media (max-width: 991.98px) {
  .article_meta {
    margin-top: 32px;
  }
}
.site_padding {
  padding-top: 26px;
}
@media (max-width: 991.98px) {
  .site_padding {
    padding-top: 10px;
  }
}

.ant-tabs-tabpane {
  padding: 20px;
  background-color: #f7f7f7;
}

.ant-tabs > .ant-tabs-nav,
.ant-tabs > div > .ant-tabs-nav {
  padding: 20px;
}

.ant-table-body {
  height: calc(100vh - 452px);
}
@media (max-width: 767.98px) {
  .ant-table-body {
    height: auto;
    max-height: calc(100vh - 415px) !important;
  }
}

.ant-table {
  font-size: 12px !important;
}

.ant-menu {
  font-size: 12px !important;
}

.ant-table-cell {
  padding: 13px 16px !important;
}

.font-12 {
  font-size: 12px !important;
}

.ant-form {
  font-size: 12px !important;
}

.ant-form label {
  font-size: 12px !important;
}

.ant-select-lg {
  font-size: 12px !important;
}

.ant-table .ant-table-thead .ant-table-column-sorters {
  padding: 0;
}

.ant-table-pagination.ant-pagination {
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.ant-table-pagination.ant-pagination .ant-pagination-item-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {
  margin: -13px -16px -16px 34px !important;
}

.max-height {
  max-height: calc(100vh - 530px);
  margin-bottom: 0;
  overflow: auto;
}

.about-tables {
  padding-right: 24px;
}

.ant-carousel {
  height: 100%;
}
.ant-carousel .slick-dots li {
  width: 10px !important;
}
.ant-carousel .slick-dots li button {
  width: 7px !important;
  height: 7px !important;
  background: rgba(0, 0, 0, 0.8) !important;
  border-radius: 100% !important;
}
.ant-carousel .slick-dots li.slick-active {
  width: 10px !important;
}
.ant-carousel .slick-dots li.slick-active button {
  width: 7px !important;
  height: 7px !important;
  background: #000 !important;
  border-radius: 100% !important;
}
.ant-carousel .slick-slider {
  height: 100%;
}
.ant-carousel .slick-dots-bottom {
  bottom: -38px !important;
}

.mce-preview-object {
  width: 100%;
}

h2, .h2 {
  font-size: 1.5rem !important;
}

.bg-purple {
  background-color: #490c4e !important;
}

.plcp-bg-height {
  height: calc(100vh - 60px);
}

.campaign-modal {
  width: 1000px !important;
  max-width: 800px !important;
}`, "",{"version":3,"sources":["webpack://./scss/app.scss","webpack://./scss/_fonts.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_core.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_sizing.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_mixins.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_fixed-width.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_variables.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_list.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_bordered-pulled.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_animated.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_rotated-flipped.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_stacked.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_icons.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_screen-reader.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/regular.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/solid.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./../../node_modules/bootstrap/scss/_root.scss","webpack://./../../node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./../../node_modules/bootstrap/scss/_reboot.scss","webpack://./../../node_modules/bootstrap/scss/_variables.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./../../node_modules/bootstrap/scss/_type.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./../../node_modules/bootstrap/scss/_images.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_image.scss","webpack://./../../node_modules/bootstrap/scss/_containers.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_container.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../../node_modules/bootstrap/scss/_grid.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./../../node_modules/bootstrap/scss/_tables.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./../../node_modules/bootstrap/scss/forms/_labels.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./../../node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./../../node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./../../node_modules/bootstrap/scss/_buttons.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./../../node_modules/bootstrap/scss/_transitions.scss","webpack://./../../node_modules/bootstrap/scss/_dropdown.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./../../node_modules/bootstrap/scss/_button-group.scss","webpack://./../../node_modules/bootstrap/scss/_nav.scss","webpack://./../../node_modules/bootstrap/scss/_navbar.scss","webpack://./../../node_modules/bootstrap/scss/_card.scss","webpack://./../../node_modules/bootstrap/scss/_accordion.scss","webpack://./../../node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./../../node_modules/bootstrap/scss/_pagination.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./../../node_modules/bootstrap/scss/_badge.scss","webpack://./../../node_modules/bootstrap/scss/_alert.scss","webpack://./../../node_modules/bootstrap/scss/_progress.scss","webpack://./../../node_modules/bootstrap/scss/_list-group.scss","webpack://./../../node_modules/bootstrap/scss/_close.scss","webpack://./../../node_modules/bootstrap/scss/_toasts.scss","webpack://./../../node_modules/bootstrap/scss/_modal.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./../../node_modules/bootstrap/scss/_tooltip.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./../../node_modules/bootstrap/scss/_popover.scss","webpack://./../../node_modules/bootstrap/scss/_carousel.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./../../node_modules/bootstrap/scss/_spinners.scss","webpack://./../../node_modules/bootstrap/scss/_offcanvas.scss","webpack://./scss/_variables.scss","webpack://./../../node_modules/bootstrap/scss/_placeholders.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_position.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./../../node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,oCAAA;EACA,4CAAA;EACA,uOAAA;ADEF;ACCA;EACE,kCAAA;EACA,4CAAA;EACA,uOAAA;ADCF;ACEA;EACE,iCAAA;EACA,4CAAA;EACA,yOAAA;ADAF;ACGA;EACE,sCAAA;EACA,6CAAA;EACA,2OAAA;ADDF;ACIA;EACE,qCAAA;EACA,6CAAA;EACA,2OAAA;ADFF;ACKA;EACE,mCAAA;EACA,6CAAA;EACA,2OAAA;ADHF;ACMA;EACE,oCAAA;EACA,6CAAA;EACA,2OAAA;ADJF;ACOA;EACE,uCAAA;EACA,6CAAA;EACA,2OAAA;ADLF;ACQA;EACE,kCAAA;EACA,6CAAA;EACA,2OAAA;ADNF;ACSA;EACE,oCAAA;EACA,6CAAA;EACA,2OAAA;ADPF;AElDA;;;;EAAA;ACGA;EACE,0DAAA;EACA,iCAAA;AHsDF;;AGnDA;;;;;;;EAOE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;AHsDF;;AGnDA;;;;;;;EAOE,kBAAA;AHsDF;;AGnDA;;;;;EAKE,kCAAA;AHsDF;;AGpDA;;EAEE,oCAAA;AHuDF;;AI7FE;EACE,cAAA;AJgGJ;;AIjGE;EACE,cAAA;AJoGJ;;AIrGE;EACE,cAAA;AJwGJ;;AIzGE;EACE,cAAA;AJ4GJ;;AI7GE;EACE,cAAA;AJgHJ;;AIjHE;EACE,cAAA;AJoHJ;;AIrHE;EACE,cAAA;AJwHJ;;AIzHE;EACE,cAAA;AJ4HJ;;AI7HE;EACE,cAAA;AJgIJ;;AIjIE;EACE,eAAA;AJoIJ;;AI9HE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;AL8HF;;AIpIE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;ALoIF;;AI1IE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;AL0IF;;AIhJE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;ALgJF;;AItJE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;ALsJF;;AI5JE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;AL4JF;;AM3KA;EACE,kBAAA;EACA,aCO0B;APuK5B;;AQhLA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;ARmLF;AQjLE;EAAO,kBAAA;ARoLT;;AQjLA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;ARoLF;;ASjMA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;AToMF;;ASjMA;EACE,WAAA;EACA,0CAAA;AToMF;;ASjMA;EACE,YAAA;EACA,yCAAA;AToMF;;AUnNA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AVsNF;;AUnNA;EACE,yBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,wFAAA;AVsNF;;AUnNA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AVsNF;;AUnNA;EACE,4BAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AVsNF;;AUnNA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AVsNF;;AUnNA;EACE,wBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AVsNF;;AUnNA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AVsNF;;AUnNA;EACE,iCAAA;AVsNF;;AUnNA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;AVsNF;;AUhNA;EACE;;;;;;;;;IASE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;EVmNF;AACF;AUhNA;EACE;IAAU,mBAAA;EVmNV;EUlNA;IAAM,4CAAA;EVqNN;AACF;AUnNA;EACE;IAAO,oCAAA;EVsNP;EUrNA;IAAO,wGAAA;EVwNP;EUvNA;IAAO,oIAAA;EV0NP;EUzNA;IAAO,wGAAA;EV4NP;EU3NA;IAAO,qEAAA;EV8NP;EU7NA;IAAO,oCAAA;EVgOP;EU/NA;IAAO,oCAAA;EVkOP;AACF;AUhOA;EACE;IAAM,oCAAA;EVmON;AACF;AUjOA;EACE;IACE,yCAAA;IACA,mBAAA;EVmOF;EUjOA;IACE,UAAA;IACA,kDAAA;EVmOF;AACF;AUhOA;EACE;IACE,iHAAA;EVkOF;AACF;AU/NA;EACE;IAAK,yBAAA;EVkOL;EUjOA;IAAK,wBAAA;EVoOL;EUnOA;IAAU,yBAAA;EVsOV;EUrOA;IAAW,wBAAA;EVwOX;EUvOA;IAAM,yBAAA;EV0ON;EUzOA;IAAM,wBAAA;EV4ON;EU3OA;IAAM,yBAAA;EV8ON;EU7OA;IAAM,wBAAA;EVgPN;EU/OA;IAAY,uBAAA;EVkPZ;AACF;AUhPA;EACE;IAAK,uBAAA;EVmPL;EUlPA;IAAO,yBAAA;EVqPP;AACF;AWzYA;EACE,wBAAA;AX2YF;;AWxYA;EACE,yBAAA;AX2YF;;AWxYA;EACE,yBAAA;AX2YF;;AWxYA;EACE,uBAAA;AX2YF;;AWxYA;EACE,uBAAA;AX2YF;;AWxYA;;EAEE,wBAAA;AX2YF;;AWxYA;EACE,4CAAA;AX2YF;;AYraA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLsC0B;EKrC1B,YLsC0B;APkY5B;;AYraA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;AZwaF;;AYraA;EACE,oBAAA;AZwaF;;AYraA;EACE,cAAA;AZwaF;;AYraA;EACE,8BAAA;AZwaF;;AancA;gEAAA;AAIE;EACE,YAAA;AbocJ;;AarcE;EACE,YAAA;AbwcJ;;AazcE;EACE,YAAA;Ab4cJ;;Aa7cE;EACE,YAAA;AbgdJ;;AajdE;EACE,YAAA;AbodJ;;AardE;EACE,YAAA;AbwdJ;;AazdE;EACE,YAAA;Ab4dJ;;Aa7dE;EACE,YAAA;AbgeJ;;AajeE;EACE,YAAA;AboeJ;;AareE;EACE,YAAA;AbweJ;;AazeE;EACE,aAAA;Ab4eJ;;Aa7eE;EACE,aAAA;AbgfJ;;AajfE;EACE,aAAA;AbofJ;;AarfE;EACE,aAAA;AbwfJ;;AazfE;EACE,UAAA;Ab4fJ;;Aa7fE;EACE,aAAA;AbggBJ;;AajgBE;EACE,aAAA;AbogBJ;;AargBE;EACE,aAAA;AbwgBJ;;AazgBE;EACE,aAAA;Ab4gBJ;;Aa7gBE;EACE,aAAA;AbghBJ;;AajhBE;EACE,aAAA;AbohBJ;;AarhBE;EACE,aAAA;AbwhBJ;;AazhBE;EACE,aAAA;Ab4hBJ;;Aa7hBE;EACE,aAAA;AbgiBJ;;AajiBE;EACE,aAAA;AboiBJ;;AariBE;EACE,aAAA;AbwiBJ;;AaziBE;EACE,aAAA;Ab4iBJ;;Aa7iBE;EACE,aAAA;AbgjBJ;;AajjBE;EACE,aAAA;AbojBJ;;AarjBE;EACE,aAAA;AbwjBJ;;AazjBE;EACE,aAAA;Ab4jBJ;;Aa7jBE;EACE,aAAA;AbgkBJ;;AajkBE;EACE,aAAA;AbokBJ;;AarkBE;EACE,aAAA;AbwkBJ;;AazkBE;EACE,aAAA;Ab4kBJ;;Aa7kBE;EACE,aAAA;AbglBJ;;AajlBE;EACE,aAAA;AbolBJ;;AarlBE;EACE,aAAA;AbwlBJ;;AazlBE;EACE,aAAA;Ab4lBJ;;Aa7lBE;EACE,aAAA;AbgmBJ;;AajmBE;EACE,aAAA;AbomBJ;;AarmBE;EACE,aAAA;AbwmBJ;;AazmBE;EACE,aAAA;Ab4mBJ;;Aa7mBE;EACE,aAAA;AbgnBJ;;AajnBE;EACE,aAAA;AbonBJ;;AarnBE;EACE,aAAA;AbwnBJ;;AaznBE;EACE,aAAA;Ab4nBJ;;Aa7nBE;EACE,aAAA;AbgoBJ;;AajoBE;EACE,aAAA;AbooBJ;;AaroBE;EACE,aAAA;AbwoBJ;;AazoBE;EACE,aAAA;Ab4oBJ;;Aa7oBE;EACE,aAAA;AbgpBJ;;AajpBE;EACE,aAAA;AbopBJ;;AarpBE;EACE,aAAA;AbwpBJ;;AazpBE;EACE,aAAA;Ab4pBJ;;Aa7pBE;EACE,aAAA;AbgqBJ;;AajqBE;EACE,aAAA;AboqBJ;;AarqBE;EACE,aAAA;AbwqBJ;;AazqBE;EACE,aAAA;Ab4qBJ;;Aa7qBE;EACE,aAAA;AbgrBJ;;AajrBE;EACE,aAAA;AborBJ;;AarrBE;EACE,aAAA;AbwrBJ;;AazrBE;EACE,aAAA;Ab4rBJ;;Aa7rBE;EACE,aAAA;AbgsBJ;;AajsBE;EACE,aAAA;AbosBJ;;AarsBE;EACE,aAAA;AbwsBJ;;AazsBE;EACE,aAAA;Ab4sBJ;;Aa7sBE;EACE,aAAA;AbgtBJ;;AajtBE;EACE,aAAA;AbotBJ;;AartBE;EACE,aAAA;AbwtBJ;;AaztBE;EACE,aAAA;Ab4tBJ;;Aa7tBE;EACE,aAAA;AbguBJ;;AajuBE;EACE,aAAA;AbouBJ;;AaruBE;EACE,aAAA;AbwuBJ;;AazuBE;EACE,aAAA;Ab4uBJ;;Aa7uBE;EACE,aAAA;AbgvBJ;;AajvBE;EACE,aAAA;AbovBJ;;AarvBE;EACE,aAAA;AbwvBJ;;AazvBE;EACE,aAAA;Ab4vBJ;;Aa7vBE;EACE,aAAA;AbgwBJ;;AajwBE;EACE,aAAA;AbowBJ;;AarwBE;EACE,aAAA;AbwwBJ;;AazwBE;EACE,aAAA;Ab4wBJ;;Aa7wBE;EACE,aAAA;AbgxBJ;;AajxBE;EACE,aAAA;AboxBJ;;AarxBE;EACE,aAAA;AbwxBJ;;AazxBE;EACE,aAAA;Ab4xBJ;;Aa7xBE;EACE,aAAA;AbgyBJ;;AajyBE;EACE,aAAA;AboyBJ;;AaryBE;EACE,aAAA;AbwyBJ;;AazyBE;EACE,aAAA;Ab4yBJ;;Aa7yBE;EACE,aAAA;AbgzBJ;;AajzBE;EACE,aAAA;AbozBJ;;AarzBE;EACE,aAAA;AbwzBJ;;AazzBE;EACE,aAAA;Ab4zBJ;;Aa7zBE;EACE,aAAA;Abg0BJ;;Aaj0BE;EACE,aAAA;Abo0BJ;;Aar0BE;EACE,aAAA;Abw0BJ;;Aaz0BE;EACE,aAAA;Ab40BJ;;Aa70BE;EACE,aAAA;Abg1BJ;;Aaj1BE;EACE,aAAA;Abo1BJ;;Aar1BE;EACE,aAAA;Abw1BJ;;Aaz1BE;EACE,aAAA;Ab41BJ;;Aa71BE;EACE,aAAA;Abg2BJ;;Aaj2BE;EACE,aAAA;Abo2BJ;;Aar2BE;EACE,aAAA;Abw2BJ;;Aaz2BE;EACE,SAAA;Ab42BJ;;Aa72BE;EACE,aAAA;Abg3BJ;;Aaj3BE;EACE,aAAA;Abo3BJ;;Aar3BE;EACE,aAAA;Abw3BJ;;Aaz3BE;EACE,aAAA;Ab43BJ;;Aa73BE;EACE,aAAA;Abg4BJ;;Aaj4BE;EACE,aAAA;Abo4BJ;;Aar4BE;EACE,aAAA;Abw4BJ;;Aaz4BE;EACE,aAAA;Ab44BJ;;Aa74BE;EACE,aAAA;Abg5BJ;;Aaj5BE;EACE,aAAA;Abo5BJ;;Aar5BE;EACE,aAAA;Abw5BJ;;Aaz5BE;EACE,aAAA;Ab45BJ;;Aa75BE;EACE,aAAA;Abg6BJ;;Aaj6BE;EACE,aAAA;Abo6BJ;;Aar6BE;EACE,aAAA;Abw6BJ;;Aaz6BE;EACE,aAAA;Ab46BJ;;Aa76BE;EACE,aAAA;Abg7BJ;;Aaj7BE;EACE,aAAA;Abo7BJ;;Aar7BE;EACE,aAAA;Abw7BJ;;Aaz7BE;EACE,aAAA;Ab47BJ;;Aa77BE;EACE,aAAA;Abg8BJ;;Aaj8BE;EACE,aAAA;Abo8BJ;;Aar8BE;EACE,aAAA;Abw8BJ;;Aaz8BE;EACE,aAAA;Ab48BJ;;Aa78BE;EACE,aAAA;Abg9BJ;;Aaj9BE;EACE,aAAA;Abo9BJ;;Aar9BE;EACE,aAAA;Abw9BJ;;Aaz9BE;EACE,aAAA;Ab49BJ;;Aa79BE;EACE,aAAA;Abg+BJ;;Aaj+BE;EACE,aAAA;Abo+BJ;;Aar+BE;EACE,aAAA;Abw+BJ;;Aaz+BE;EACE,aAAA;Ab4+BJ;;Aa7+BE;EACE,aAAA;Abg/BJ;;Aaj/BE;EACE,aAAA;Abo/BJ;;Aar/BE;EACE,SAAA;Abw/BJ;;Aaz/BE;EACE,aAAA;Ab4/BJ;;Aa7/BE;EACE,aAAA;AbggCJ;;AajgCE;EACE,aAAA;AbogCJ;;AargCE;EACE,aAAA;AbwgCJ;;AazgCE;EACE,aAAA;Ab4gCJ;;Aa7gCE;EACE,aAAA;AbghCJ;;AajhCE;EACE,aAAA;AbohCJ;;AarhCE;EACE,aAAA;AbwhCJ;;AazhCE;EACE,aAAA;Ab4hCJ;;Aa7hCE;EACE,aAAA;AbgiCJ;;AajiCE;EACE,aAAA;AboiCJ;;AariCE;EACE,aAAA;AbwiCJ;;AaziCE;EACE,aAAA;Ab4iCJ;;Aa7iCE;EACE,aAAA;AbgjCJ;;AajjCE;EACE,aAAA;AbojCJ;;AarjCE;EACE,aAAA;AbwjCJ;;AazjCE;EACE,aAAA;Ab4jCJ;;Aa7jCE;EACE,aAAA;AbgkCJ;;AajkCE;EACE,aAAA;AbokCJ;;AarkCE;EACE,aAAA;AbwkCJ;;AazkCE;EACE,aAAA;Ab4kCJ;;Aa7kCE;EACE,aAAA;AbglCJ;;AajlCE;EACE,aAAA;AbolCJ;;AarlCE;EACE,aAAA;AbwlCJ;;AazlCE;EACE,aAAA;Ab4lCJ;;Aa7lCE;EACE,aAAA;AbgmCJ;;AajmCE;EACE,aAAA;AbomCJ;;AarmCE;EACE,aAAA;AbwmCJ;;AazmCE;EACE,aAAA;Ab4mCJ;;Aa7mCE;EACE,aAAA;AbgnCJ;;AajnCE;EACE,aAAA;AbonCJ;;AarnCE;EACE,aAAA;AbwnCJ;;AaznCE;EACE,aAAA;Ab4nCJ;;Aa7nCE;EACE,aAAA;AbgoCJ;;AajoCE;EACE,aAAA;AbooCJ;;AaroCE;EACE,aAAA;AbwoCJ;;AazoCE;EACE,aAAA;Ab4oCJ;;Aa7oCE;EACE,aAAA;AbgpCJ;;AajpCE;EACE,aAAA;AbopCJ;;AarpCE;EACE,aAAA;AbwpCJ;;AazpCE;EACE,aAAA;Ab4pCJ;;Aa7pCE;EACE,aAAA;AbgqCJ;;AajqCE;EACE,aAAA;AboqCJ;;AarqCE;EACE,aAAA;AbwqCJ;;AazqCE;EACE,aAAA;Ab4qCJ;;Aa7qCE;EACE,aAAA;AbgrCJ;;AajrCE;EACE,aAAA;AborCJ;;AarrCE;EACE,aAAA;AbwrCJ;;AazrCE;EACE,aAAA;Ab4rCJ;;Aa7rCE;EACE,aAAA;AbgsCJ;;AajsCE;EACE,aAAA;AbosCJ;;AarsCE;EACE,aAAA;AbwsCJ;;AazsCE;EACE,aAAA;Ab4sCJ;;Aa7sCE;EACE,aAAA;AbgtCJ;;AajtCE;EACE,aAAA;AbotCJ;;AartCE;EACE,aAAA;AbwtCJ;;AaztCE;EACE,aAAA;Ab4tCJ;;Aa7tCE;EACE,aAAA;AbguCJ;;AajuCE;EACE,aAAA;AbouCJ;;AaruCE;EACE,aAAA;AbwuCJ;;AazuCE;EACE,aAAA;Ab4uCJ;;Aa7uCE;EACE,aAAA;AbgvCJ;;AajvCE;EACE,aAAA;AbovCJ;;AarvCE;EACE,aAAA;AbwvCJ;;AazvCE;EACE,aAAA;Ab4vCJ;;Aa7vCE;EACE,aAAA;AbgwCJ;;AajwCE;EACE,aAAA;AbowCJ;;AarwCE;EACE,aAAA;AbwwCJ;;AazwCE;EACE,aAAA;Ab4wCJ;;Aa7wCE;EACE,aAAA;AbgxCJ;;AajxCE;EACE,aAAA;AboxCJ;;AarxCE;EACE,aAAA;AbwxCJ;;AazxCE;EACE,aAAA;Ab4xCJ;;Aa7xCE;EACE,aAAA;AbgyCJ;;AajyCE;EACE,aAAA;AboyCJ;;AaryCE;EACE,aAAA;AbwyCJ;;AazyCE;EACE,aAAA;Ab4yCJ;;Aa7yCE;EACE,aAAA;AbgzCJ;;AajzCE;EACE,aAAA;AbozCJ;;AarzCE;EACE,aAAA;AbwzCJ;;AazzCE;EACE,aAAA;Ab4zCJ;;Aa7zCE;EACE,aAAA;Abg0CJ;;Aaj0CE;EACE,aAAA;Abo0CJ;;Aar0CE;EACE,aAAA;Abw0CJ;;Aaz0CE;EACE,aAAA;Ab40CJ;;Aa70CE;EACE,aAAA;Abg1CJ;;Aaj1CE;EACE,aAAA;Abo1CJ;;Aar1CE;EACE,aAAA;Abw1CJ;;Aaz1CE;EACE,aAAA;Ab41CJ;;Aa71CE;EACE,aAAA;Abg2CJ;;Aaj2CE;EACE,aAAA;Abo2CJ;;Aar2CE;EACE,aAAA;Abw2CJ;;Aaz2CE;EACE,aAAA;Ab42CJ;;Aa72CE;EACE,aAAA;Abg3CJ;;Aaj3CE;EACE,aAAA;Abo3CJ;;Aar3CE;EACE,aAAA;Abw3CJ;;Aaz3CE;EACE,aAAA;Ab43CJ;;Aa73CE;EACE,aAAA;Abg4CJ;;Aaj4CE;EACE,aAAA;Abo4CJ;;Aar4CE;EACE,UAAA;Abw4CJ;;Aaz4CE;EACE,aAAA;Ab44CJ;;Aa74CE;EACE,aAAA;Abg5CJ;;Aaj5CE;EACE,aAAA;Abo5CJ;;Aar5CE;EACE,aAAA;Abw5CJ;;Aaz5CE;EACE,aAAA;Ab45CJ;;Aa75CE;EACE,aAAA;Abg6CJ;;Aaj6CE;EACE,aAAA;Abo6CJ;;Aar6CE;EACE,aAAA;Abw6CJ;;Aaz6CE;EACE,aAAA;Ab46CJ;;Aa76CE;EACE,aAAA;Abg7CJ;;Aaj7CE;EACE,aAAA;Abo7CJ;;Aar7CE;EACE,aAAA;Abw7CJ;;Aaz7CE;EACE,aAAA;Ab47CJ;;Aa77CE;EACE,aAAA;Abg8CJ;;Aaj8CE;EACE,aAAA;Abo8CJ;;Aar8CE;EACE,aAAA;Abw8CJ;;Aaz8CE;EACE,aAAA;Ab48CJ;;Aa78CE;EACE,aAAA;Abg9CJ;;Aaj9CE;EACE,aAAA;Abo9CJ;;Aar9CE;EACE,aAAA;Abw9CJ;;Aaz9CE;EACE,aAAA;Ab49CJ;;Aa79CE;EACE,aAAA;Abg+CJ;;Aaj+CE;EACE,aAAA;Abo+CJ;;Aar+CE;EACE,aAAA;Abw+CJ;;Aaz+CE;EACE,aAAA;Ab4+CJ;;Aa7+CE;EACE,aAAA;Abg/CJ;;Aaj/CE;EACE,aAAA;Abo/CJ;;Aar/CE;EACE,aAAA;Abw/CJ;;Aaz/CE;EACE,aAAA;Ab4/CJ;;Aa7/CE;EACE,aAAA;AbggDJ;;AajgDE;EACE,aAAA;AbogDJ;;AargDE;EACE,aAAA;AbwgDJ;;AazgDE;EACE,aAAA;Ab4gDJ;;Aa7gDE;EACE,aAAA;AbghDJ;;AajhDE;EACE,aAAA;AbohDJ;;AarhDE;EACE,aAAA;AbwhDJ;;AazhDE;EACE,aAAA;Ab4hDJ;;Aa7hDE;EACE,aAAA;AbgiDJ;;AajiDE;EACE,aAAA;AboiDJ;;AariDE;EACE,aAAA;AbwiDJ;;AaziDE;EACE,aAAA;Ab4iDJ;;Aa7iDE;EACE,aAAA;AbgjDJ;;AajjDE;EACE,aAAA;AbojDJ;;AarjDE;EACE,aAAA;AbwjDJ;;AazjDE;EACE,aAAA;Ab4jDJ;;Aa7jDE;EACE,aAAA;AbgkDJ;;AajkDE;EACE,aAAA;AbokDJ;;AarkDE;EACE,aAAA;AbwkDJ;;AazkDE;EACE,aAAA;Ab4kDJ;;Aa7kDE;EACE,aAAA;AbglDJ;;AajlDE;EACE,aAAA;AbolDJ;;AarlDE;EACE,aAAA;AbwlDJ;;AazlDE;EACE,aAAA;Ab4lDJ;;Aa7lDE;EACE,aAAA;AbgmDJ;;AajmDE;EACE,aAAA;AbomDJ;;AarmDE;EACE,aAAA;AbwmDJ;;AazmDE;EACE,aAAA;Ab4mDJ;;Aa7mDE;EACE,aAAA;AbgnDJ;;AajnDE;EACE,aAAA;AbonDJ;;AarnDE;EACE,aAAA;AbwnDJ;;AaznDE;EACE,aAAA;Ab4nDJ;;Aa7nDE;EACE,aAAA;AbgoDJ;;AajoDE;EACE,aAAA;AbooDJ;;AaroDE;EACE,aAAA;AbwoDJ;;AazoDE;EACE,aAAA;Ab4oDJ;;Aa7oDE;EACE,aAAA;AbgpDJ;;AajpDE;EACE,aAAA;AbopDJ;;AarpDE;EACE,aAAA;AbwpDJ;;AazpDE;EACE,aAAA;Ab4pDJ;;Aa7pDE;EACE,aAAA;AbgqDJ;;AajqDE;EACE,aAAA;AboqDJ;;AarqDE;EACE,aAAA;AbwqDJ;;AazqDE;EACE,aAAA;Ab4qDJ;;Aa7qDE;EACE,aAAA;AbgrDJ;;AajrDE;EACE,aAAA;AborDJ;;AarrDE;EACE,aAAA;AbwrDJ;;AazrDE;EACE,aAAA;Ab4rDJ;;Aa7rDE;EACE,aAAA;AbgsDJ;;AajsDE;EACE,aAAA;AbosDJ;;AarsDE;EACE,aAAA;AbwsDJ;;AazsDE;EACE,aAAA;Ab4sDJ;;Aa7sDE;EACE,aAAA;AbgtDJ;;AajtDE;EACE,aAAA;AbotDJ;;AartDE;EACE,aAAA;AbwtDJ;;AaztDE;EACE,SAAA;Ab4tDJ;;Aa7tDE;EACE,aAAA;AbguDJ;;AajuDE;EACE,aAAA;AbouDJ;;AaruDE;EACE,aAAA;AbwuDJ;;AazuDE;EACE,aAAA;Ab4uDJ;;Aa7uDE;EACE,aAAA;AbgvDJ;;AajvDE;EACE,aAAA;AbovDJ;;AarvDE;EACE,SAAA;AbwvDJ;;AazvDE;EACE,aAAA;Ab4vDJ;;Aa7vDE;EACE,aAAA;AbgwDJ;;AajwDE;EACE,aAAA;AbowDJ;;AarwDE;EACE,aAAA;AbwwDJ;;AazwDE;EACE,aAAA;Ab4wDJ;;Aa7wDE;EACE,aAAA;AbgxDJ;;AajxDE;EACE,aAAA;AboxDJ;;AarxDE;EACE,aAAA;AbwxDJ;;AazxDE;EACE,aAAA;Ab4xDJ;;Aa7xDE;EACE,aAAA;AbgyDJ;;AajyDE;EACE,aAAA;AboyDJ;;AaryDE;EACE,aAAA;AbwyDJ;;AazyDE;EACE,aAAA;Ab4yDJ;;Aa7yDE;EACE,aAAA;AbgzDJ;;AajzDE;EACE,aAAA;AbozDJ;;AarzDE;EACE,aAAA;AbwzDJ;;AazzDE;EACE,aAAA;Ab4zDJ;;Aa7zDE;EACE,aAAA;Abg0DJ;;Aaj0DE;EACE,SAAA;Abo0DJ;;Aar0DE;EACE,SAAA;Abw0DJ;;Aaz0DE;EACE,aAAA;Ab40DJ;;Aa70DE;EACE,aAAA;Abg1DJ;;Aaj1DE;EACE,aAAA;Abo1DJ;;Aar1DE;EACE,aAAA;Abw1DJ;;Aaz1DE;EACE,aAAA;Ab41DJ;;Aa71DE;EACE,aAAA;Abg2DJ;;Aaj2DE;EACE,aAAA;Abo2DJ;;Aar2DE;EACE,aAAA;Abw2DJ;;Aaz2DE;EACE,aAAA;Ab42DJ;;Aa72DE;EACE,aAAA;Abg3DJ;;Aaj3DE;EACE,aAAA;Abo3DJ;;Aar3DE;EACE,aAAA;Abw3DJ;;Aaz3DE;EACE,aAAA;Ab43DJ;;Aa73DE;EACE,aAAA;Abg4DJ;;Aaj4DE;EACE,aAAA;Abo4DJ;;Aar4DE;EACE,aAAA;Abw4DJ;;Aaz4DE;EACE,aAAA;Ab44DJ;;Aa74DE;EACE,aAAA;Abg5DJ;;Aaj5DE;EACE,aAAA;Abo5DJ;;Aar5DE;EACE,aAAA;Abw5DJ;;Aaz5DE;EACE,aAAA;Ab45DJ;;Aa75DE;EACE,aAAA;Abg6DJ;;Aaj6DE;EACE,aAAA;Abo6DJ;;Aar6DE;EACE,aAAA;Abw6DJ;;Aaz6DE;EACE,aAAA;Ab46DJ;;Aa76DE;EACE,aAAA;Abg7DJ;;Aaj7DE;EACE,aAAA;Abo7DJ;;Aar7DE;EACE,aAAA;Abw7DJ;;Aaz7DE;EACE,aAAA;Ab47DJ;;Aa77DE;EACE,aAAA;Abg8DJ;;Aaj8DE;EACE,aAAA;Abo8DJ;;Aar8DE;EACE,aAAA;Abw8DJ;;Aaz8DE;EACE,aAAA;Ab48DJ;;Aa78DE;EACE,aAAA;Abg9DJ;;Aaj9DE;EACE,aAAA;Abo9DJ;;Aar9DE;EACE,SAAA;Abw9DJ;;Aaz9DE;EACE,aAAA;Ab49DJ;;Aa79DE;EACE,aAAA;Abg+DJ;;Aaj+DE;EACE,aAAA;Abo+DJ;;Aar+DE;EACE,aAAA;Abw+DJ;;Aaz+DE;EACE,aAAA;Ab4+DJ;;Aa7+DE;EACE,aAAA;Abg/DJ;;Aaj/DE;EACE,aAAA;Abo/DJ;;Aar/DE;EACE,aAAA;Abw/DJ;;Aaz/DE;EACE,aAAA;Ab4/DJ;;Aa7/DE;EACE,aAAA;AbggEJ;;AajgEE;EACE,aAAA;AbogEJ;;AargEE;EACE,aAAA;AbwgEJ;;AazgEE;EACE,aAAA;Ab4gEJ;;Aa7gEE;EACE,aAAA;AbghEJ;;AajhEE;EACE,aAAA;AbohEJ;;AarhEE;EACE,aAAA;AbwhEJ;;AazhEE;EACE,aAAA;Ab4hEJ;;Aa7hEE;EACE,aAAA;AbgiEJ;;AajiEE;EACE,aAAA;AboiEJ;;AariEE;EACE,SAAA;AbwiEJ;;AaziEE;EACE,aAAA;Ab4iEJ;;Aa7iEE;EACE,aAAA;AbgjEJ;;AajjEE;EACE,aAAA;AbojEJ;;AarjEE;EACE,aAAA;AbwjEJ;;AazjEE;EACE,aAAA;Ab4jEJ;;Aa7jEE;EACE,aAAA;AbgkEJ;;AajkEE;EACE,aAAA;AbokEJ;;AarkEE;EACE,aAAA;AbwkEJ;;AazkEE;EACE,aAAA;Ab4kEJ;;Aa7kEE;EACE,aAAA;AbglEJ;;AajlEE;EACE,aAAA;AbolEJ;;AarlEE;EACE,aAAA;AbwlEJ;;AazlEE;EACE,aAAA;Ab4lEJ;;Aa7lEE;EACE,aAAA;AbgmEJ;;AajmEE;EACE,aAAA;AbomEJ;;AarmEE;EACE,aAAA;AbwmEJ;;AazmEE;EACE,aAAA;Ab4mEJ;;Aa7mEE;EACE,aAAA;AbgnEJ;;AajnEE;EACE,aAAA;AbonEJ;;AarnEE;EACE,aAAA;AbwnEJ;;AaznEE;EACE,aAAA;Ab4nEJ;;Aa7nEE;EACE,aAAA;AbgoEJ;;AajoEE;EACE,aAAA;AbooEJ;;AaroEE;EACE,aAAA;AbwoEJ;;AazoEE;EACE,aAAA;Ab4oEJ;;Aa7oEE;EACE,aAAA;AbgpEJ;;AajpEE;EACE,aAAA;AbopEJ;;AarpEE;EACE,aAAA;AbwpEJ;;AazpEE;EACE,aAAA;Ab4pEJ;;Aa7pEE;EACE,aAAA;AbgqEJ;;AajqEE;EACE,aAAA;AboqEJ;;AarqEE;EACE,aAAA;AbwqEJ;;AazqEE;EACE,aAAA;Ab4qEJ;;Aa7qEE;EACE,aAAA;AbgrEJ;;AajrEE;EACE,aAAA;AborEJ;;AarrEE;EACE,aAAA;AbwrEJ;;AazrEE;EACE,aAAA;Ab4rEJ;;Aa7rEE;EACE,aAAA;AbgsEJ;;AajsEE;EACE,aAAA;AbosEJ;;AarsEE;EACE,aAAA;AbwsEJ;;AazsEE;EACE,aAAA;Ab4sEJ;;Aa7sEE;EACE,aAAA;AbgtEJ;;AajtEE;EACE,aAAA;AbotEJ;;AartEE;EACE,aAAA;AbwtEJ;;AaztEE;EACE,aAAA;Ab4tEJ;;Aa7tEE;EACE,aAAA;AbguEJ;;AajuEE;EACE,aAAA;AbouEJ;;AaruEE;EACE,aAAA;AbwuEJ;;AazuEE;EACE,aAAA;Ab4uEJ;;Aa7uEE;EACE,aAAA;AbgvEJ;;AajvEE;EACE,aAAA;AbovEJ;;AarvEE;EACE,aAAA;AbwvEJ;;AazvEE;EACE,aAAA;Ab4vEJ;;Aa7vEE;EACE,aAAA;AbgwEJ;;AajwEE;EACE,aAAA;AbowEJ;;AarwEE;EACE,aAAA;AbwwEJ;;AazwEE;EACE,aAAA;Ab4wEJ;;Aa7wEE;EACE,aAAA;AbgxEJ;;AajxEE;EACE,aAAA;AboxEJ;;AarxEE;EACE,aAAA;AbwxEJ;;AazxEE;EACE,aAAA;Ab4xEJ;;Aa7xEE;EACE,aAAA;AbgyEJ;;AajyEE;EACE,aAAA;AboyEJ;;AaryEE;EACE,aAAA;AbwyEJ;;AazyEE;EACE,aAAA;Ab4yEJ;;Aa7yEE;EACE,aAAA;AbgzEJ;;AajzEE;EACE,aAAA;AbozEJ;;AarzEE;EACE,aAAA;AbwzEJ;;AazzEE;EACE,aAAA;Ab4zEJ;;Aa7zEE;EACE,aAAA;Abg0EJ;;Aaj0EE;EACE,aAAA;Abo0EJ;;Aar0EE;EACE,aAAA;Abw0EJ;;Aaz0EE;EACE,aAAA;Ab40EJ;;Aa70EE;EACE,aAAA;Abg1EJ;;Aaj1EE;EACE,aAAA;Abo1EJ;;Aar1EE;EACE,aAAA;Abw1EJ;;Aaz1EE;EACE,aAAA;Ab41EJ;;Aa71EE;EACE,aAAA;Abg2EJ;;Aaj2EE;EACE,aAAA;Abo2EJ;;Aar2EE;EACE,aAAA;Abw2EJ;;Aaz2EE;EACE,aAAA;Ab42EJ;;Aa72EE;EACE,aAAA;Abg3EJ;;Aaj3EE;EACE,aAAA;Abo3EJ;;Aar3EE;EACE,SAAA;Abw3EJ;;Aaz3EE;EACE,aAAA;Ab43EJ;;Aa73EE;EACE,aAAA;Abg4EJ;;Aaj4EE;EACE,aAAA;Abo4EJ;;Aar4EE;EACE,aAAA;Abw4EJ;;Aaz4EE;EACE,aAAA;Ab44EJ;;Aa74EE;EACE,aAAA;Abg5EJ;;Aaj5EE;EACE,aAAA;Abo5EJ;;Aar5EE;EACE,aAAA;Abw5EJ;;Aaz5EE;EACE,aAAA;Ab45EJ;;Aa75EE;EACE,aAAA;Abg6EJ;;Aaj6EE;EACE,aAAA;Abo6EJ;;Aar6EE;EACE,aAAA;Abw6EJ;;Aaz6EE;EACE,aAAA;Ab46EJ;;Aa76EE;EACE,aAAA;Abg7EJ;;Aaj7EE;EACE,aAAA;Abo7EJ;;Aar7EE;EACE,aAAA;Abw7EJ;;Aaz7EE;EACE,aAAA;Ab47EJ;;Aa77EE;EACE,aAAA;Abg8EJ;;Aaj8EE;EACE,aAAA;Abo8EJ;;Aar8EE;EACE,aAAA;Abw8EJ;;Aaz8EE;EACE,aAAA;Ab48EJ;;Aa78EE;EACE,aAAA;Abg9EJ;;Aaj9EE;EACE,aAAA;Abo9EJ;;Aar9EE;EACE,aAAA;Abw9EJ;;Aaz9EE;EACE,aAAA;Ab49EJ;;Aa79EE;EACE,aAAA;Abg+EJ;;Aaj+EE;EACE,aAAA;Abo+EJ;;Aar+EE;EACE,aAAA;Abw+EJ;;Aaz+EE;EACE,aAAA;Ab4+EJ;;Aa7+EE;EACE,aAAA;Abg/EJ;;Aaj/EE;EACE,aAAA;Abo/EJ;;Aar/EE;EACE,aAAA;Abw/EJ;;Aaz/EE;EACE,aAAA;Ab4/EJ;;Aa7/EE;EACE,aAAA;AbggFJ;;AajgFE;EACE,aAAA;AbogFJ;;AargFE;EACE,aAAA;AbwgFJ;;AazgFE;EACE,aAAA;Ab4gFJ;;Aa7gFE;EACE,aAAA;AbghFJ;;AajhFE;EACE,aAAA;AbohFJ;;AarhFE;EACE,aAAA;AbwhFJ;;AazhFE;EACE,aAAA;Ab4hFJ;;Aa7hFE;EACE,aAAA;AbgiFJ;;AajiFE;EACE,aAAA;AboiFJ;;AariFE;EACE,aAAA;AbwiFJ;;AaziFE;EACE,aAAA;Ab4iFJ;;Aa7iFE;EACE,aAAA;AbgjFJ;;AajjFE;EACE,aAAA;AbojFJ;;AarjFE;EACE,aAAA;AbwjFJ;;AazjFE;EACE,aAAA;Ab4jFJ;;Aa7jFE;EACE,aAAA;AbgkFJ;;AajkFE;EACE,aAAA;AbokFJ;;AarkFE;EACE,aAAA;AbwkFJ;;AazkFE;EACE,aAAA;Ab4kFJ;;Aa7kFE;EACE,aAAA;AbglFJ;;AajlFE;EACE,aAAA;AbolFJ;;AarlFE;EACE,aAAA;AbwlFJ;;AazlFE;EACE,aAAA;Ab4lFJ;;Aa7lFE;EACE,aAAA;AbgmFJ;;AajmFE;EACE,aAAA;AbomFJ;;AarmFE;EACE,aAAA;AbwmFJ;;AazmFE;EACE,aAAA;Ab4mFJ;;Aa7mFE;EACE,aAAA;AbgnFJ;;AajnFE;EACE,aAAA;AbonFJ;;AarnFE;EACE,aAAA;AbwnFJ;;AaznFE;EACE,aAAA;Ab4nFJ;;Aa7nFE;EACE,aAAA;AbgoFJ;;AajoFE;EACE,aAAA;AbooFJ;;AaroFE;EACE,aAAA;AbwoFJ;;AazoFE;EACE,aAAA;Ab4oFJ;;Aa7oFE;EACE,aAAA;AbgpFJ;;AajpFE;EACE,aAAA;AbopFJ;;AarpFE;EACE,aAAA;AbwpFJ;;AazpFE;EACE,aAAA;Ab4pFJ;;Aa7pFE;EACE,aAAA;AbgqFJ;;AajqFE;EACE,aAAA;AboqFJ;;AarqFE;EACE,aAAA;AbwqFJ;;AazqFE;EACE,aAAA;Ab4qFJ;;Aa7qFE;EACE,aAAA;AbgrFJ;;AajrFE;EACE,aAAA;AborFJ;;AarrFE;EACE,aAAA;AbwrFJ;;AazrFE;EACE,aAAA;Ab4rFJ;;Aa7rFE;EACE,aAAA;AbgsFJ;;AajsFE;EACE,aAAA;AbosFJ;;AarsFE;EACE,aAAA;AbwsFJ;;AazsFE;EACE,aAAA;Ab4sFJ;;Aa7sFE;EACE,aAAA;AbgtFJ;;AajtFE;EACE,aAAA;AbotFJ;;AartFE;EACE,aAAA;AbwtFJ;;AaztFE;EACE,aAAA;Ab4tFJ;;Aa7tFE;EACE,aAAA;AbguFJ;;AajuFE;EACE,aAAA;AbouFJ;;AaruFE;EACE,aAAA;AbwuFJ;;AazuFE;EACE,aAAA;Ab4uFJ;;Aa7uFE;EACE,aAAA;AbgvFJ;;AajvFE;EACE,aAAA;AbovFJ;;AarvFE;EACE,aAAA;AbwvFJ;;AazvFE;EACE,aAAA;Ab4vFJ;;Aa7vFE;EACE,aAAA;AbgwFJ;;AajwFE;EACE,aAAA;AbowFJ;;AarwFE;EACE,aAAA;AbwwFJ;;AazwFE;EACE,aAAA;Ab4wFJ;;Aa7wFE;EACE,aAAA;AbgxFJ;;AajxFE;EACE,aAAA;AboxFJ;;AarxFE;EACE,aAAA;AbwxFJ;;AazxFE;EACE,aAAA;Ab4xFJ;;Aa7xFE;EACE,aAAA;AbgyFJ;;AajyFE;EACE,aAAA;AboyFJ;;AaryFE;EACE,aAAA;AbwyFJ;;AazyFE;EACE,aAAA;Ab4yFJ;;Aa7yFE;EACE,aAAA;AbgzFJ;;AajzFE;EACE,aAAA;AbozFJ;;AarzFE;EACE,aAAA;AbwzFJ;;AazzFE;EACE,aAAA;Ab4zFJ;;Aa7zFE;EACE,aAAA;Abg0FJ;;Aaj0FE;EACE,aAAA;Abo0FJ;;Aar0FE;EACE,aAAA;Abw0FJ;;Aaz0FE;EACE,aAAA;Ab40FJ;;Aa70FE;EACE,aAAA;Abg1FJ;;Aaj1FE;EACE,aAAA;Abo1FJ;;Aar1FE;EACE,aAAA;Abw1FJ;;Aaz1FE;EACE,aAAA;Ab41FJ;;Aa71FE;EACE,aAAA;Abg2FJ;;Aaj2FE;EACE,aAAA;Abo2FJ;;Aar2FE;EACE,aAAA;Abw2FJ;;Aaz2FE;EACE,aAAA;Ab42FJ;;Aa72FE;EACE,aAAA;Abg3FJ;;Aaj3FE;EACE,aAAA;Abo3FJ;;Aar3FE;EACE,aAAA;Abw3FJ;;Aaz3FE;EACE,aAAA;Ab43FJ;;Aa73FE;EACE,aAAA;Abg4FJ;;Aaj4FE;EACE,aAAA;Abo4FJ;;Aar4FE;EACE,aAAA;Abw4FJ;;Aaz4FE;EACE,aAAA;Ab44FJ;;Aa74FE;EACE,aAAA;Abg5FJ;;Aaj5FE;EACE,aAAA;Abo5FJ;;Aar5FE;EACE,aAAA;Abw5FJ;;Aaz5FE;EACE,aAAA;Ab45FJ;;Aa75FE;EACE,aAAA;Abg6FJ;;Aaj6FE;EACE,aAAA;Abo6FJ;;Aar6FE;EACE,aAAA;Abw6FJ;;Aaz6FE;EACE,aAAA;Ab46FJ;;Aa76FE;EACE,aAAA;Abg7FJ;;Aaj7FE;EACE,aAAA;Abo7FJ;;Aar7FE;EACE,aAAA;Abw7FJ;;Aaz7FE;EACE,aAAA;Ab47FJ;;Aa77FE;EACE,aAAA;Abg8FJ;;Aaj8FE;EACE,aAAA;Abo8FJ;;Aar8FE;EACE,aAAA;Abw8FJ;;Aaz8FE;EACE,aAAA;Ab48FJ;;Aa78FE;EACE,aAAA;Abg9FJ;;Aaj9FE;EACE,aAAA;Abo9FJ;;Aar9FE;EACE,aAAA;Abw9FJ;;Aaz9FE;EACE,aAAA;Ab49FJ;;Aa79FE;EACE,aAAA;Abg+FJ;;Aaj+FE;EACE,aAAA;Abo+FJ;;Aar+FE;EACE,aAAA;Abw+FJ;;Aaz+FE;EACE,aAAA;Ab4+FJ;;Aa7+FE;EACE,aAAA;Abg/FJ;;Aaj/FE;EACE,aAAA;Abo/FJ;;Aar/FE;EACE,aAAA;Abw/FJ;;Aaz/FE;EACE,aAAA;Ab4/FJ;;Aa7/FE;EACE,aAAA;AbggGJ;;AajgGE;EACE,aAAA;AbogGJ;;AargGE;EACE,aAAA;AbwgGJ;;AazgGE;EACE,aAAA;Ab4gGJ;;Aa7gGE;EACE,aAAA;AbghGJ;;AajhGE;EACE,aAAA;AbohGJ;;AarhGE;EACE,aAAA;AbwhGJ;;AazhGE;EACE,aAAA;Ab4hGJ;;Aa7hGE;EACE,aAAA;AbgiGJ;;AajiGE;EACE,aAAA;AboiGJ;;AariGE;EACE,aAAA;AbwiGJ;;AaziGE;EACE,aAAA;Ab4iGJ;;Aa7iGE;EACE,aAAA;AbgjGJ;;AajjGE;EACE,aAAA;AbojGJ;;AarjGE;EACE,aAAA;AbwjGJ;;AazjGE;EACE,aAAA;Ab4jGJ;;Aa7jGE;EACE,aAAA;AbgkGJ;;AajkGE;EACE,aAAA;AbokGJ;;AarkGE;EACE,aAAA;AbwkGJ;;AazkGE;EACE,aAAA;Ab4kGJ;;Aa7kGE;EACE,aAAA;AbglGJ;;AajlGE;EACE,aAAA;AbolGJ;;AarlGE;EACE,aAAA;AbwlGJ;;AazlGE;EACE,aAAA;Ab4lGJ;;Aa7lGE;EACE,aAAA;AbgmGJ;;AajmGE;EACE,aAAA;AbomGJ;;AarmGE;EACE,aAAA;AbwmGJ;;AazmGE;EACE,aAAA;Ab4mGJ;;Aa7mGE;EACE,aAAA;AbgnGJ;;AajnGE;EACE,aAAA;AbonGJ;;AarnGE;EACE,aAAA;AbwnGJ;;AaznGE;EACE,aAAA;Ab4nGJ;;Aa7nGE;EACE,aAAA;AbgoGJ;;AajoGE;EACE,aAAA;AbooGJ;;AaroGE;EACE,aAAA;AbwoGJ;;AazoGE;EACE,aAAA;Ab4oGJ;;Aa7oGE;EACE,aAAA;AbgpGJ;;AajpGE;EACE,aAAA;AbopGJ;;AarpGE;EACE,aAAA;AbwpGJ;;AazpGE;EACE,aAAA;Ab4pGJ;;Aa7pGE;EACE,aAAA;AbgqGJ;;AajqGE;EACE,aAAA;AboqGJ;;AarqGE;EACE,aAAA;AbwqGJ;;AazqGE;EACE,aAAA;Ab4qGJ;;Aa7qGE;EACE,aAAA;AbgrGJ;;AajrGE;EACE,aAAA;AborGJ;;AarrGE;EACE,aAAA;AbwrGJ;;AazrGE;EACE,aAAA;Ab4rGJ;;Aa7rGE;EACE,aAAA;AbgsGJ;;AajsGE;EACE,aAAA;AbosGJ;;AarsGE;EACE,aAAA;AbwsGJ;;AazsGE;EACE,aAAA;Ab4sGJ;;Aa7sGE;EACE,aAAA;AbgtGJ;;AajtGE;EACE,aAAA;AbotGJ;;AartGE;EACE,aAAA;AbwtGJ;;AaztGE;EACE,aAAA;Ab4tGJ;;Aa7tGE;EACE,aAAA;AbguGJ;;AajuGE;EACE,aAAA;AbouGJ;;AaruGE;EACE,aAAA;AbwuGJ;;AazuGE;EACE,aAAA;Ab4uGJ;;Aa7uGE;EACE,aAAA;AbgvGJ;;AajvGE;EACE,aAAA;AbovGJ;;AarvGE;EACE,aAAA;AbwvGJ;;AazvGE;EACE,aAAA;Ab4vGJ;;Aa7vGE;EACE,aAAA;AbgwGJ;;AajwGE;EACE,aAAA;AbowGJ;;AarwGE;EACE,aAAA;AbwwGJ;;AazwGE;EACE,aAAA;Ab4wGJ;;Aa7wGE;EACE,aAAA;AbgxGJ;;AajxGE;EACE,aAAA;AboxGJ;;AarxGE;EACE,aAAA;AbwxGJ;;AazxGE;EACE,aAAA;Ab4xGJ;;Aa7xGE;EACE,aAAA;AbgyGJ;;AajyGE;EACE,aAAA;AboyGJ;;AaryGE;EACE,aAAA;AbwyGJ;;AazyGE;EACE,aAAA;Ab4yGJ;;Aa7yGE;EACE,aAAA;AbgzGJ;;AajzGE;EACE,aAAA;AbozGJ;;AarzGE;EACE,aAAA;AbwzGJ;;AazzGE;EACE,aAAA;Ab4zGJ;;Aa7zGE;EACE,aAAA;Abg0GJ;;Aaj0GE;EACE,aAAA;Abo0GJ;;Aar0GE;EACE,aAAA;Abw0GJ;;Aaz0GE;EACE,aAAA;Ab40GJ;;Aa70GE;EACE,aAAA;Abg1GJ;;Aaj1GE;EACE,aAAA;Abo1GJ;;Aar1GE;EACE,aAAA;Abw1GJ;;Aaz1GE;EACE,aAAA;Ab41GJ;;Aa71GE;EACE,aAAA;Abg2GJ;;Aaj2GE;EACE,aAAA;Abo2GJ;;Aar2GE;EACE,aAAA;Abw2GJ;;Aaz2GE;EACE,aAAA;Ab42GJ;;Aa72GE;EACE,aAAA;Abg3GJ;;Aaj3GE;EACE,aAAA;Abo3GJ;;Aar3GE;EACE,aAAA;Abw3GJ;;Aaz3GE;EACE,aAAA;Ab43GJ;;Aa73GE;EACE,aAAA;Abg4GJ;;Aaj4GE;EACE,aAAA;Abo4GJ;;Aar4GE;EACE,aAAA;Abw4GJ;;Aaz4GE;EACE,aAAA;Ab44GJ;;Aa74GE;EACE,aAAA;Abg5GJ;;Aaj5GE;EACE,aAAA;Abo5GJ;;Aar5GE;EACE,aAAA;Abw5GJ;;Aaz5GE;EACE,aAAA;Ab45GJ;;Aa75GE;EACE,aAAA;Abg6GJ;;Aaj6GE;EACE,aAAA;Abo6GJ;;Aar6GE;EACE,aAAA;Abw6GJ;;Aaz6GE;EACE,aAAA;Ab46GJ;;Aa76GE;EACE,aAAA;Abg7GJ;;Aaj7GE;EACE,aAAA;Abo7GJ;;Aar7GE;EACE,SAAA;Abw7GJ;;Aaz7GE;EACE,aAAA;Ab47GJ;;Aa77GE;EACE,aAAA;Abg8GJ;;Aaj8GE;EACE,aAAA;Abo8GJ;;Aar8GE;EACE,SAAA;Abw8GJ;;Aaz8GE;EACE,aAAA;Ab48GJ;;Aa78GE;EACE,aAAA;Abg9GJ;;Aaj9GE;EACE,aAAA;Abo9GJ;;Aar9GE;EACE,aAAA;Abw9GJ;;Aaz9GE;EACE,SAAA;Ab49GJ;;Aa79GE;EACE,aAAA;Abg+GJ;;Aaj+GE;EACE,aAAA;Abo+GJ;;Aar+GE;EACE,aAAA;Abw+GJ;;Aaz+GE;EACE,aAAA;Ab4+GJ;;Aa7+GE;EACE,aAAA;Abg/GJ;;Aaj/GE;EACE,aAAA;Abo/GJ;;Aar/GE;EACE,aAAA;Abw/GJ;;Aaz/GE;EACE,aAAA;Ab4/GJ;;Aa7/GE;EACE,aAAA;AbggHJ;;AajgHE;EACE,aAAA;AbogHJ;;AargHE;EACE,aAAA;AbwgHJ;;AazgHE;EACE,aAAA;Ab4gHJ;;Aa7gHE;EACE,aAAA;AbghHJ;;AajhHE;EACE,aAAA;AbohHJ;;AarhHE;EACE,aAAA;AbwhHJ;;AazhHE;EACE,aAAA;Ab4hHJ;;Aa7hHE;EACE,aAAA;AbgiHJ;;AajiHE;EACE,aAAA;AboiHJ;;AariHE;EACE,aAAA;AbwiHJ;;AaziHE;EACE,aAAA;Ab4iHJ;;Aa7iHE;EACE,aAAA;AbgjHJ;;AajjHE;EACE,aAAA;AbojHJ;;AarjHE;EACE,UAAA;AbwjHJ;;AazjHE;EACE,aAAA;Ab4jHJ;;Aa7jHE;EACE,aAAA;AbgkHJ;;AajkHE;EACE,aAAA;AbokHJ;;AarkHE;EACE,aAAA;AbwkHJ;;AazkHE;EACE,aAAA;Ab4kHJ;;Aa7kHE;EACE,aAAA;AbglHJ;;AajlHE;EACE,aAAA;AbolHJ;;AarlHE;EACE,aAAA;AbwlHJ;;AazlHE;EACE,aAAA;Ab4lHJ;;Aa7lHE;EACE,aAAA;AbgmHJ;;AajmHE;EACE,aAAA;AbomHJ;;AarmHE;EACE,aAAA;AbwmHJ;;AazmHE;EACE,aAAA;Ab4mHJ;;Aa7mHE;EACE,aAAA;AbgnHJ;;AajnHE;EACE,aAAA;AbonHJ;;AarnHE;EACE,aAAA;AbwnHJ;;AaznHE;EACE,aAAA;Ab4nHJ;;Aa7nHE;EACE,aAAA;AbgoHJ;;AajoHE;EACE,aAAA;AbooHJ;;AaroHE;EACE,aAAA;AbwoHJ;;AazoHE;EACE,aAAA;Ab4oHJ;;Aa7oHE;EACE,aAAA;AbgpHJ;;AajpHE;EACE,SAAA;AbopHJ;;AarpHE;EACE,aAAA;AbwpHJ;;AazpHE;EACE,aAAA;Ab4pHJ;;Aa7pHE;EACE,aAAA;AbgqHJ;;AajqHE;EACE,aAAA;AboqHJ;;AarqHE;EACE,aAAA;AbwqHJ;;AazqHE;EACE,aAAA;Ab4qHJ;;Aa7qHE;EACE,aAAA;AbgrHJ;;AajrHE;EACE,aAAA;AborHJ;;AarrHE;EACE,aAAA;AbwrHJ;;AazrHE;EACE,aAAA;Ab4rHJ;;Aa7rHE;EACE,aAAA;AbgsHJ;;AajsHE;EACE,aAAA;AbosHJ;;AarsHE;EACE,aAAA;AbwsHJ;;AazsHE;EACE,aAAA;Ab4sHJ;;Aa7sHE;EACE,aAAA;AbgtHJ;;AajtHE;EACE,aAAA;AbotHJ;;AartHE;EACE,aAAA;AbwtHJ;;AaztHE;EACE,aAAA;Ab4tHJ;;Aa7tHE;EACE,aAAA;AbguHJ;;AajuHE;EACE,aAAA;AbouHJ;;AaruHE;EACE,aAAA;AbwuHJ;;AazuHE;EACE,aAAA;Ab4uHJ;;Aa7uHE;EACE,aAAA;AbgvHJ;;AajvHE;EACE,aAAA;AbovHJ;;AarvHE;EACE,aAAA;AbwvHJ;;AazvHE;EACE,aAAA;Ab4vHJ;;Aa7vHE;EACE,aAAA;AbgwHJ;;AajwHE;EACE,aAAA;AbowHJ;;AarwHE;EACE,aAAA;AbwwHJ;;AazwHE;EACE,aAAA;Ab4wHJ;;Aa7wHE;EACE,aAAA;AbgxHJ;;AajxHE;EACE,aAAA;AboxHJ;;AarxHE;EACE,aAAA;AbwxHJ;;AazxHE;EACE,aAAA;Ab4xHJ;;Aa7xHE;EACE,aAAA;AbgyHJ;;AajyHE;EACE,aAAA;AboyHJ;;AaryHE;EACE,aAAA;AbwyHJ;;AazyHE;EACE,aAAA;Ab4yHJ;;Aa7yHE;EACE,aAAA;AbgzHJ;;AajzHE;EACE,SAAA;AbozHJ;;AarzHE;EACE,aAAA;AbwzHJ;;AazzHE;EACE,aAAA;Ab4zHJ;;Aa7zHE;EACE,aAAA;Abg0HJ;;Aaj0HE;EACE,aAAA;Abo0HJ;;Aar0HE;EACE,aAAA;Abw0HJ;;Aaz0HE;EACE,aAAA;Ab40HJ;;Aa70HE;EACE,aAAA;Abg1HJ;;Aaj1HE;EACE,aAAA;Abo1HJ;;Aar1HE;EACE,aAAA;Abw1HJ;;Aaz1HE;EACE,aAAA;Ab41HJ;;Aa71HE;EACE,aAAA;Abg2HJ;;Aaj2HE;EACE,aAAA;Abo2HJ;;Aar2HE;EACE,aAAA;Abw2HJ;;Aaz2HE;EACE,aAAA;Ab42HJ;;Aa72HE;EACE,aAAA;Abg3HJ;;Aaj3HE;EACE,aAAA;Abo3HJ;;Aar3HE;EACE,aAAA;Abw3HJ;;Aaz3HE;EACE,aAAA;Ab43HJ;;Aa73HE;EACE,aAAA;Abg4HJ;;Aaj4HE;EACE,aAAA;Abo4HJ;;Aar4HE;EACE,aAAA;Abw4HJ;;Aaz4HE;EACE,aAAA;Ab44HJ;;Aa74HE;EACE,SAAA;Abg5HJ;;Aaj5HE;EACE,aAAA;Abo5HJ;;Aar5HE;EACE,aAAA;Abw5HJ;;Aaz5HE;EACE,aAAA;Ab45HJ;;Aa75HE;EACE,aAAA;Abg6HJ;;Aaj6HE;EACE,aAAA;Abo6HJ;;Aar6HE;EACE,aAAA;Abw6HJ;;Aaz6HE;EACE,aAAA;Ab46HJ;;Aa76HE;EACE,aAAA;Abg7HJ;;Aaj7HE;EACE,aAAA;Abo7HJ;;Aar7HE;EACE,aAAA;Abw7HJ;;Aaz7HE;EACE,aAAA;Ab47HJ;;Aa77HE;EACE,aAAA;Abg8HJ;;Aaj8HE;EACE,aAAA;Abo8HJ;;Aar8HE;EACE,aAAA;Abw8HJ;;Aaz8HE;EACE,aAAA;Ab48HJ;;Aa78HE;EACE,aAAA;Abg9HJ;;Aaj9HE;EACE,aAAA;Abo9HJ;;Aar9HE;EACE,aAAA;Abw9HJ;;Aaz9HE;EACE,aAAA;Ab49HJ;;Aa79HE;EACE,aAAA;Abg+HJ;;Aaj+HE;EACE,aAAA;Abo+HJ;;Aar+HE;EACE,aAAA;Abw+HJ;;Aaz+HE;EACE,aAAA;Ab4+HJ;;Aa7+HE;EACE,aAAA;Abg/HJ;;Aaj/HE;EACE,aAAA;Abo/HJ;;Aar/HE;EACE,aAAA;Abw/HJ;;Aaz/HE;EACE,aAAA;Ab4/HJ;;Aa7/HE;EACE,aAAA;AbggIJ;;AajgIE;EACE,aAAA;AbogIJ;;AargIE;EACE,aAAA;AbwgIJ;;AazgIE;EACE,aAAA;Ab4gIJ;;Aa7gIE;EACE,aAAA;AbghIJ;;AajhIE;EACE,aAAA;AbohIJ;;AarhIE;EACE,aAAA;AbwhIJ;;AazhIE;EACE,aAAA;Ab4hIJ;;Aa7hIE;EACE,aAAA;AbgiIJ;;AajiIE;EACE,aAAA;AboiIJ;;AariIE;EACE,aAAA;AbwiIJ;;AaziIE;EACE,aAAA;Ab4iIJ;;Aa7iIE;EACE,aAAA;AbgjIJ;;AajjIE;EACE,aAAA;AbojIJ;;AarjIE;EACE,aAAA;AbwjIJ;;AazjIE;EACE,aAAA;Ab4jIJ;;Aa7jIE;EACE,aAAA;AbgkIJ;;AajkIE;EACE,aAAA;AbokIJ;;AarkIE;EACE,aAAA;AbwkIJ;;AazkIE;EACE,aAAA;Ab4kIJ;;Aa7kIE;EACE,aAAA;AbglIJ;;AajlIE;EACE,aAAA;AbolIJ;;AarlIE;EACE,aAAA;AbwlIJ;;AazlIE;EACE,aAAA;Ab4lIJ;;Aa7lIE;EACE,aAAA;AbgmIJ;;AajmIE;EACE,aAAA;AbomIJ;;AarmIE;EACE,aAAA;AbwmIJ;;AazmIE;EACE,aAAA;Ab4mIJ;;Aa7mIE;EACE,aAAA;AbgnIJ;;AajnIE;EACE,aAAA;AbonIJ;;AarnIE;EACE,aAAA;AbwnIJ;;AaznIE;EACE,aAAA;Ab4nIJ;;Aa7nIE;EACE,aAAA;AbgoIJ;;AajoIE;EACE,aAAA;AbooIJ;;AaroIE;EACE,aAAA;AbwoIJ;;AazoIE;EACE,aAAA;Ab4oIJ;;Aa7oIE;EACE,aAAA;AbgpIJ;;AajpIE;EACE,aAAA;AbopIJ;;AarpIE;EACE,aAAA;AbwpIJ;;AazpIE;EACE,aAAA;Ab4pIJ;;Aa7pIE;EACE,aAAA;AbgqIJ;;AajqIE;EACE,aAAA;AboqIJ;;AarqIE;EACE,aAAA;AbwqIJ;;AazqIE;EACE,aAAA;Ab4qIJ;;Aa7qIE;EACE,aAAA;AbgrIJ;;AajrIE;EACE,aAAA;AborIJ;;AarrIE;EACE,aAAA;AbwrIJ;;AazrIE;EACE,aAAA;Ab4rIJ;;Aa7rIE;EACE,aAAA;AbgsIJ;;AajsIE;EACE,aAAA;AbosIJ;;AarsIE;EACE,aAAA;AbwsIJ;;AazsIE;EACE,aAAA;Ab4sIJ;;Aa7sIE;EACE,aAAA;AbgtIJ;;AajtIE;EACE,aAAA;AbotIJ;;AartIE;EACE,aAAA;AbwtIJ;;AaztIE;EACE,aAAA;Ab4tIJ;;Aa7tIE;EACE,aAAA;AbguIJ;;AajuIE;EACE,aAAA;AbouIJ;;AaruIE;EACE,aAAA;AbwuIJ;;AazuIE;EACE,aAAA;Ab4uIJ;;Aa7uIE;EACE,aAAA;AbgvIJ;;AajvIE;EACE,aAAA;AbovIJ;;AarvIE;EACE,aAAA;AbwvIJ;;AazvIE;EACE,aAAA;Ab4vIJ;;Aa7vIE;EACE,aAAA;AbgwIJ;;AajwIE;EACE,aAAA;AbowIJ;;AarwIE;EACE,aAAA;AbwwIJ;;AazwIE;EACE,aAAA;Ab4wIJ;;Aa7wIE;EACE,aAAA;AbgxIJ;;AajxIE;EACE,aAAA;AboxIJ;;AarxIE;EACE,aAAA;AbwxIJ;;AazxIE;EACE,aAAA;Ab4xIJ;;Aa7xIE;EACE,aAAA;AbgyIJ;;AajyIE;EACE,aAAA;AboyIJ;;AaryIE;EACE,aAAA;AbwyIJ;;AazyIE;EACE,aAAA;Ab4yIJ;;Aa7yIE;EACE,aAAA;AbgzIJ;;AajzIE;EACE,aAAA;AbozIJ;;AarzIE;EACE,aAAA;AbwzIJ;;AazzIE;EACE,aAAA;Ab4zIJ;;Aa7zIE;EACE,aAAA;Abg0IJ;;Aaj0IE;EACE,aAAA;Abo0IJ;;Aar0IE;EACE,aAAA;Abw0IJ;;Aaz0IE;EACE,aAAA;Ab40IJ;;Aa70IE;EACE,aAAA;Abg1IJ;;Aaj1IE;EACE,aAAA;Abo1IJ;;Aar1IE;EACE,aAAA;Abw1IJ;;Aaz1IE;EACE,aAAA;Ab41IJ;;Aa71IE;EACE,aAAA;Abg2IJ;;Aaj2IE;EACE,aAAA;Abo2IJ;;Aar2IE;EACE,aAAA;Abw2IJ;;Aaz2IE;EACE,aAAA;Ab42IJ;;Aa72IE;EACE,aAAA;Abg3IJ;;Aaj3IE;EACE,aAAA;Abo3IJ;;Aar3IE;EACE,aAAA;Abw3IJ;;Aaz3IE;EACE,aAAA;Ab43IJ;;Aa73IE;EACE,aAAA;Abg4IJ;;Aaj4IE;EACE,aAAA;Abo4IJ;;Aar4IE;EACE,aAAA;Abw4IJ;;Aaz4IE;EACE,aAAA;Ab44IJ;;Aa74IE;EACE,aAAA;Abg5IJ;;Aaj5IE;EACE,aAAA;Abo5IJ;;Aar5IE;EACE,aAAA;Abw5IJ;;Aaz5IE;EACE,aAAA;Ab45IJ;;Aa75IE;EACE,aAAA;Abg6IJ;;Aaj6IE;EACE,aAAA;Abo6IJ;;Aar6IE;EACE,aAAA;Abw6IJ;;Aaz6IE;EACE,aAAA;Ab46IJ;;Aa76IE;EACE,aAAA;Abg7IJ;;Aaj7IE;EACE,aAAA;Abo7IJ;;Aar7IE;EACE,aAAA;Abw7IJ;;Aaz7IE;EACE,aAAA;Ab47IJ;;Aa77IE;EACE,aAAA;Abg8IJ;;Aaj8IE;EACE,aAAA;Abo8IJ;;Aar8IE;EACE,aAAA;Abw8IJ;;Aaz8IE;EACE,aAAA;Ab48IJ;;Aa78IE;EACE,aAAA;Abg9IJ;;Aaj9IE;EACE,aAAA;Abo9IJ;;Aar9IE;EACE,aAAA;Abw9IJ;;Aaz9IE;EACE,aAAA;Ab49IJ;;Aa79IE;EACE,aAAA;Abg+IJ;;Aaj+IE;EACE,aAAA;Abo+IJ;;Aar+IE;EACE,aAAA;Abw+IJ;;Aaz+IE;EACE,aAAA;Ab4+IJ;;Aa7+IE;EACE,aAAA;Abg/IJ;;Aaj/IE;EACE,aAAA;Abo/IJ;;Aar/IE;EACE,aAAA;Abw/IJ;;Aaz/IE;EACE,aAAA;Ab4/IJ;;Aa7/IE;EACE,aAAA;AbggJJ;;AajgJE;EACE,aAAA;AbogJJ;;AargJE;EACE,aAAA;AbwgJJ;;AazgJE;EACE,aAAA;Ab4gJJ;;Aa7gJE;EACE,aAAA;AbghJJ;;AajhJE;EACE,aAAA;AbohJJ;;AarhJE;EACE,aAAA;AbwhJJ;;AazhJE;EACE,aAAA;Ab4hJJ;;Aa7hJE;EACE,aAAA;AbgiJJ;;AajiJE;EACE,aAAA;AboiJJ;;AariJE;EACE,aAAA;AbwiJJ;;AaziJE;EACE,aAAA;Ab4iJJ;;Aa7iJE;EACE,aAAA;AbgjJJ;;AajjJE;EACE,aAAA;AbojJJ;;AarjJE;EACE,aAAA;AbwjJJ;;AazjJE;EACE,aAAA;Ab4jJJ;;Aa7jJE;EACE,aAAA;AbgkJJ;;AajkJE;EACE,aAAA;AbokJJ;;AarkJE;EACE,aAAA;AbwkJJ;;AazkJE;EACE,aAAA;Ab4kJJ;;Aa7kJE;EACE,aAAA;AbglJJ;;AajlJE;EACE,aAAA;AbolJJ;;AarlJE;EACE,aAAA;AbwlJJ;;AazlJE;EACE,aAAA;Ab4lJJ;;Aa7lJE;EACE,aAAA;AbgmJJ;;AajmJE;EACE,aAAA;AbomJJ;;AarmJE;EACE,aAAA;AbwmJJ;;AazmJE;EACE,aAAA;Ab4mJJ;;Aa7mJE;EACE,aAAA;AbgnJJ;;AajnJE;EACE,aAAA;AbonJJ;;AarnJE;EACE,aAAA;AbwnJJ;;AaznJE;EACE,aAAA;Ab4nJJ;;Aa7nJE;EACE,aAAA;AbgoJJ;;AajoJE;EACE,aAAA;AbooJJ;;AaroJE;EACE,aAAA;AbwoJJ;;AazoJE;EACE,SAAA;Ab4oJJ;;Aa7oJE;EACE,aAAA;AbgpJJ;;AajpJE;EACE,aAAA;AbopJJ;;AarpJE;EACE,aAAA;AbwpJJ;;AazpJE;EACE,aAAA;Ab4pJJ;;Aa7pJE;EACE,aAAA;AbgqJJ;;AajqJE;EACE,aAAA;AboqJJ;;AarqJE;EACE,aAAA;AbwqJJ;;AazqJE;EACE,aAAA;Ab4qJJ;;Aa7qJE;EACE,aAAA;AbgrJJ;;AajrJE;EACE,SAAA;AborJJ;;AarrJE;EACE,aAAA;AbwrJJ;;AazrJE;EACE,aAAA;Ab4rJJ;;Aa7rJE;EACE,aAAA;AbgsJJ;;AajsJE;EACE,aAAA;AbosJJ;;AarsJE;EACE,aAAA;AbwsJJ;;AazsJE;EACE,aAAA;Ab4sJJ;;Aa7sJE;EACE,aAAA;AbgtJJ;;AajtJE;EACE,aAAA;AbotJJ;;AartJE;EACE,aAAA;AbwtJJ;;AaztJE;EACE,aAAA;Ab4tJJ;;Aa7tJE;EACE,aAAA;AbguJJ;;AajuJE;EACE,aAAA;AbouJJ;;AaruJE;EACE,aAAA;AbwuJJ;;AazuJE;EACE,aAAA;Ab4uJJ;;Aa7uJE;EACE,aAAA;AbgvJJ;;AajvJE;EACE,aAAA;AbovJJ;;AarvJE;EACE,aAAA;AbwvJJ;;AazvJE;EACE,aAAA;Ab4vJJ;;Aa7vJE;EACE,aAAA;AbgwJJ;;AajwJE;EACE,aAAA;AbowJJ;;AarwJE;EACE,aAAA;AbwwJJ;;AazwJE;EACE,aAAA;Ab4wJJ;;Aa7wJE;EACE,aAAA;AbgxJJ;;AajxJE;EACE,aAAA;AboxJJ;;AarxJE;EACE,aAAA;AbwxJJ;;AazxJE;EACE,aAAA;Ab4xJJ;;Aa7xJE;EACE,aAAA;AbgyJJ;;AajyJE;EACE,aAAA;AboyJJ;;AaryJE;EACE,aAAA;AbwyJJ;;AazyJE;EACE,aAAA;Ab4yJJ;;Aa7yJE;EACE,aAAA;AbgzJJ;;AajzJE;EACE,aAAA;AbozJJ;;AarzJE;EACE,aAAA;AbwzJJ;;AazzJE;EACE,aAAA;Ab4zJJ;;Aa7zJE;EACE,aAAA;Abg0JJ;;Aaj0JE;EACE,aAAA;Abo0JJ;;Aar0JE;EACE,aAAA;Abw0JJ;;Aaz0JE;EACE,aAAA;Ab40JJ;;Aa70JE;EACE,aAAA;Abg1JJ;;Aaj1JE;EACE,aAAA;Abo1JJ;;Aar1JE;EACE,aAAA;Abw1JJ;;Aaz1JE;EACE,aAAA;Ab41JJ;;Aa71JE;EACE,aAAA;Abg2JJ;;Aaj2JE;EACE,aAAA;Abo2JJ;;Aar2JE;EACE,aAAA;Abw2JJ;;Aaz2JE;EACE,aAAA;Ab42JJ;;Aa72JE;EACE,aAAA;Abg3JJ;;Aaj3JE;EACE,aAAA;Abo3JJ;;Aar3JE;EACE,aAAA;Abw3JJ;;Aaz3JE;EACE,aAAA;Ab43JJ;;Aa73JE;EACE,aAAA;Abg4JJ;;Aaj4JE;EACE,aAAA;Abo4JJ;;Aar4JE;EACE,aAAA;Abw4JJ;;Aaz4JE;EACE,aAAA;Ab44JJ;;Aa74JE;EACE,aAAA;Abg5JJ;;Aaj5JE;EACE,aAAA;Abo5JJ;;Aar5JE;EACE,aAAA;Abw5JJ;;Aaz5JE;EACE,aAAA;Ab45JJ;;Aa75JE;EACE,aAAA;Abg6JJ;;Aaj6JE;EACE,aAAA;Abo6JJ;;Aar6JE;EACE,aAAA;Abw6JJ;;Aaz6JE;EACE,aAAA;Ab46JJ;;Aa76JE;EACE,aAAA;Abg7JJ;;Aaj7JE;EACE,aAAA;Abo7JJ;;Aar7JE;EACE,aAAA;Abw7JJ;;Aaz7JE;EACE,aAAA;Ab47JJ;;Aa77JE;EACE,aAAA;Abg8JJ;;Aaj8JE;EACE,aAAA;Abo8JJ;;Aar8JE;EACE,aAAA;Abw8JJ;;Aaz8JE;EACE,aAAA;Ab48JJ;;Aa78JE;EACE,aAAA;Abg9JJ;;Aaj9JE;EACE,aAAA;Abo9JJ;;Aar9JE;EACE,aAAA;Abw9JJ;;Aaz9JE;EACE,aAAA;Ab49JJ;;Aa79JE;EACE,aAAA;Abg+JJ;;Aaj+JE;EACE,aAAA;Abo+JJ;;Aar+JE;EACE,aAAA;Abw+JJ;;Aaz+JE;EACE,aAAA;Ab4+JJ;;Aa7+JE;EACE,aAAA;Abg/JJ;;Aaj/JE;EACE,aAAA;Abo/JJ;;Aar/JE;EACE,aAAA;Abw/JJ;;Aaz/JE;EACE,aAAA;Ab4/JJ;;Aa7/JE;EACE,aAAA;AbggKJ;;AajgKE;EACE,aAAA;AbogKJ;;AargKE;EACE,aAAA;AbwgKJ;;AazgKE;EACE,aAAA;Ab4gKJ;;Aa7gKE;EACE,aAAA;AbghKJ;;AajhKE;EACE,aAAA;AbohKJ;;AarhKE;EACE,aAAA;AbwhKJ;;AazhKE;EACE,aAAA;Ab4hKJ;;Aa7hKE;EACE,aAAA;AbgiKJ;;AajiKE;EACE,aAAA;AboiKJ;;AariKE;EACE,aAAA;AbwiKJ;;AaziKE;EACE,aAAA;Ab4iKJ;;Aa7iKE;EACE,aAAA;AbgjKJ;;AajjKE;EACE,aAAA;AbojKJ;;AarjKE;EACE,aAAA;AbwjKJ;;AazjKE;EACE,aAAA;Ab4jKJ;;Aa7jKE;EACE,aAAA;AbgkKJ;;AajkKE;EACE,aAAA;AbokKJ;;AarkKE;EACE,aAAA;AbwkKJ;;AazkKE;EACE,aAAA;Ab4kKJ;;Aa7kKE;EACE,aAAA;AbglKJ;;AajlKE;EACE,aAAA;AbolKJ;;AarlKE;EACE,aAAA;AbwlKJ;;AazlKE;EACE,aAAA;Ab4lKJ;;Aa7lKE;EACE,aAAA;AbgmKJ;;AajmKE;EACE,aAAA;AbomKJ;;AarmKE;EACE,aAAA;AbwmKJ;;AazmKE;EACE,aAAA;Ab4mKJ;;Aa7mKE;EACE,aAAA;AbgnKJ;;AajnKE;EACE,aAAA;AbonKJ;;AarnKE;EACE,aAAA;AbwnKJ;;AaznKE;EACE,aAAA;Ab4nKJ;;Aa7nKE;EACE,aAAA;AbgoKJ;;AajoKE;EACE,aAAA;AbooKJ;;AaroKE;EACE,aAAA;AbwoKJ;;AazoKE;EACE,aAAA;Ab4oKJ;;Aa7oKE;EACE,aAAA;AbgpKJ;;AajpKE;EACE,aAAA;AbopKJ;;AarpKE;EACE,aAAA;AbwpKJ;;AazpKE;EACE,aAAA;Ab4pKJ;;Aa7pKE;EACE,aAAA;AbgqKJ;;AajqKE;EACE,aAAA;AboqKJ;;AarqKE;EACE,aAAA;AbwqKJ;;AazqKE;EACE,aAAA;Ab4qKJ;;Aa7qKE;EACE,aAAA;AbgrKJ;;AajrKE;EACE,aAAA;AborKJ;;AarrKE;EACE,aAAA;AbwrKJ;;AazrKE;EACE,aAAA;Ab4rKJ;;Aa7rKE;EACE,aAAA;AbgsKJ;;AajsKE;EACE,aAAA;AbosKJ;;AarsKE;EACE,aAAA;AbwsKJ;;AazsKE;EACE,aAAA;Ab4sKJ;;Aa7sKE;EACE,aAAA;AbgtKJ;;AajtKE;EACE,aAAA;AbotKJ;;AartKE;EACE,aAAA;AbwtKJ;;AaztKE;EACE,aAAA;Ab4tKJ;;Aa7tKE;EACE,aAAA;AbguKJ;;AajuKE;EACE,aAAA;AbouKJ;;AaruKE;EACE,aAAA;AbwuKJ;;AazuKE;EACE,SAAA;Ab4uKJ;;Aa7uKE;EACE,aAAA;AbgvKJ;;AajvKE;EACE,aAAA;AbovKJ;;AarvKE;EACE,aAAA;AbwvKJ;;AazvKE;EACE,aAAA;Ab4vKJ;;Aa7vKE;EACE,aAAA;AbgwKJ;;AajwKE;EACE,aAAA;AbowKJ;;AarwKE;EACE,aAAA;AbwwKJ;;AazwKE;EACE,aAAA;Ab4wKJ;;Aa7wKE;EACE,aAAA;AbgxKJ;;AajxKE;EACE,SAAA;AboxKJ;;AarxKE;EACE,aAAA;AbwxKJ;;AazxKE;EACE,aAAA;Ab4xKJ;;Aa7xKE;EACE,aAAA;AbgyKJ;;AajyKE;EACE,aAAA;AboyKJ;;AaryKE;EACE,aAAA;AbwyKJ;;AazyKE;EACE,aAAA;Ab4yKJ;;Aa7yKE;EACE,aAAA;AbgzKJ;;AajzKE;EACE,aAAA;AbozKJ;;AarzKE;EACE,aAAA;AbwzKJ;;AazzKE;EACE,aAAA;Ab4zKJ;;Aa7zKE;EACE,aAAA;Abg0KJ;;Aaj0KE;EACE,aAAA;Abo0KJ;;Aar0KE;EACE,aAAA;Abw0KJ;;Aaz0KE;EACE,aAAA;Ab40KJ;;Aa70KE;EACE,aAAA;Abg1KJ;;Aaj1KE;EACE,aAAA;Abo1KJ;;Aar1KE;EACE,aAAA;Abw1KJ;;Aaz1KE;EACE,aAAA;Ab41KJ;;Aa71KE;EACE,aAAA;Abg2KJ;;Aaj2KE;EACE,aAAA;Abo2KJ;;Aar2KE;EACE,aAAA;Abw2KJ;;Aaz2KE;EACE,aAAA;Ab42KJ;;Aa72KE;EACE,aAAA;Abg3KJ;;Aaj3KE;EACE,aAAA;Abo3KJ;;Aar3KE;EACE,aAAA;Abw3KJ;;Aaz3KE;EACE,aAAA;Ab43KJ;;Aa73KE;EACE,aAAA;Abg4KJ;;Aaj4KE;EACE,aAAA;Abo4KJ;;Aar4KE;EACE,aAAA;Abw4KJ;;Aaz4KE;EACE,aAAA;Ab44KJ;;Aa74KE;EACE,aAAA;Abg5KJ;;Aaj5KE;EACE,aAAA;Abo5KJ;;Aar5KE;EACE,aAAA;Abw5KJ;;Aaz5KE;EACE,aAAA;Ab45KJ;;Aa75KE;EACE,aAAA;Abg6KJ;;Aaj6KE;EACE,aAAA;Abo6KJ;;Aar6KE;EACE,aAAA;Abw6KJ;;Aaz6KE;EACE,aAAA;Ab46KJ;;Aa76KE;EACE,aAAA;Abg7KJ;;Aaj7KE;EACE,aAAA;Abo7KJ;;Aar7KE;EACE,aAAA;Abw7KJ;;Aaz7KE;EACE,aAAA;Ab47KJ;;Aa77KE;EACE,aAAA;Abg8KJ;;Aaj8KE;EACE,aAAA;Abo8KJ;;Aar8KE;EACE,aAAA;Abw8KJ;;Aaz8KE;EACE,aAAA;Ab48KJ;;Aa78KE;EACE,aAAA;Abg9KJ;;Aaj9KE;EACE,aAAA;Abo9KJ;;Aar9KE;EACE,SAAA;Abw9KJ;;Aaz9KE;EACE,aAAA;Ab49KJ;;Aa79KE;EACE,aAAA;Abg+KJ;;Aaj+KE;EACE,aAAA;Abo+KJ;;Aar+KE;EACE,aAAA;Abw+KJ;;Aaz+KE;EACE,aAAA;Ab4+KJ;;Aa7+KE;EACE,aAAA;Abg/KJ;;Aaj/KE;EACE,aAAA;Abo/KJ;;Aar/KE;EACE,aAAA;Abw/KJ;;Aaz/KE;EACE,aAAA;Ab4/KJ;;Aa7/KE;EACE,aAAA;AbggLJ;;AajgLE;EACE,aAAA;AbogLJ;;AargLE;EACE,aAAA;AbwgLJ;;AazgLE;EACE,aAAA;Ab4gLJ;;Aa7gLE;EACE,aAAA;AbghLJ;;AajhLE;EACE,aAAA;AbohLJ;;AarhLE;EACE,aAAA;AbwhLJ;;AazhLE;EACE,aAAA;Ab4hLJ;;Aa7hLE;EACE,aAAA;AbgiLJ;;AajiLE;EACE,aAAA;AboiLJ;;AariLE;EACE,aAAA;AbwiLJ;;AaziLE;EACE,aAAA;Ab4iLJ;;Aa7iLE;EACE,aAAA;AbgjLJ;;AajjLE;EACE,aAAA;AbojLJ;;AarjLE;EACE,aAAA;AbwjLJ;;AazjLE;EACE,aAAA;Ab4jLJ;;Aa7jLE;EACE,aAAA;AbgkLJ;;AajkLE;EACE,aAAA;AbokLJ;;AarkLE;EACE,aAAA;AbwkLJ;;AazkLE;EACE,aAAA;Ab4kLJ;;Aa7kLE;EACE,aAAA;AbglLJ;;AajlLE;EACE,aAAA;AbolLJ;;AarlLE;EACE,aAAA;AbwlLJ;;AazlLE;EACE,aAAA;Ab4lLJ;;Aa7lLE;EACE,aAAA;AbgmLJ;;AajmLE;EACE,aAAA;AbomLJ;;AarmLE;EACE,SAAA;AbwmLJ;;AazmLE;EACE,aAAA;Ab4mLJ;;Aa7mLE;EACE,aAAA;AbgnLJ;;AajnLE;EACE,aAAA;AbonLJ;;AarnLE;EACE,aAAA;AbwnLJ;;AaznLE;EACE,aAAA;Ab4nLJ;;Aa7nLE;EACE,aAAA;AbgoLJ;;AajoLE;EACE,aAAA;AbooLJ;;AaroLE;EACE,aAAA;AbwoLJ;;AazoLE;EACE,aAAA;Ab4oLJ;;Aa7oLE;EACE,aAAA;AbgpLJ;;AajpLE;EACE,aAAA;AbopLJ;;AarpLE;EACE,aAAA;AbwpLJ;;AazpLE;EACE,aAAA;Ab4pLJ;;Aa7pLE;EACE,aAAA;AbgqLJ;;AajqLE;EACE,aAAA;AboqLJ;;AarqLE;EACE,aAAA;AbwqLJ;;AazqLE;EACE,aAAA;Ab4qLJ;;Aa7qLE;EACE,aAAA;AbgrLJ;;AajrLE;EACE,aAAA;AborLJ;;AarrLE;EACE,aAAA;AbwrLJ;;AazrLE;EACE,aAAA;Ab4rLJ;;Aa7rLE;EACE,aAAA;AbgsLJ;;AajsLE;EACE,aAAA;AbosLJ;;AarsLE;EACE,aAAA;AbwsLJ;;AazsLE;EACE,aAAA;Ab4sLJ;;Aa7sLE;EACE,aAAA;AbgtLJ;;AajtLE;EACE,aAAA;AbotLJ;;AartLE;EACE,aAAA;AbwtLJ;;AaztLE;EACE,aAAA;Ab4tLJ;;Aa7tLE;EACE,aAAA;AbguLJ;;AajuLE;EACE,aAAA;AbouLJ;;AaruLE;EACE,aAAA;AbwuLJ;;AazuLE;EACE,aAAA;Ab4uLJ;;Aa7uLE;EACE,aAAA;AbgvLJ;;AajvLE;EACE,aAAA;AbovLJ;;AarvLE;EACE,aAAA;AbwvLJ;;AazvLE;EACE,aAAA;Ab4vLJ;;Aa7vLE;EACE,aAAA;AbgwLJ;;AajwLE;EACE,aAAA;AbowLJ;;AarwLE;EACE,aAAA;AbwwLJ;;AazwLE;EACE,aAAA;Ab4wLJ;;Aa7wLE;EACE,aAAA;AbgxLJ;;AajxLE;EACE,aAAA;AboxLJ;;AarxLE;EACE,aAAA;AbwxLJ;;AazxLE;EACE,aAAA;Ab4xLJ;;Aa7xLE;EACE,aAAA;AbgyLJ;;AajyLE;EACE,aAAA;AboyLJ;;AaryLE;EACE,aAAA;AbwyLJ;;AazyLE;EACE,aAAA;Ab4yLJ;;Aa7yLE;EACE,aAAA;AbgzLJ;;AajzLE;EACE,aAAA;AbozLJ;;AarzLE;EACE,aAAA;AbwzLJ;;AazzLE;EACE,aAAA;Ab4zLJ;;Aa7zLE;EACE,aAAA;Abg0LJ;;Aaj0LE;EACE,aAAA;Abo0LJ;;Aar0LE;EACE,aAAA;Abw0LJ;;Aaz0LE;EACE,aAAA;Ab40LJ;;Aa70LE;EACE,aAAA;Abg1LJ;;Aaj1LE;EACE,aAAA;Abo1LJ;;Aar1LE;EACE,aAAA;Abw1LJ;;Aaz1LE;EACE,aAAA;Ab41LJ;;Aa71LE;EACE,aAAA;Abg2LJ;;Aaj2LE;EACE,UAAA;Abo2LJ;;Aar2LE;EACE,aAAA;Abw2LJ;;Aaz2LE;EACE,aAAA;Ab42LJ;;Aa72LE;EACE,aAAA;Abg3LJ;;Aaj3LE;EACE,aAAA;Abo3LJ;;Aar3LE;EACE,aAAA;Abw3LJ;;Aaz3LE;EACE,aAAA;Ab43LJ;;Aa73LE;EACE,aAAA;Abg4LJ;;Aaj4LE;EACE,aAAA;Abo4LJ;;Aar4LE;EACE,aAAA;Abw4LJ;;Aaz4LE;EACE,aAAA;Ab44LJ;;Aa74LE;EACE,aAAA;Abg5LJ;;Aaj5LE;EACE,aAAA;Abo5LJ;;Aar5LE;EACE,aAAA;Abw5LJ;;Aaz5LE;EACE,aAAA;Ab45LJ;;Aa75LE;EACE,aAAA;Abg6LJ;;Aaj6LE;EACE,aAAA;Abo6LJ;;Aar6LE;EACE,aAAA;Abw6LJ;;Aaz6LE;EACE,aAAA;Ab46LJ;;Aa76LE;EACE,aAAA;Abg7LJ;;Aaj7LE;EACE,aAAA;Abo7LJ;;Aar7LE;EACE,aAAA;Abw7LJ;;Aaz7LE;EACE,aAAA;Ab47LJ;;Aa77LE;EACE,aAAA;Abg8LJ;;Aaj8LE;EACE,aAAA;Abo8LJ;;Aar8LE;EACE,aAAA;Abw8LJ;;Aaz8LE;EACE,aAAA;Ab48LJ;;Aa78LE;EACE,aAAA;Abg9LJ;;Aaj9LE;EACE,aAAA;Abo9LJ;;Aar9LE;EACE,aAAA;Abw9LJ;;Aaz9LE;EACE,aAAA;Ab49LJ;;Aa79LE;EACE,aAAA;Abg+LJ;;Aaj+LE;EACE,aAAA;Abo+LJ;;Aar+LE;EACE,aAAA;Abw+LJ;;Aaz+LE;EACE,aAAA;Ab4+LJ;;Aa7+LE;EACE,aAAA;Abg/LJ;;Aaj/LE;EACE,aAAA;Abo/LJ;;Aar/LE;EACE,aAAA;Abw/LJ;;Aaz/LE;EACE,aAAA;Ab4/LJ;;Aa7/LE;EACE,aAAA;AbggMJ;;AajgME;EACE,aAAA;AbogMJ;;AargME;EACE,aAAA;AbwgMJ;;AazgME;EACE,aAAA;Ab4gMJ;;Aa7gME;EACE,aAAA;AbghMJ;;AajhME;EACE,aAAA;AbohMJ;;AarhME;EACE,aAAA;AbwhMJ;;AazhME;EACE,aAAA;Ab4hMJ;;Aa7hME;EACE,aAAA;AbgiMJ;;AajiME;EACE,aAAA;AboiMJ;;AariME;EACE,aAAA;AbwiMJ;;AaziME;EACE,aAAA;Ab4iMJ;;Aa7iME;EACE,aAAA;AbgjMJ;;AajjME;EACE,aAAA;AbojMJ;;AarjME;EACE,UAAA;AbwjMJ;;AazjME;EACE,aAAA;Ab4jMJ;;Aa7jME;EACE,aAAA;AbgkMJ;;AajkME;EACE,aAAA;AbokMJ;;AarkME;EACE,aAAA;AbwkMJ;;AazkME;EACE,aAAA;Ab4kMJ;;Aa7kME;EACE,aAAA;AbglMJ;;AajlME;EACE,aAAA;AbolMJ;;AarlME;EACE,aAAA;AbwlMJ;;AazlME;EACE,aAAA;Ab4lMJ;;Aa7lME;EACE,aAAA;AbgmMJ;;AajmME;EACE,aAAA;AbomMJ;;AarmME;EACE,aAAA;AbwmMJ;;AazmME;EACE,aAAA;Ab4mMJ;;Aa7mME;EACE,aAAA;AbgnMJ;;AajnME;EACE,aAAA;AbonMJ;;AarnME;EACE,aAAA;AbwnMJ;;AaznME;EACE,aAAA;Ab4nMJ;;Aa7nME;EACE,aAAA;AbgoMJ;;AajoME;EACE,aAAA;AbooMJ;;AaroME;EACE,aAAA;AbwoMJ;;AazoME;EACE,aAAA;Ab4oMJ;;Aa7oME;EACE,aAAA;AbgpMJ;;AajpME;EACE,aAAA;AbopMJ;;AarpME;EACE,aAAA;AbwpMJ;;AazpME;EACE,aAAA;Ab4pMJ;;Aa7pME;EACE,aAAA;AbgqMJ;;AajqME;EACE,aAAA;AboqMJ;;AarqME;EACE,aAAA;AbwqMJ;;AazqME;EACE,aAAA;Ab4qMJ;;Aa7qME;EACE,aAAA;AbgrMJ;;AajrME;EACE,aAAA;AborMJ;;AarrME;EACE,aAAA;AbwrMJ;;AazrME;EACE,aAAA;Ab4rMJ;;Aa7rME;EACE,aAAA;AbgsMJ;;AajsME;EACE,aAAA;AbosMJ;;AarsME;EACE,aAAA;AbwsMJ;;AazsME;EACE,aAAA;Ab4sMJ;;Aa7sME;EACE,aAAA;AbgtMJ;;AajtME;EACE,aAAA;AbotMJ;;AartME;EACE,aAAA;AbwtMJ;;AaztME;EACE,aAAA;Ab4tMJ;;Aa7tME;EACE,aAAA;AbguMJ;;AajuME;EACE,aAAA;AbouMJ;;AaruME;EACE,aAAA;AbwuMJ;;AazuME;EACE,aAAA;Ab4uMJ;;Aa7uME;EACE,aAAA;AbgvMJ;;AajvME;EACE,aAAA;AbovMJ;;AarvME;EACE,aAAA;AbwvMJ;;AazvME;EACE,aAAA;Ab4vMJ;;Aa7vME;EACE,aAAA;AbgwMJ;;AajwME;EACE,aAAA;AbowMJ;;AarwME;EACE,aAAA;AbwwMJ;;AazwME;EACE,aAAA;Ab4wMJ;;Aa7wME;EACE,aAAA;AbgxMJ;;AajxME;EACE,aAAA;AboxMJ;;AarxME;EACE,aAAA;AbwxMJ;;AazxME;EACE,aAAA;Ab4xMJ;;Aa7xME;EACE,aAAA;AbgyMJ;;AajyME;EACE,aAAA;AboyMJ;;AaryME;EACE,aAAA;AbwyMJ;;AazyME;EACE,aAAA;Ab4yMJ;;Aa7yME;EACE,aAAA;AbgzMJ;;AajzME;EACE,aAAA;AbozMJ;;AarzME;EACE,aAAA;AbwzMJ;;AazzME;EACE,aAAA;Ab4zMJ;;Aa7zME;EACE,aAAA;Abg0MJ;;Aaj0ME;EACE,aAAA;Abo0MJ;;Aar0ME;EACE,aAAA;Abw0MJ;;Aaz0ME;EACE,aAAA;Ab40MJ;;Aa70ME;EACE,aAAA;Abg1MJ;;Aaj1ME;EACE,aAAA;Abo1MJ;;Aar1ME;EACE,aAAA;Abw1MJ;;Aaz1ME;EACE,aAAA;Ab41MJ;;Aa71ME;EACE,aAAA;Abg2MJ;;Aaj2ME;EACE,aAAA;Abo2MJ;;Aar2ME;EACE,aAAA;Abw2MJ;;Aaz2ME;EACE,aAAA;Ab42MJ;;Aa72ME;EACE,aAAA;Abg3MJ;;Aaj3ME;EACE,aAAA;Abo3MJ;;Aar3ME;EACE,aAAA;Abw3MJ;;Aaz3ME;EACE,aAAA;Ab43MJ;;Aa73ME;EACE,aAAA;Abg4MJ;;Aaj4ME;EACE,aAAA;Abo4MJ;;Aar4ME;EACE,aAAA;Abw4MJ;;Aaz4ME;EACE,aAAA;Ab44MJ;;Aa74ME;EACE,aAAA;Abg5MJ;;Aaj5ME;EACE,aAAA;Abo5MJ;;Aar5ME;EACE,aAAA;Abw5MJ;;Aaz5ME;EACE,aAAA;Ab45MJ;;Aa75ME;EACE,aAAA;Abg6MJ;;Aaj6ME;EACE,aAAA;Abo6MJ;;Aar6ME;EACE,aAAA;Abw6MJ;;Aaz6ME;EACE,aAAA;Ab46MJ;;Aa76ME;EACE,aAAA;Abg7MJ;;Aaj7ME;EACE,aAAA;Abo7MJ;;Aar7ME;EACE,aAAA;Abw7MJ;;Aaz7ME;EACE,aAAA;Ab47MJ;;Aa77ME;EACE,aAAA;Abg8MJ;;Aaj8ME;EACE,aAAA;Abo8MJ;;Aar8ME;EACE,aAAA;Abw8MJ;;Aaz8ME;EACE,aAAA;Ab48MJ;;Aa78ME;EACE,aAAA;Abg9MJ;;Aaj9ME;EACE,aAAA;Abo9MJ;;Aar9ME;EACE,aAAA;Abw9MJ;;Aaz9ME;EACE,aAAA;Ab49MJ;;Aa79ME;EACE,SAAA;Abg+MJ;;Aaj+ME;EACE,aAAA;Abo+MJ;;Aar+ME;EACE,aAAA;Abw+MJ;;Aaz+ME;EACE,aAAA;Ab4+MJ;;Aa7+ME;EACE,aAAA;Abg/MJ;;Aaj/ME;EACE,aAAA;Abo/MJ;;Aar/ME;EACE,aAAA;Abw/MJ;;Aaz/ME;EACE,aAAA;Ab4/MJ;;Aa7/ME;EACE,aAAA;AbggNJ;;AajgNE;EACE,aAAA;AbogNJ;;AargNE;EACE,aAAA;AbwgNJ;;AazgNE;EACE,aAAA;Ab4gNJ;;Aa7gNE;EACE,aAAA;AbghNJ;;AajhNE;EACE,aAAA;AbohNJ;;AarhNE;EACE,aAAA;AbwhNJ;;AazhNE;EACE,aAAA;Ab4hNJ;;Aa7hNE;EACE,aAAA;AbgiNJ;;AajiNE;EACE,aAAA;AboiNJ;;AariNE;EACE,aAAA;AbwiNJ;;AaziNE;EACE,aAAA;Ab4iNJ;;Aa7iNE;EACE,aAAA;AbgjNJ;;AajjNE;EACE,aAAA;AbojNJ;;AarjNE;EACE,aAAA;AbwjNJ;;AazjNE;EACE,aAAA;Ab4jNJ;;Aa7jNE;EACE,aAAA;AbgkNJ;;AajkNE;EACE,aAAA;AbokNJ;;AarkNE;EACE,aAAA;AbwkNJ;;AazkNE;EACE,aAAA;Ab4kNJ;;Aa7kNE;EACE,aAAA;AbglNJ;;AajlNE;EACE,aAAA;AbolNJ;;AarlNE;EACE,aAAA;AbwlNJ;;AazlNE;EACE,UAAA;Ab4lNJ;;Aa7lNE;EACE,UAAA;AbgmNJ;;AajmNE;EACE,aAAA;AbomNJ;;AarmNE;EACE,aAAA;AbwmNJ;;AazmNE;EACE,aAAA;Ab4mNJ;;Aa7mNE;EACE,aAAA;AbgnNJ;;AajnNE;EACE,aAAA;AbonNJ;;AarnNE;EACE,aAAA;AbwnNJ;;AaznNE;EACE,aAAA;Ab4nNJ;;Aa7nNE;EACE,aAAA;AbgoNJ;;AajoNE;EACE,aAAA;AbooNJ;;AaroNE;EACE,aAAA;AbwoNJ;;AazoNE;EACE,aAAA;Ab4oNJ;;Aa7oNE;EACE,aAAA;AbgpNJ;;AajpNE;EACE,aAAA;AbopNJ;;AarpNE;EACE,aAAA;AbwpNJ;;AazpNE;EACE,aAAA;Ab4pNJ;;Aa7pNE;EACE,aAAA;AbgqNJ;;AajqNE;EACE,aAAA;AboqNJ;;AarqNE;EACE,aAAA;AbwqNJ;;AazqNE;EACE,aAAA;Ab4qNJ;;Aa7qNE;EACE,aAAA;AbgrNJ;;AajrNE;EACE,aAAA;AborNJ;;AarrNE;EACE,aAAA;AbwrNJ;;AazrNE;EACE,aAAA;Ab4rNJ;;Aa7rNE;EACE,aAAA;AbgsNJ;;AajsNE;EACE,UAAA;AbosNJ;;AarsNE;EACE,aAAA;AbwsNJ;;AazsNE;EACE,aAAA;Ab4sNJ;;Aa7sNE;EACE,aAAA;AbgtNJ;;AajtNE;EACE,aAAA;AbotNJ;;AartNE;EACE,aAAA;AbwtNJ;;AaztNE;EACE,aAAA;Ab4tNJ;;Aa7tNE;EACE,aAAA;AbguNJ;;AajuNE;EACE,aAAA;AbouNJ;;AaruNE;EACE,aAAA;AbwuNJ;;AazuNE;EACE,aAAA;Ab4uNJ;;Aa7uNE;EACE,aAAA;AbgvNJ;;AajvNE;EACE,aAAA;AbovNJ;;AarvNE;EACE,aAAA;AbwvNJ;;AazvNE;EACE,aAAA;Ab4vNJ;;Aa7vNE;EACE,aAAA;AbgwNJ;;AajwNE;EACE,aAAA;AbowNJ;;AarwNE;EACE,aAAA;AbwwNJ;;AazwNE;EACE,aAAA;Ab4wNJ;;Aa7wNE;EACE,aAAA;AbgxNJ;;AajxNE;EACE,aAAA;AboxNJ;;AarxNE;EACE,aAAA;AbwxNJ;;AazxNE;EACE,aAAA;Ab4xNJ;;Aa7xNE;EACE,aAAA;AbgyNJ;;AajyNE;EACE,aAAA;AboyNJ;;AaryNE;EACE,aAAA;AbwyNJ;;AazyNE;EACE,aAAA;Ab4yNJ;;Aa7yNE;EACE,aAAA;AbgzNJ;;AajzNE;EACE,aAAA;AbozNJ;;AarzNE;EACE,aAAA;AbwzNJ;;AazzNE;EACE,aAAA;Ab4zNJ;;Aa7zNE;EACE,aAAA;Abg0NJ;;Aaj0NE;EACE,aAAA;Abo0NJ;;Aar0NE;EACE,aAAA;Abw0NJ;;Aaz0NE;EACE,aAAA;Ab40NJ;;Aa70NE;EACE,aAAA;Abg1NJ;;Aaj1NE;EACE,aAAA;Abo1NJ;;Aar1NE;EACE,aAAA;Abw1NJ;;Aaz1NE;EACE,aAAA;Ab41NJ;;Aa71NE;EACE,aAAA;Abg2NJ;;Aaj2NE;EACE,aAAA;Abo2NJ;;Aar2NE;EACE,aAAA;Abw2NJ;;Aaz2NE;EACE,aAAA;Ab42NJ;;Aa72NE;EACE,aAAA;Abg3NJ;;Aaj3NE;EACE,aAAA;Abo3NJ;;Aar3NE;EACE,aAAA;Abw3NJ;;Aaz3NE;EACE,aAAA;Ab43NJ;;Aa73NE;EACE,aAAA;Abg4NJ;;Aaj4NE;EACE,aAAA;Abo4NJ;;Aar4NE;EACE,aAAA;Abw4NJ;;Aaz4NE;EACE,UAAA;Ab44NJ;;Aa74NE;EACE,UAAA;Abg5NJ;;Aaj5NE;EACE,aAAA;Abo5NJ;;Aar5NE;EACE,aAAA;Abw5NJ;;Aaz5NE;EACE,aAAA;Ab45NJ;;Aa75NE;EACE,aAAA;Abg6NJ;;Aaj6NE;EACE,aAAA;Abo6NJ;;Aar6NE;EACE,aAAA;Abw6NJ;;Aaz6NE;EACE,aAAA;Ab46NJ;;Aa76NE;EACE,aAAA;Abg7NJ;;Aaj7NE;EACE,aAAA;Abo7NJ;;Aar7NE;EACE,aAAA;Abw7NJ;;Aaz7NE;EACE,aAAA;Ab47NJ;;Aa77NE;EACE,aAAA;Abg8NJ;;Aaj8NE;EACE,aAAA;Abo8NJ;;Aar8NE;EACE,aAAA;Abw8NJ;;Aaz8NE;EACE,aAAA;Ab48NJ;;Aa78NE;EACE,aAAA;Abg9NJ;;Aaj9NE;EACE,aAAA;Abo9NJ;;Aar9NE;EACE,aAAA;Abw9NJ;;Aaz9NE;EACE,aAAA;Ab49NJ;;Aa79NE;EACE,aAAA;Abg+NJ;;Aaj+NE;EACE,aAAA;Abo+NJ;;Aar+NE;EACE,aAAA;Abw+NJ;;Aaz+NE;EACE,aAAA;Ab4+NJ;;Aa7+NE;EACE,aAAA;Abg/NJ;;Aaj/NE;EACE,aAAA;Abo/NJ;;Aar/NE;EACE,aAAA;Abw/NJ;;Aaz/NE;EACE,aAAA;Ab4/NJ;;Aa7/NE;EACE,aAAA;AbggOJ;;AajgOE;EACE,aAAA;AbogOJ;;AargOE;EACE,aAAA;AbwgOJ;;AazgOE;EACE,aAAA;Ab4gOJ;;Aa7gOE;EACE,aAAA;AbghOJ;;AajhOE;EACE,aAAA;AbohOJ;;AarhOE;EACE,aAAA;AbwhOJ;;AazhOE;EACE,aAAA;Ab4hOJ;;Aa7hOE;EACE,aAAA;AbgiOJ;;AajiOE;EACE,aAAA;AboiOJ;;AariOE;EACE,aAAA;AbwiOJ;;AaziOE;EACE,aAAA;Ab4iOJ;;Aa7iOE;EACE,aAAA;AbgjOJ;;AajjOE;EACE,aAAA;AbojOJ;;AarjOE;EACE,aAAA;AbwjOJ;;AazjOE;EACE,aAAA;Ab4jOJ;;Aa7jOE;EACE,aAAA;AbgkOJ;;AajkOE;EACE,aAAA;AbokOJ;;AarkOE;EACE,aAAA;AbwkOJ;;AazkOE;EACE,aAAA;Ab4kOJ;;Aa7kOE;EACE,aAAA;AbglOJ;;AajlOE;EACE,aAAA;AbolOJ;;AarlOE;EACE,aAAA;AbwlOJ;;AazlOE;EACE,aAAA;Ab4lOJ;;Aa7lOE;EACE,aAAA;AbgmOJ;;AajmOE;EACE,aAAA;AbomOJ;;AarmOE;EACE,aAAA;AbwmOJ;;AazmOE;EACE,aAAA;Ab4mOJ;;Aa7mOE;EACE,aAAA;AbgnOJ;;AajnOE;EACE,aAAA;AbonOJ;;AarnOE;EACE,aAAA;AbwnOJ;;AaznOE;EACE,aAAA;Ab4nOJ;;Aa7nOE;EACE,aAAA;AbgoOJ;;AajoOE;EACE,aAAA;AbooOJ;;AaroOE;EACE,aAAA;AbwoOJ;;AazoOE;EACE,aAAA;Ab4oOJ;;Aa7oOE;EACE,aAAA;AbgpOJ;;AajpOE;EACE,aAAA;AbopOJ;;AarpOE;EACE,aAAA;AbwpOJ;;AazpOE;EACE,aAAA;Ab4pOJ;;Aa7pOE;EACE,aAAA;AbgqOJ;;AajqOE;EACE,aAAA;AboqOJ;;AarqOE;EACE,aAAA;AbwqOJ;;AazqOE;EACE,aAAA;Ab4qOJ;;Aa7qOE;EACE,aAAA;AbgrOJ;;AajrOE;EACE,aAAA;AborOJ;;AarrOE;EACE,aAAA;AbwrOJ;;AazrOE;EACE,aAAA;Ab4rOJ;;Aa7rOE;EACE,aAAA;AbgsOJ;;AajsOE;EACE,aAAA;AbosOJ;;AarsOE;EACE,aAAA;AbwsOJ;;AazsOE;EACE,aAAA;Ab4sOJ;;Aa7sOE;EACE,aAAA;AbgtOJ;;AajtOE;EACE,aAAA;AbotOJ;;AartOE;EACE,UAAA;AbwtOJ;;AaztOE;EACE,aAAA;Ab4tOJ;;Aa7tOE;EACE,aAAA;AbguOJ;;AajuOE;EACE,aAAA;AbouOJ;;AaruOE;EACE,SAAA;AbwuOJ;;AazuOE;EACE,aAAA;Ab4uOJ;;Aa7uOE;EACE,aAAA;AbgvOJ;;AajvOE;EACE,aAAA;AbovOJ;;AarvOE;EACE,aAAA;AbwvOJ;;AazvOE;EACE,aAAA;Ab4vOJ;;Aa7vOE;EACE,aAAA;AbgwOJ;;AajwOE;EACE,aAAA;AbowOJ;;AarwOE;EACE,aAAA;AbwwOJ;;AazwOE;EACE,aAAA;Ab4wOJ;;Aa7wOE;EACE,aAAA;AbgxOJ;;AajxOE;EACE,aAAA;AboxOJ;;AarxOE;EACE,aAAA;AbwxOJ;;AazxOE;EACE,aAAA;Ab4xOJ;;Aa7xOE;EACE,aAAA;AbgyOJ;;AajyOE;EACE,aAAA;AboyOJ;;AaryOE;EACE,aAAA;AbwyOJ;;AazyOE;EACE,aAAA;Ab4yOJ;;Aa7yOE;EACE,aAAA;AbgzOJ;;AajzOE;EACE,aAAA;AbozOJ;;AarzOE;EACE,aAAA;AbwzOJ;;AazzOE;EACE,aAAA;Ab4zOJ;;Aa7zOE;EACE,aAAA;Abg0OJ;;Aaj0OE;EACE,aAAA;Abo0OJ;;Aar0OE;EACE,aAAA;Abw0OJ;;Aaz0OE;EACE,aAAA;Ab40OJ;;Aa70OE;EACE,aAAA;Abg1OJ;;Aaj1OE;EACE,aAAA;Abo1OJ;;Aar1OE;EACE,aAAA;Abw1OJ;;Aaz1OE;EACE,aAAA;Ab41OJ;;Aa71OE;EACE,aAAA;Abg2OJ;;Aaj2OE;EACE,aAAA;Abo2OJ;;Aar2OE;EACE,aAAA;Abw2OJ;;Aaz2OE;EACE,aAAA;Ab42OJ;;Aa72OE;EACE,aAAA;Abg3OJ;;Aaj3OE;EACE,aAAA;Abo3OJ;;Aar3OE;EACE,aAAA;Abw3OJ;;Aaz3OE;EACE,aAAA;Ab43OJ;;Aa73OE;EACE,aAAA;Abg4OJ;;Aaj4OE;EACE,aAAA;Abo4OJ;;Aar4OE;EACE,aAAA;Abw4OJ;;Aaz4OE;EACE,aAAA;Ab44OJ;;Aa74OE;EACE,aAAA;Abg5OJ;;Aaj5OE;EACE,aAAA;Abo5OJ;;Aar5OE;EACE,aAAA;Abw5OJ;;Aaz5OE;EACE,aAAA;Ab45OJ;;Aa75OE;EACE,aAAA;Abg6OJ;;Aaj6OE;EACE,aAAA;Abo6OJ;;Aar6OE;EACE,aAAA;Abw6OJ;;Aaz6OE;EACE,aAAA;Ab46OJ;;Aa76OE;EACE,aAAA;Abg7OJ;;Aaj7OE;EACE,aAAA;Abo7OJ;;Aar7OE;EACE,aAAA;Abw7OJ;;Aaz7OE;EACE,aAAA;Ab47OJ;;Aa77OE;EACE,aAAA;Abg8OJ;;Aaj8OE;EACE,aAAA;Abo8OJ;;Aar8OE;EACE,SAAA;Abw8OJ;;Aaz8OE;EACE,aAAA;Ab48OJ;;Aa78OE;EACE,aAAA;Abg9OJ;;Aaj9OE;EACE,aAAA;Abo9OJ;;Aar9OE;EACE,aAAA;Abw9OJ;;Aaz9OE;EACE,aAAA;Ab49OJ;;Aa79OE;EACE,aAAA;Abg+OJ;;Aaj+OE;EACE,aAAA;Abo+OJ;;Aar+OE;EACE,aAAA;Abw+OJ;;Aaz+OE;EACE,aAAA;Ab4+OJ;;Aa7+OE;EACE,aAAA;Abg/OJ;;Aaj/OE;EACE,aAAA;Abo/OJ;;Aar/OE;EACE,aAAA;Abw/OJ;;Aaz/OE;EACE,aAAA;Ab4/OJ;;Aa7/OE;EACE,aAAA;AbggPJ;;AajgPE;EACE,aAAA;AbogPJ;;AargPE;EACE,aAAA;AbwgPJ;;AazgPE;EACE,aAAA;Ab4gPJ;;Aa7gPE;EACE,aAAA;AbghPJ;;AajhPE;EACE,aAAA;AbohPJ;;AarhPE;EACE,aAAA;AbwhPJ;;AazhPE;EACE,aAAA;Ab4hPJ;;Aa7hPE;EACE,aAAA;AbgiPJ;;AajiPE;EACE,aAAA;AboiPJ;;AariPE;EACE,aAAA;AbwiPJ;;AaziPE;EACE,aAAA;Ab4iPJ;;Aa7iPE;EACE,aAAA;AbgjPJ;;AajjPE;EACE,aAAA;AbojPJ;;AarjPE;EACE,aAAA;AbwjPJ;;AazjPE;EACE,aAAA;Ab4jPJ;;Aa7jPE;EACE,aAAA;AbgkPJ;;AajkPE;EACE,aAAA;AbokPJ;;AarkPE;EACE,aAAA;AbwkPJ;;AazkPE;EACE,aAAA;Ab4kPJ;;Aa7kPE;EACE,aAAA;AbglPJ;;AajlPE;EACE,aAAA;AbolPJ;;AarlPE;EACE,aAAA;AbwlPJ;;AazlPE;EACE,aAAA;Ab4lPJ;;Aa7lPE;EACE,aAAA;AbgmPJ;;AajmPE;EACE,aAAA;AbomPJ;;AarmPE;EACE,aAAA;AbwmPJ;;AazmPE;EACE,aAAA;Ab4mPJ;;Aa7mPE;EACE,aAAA;AbgnPJ;;AajnPE;EACE,aAAA;AbonPJ;;AarnPE;EACE,aAAA;AbwnPJ;;AaznPE;EACE,aAAA;Ab4nPJ;;Aa7nPE;EACE,aAAA;AbgoPJ;;AajoPE;EACE,aAAA;AbooPJ;;AaroPE;EACE,aAAA;AbwoPJ;;AazoPE;EACE,aAAA;Ab4oPJ;;Aa7oPE;EACE,aAAA;AbgpPJ;;AajpPE;EACE,aAAA;AbopPJ;;AarpPE;EACE,aAAA;AbwpPJ;;AazpPE;EACE,aAAA;Ab4pPJ;;Aa7pPE;EACE,aAAA;AbgqPJ;;AajqPE;EACE,aAAA;AboqPJ;;AarqPE;EACE,aAAA;AbwqPJ;;AazqPE;EACE,aAAA;Ab4qPJ;;Aa7qPE;EACE,aAAA;AbgrPJ;;AajrPE;EACE,aAAA;AborPJ;;AarrPE;EACE,aAAA;AbwrPJ;;AazrPE;EACE,aAAA;Ab4rPJ;;Aa7rPE;EACE,aAAA;AbgsPJ;;AajsPE;EACE,aAAA;AbosPJ;;AarsPE;EACE,aAAA;AbwsPJ;;AazsPE;EACE,aAAA;Ab4sPJ;;Aa7sPE;EACE,aAAA;AbgtPJ;;AajtPE;EACE,aAAA;AbotPJ;;AartPE;EACE,aAAA;AbwtPJ;;AaztPE;EACE,aAAA;Ab4tPJ;;Aa7tPE;EACE,aAAA;AbguPJ;;AajuPE;EACE,aAAA;AbouPJ;;AaruPE;EACE,aAAA;AbwuPJ;;AazuPE;EACE,aAAA;Ab4uPJ;;Aa7uPE;EACE,aAAA;AbgvPJ;;AajvPE;EACE,aAAA;AbovPJ;;AarvPE;EACE,aAAA;AbwvPJ;;AazvPE;EACE,aAAA;Ab4vPJ;;Aa7vPE;EACE,aAAA;AbgwPJ;;AajwPE;EACE,aAAA;AbowPJ;;AarwPE;EACE,aAAA;AbwwPJ;;AazwPE;EACE,aAAA;Ab4wPJ;;Aa7wPE;EACE,aAAA;AbgxPJ;;AajxPE;EACE,aAAA;AboxPJ;;AarxPE;EACE,aAAA;AbwxPJ;;AazxPE;EACE,aAAA;Ab4xPJ;;Aa7xPE;EACE,aAAA;AbgyPJ;;AajyPE;EACE,aAAA;AboyPJ;;AaryPE;EACE,aAAA;AbwyPJ;;AazyPE;EACE,aAAA;Ab4yPJ;;Aa7yPE;EACE,aAAA;AbgzPJ;;AajzPE;EACE,aAAA;AbozPJ;;AarzPE;EACE,aAAA;AbwzPJ;;AazzPE;EACE,aAAA;Ab4zPJ;;Aa7zPE;EACE,aAAA;Abg0PJ;;Aaj0PE;EACE,aAAA;Abo0PJ;;Aar0PE;EACE,aAAA;Abw0PJ;;Aaz0PE;EACE,aAAA;Ab40PJ;;Aa70PE;EACE,aAAA;Abg1PJ;;Aaj1PE;EACE,aAAA;Abo1PJ;;Aar1PE;EACE,aAAA;Abw1PJ;;Aaz1PE;EACE,aAAA;Ab41PJ;;Aa71PE;EACE,aAAA;Abg2PJ;;Aaj2PE;EACE,aAAA;Abo2PJ;;Aar2PE;EACE,aAAA;Abw2PJ;;Aaz2PE;EACE,aAAA;Ab42PJ;;Aa72PE;EACE,aAAA;Abg3PJ;;Aaj3PE;EACE,aAAA;Abo3PJ;;Aar3PE;EACE,aAAA;Abw3PJ;;Aaz3PE;EACE,aAAA;Ab43PJ;;Aa73PE;EACE,aAAA;Abg4PJ;;Aaj4PE;EACE,aAAA;Abo4PJ;;Aar4PE;EACE,aAAA;Abw4PJ;;Aaz4PE;EACE,aAAA;Ab44PJ;;Aa74PE;EACE,aAAA;Abg5PJ;;Aaj5PE;EACE,aAAA;Abo5PJ;;Aar5PE;EACE,aAAA;Abw5PJ;;Aaz5PE;EACE,aAAA;Ab45PJ;;Aa75PE;EACE,aAAA;Abg6PJ;;Aaj6PE;EACE,aAAA;Abo6PJ;;Aar6PE;EACE,aAAA;Abw6PJ;;Aaz6PE;EACE,aAAA;Ab46PJ;;Aa76PE;EACE,aAAA;Abg7PJ;;Aaj7PE;EACE,aAAA;Abo7PJ;;Aar7PE;EACE,aAAA;Abw7PJ;;Aaz7PE;EACE,UAAA;Ab47PJ;;Aa77PE;EACE,aAAA;Abg8PJ;;Aaj8PE;EACE,aAAA;Abo8PJ;;Aar8PE;EACE,aAAA;Abw8PJ;;Aaz8PE;EACE,aAAA;Ab48PJ;;Aa78PE;EACE,aAAA;Abg9PJ;;Aaj9PE;EACE,UAAA;Abo9PJ;;Aar9PE;EACE,UAAA;Abw9PJ;;Aaz9PE;EACE,UAAA;Ab49PJ;;Aa79PE;EACE,SAAA;Abg+PJ;;Aaj+PE;EACE,aAAA;Abo+PJ;;Aar+PE;EACE,aAAA;Abw+PJ;;Aaz+PE;EACE,aAAA;Ab4+PJ;;Aa7+PE;EACE,aAAA;Abg/PJ;;Aaj/PE;EACE,aAAA;Abo/PJ;;Aar/PE;EACE,aAAA;Abw/PJ;;Aaz/PE;EACE,aAAA;Ab4/PJ;;Aa7/PE;EACE,aAAA;AbggQJ;;AajgQE;EACE,aAAA;AbogQJ;;AargQE;EACE,aAAA;AbwgQJ;;AazgQE;EACE,aAAA;Ab4gQJ;;Aa7gQE;EACE,aAAA;AbghQJ;;AajhQE;EACE,SAAA;AbohQJ;;AarhQE;EACE,aAAA;AbwhQJ;;AazhQE;EACE,aAAA;Ab4hQJ;;Aa7hQE;EACE,aAAA;AbgiQJ;;AajiQE;EACE,aAAA;AboiQJ;;AariQE;EACE,aAAA;AbwiQJ;;AaziQE;EACE,aAAA;Ab4iQJ;;Aa7iQE;EACE,aAAA;AbgjQJ;;AajjQE;EACE,aAAA;AbojQJ;;AarjQE;EACE,aAAA;AbwjQJ;;AazjQE;EACE,aAAA;Ab4jQJ;;Aa7jQE;EACE,aAAA;AbgkQJ;;AajkQE;EACE,aAAA;AbokQJ;;AarkQE;EACE,aAAA;AbwkQJ;;AazkQE;EACE,aAAA;Ab4kQJ;;Aa7kQE;EACE,aAAA;AbglQJ;;AajlQE;EACE,aAAA;AbolQJ;;AarlQE;EACE,aAAA;AbwlQJ;;AazlQE;EACE,aAAA;Ab4lQJ;;Aa7lQE;EACE,aAAA;AbgmQJ;;AajmQE;EACE,aAAA;AbomQJ;;AarmQE;EACE,aAAA;AbwmQJ;;Ac5mQA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AL4lQF;;AKvlQE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;ALymQF;;Ae1oQA;;;;EAAA;AAQA;EACE,gDAAA;EACA,yDAAA;Af0oQF;;AetoQA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBRgC0B;EQ/B1B,0HAAA;AfyoQF;AeroQA;;EAEE,gBAAA;AfuoQF;;AgBhqQA;;;;EAAA;AAQA;EACE,gDAAA;EACA,uDAAA;AhBgqQF;;AgB5pQA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBTgC0B;ES/B1B,0HAAA;AhB+pQF;AgB3pQA;;EAEE,gBAAA;AhB6pQF;;AiBrrQE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,4BAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,8EAAA;EAAA,iFAAA;EAAA,8EAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,6EAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,2EAAA;EAAA,6EAAA;EAAA,2EAAA;EAAA,wEAAA;EAAA,gEAAA;EAAA,0EAAA;EAAA,yEAAA;EAAA,4BAAA;EAIA,+EAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,4EAAA;EAAA,qEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,qCAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,yEAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,2DAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AlBqrQF;;AoBryQI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,qEAAA;EACA,gCAAA;EAGE,+EAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,4EAAA;EAAA,qEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,yEAAA;EAAA,0EAAA;EAAA,yEAAA;EAAA,uEAAA;EAAA,8DAAA;EAAA,wEAAA;EAAA,6BAAA;EAAA,0CAAA;EAIA,8EAAA;EAAA,iFAAA;EAAA,8EAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,oEAAA;EACA,0EAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yDAAA;EACA,6BAAA;EACA,0DAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,0EAAA;EACA,iFAAA;EACA,4EAAA;EACA,mFAAA;AlBqrQJ;;AqB71QA;;;EAGE,sBAAA;ArBg2QF;;AqBj1QI;EANJ;IAOM,uBAAA;ErBq1QJ;AACF;;AqBx0QA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ArB20QF;;AqBl0QA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AtB4sP9B;;AqB3zQA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ArB4zQF;;AqBzzQA;EFuMQ,iCAAA;AnBsnQR;AmBlxQI;EE3CJ;IF8MQ,iBAAA;EnBmnQN;AACF;;AqB7zQA;EFkMQ,iCAAA;AnB+nQR;AmB3xQI;EEtCJ;IFyMQ,eAAA;EnB4nQN;AACF;;AqBj0QA;EF6LQ,+BAAA;AnBwoQR;AmBpyQI;EEjCJ;IFoMQ,kBAAA;EnBqoQN;AACF;;AqBr0QA;EFwLQ,iCAAA;AnBipQR;AmB7yQI;EE5BJ;IF+LQ,iBAAA;EnB8oQN;AACF;;AqBz0QA;EF+KM,kBALI;AnBmqQV;;AqBx0QA;EF0KM,eALI;AnBuqQV;;AqBj0QA;EACE,aAAA;EACA,mBCwV0B;AtB4+P5B;;AqB1zQA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;ArB6zQF;;AqBvzQA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ArB0zQF;;AqBpzQA;;EAEE,kBAAA;ArBuzQF;;AqBpzQA;;;EAGE,aAAA;EACA,mBAAA;ArBuzQF;;AqBpzQA;;;;EAIE,gBAAA;ArBuzQF;;AqBpzQA;EACE,gBC6b4B;AtB03P9B;;AqBlzQA;EACE,qBAAA;EACA,cAAA;ArBqzQF;;AqB/yQA;EACE,gBAAA;ArBkzQF;;AqB1yQA;;EAEE,mBCsa4B;AtBu4P9B;;AqBryQA;EF6EM,kBALI;AnBiuQV;;AqBlyQA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ArBqyQF;;AqB5xQA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ArB+xQF;;AqB5xQA;EAAM,eAAA;ArBgyQN;;AqB/xQA;EAAM,WAAA;ArBmyQN;;AqB9xQA;EACE,gEAAA;EACA,0BCgNwC;AtBilQ1C;AqB/xQE;EACE,mDAAA;ArBiyQJ;;AqBtxQE;EAEE,cAAA;EACA,qBAAA;ArBwxQJ;;AqBjxQA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AnB4wQV;;AqB7wQA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AnBoxQV;AqB5wQE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ArB8wQJ;;AqB1wQA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ArB6wQF;AqB1wQE;EACE,cAAA;ArB4wQJ;;AqBxwQA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;AvBijRJ;AqBzwQE;EACE,UAAA;EF7BE,cALI;AnB8yQV;;AqBjwQA;EACE,gBAAA;ArBowQF;;AqB9vQA;;EAEE,sBAAA;ArBiwQF;;AqBzvQA;EACE,oBAAA;EACA,yBAAA;ArB4vQF;;AqBzvQA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ArB4vQF;;AqBrvQA;EAEE,mBAAA;EACA,gCAAA;ArBuvQF;;AqBpvQA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ArBuvQF;;AqB/uQA;EACE,qBAAA;ArBkvQF;;AqB5uQA;EAEE,gBAAA;ArB8uQF;;AqBtuQA;EACE,UAAA;ArByuQF;;AqBpuQA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ArBuuQF;;AqBnuQA;;EAEE,oBAAA;ArBsuQF;;AqBjuQA;EACE,eAAA;ArBouQF;;AqBjuQA;EAGE,iBAAA;ArBkuQF;AqB/tQE;EACE,UAAA;ArBiuQJ;;AqB1tQA;EACE,wBAAA;ArB6tQF;;AqBrtQA;;;;EAIE,0BAAA;ArBwtQF;AqBrtQI;;;;EACE,eAAA;ArB0tQN;;AqBntQA;EACE,UAAA;EACA,kBAAA;ArBstQF;;AqBjtQA;EACE,gBAAA;ArBotQF;;AqB1sQA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ArB6sQF;;AqBrsQA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AnB25QR;AmBvjRI;EEyWJ;IFtMQ,iBAAA;EnBw5QN;AACF;AqB1sQE;EACE,WAAA;ArB4sQJ;;AqBrsQA;;;;;;;EAOE,UAAA;ArBwsQF;;AqBrsQA;EACE,YAAA;ArBwsQF;;AqB/rQA;EACE,6BAAA;EACA,oBAAA;ArBksQF;AqB/rQE;EACE,eAAA;EACA,oBAAA;ArBisQJ;;AqBxrQA;;;;;;;CAAA;AAWA;EACE,wBAAA;ArBwrQF;;AqBnrQA;EACE,UAAA;ArBsrQF;;AqB/qQA;EACE,aAAA;EACA,0BAAA;ArBkrQF;;AqB7qQA;EACE,qBAAA;ArBgrQF;;AqB3qQA;EACE,SAAA;ArB8qQF;;AqBvqQA;EACE,kBAAA;EACA,eAAA;ArB0qQF;;AqBlqQA;EACE,wBAAA;ArBqqQF;;AqB7pQA;EACE,wBAAA;ArBgqQF;;AwB3uRA;ELmQM,kBALI;EK5PR,gBFwoB4B;AtBsmQ9B;;AwBzuRE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AnB++QR;AmB3oRI;EKpGF;ILuQM,eAAA;EnB4+QN;AACF;;AwBpvRE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AnB0/QR;AmBtpRI;EKpGF;ILuQM,iBAAA;EnBu/QN;AACF;;AwB/vRE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AnBqgRR;AmBjqRI;EKpGF;ILuQM,eAAA;EnBkgRN;AACF;;AwB1wRE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AnBghRR;AmB5qRI;EKpGF;ILuQM,iBAAA;EnB6gRN;AACF;;AwBrxRE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AnB2hRR;AmBvrRI;EKpGF;ILuQM,eAAA;EnBwhRN;AACF;;AwBhyRE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AnBsiRR;AmBlsRI;EKpGF;ILuQM,iBAAA;EnBmiRN;AACF;;AwBnxRA;ECvDE,eAAA;EACA,gBAAA;AzB80RF;;AwBnxRA;EC5DE,eAAA;EACA,gBAAA;AzBm1RF;;AwBrxRA;EACE,qBAAA;AxBwxRF;AwBtxRE;EACE,oBFsoB0B;AtBkpQ9B;;AwB9wRA;EL8MM,kBALI;EKvMR,yBAAA;AxBixRF;;AwB7wRA;EACE,mBFiUO;EH1HH,kBALI;AnB+kRV;AwB9wRE;EACE,gBAAA;AxBgxRJ;;AwB5wRA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AtBq2RX;AwB7wRE;EACE,aAAA;AxB+wRJ;;A0B/2RA;ECIE,eAAA;EAGA,YAAA;A3B62RF;;A0B92RA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;A3Bs3RF;;A0Bx2RA;EAEE,qBAAA;A1B02RF;;A0Bv2RA;EACE,qBAAA;EACA,cAAA;A1B02RF;;A0Bv2RA;EPyPM,kBALI;EOlPR,gCJkjDkC;AtBwzOpC;;A4B54RE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;A7By5RF;;A8Bn2RI;EF5CE;IACE,gBNkee;EtBi7QrB;AACF;A8Bz2RI;EF5CE;IACE,gBNkee;EtBs7QrB;AACF;A8B92RI;EF5CE;IACE,gBNkee;EtB27QrB;AACF;A8Bn3RI;EF5CE;IACE,iBNkee;EtBg8QrB;AACF;A8Bx3RI;EF5CE;IACE,iBNkee;EtBq8QrB;AACF;A+Bx7RA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;A/B87RJ;;A+Bz7RE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhCk8RF;A+Bh8RI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhC47RF;;AgC74RM;EACE,WAAA;AhCg5RR;;AgC74RM;EApCJ,cAAA;EACA,WAAA;AhCq7RF;;AgCv6RE;EACE,cAAA;EACA,WAAA;AhC06RJ;;AgC56RE;EACE,cAAA;EACA,UAAA;AhC+6RJ;;AgCj7RE;EACE,cAAA;EACA,mBAAA;AhCo7RJ;;AgCt7RE;EACE,cAAA;EACA,UAAA;AhCy7RJ;;AgC37RE;EACE,cAAA;EACA,UAAA;AhC87RJ;;AgCh8RE;EACE,cAAA;EACA,mBAAA;AhCm8RJ;;AgCp6RM;EAhDJ,cAAA;EACA,WAAA;AhCw9RF;;AgCn6RU;EAhEN,cAAA;EACA,kBAAA;AhCu+RJ;;AgCx6RU;EAhEN,cAAA;EACA,mBAAA;AhC4+RJ;;AgC76RU;EAhEN,cAAA;EACA,UAAA;AhCi/RJ;;AgCl7RU;EAhEN,cAAA;EACA,mBAAA;AhCs/RJ;;AgCv7RU;EAhEN,cAAA;EACA,mBAAA;AhC2/RJ;;AgC57RU;EAhEN,cAAA;EACA,UAAA;AhCggSJ;;AgCj8RU;EAhEN,cAAA;EACA,mBAAA;AhCqgSJ;;AgCt8RU;EAhEN,cAAA;EACA,mBAAA;AhC0gSJ;;AgC38RU;EAhEN,cAAA;EACA,UAAA;AhC+gSJ;;AgCh9RU;EAhEN,cAAA;EACA,mBAAA;AhCohSJ;;AgCr9RU;EAhEN,cAAA;EACA,mBAAA;AhCyhSJ;;AgC19RU;EAhEN,cAAA;EACA,WAAA;AhC8hSJ;;AgCv9RY;EAxDV,wBAAA;AhCmhSF;;AgC39RY;EAxDV,yBAAA;AhCuhSF;;AgC/9RY;EAxDV,gBAAA;AhC2hSF;;AgCn+RY;EAxDV,yBAAA;AhC+hSF;;AgCv+RY;EAxDV,yBAAA;AhCmiSF;;AgC3+RY;EAxDV,gBAAA;AhCuiSF;;AgC/+RY;EAxDV,yBAAA;AhC2iSF;;AgCn/RY;EAxDV,yBAAA;AhC+iSF;;AgCv/RY;EAxDV,gBAAA;AhCmjSF;;AgC3/RY;EAxDV,yBAAA;AhCujSF;;AgC//RY;EAxDV,yBAAA;AhC2jSF;;AgCx/RQ;;EAEE,gBAAA;AhC2/RV;;AgCx/RQ;;EAEE,gBAAA;AhC2/RV;;AgClgSQ;;EAEE,sBAAA;AhCqgSV;;AgClgSQ;;EAEE,sBAAA;AhCqgSV;;AgC5gSQ;;EAEE,qBAAA;AhC+gSV;;AgC5gSQ;;EAEE,qBAAA;AhC+gSV;;AgCthSQ;;EAEE,mBAAA;AhCyhSV;;AgCthSQ;;EAEE,mBAAA;AhCyhSV;;AgChiSQ;;EAEE,qBAAA;AhCmiSV;;AgChiSQ;;EAEE,qBAAA;AhCmiSV;;AgC1iSQ;;EAEE,mBAAA;AhC6iSV;;AgC1iSQ;;EAEE,mBAAA;AhC6iSV;;A8BvmSI;EEUE;IACE,WAAA;EhCimSN;EgC9lSI;IApCJ,cAAA;IACA,WAAA;EhCqoSA;EgCvnSA;IACE,cAAA;IACA,WAAA;EhCynSF;EgC3nSA;IACE,cAAA;IACA,UAAA;EhC6nSF;EgC/nSA;IACE,cAAA;IACA,mBAAA;EhCioSF;EgCnoSA;IACE,cAAA;IACA,UAAA;EhCqoSF;EgCvoSA;IACE,cAAA;IACA,UAAA;EhCyoSF;EgC3oSA;IACE,cAAA;IACA,mBAAA;EhC6oSF;EgC9mSI;IAhDJ,cAAA;IACA,WAAA;EhCiqSA;EgC5mSQ;IAhEN,cAAA;IACA,kBAAA;EhC+qSF;EgChnSQ;IAhEN,cAAA;IACA,mBAAA;EhCmrSF;EgCpnSQ;IAhEN,cAAA;IACA,UAAA;EhCurSF;EgCxnSQ;IAhEN,cAAA;IACA,mBAAA;EhC2rSF;EgC5nSQ;IAhEN,cAAA;IACA,mBAAA;EhC+rSF;EgChoSQ;IAhEN,cAAA;IACA,UAAA;EhCmsSF;EgCpoSQ;IAhEN,cAAA;IACA,mBAAA;EhCusSF;EgCxoSQ;IAhEN,cAAA;IACA,mBAAA;EhC2sSF;EgC5oSQ;IAhEN,cAAA;IACA,UAAA;EhC+sSF;EgChpSQ;IAhEN,cAAA;IACA,mBAAA;EhCmtSF;EgCppSQ;IAhEN,cAAA;IACA,mBAAA;EhCutSF;EgCxpSQ;IAhEN,cAAA;IACA,WAAA;EhC2tSF;EgCppSU;IAxDV,cAAA;EhC+sSA;EgCvpSU;IAxDV,wBAAA;EhCktSA;EgC1pSU;IAxDV,yBAAA;EhCqtSA;EgC7pSU;IAxDV,gBAAA;EhCwtSA;EgChqSU;IAxDV,yBAAA;EhC2tSA;EgCnqSU;IAxDV,yBAAA;EhC8tSA;EgCtqSU;IAxDV,gBAAA;EhCiuSA;EgCzqSU;IAxDV,yBAAA;EhCouSA;EgC5qSU;IAxDV,yBAAA;EhCuuSA;EgC/qSU;IAxDV,gBAAA;EhC0uSA;EgClrSU;IAxDV,yBAAA;EhC6uSA;EgCrrSU;IAxDV,yBAAA;EhCgvSA;EgC7qSM;;IAEE,gBAAA;EhC+qSR;EgC5qSM;;IAEE,gBAAA;EhC8qSR;EgCrrSM;;IAEE,sBAAA;EhCurSR;EgCprSM;;IAEE,sBAAA;EhCsrSR;EgC7rSM;;IAEE,qBAAA;EhC+rSR;EgC5rSM;;IAEE,qBAAA;EhC8rSR;EgCrsSM;;IAEE,mBAAA;EhCusSR;EgCpsSM;;IAEE,mBAAA;EhCssSR;EgC7sSM;;IAEE,qBAAA;EhC+sSR;EgC5sSM;;IAEE,qBAAA;EhC8sSR;EgCrtSM;;IAEE,mBAAA;EhCutSR;EgCptSM;;IAEE,mBAAA;EhCstSR;AACF;A8BjxSI;EEUE;IACE,WAAA;EhC0wSN;EgCvwSI;IApCJ,cAAA;IACA,WAAA;EhC8ySA;EgChySA;IACE,cAAA;IACA,WAAA;EhCkySF;EgCpySA;IACE,cAAA;IACA,UAAA;EhCsySF;EgCxySA;IACE,cAAA;IACA,mBAAA;EhC0ySF;EgC5ySA;IACE,cAAA;IACA,UAAA;EhC8ySF;EgChzSA;IACE,cAAA;IACA,UAAA;EhCkzSF;EgCpzSA;IACE,cAAA;IACA,mBAAA;EhCszSF;EgCvxSI;IAhDJ,cAAA;IACA,WAAA;EhC00SA;EgCrxSQ;IAhEN,cAAA;IACA,kBAAA;EhCw1SF;EgCzxSQ;IAhEN,cAAA;IACA,mBAAA;EhC41SF;EgC7xSQ;IAhEN,cAAA;IACA,UAAA;EhCg2SF;EgCjySQ;IAhEN,cAAA;IACA,mBAAA;EhCo2SF;EgCrySQ;IAhEN,cAAA;IACA,mBAAA;EhCw2SF;EgCzySQ;IAhEN,cAAA;IACA,UAAA;EhC42SF;EgC7ySQ;IAhEN,cAAA;IACA,mBAAA;EhCg3SF;EgCjzSQ;IAhEN,cAAA;IACA,mBAAA;EhCo3SF;EgCrzSQ;IAhEN,cAAA;IACA,UAAA;EhCw3SF;EgCzzSQ;IAhEN,cAAA;IACA,mBAAA;EhC43SF;EgC7zSQ;IAhEN,cAAA;IACA,mBAAA;EhCg4SF;EgCj0SQ;IAhEN,cAAA;IACA,WAAA;EhCo4SF;EgC7zSU;IAxDV,cAAA;EhCw3SA;EgCh0SU;IAxDV,wBAAA;EhC23SA;EgCn0SU;IAxDV,yBAAA;EhC83SA;EgCt0SU;IAxDV,gBAAA;EhCi4SA;EgCz0SU;IAxDV,yBAAA;EhCo4SA;EgC50SU;IAxDV,yBAAA;EhCu4SA;EgC/0SU;IAxDV,gBAAA;EhC04SA;EgCl1SU;IAxDV,yBAAA;EhC64SA;EgCr1SU;IAxDV,yBAAA;EhCg5SA;EgCx1SU;IAxDV,gBAAA;EhCm5SA;EgC31SU;IAxDV,yBAAA;EhCs5SA;EgC91SU;IAxDV,yBAAA;EhCy5SA;EgCt1SM;;IAEE,gBAAA;EhCw1SR;EgCr1SM;;IAEE,gBAAA;EhCu1SR;EgC91SM;;IAEE,sBAAA;EhCg2SR;EgC71SM;;IAEE,sBAAA;EhC+1SR;EgCt2SM;;IAEE,qBAAA;EhCw2SR;EgCr2SM;;IAEE,qBAAA;EhCu2SR;EgC92SM;;IAEE,mBAAA;EhCg3SR;EgC72SM;;IAEE,mBAAA;EhC+2SR;EgCt3SM;;IAEE,qBAAA;EhCw3SR;EgCr3SM;;IAEE,qBAAA;EhCu3SR;EgC93SM;;IAEE,mBAAA;EhCg4SR;EgC73SM;;IAEE,mBAAA;EhC+3SR;AACF;A8B17SI;EEUE;IACE,WAAA;EhCm7SN;EgCh7SI;IApCJ,cAAA;IACA,WAAA;EhCu9SA;EgCz8SA;IACE,cAAA;IACA,WAAA;EhC28SF;EgC78SA;IACE,cAAA;IACA,UAAA;EhC+8SF;EgCj9SA;IACE,cAAA;IACA,mBAAA;EhCm9SF;EgCr9SA;IACE,cAAA;IACA,UAAA;EhCu9SF;EgCz9SA;IACE,cAAA;IACA,UAAA;EhC29SF;EgC79SA;IACE,cAAA;IACA,mBAAA;EhC+9SF;EgCh8SI;IAhDJ,cAAA;IACA,WAAA;EhCm/SA;EgC97SQ;IAhEN,cAAA;IACA,kBAAA;EhCigTF;EgCl8SQ;IAhEN,cAAA;IACA,mBAAA;EhCqgTF;EgCt8SQ;IAhEN,cAAA;IACA,UAAA;EhCygTF;EgC18SQ;IAhEN,cAAA;IACA,mBAAA;EhC6gTF;EgC98SQ;IAhEN,cAAA;IACA,mBAAA;EhCihTF;EgCl9SQ;IAhEN,cAAA;IACA,UAAA;EhCqhTF;EgCt9SQ;IAhEN,cAAA;IACA,mBAAA;EhCyhTF;EgC19SQ;IAhEN,cAAA;IACA,mBAAA;EhC6hTF;EgC99SQ;IAhEN,cAAA;IACA,UAAA;EhCiiTF;EgCl+SQ;IAhEN,cAAA;IACA,mBAAA;EhCqiTF;EgCt+SQ;IAhEN,cAAA;IACA,mBAAA;EhCyiTF;EgC1+SQ;IAhEN,cAAA;IACA,WAAA;EhC6iTF;EgCt+SU;IAxDV,cAAA;EhCiiTA;EgCz+SU;IAxDV,wBAAA;EhCoiTA;EgC5+SU;IAxDV,yBAAA;EhCuiTA;EgC/+SU;IAxDV,gBAAA;EhC0iTA;EgCl/SU;IAxDV,yBAAA;EhC6iTA;EgCr/SU;IAxDV,yBAAA;EhCgjTA;EgCx/SU;IAxDV,gBAAA;EhCmjTA;EgC3/SU;IAxDV,yBAAA;EhCsjTA;EgC9/SU;IAxDV,yBAAA;EhCyjTA;EgCjgTU;IAxDV,gBAAA;EhC4jTA;EgCpgTU;IAxDV,yBAAA;EhC+jTA;EgCvgTU;IAxDV,yBAAA;EhCkkTA;EgC//SM;;IAEE,gBAAA;EhCigTR;EgC9/SM;;IAEE,gBAAA;EhCggTR;EgCvgTM;;IAEE,sBAAA;EhCygTR;EgCtgTM;;IAEE,sBAAA;EhCwgTR;EgC/gTM;;IAEE,qBAAA;EhCihTR;EgC9gTM;;IAEE,qBAAA;EhCghTR;EgCvhTM;;IAEE,mBAAA;EhCyhTR;EgCthTM;;IAEE,mBAAA;EhCwhTR;EgC/hTM;;IAEE,qBAAA;EhCiiTR;EgC9hTM;;IAEE,qBAAA;EhCgiTR;EgCviTM;;IAEE,mBAAA;EhCyiTR;EgCtiTM;;IAEE,mBAAA;EhCwiTR;AACF;A8BnmTI;EEUE;IACE,WAAA;EhC4lTN;EgCzlTI;IApCJ,cAAA;IACA,WAAA;EhCgoTA;EgClnTA;IACE,cAAA;IACA,WAAA;EhConTF;EgCtnTA;IACE,cAAA;IACA,UAAA;EhCwnTF;EgC1nTA;IACE,cAAA;IACA,mBAAA;EhC4nTF;EgC9nTA;IACE,cAAA;IACA,UAAA;EhCgoTF;EgCloTA;IACE,cAAA;IACA,UAAA;EhCooTF;EgCtoTA;IACE,cAAA;IACA,mBAAA;EhCwoTF;EgCzmTI;IAhDJ,cAAA;IACA,WAAA;EhC4pTA;EgCvmTQ;IAhEN,cAAA;IACA,kBAAA;EhC0qTF;EgC3mTQ;IAhEN,cAAA;IACA,mBAAA;EhC8qTF;EgC/mTQ;IAhEN,cAAA;IACA,UAAA;EhCkrTF;EgCnnTQ;IAhEN,cAAA;IACA,mBAAA;EhCsrTF;EgCvnTQ;IAhEN,cAAA;IACA,mBAAA;EhC0rTF;EgC3nTQ;IAhEN,cAAA;IACA,UAAA;EhC8rTF;EgC/nTQ;IAhEN,cAAA;IACA,mBAAA;EhCksTF;EgCnoTQ;IAhEN,cAAA;IACA,mBAAA;EhCssTF;EgCvoTQ;IAhEN,cAAA;IACA,UAAA;EhC0sTF;EgC3oTQ;IAhEN,cAAA;IACA,mBAAA;EhC8sTF;EgC/oTQ;IAhEN,cAAA;IACA,mBAAA;EhCktTF;EgCnpTQ;IAhEN,cAAA;IACA,WAAA;EhCstTF;EgC/oTU;IAxDV,cAAA;EhC0sTA;EgClpTU;IAxDV,wBAAA;EhC6sTA;EgCrpTU;IAxDV,yBAAA;EhCgtTA;EgCxpTU;IAxDV,gBAAA;EhCmtTA;EgC3pTU;IAxDV,yBAAA;EhCstTA;EgC9pTU;IAxDV,yBAAA;EhCytTA;EgCjqTU;IAxDV,gBAAA;EhC4tTA;EgCpqTU;IAxDV,yBAAA;EhC+tTA;EgCvqTU;IAxDV,yBAAA;EhCkuTA;EgC1qTU;IAxDV,gBAAA;EhCquTA;EgC7qTU;IAxDV,yBAAA;EhCwuTA;EgChrTU;IAxDV,yBAAA;EhC2uTA;EgCxqTM;;IAEE,gBAAA;EhC0qTR;EgCvqTM;;IAEE,gBAAA;EhCyqTR;EgChrTM;;IAEE,sBAAA;EhCkrTR;EgC/qTM;;IAEE,sBAAA;EhCirTR;EgCxrTM;;IAEE,qBAAA;EhC0rTR;EgCvrTM;;IAEE,qBAAA;EhCyrTR;EgChsTM;;IAEE,mBAAA;EhCksTR;EgC/rTM;;IAEE,mBAAA;EhCisTR;EgCxsTM;;IAEE,qBAAA;EhC0sTR;EgCvsTM;;IAEE,qBAAA;EhCysTR;EgChtTM;;IAEE,mBAAA;EhCktTR;EgC/sTM;;IAEE,mBAAA;EhCitTR;AACF;A8B5wTI;EEUE;IACE,WAAA;EhCqwTN;EgClwTI;IApCJ,cAAA;IACA,WAAA;EhCyyTA;EgC3xTA;IACE,cAAA;IACA,WAAA;EhC6xTF;EgC/xTA;IACE,cAAA;IACA,UAAA;EhCiyTF;EgCnyTA;IACE,cAAA;IACA,mBAAA;EhCqyTF;EgCvyTA;IACE,cAAA;IACA,UAAA;EhCyyTF;EgC3yTA;IACE,cAAA;IACA,UAAA;EhC6yTF;EgC/yTA;IACE,cAAA;IACA,mBAAA;EhCizTF;EgClxTI;IAhDJ,cAAA;IACA,WAAA;EhCq0TA;EgChxTQ;IAhEN,cAAA;IACA,kBAAA;EhCm1TF;EgCpxTQ;IAhEN,cAAA;IACA,mBAAA;EhCu1TF;EgCxxTQ;IAhEN,cAAA;IACA,UAAA;EhC21TF;EgC5xTQ;IAhEN,cAAA;IACA,mBAAA;EhC+1TF;EgChyTQ;IAhEN,cAAA;IACA,mBAAA;EhCm2TF;EgCpyTQ;IAhEN,cAAA;IACA,UAAA;EhCu2TF;EgCxyTQ;IAhEN,cAAA;IACA,mBAAA;EhC22TF;EgC5yTQ;IAhEN,cAAA;IACA,mBAAA;EhC+2TF;EgChzTQ;IAhEN,cAAA;IACA,UAAA;EhCm3TF;EgCpzTQ;IAhEN,cAAA;IACA,mBAAA;EhCu3TF;EgCxzTQ;IAhEN,cAAA;IACA,mBAAA;EhC23TF;EgC5zTQ;IAhEN,cAAA;IACA,WAAA;EhC+3TF;EgCxzTU;IAxDV,cAAA;EhCm3TA;EgC3zTU;IAxDV,wBAAA;EhCs3TA;EgC9zTU;IAxDV,yBAAA;EhCy3TA;EgCj0TU;IAxDV,gBAAA;EhC43TA;EgCp0TU;IAxDV,yBAAA;EhC+3TA;EgCv0TU;IAxDV,yBAAA;EhCk4TA;EgC10TU;IAxDV,gBAAA;EhCq4TA;EgC70TU;IAxDV,yBAAA;EhCw4TA;EgCh1TU;IAxDV,yBAAA;EhC24TA;EgCn1TU;IAxDV,gBAAA;EhC84TA;EgCt1TU;IAxDV,yBAAA;EhCi5TA;EgCz1TU;IAxDV,yBAAA;EhCo5TA;EgCj1TM;;IAEE,gBAAA;EhCm1TR;EgCh1TM;;IAEE,gBAAA;EhCk1TR;EgCz1TM;;IAEE,sBAAA;EhC21TR;EgCx1TM;;IAEE,sBAAA;EhC01TR;EgCj2TM;;IAEE,qBAAA;EhCm2TR;EgCh2TM;;IAEE,qBAAA;EhCk2TR;EgCz2TM;;IAEE,mBAAA;EhC22TR;EgCx2TM;;IAEE,mBAAA;EhC02TR;EgCj3TM;;IAEE,qBAAA;EhCm3TR;EgCh3TM;;IAEE,qBAAA;EhCk3TR;EgCz3TM;;IAEE,mBAAA;EhC23TR;EgCx3TM;;IAEE,mBAAA;EhC03TR;AACF;AiCh/TA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjC++TF;AiCx+TE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjCy+TJ;AiCt+TE;EACE,uBAAA;AjCw+TJ;AiCr+TE;EACE,sBAAA;AjCu+TJ;;AiCn+TA;EACE,+DAAA;AjCs+TF;;AiC/9TA;EACE,iBAAA;AjCk+TF;;AiCx9TE;EACE,wBAAA;AjC29TJ;;AiC58TE;EACE,sCAAA;AjC+8TJ;AiC58TI;EACE,sCAAA;AjC88TN;;AiCv8TE;EACE,sBAAA;AjC08TJ;AiCv8TE;EACE,mBAAA;AjCy8TJ;;AiC/7TE;EACE,oDAAA;EACA,8CAAA;AjCk8TJ;;AiC57TE;EACE,oDAAA;EACA,8CAAA;AjC+7TJ;;AiCv7TA;EACE,oDAAA;EACA,8CAAA;AjC07TF;;AiCl7TE;EACE,mDAAA;EACA,6CAAA;AjCq7TJ;;AkCjkUE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlC6jUJ;;AkC/kUE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,uEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlC2kUJ;;AkC7lUE;EAOE,sBAAA;EACA,kEAAA;EACA,2EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCylUJ;;AkC3mUE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCumUJ;;AkCznUE;EAOE,sBAAA;EACA,uDAAA;EACA,kEAAA;EACA,gEAAA;EACA,8BAAA;EACA,+DAAA;EACA,6BAAA;EACA,8DAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCqnUJ;;AkCvoUE;EAOE,sBAAA;EACA,kEAAA;EACA,4EAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCmoUJ;;AkCrpUE;EAOE,sBAAA;EACA,sBAAA;EACA,2EAAA;EACA,yEAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCipUJ;;AkCnqUE;EAOE,sBAAA;EACA,sBAAA;EACA,2EAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlC+pUJ;;AiC9gUI;EACE,gBAAA;EACA,iCAAA;AjCihUN;;A8B5mUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjCuhUJ;AACF;A8BnnUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjC6hUJ;AACF;A8BznUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjCmiUJ;AACF;A8B/nUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjCyiUJ;AACF;A8BroUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjC+iUJ;AACF;AmCntUA;EACE,qBbu2BsC;AtB82SxC;;AmC5sUA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;AtB8mT9B;;AmCzsUA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AnB88TV;;AmCzsUA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AnBo9TV;;AoC1uUA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;AtB44SxC;;AqChvUA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ArC8uUF;AsChvUM;EDhBN;ICiBQ,gBAAA;EtCmvUN;AACF;AqCjvUE;EACE,gBAAA;ArCmvUJ;AqCjvUI;EACE,eAAA;ArCmvUN;AqC9uUE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,gEf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;AtB0tTxB;AqCxuUE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArC4tUJ;AqCvtUE;EACE,cAAA;EACA,UAAA;ArCytUJ;AqCrtUE;EACE,gCf40BoC;Ee10BpC,UAAA;ArCstUJ;AqC9sUE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ArC6sUJ;AqCzsUE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArC2sUJ;AsCjyUM;ED0EJ;ICzEM,gBAAA;EtCoyUN;AACF;AqC7sUE;EACE,wCf47B8B;AtBmxSlC;;AqCtsUA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArCysUF;AqCvsUE;EACE,UAAA;ArCysUJ;AqCtsUE;EAEE,gBAAA;EACA,eAAA;ArCusUJ;;AqC5rUA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AvBo0UJ;AqC7rUE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;AtB2jT9B;;AqC3rUA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;AvBg1UJ;AqC5rUE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AtBmkT9B;;AqCtrUE;EACE,oEf6uBoC;AtB48SxC;AqCtrUE;EACE,mEf0uBoC;AtB88SxC;AqCrrUE;EACE,iEfuuBoC;AtBg9SxC;;AqClrUA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AtBomT9B;AqCnrUE;EACE,eAAA;ArCqrUJ;AqClrUE;EACE,oBAAA;EdvLA,sCAAA;AvB42UJ;AqCjrUE;EACE,oBAAA;Ed5LA,sCAAA;AvBg3UJ;AqChrUE;EAAoB,+Df8sBkB;AtBq+SxC;AqClrUE;EAAoB,6Df8sBkB;AtBu+SxC;;AwCp4UA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AxCo4UF;AsCz4UM;EEfN;IFgBQ,gBAAA;EtC44UN;AACF;AwCv4UE;EACE,gElBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AtBo6SlC;AwCj4UE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxCk4UJ;AwC/3UE;EAEE,wClBu1BoC;AtByiTxC;AwC33UE;EACE,kBAAA;EACA,uCAAA;AxC63UJ;;AwCz3UA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AvBu6UJ;;AwCz3UA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;AvB+6UJ;;AwCv3UI;EACE,iEAAA;AxC03UN;;AyCl8UA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AtBgiT1C;AyCn8UE;EACE,WAAA;EACA,mBAAA;AzCq8UJ;;AyCj8UA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzCo8UF;AyCl8UE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzCo8UJ;;AyCh8UA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AzCk8UF;AyC/7UE;ElB3BE,qBAAA;AvB69UJ;AyC97UE;EAEE,kBnBm4BsC;AtB4jT1C;AyC57UE;EACE,uBnB03BsC;AtBokT1C;AyC37UE;EACE,gEnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;AtB+7TxB;AyC17UE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AtBy9UV;AyC17UI;EAII,kEAAA;AzCy7UR;AyCr7UI;EAII,kEAAA;AzCo7UR;AyC/6UE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,kEAAA;AzC66UN;AyCz6UE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AtBykT3C;AyCp6UI;EACE,eAAA;EACA,YnBy1BqC;AtB6kT3C;;AyCx5UA;EACE,mBnBo1BgC;AtBukTlC;AyCz5UE;EACE,6DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzC05UJ;AsC5gVM;EG0GJ;IHzGM,gBAAA;EtC+gVN;AACF;AyC75UI;EACE,0MAAA;AzC+5UN;AyC55UI;EACE,iCnB60B4B;EmBx0B1B,6DAAA;AzC05UR;AyCr5UE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzCu5UJ;AyCr5UI;EACE,oBAAA;EACA,cAAA;AzCu5UN;;AyCl5UA;EACE,qBAAA;EACA,kBnBsyBgC;AtB+mTlC;;AyCl5UA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzCq5UF;AyCj5UI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AtB6vT9B;;AyC54UI;EACE,6DAAA;AzC+4UN;;A0ClkVA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1CqkVF;A0CnkVE;EACE,UAAA;A1CqkVJ;A0CjkVI;EAA0B,qEpB8gCa;AtBsjT3C;A0CnkVI;EAA0B,qEpB6gCa;AtByjT3C;A0CnkVE;EACE,SAAA;A1CqkVJ;A0ClkVE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,4GImBF;A1CmkVJ;AsCllVM;EIMJ;IJLM,gBAAA;EtCqlVN;AACF;A0CtkVI;EHjCF,qEjB8hCyC;AtB4kT3C;A0CpkVE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AvBomVJ;A0ClkVE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,4GI6CF;A1CmkVJ;AsC5mVM;EIiCJ;IJhCM,gBAAA;EtC+mVN;AACF;A0CtkVI;EH3DF,qEjB8hCyC;AtBsmT3C;A0CpkVE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;AvB8nVJ;A0ClkVE;EACE,oBAAA;A1CokVJ;A0ClkVI;EACE,2CpBg9BqC;AtBonT3C;A0CjkVI;EACE,2CpB48BqC;AtBunT3C;;A2C1pVA;EACE,kBAAA;A3C6pVF;A2C3pVE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AtBsnTxC;A2C1pVE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A3C4pVJ;AsCnqVM;EKTJ;ILUM,gBAAA;EtCsqVN;AACF;A2C9pVE;;EAEE,qBAAA;A3CgqVJ;A2C9pVI;;EACE,kBAAA;A3CiqVN;A2C9pVI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;AtBupTxC;A2C9pVI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;AtB4pTxC;A2C7pVE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;AtB+7T9B;A2CxpVI;;;;EACE,8DrBy/BkC;AtBoqTxC;A2CxpVI;EACE,8DrBm/BkC;AtBuqTxC;A2CrpVI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;AvBotVJ;A2CrpVE;EACE,wCrBkzBoC;AtBq2TxC;A2CnpVI;EACE,sCAAA;A3CqpVN;A2CjpVE;;EAEE,crBhFO;AtBmuVX;;A4C7uVA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5CgvVF;A4C9uVE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5CgvVJ;A4C5uVE;;;EAGE,UAAA;A5C8uVJ;A4CxuVE;EACE,kBAAA;EACA,UAAA;A5C0uVJ;A4CxuVI;EACE,UAAA;A5C0uVN;;A4C/tVA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;AvBywVJ;;A4CztVA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AvBkxVJ;;A4CztVA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;AvB2xVJ;;A4CztVA;;EAEE,mBAAA;A5C4tVF;;A4C/sVI;;;;ErBjEA,0BAAA;EACA,6BAAA;AvBuxVJ;A4C9sVI;;;;ErB1EA,0BAAA;EACA,6BAAA;AvB8xVJ;A4CxsVE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AvBqxVJ;A4CxsVE;;ErB9EE,yBAAA;EACA,4BAAA;AvB0xVJ;;A6ClzVE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AtBkwTzB;;A6CjzVE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;AvB+0VJ;;A6C/yVI;;;;EAEE,cAAA;A7CozVN;;A6Cn2VI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7CgzVR;A6C7yVM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AtBoyTzB;;A6Ch3VI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7CqyVR;;A6Cr3VI;EAuFE,+CvBq/BmB;AtB6yTzB;A6C/xVQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7CgyVV;A6C5xVM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AtBuzTzB;;A6Cn4VI;EAkHI,yCAAA;A7CqxVR;;A6Cv4VI;EAyHE,+CvBm9BmB;AtB+zTzB;A6ChxVM;EACE,4CvBg9BiB;AtBk0TzB;A6C/wVM;EACE,2DvB48BiB;AtBq0TzB;A6C9wVM;EACE,iCvBw8BiB;AtBw0TzB;;A6C3wVI;EACE,kBAAA;A7C8wVN;;A6Cx5VI;;;;;EAoJM,UAAA;A7C4wVV;;A6C54VE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;AtB41TzB;;A6C34VE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;AvBy6VJ;;A6Cz4VI;;;;EAEE,cAAA;A7C84VN;;A6C77VI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7C04VR;A6Cv4VM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;AtB83TzB;;A6C18VI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7C+3VR;;A6C/8VI;EAuFE,iDvBq/BmB;AtBu4TzB;A6Cz3VQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7C03VV;A6Ct3VM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;AtBi5TzB;;A6C79VI;EAkHI,yCAAA;A7C+2VR;;A6Cj+VI;EAyHE,iDvBm9BmB;AtBy5TzB;A6C12VM;EACE,8CvBg9BiB;AtB45TzB;A6Cz2VM;EACE,0DvB48BiB;AtB+5TzB;A6Cx2VM;EACE,mCvBw8BiB;AtBk6TzB;;A6Cr2VI;EACE,kBAAA;A7Cw2VN;;A6Cl/VI;;;;;EAsJM,UAAA;A7Co2VV;;A8C5/VA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9C0/VF;AsC9gWM;EQhBN;IRiBQ,gBAAA;EtCihWN;AACF;A8C7/VE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9C8/VJ;A8C3/VE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9C4/VJ;A8Cz/VE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Cu/VN;A8Cn/VE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Ci/VN;A8C7+VE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9Cy+VJ;A8Ct+VI;EAKI,0CAAA;A9Co+VR;A8C/9VE;EAKI,0CAAA;A9C69VN;A8Cz9VE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9Cw9VJ;;A8C58VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,qEAAA;EACA,+EAAA;EACA,uCAAA;EACA,2BAAA;EACA,sEAAA;EACA,gFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/C+jWF;;A8C79VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gDAAA;EACA,gFAAA;EACA,wCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CglWF;;A8C9+VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,+CAAA;EACA,+EAAA;EACA,uCAAA;EACA,2BAAA;EACA,sEAAA;EACA,gFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CimWF;;A8C//VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0DAAA;EACA,+EAAA;EACA,uCAAA;EACA,2BAAA;EACA,sEAAA;EACA,gFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CknWF;;A8ChhWE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0DAAA;EACA,oEAAA;EACA,uCAAA;EACA,2BAAA;EACA,2DAAA;EACA,qEAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CmoWF;;A8CjiWE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,gFAAA;EACA,sCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CopWF;;A8CljWE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,+EAAA;EACA,wCAAA;EACA,2BAAA;EACA,sEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CqqWF;;A8CnkWE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,gFAAA;EACA,qCAAA;EACA,2BAAA;EACA,sEAAA;EACA,iFAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CsrWF;;A8C1jWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/C8qWF;;A8C3kWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/C+rWF;;A8C5lWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CgtWF;;A8C7mWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CiuWF;;A8C9nWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CkvWF;;A8C/oWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CmwWF;;A8ChqWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CoxWF;;A8CjrWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CqyWF;;A8CtrWA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;AtB06V1C;A8C9qWE;EACE,0BAAA;A9CgrWJ;A8C7qWE;EACE,gCAAA;A9C+qWJ;;A8CpqWA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/CyzWF;;A8CvqWA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/Cg0WF;;AgDn4WA;EVgBM,gCUfJ;AhDs4WF;AsCn3WM;EUpBN;IVqBQ,gBAAA;EtCs3WN;AACF;AgDz4WE;EACE,UAAA;AhD24WJ;;AgDr4WE;EACE,aAAA;AhDw4WJ;;AgDp4WA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhDu4WF;AsCr4WM;EULN;IVMQ,gBAAA;EtCw4WN;AACF;AgD14WE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhD44WJ;AsC/4WM;EUAJ;IVCM,gBAAA;EtCk5WN;AACF;;AiDv6WA;;;;;;EAME,kBAAA;AjD06WF;;AiDv6WA;EACE,mBAAA;AjD06WF;AkDl5WI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlD07WF;AkDh4WI;EACE,cAAA;AlDk4WN;;AiDh7WA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AvB09WJ;AiD76WE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjD+6WJ;;AiDv5WI;EACE,oBAAA;AjD05WN;AiDx5WM;EACE,WAAA;EACA,OAAA;AjD05WR;;AiDt5WI;EACE,kBAAA;AjDy5WN;AiDv5WM;EACE,QAAA;EACA,UAAA;AjDy5WR;;A8Bn8WI;EmB4BA;IACE,oBAAA;EjD26WJ;EiDz6WI;IACE,WAAA;IACA,OAAA;EjD26WN;EiDv6WE;IACE,kBAAA;EjDy6WJ;EiDv6WI;IACE,QAAA;IACA,UAAA;EjDy6WN;AACF;A8Bp9WI;EmB4BA;IACE,oBAAA;EjD27WJ;EiDz7WI;IACE,WAAA;IACA,OAAA;EjD27WN;EiDv7WE;IACE,kBAAA;EjDy7WJ;EiDv7WI;IACE,QAAA;IACA,UAAA;EjDy7WN;AACF;A8Bp+WI;EmB4BA;IACE,oBAAA;EjD28WJ;EiDz8WI;IACE,WAAA;IACA,OAAA;EjD28WN;EiDv8WE;IACE,kBAAA;EjDy8WJ;EiDv8WI;IACE,QAAA;IACA,UAAA;EjDy8WN;AACF;A8Bp/WI;EmB4BA;IACE,oBAAA;EjD29WJ;EiDz9WI;IACE,WAAA;IACA,OAAA;EjD29WN;EiDv9WE;IACE,kBAAA;EjDy9WJ;EiDv9WI;IACE,QAAA;IACA,UAAA;EjDy9WN;AACF;A8BpgXI;EmB4BA;IACE,oBAAA;EjD2+WJ;EiDz+WI;IACE,WAAA;IACA,OAAA;EjD2+WN;EiDv+WE;IACE,kBAAA;EjDy+WJ;EiDv+WI;IACE,QAAA;IACA,UAAA;EjDy+WN;AACF;AiDh+WE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjDk+WJ;AkDtjXI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlDulXF;AkDpiXI;EACE,cAAA;AlDsiXN;;AiDt+WE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjDy+WJ;AkD3kXI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlDqmXF;AkDzjXI;EACE,cAAA;AlD2jXN;AiDj/WI;EACE,iBAAA;AjDm/WN;;AiD7+WE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjDg/WJ;AkDnmXI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlDqmXN;AkD1lXM;EACE,aAAA;AlD4lXR;AkDzlXM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlD+nXF;AkDzlXI;EACE,cAAA;AlD2lXN;AiDhgXI;EACE,iBAAA;AjDkgXN;;AiD3/WA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjD8/WF;;AiDx/WA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AvBkqXJ;AiDz/WE;EAEE,0CAAA;EV1LF,kDU4LuB;AjDy/WzB;AiDt/WE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjDu/WzB;AiDp/WE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjDq/WJ;;AiD/+WA;EACE,cAAA;AjDk/WF;;AiD9+WA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjDi/WF;;AiD7+WA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjDg/WF;;AiD5+WA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjD8+WF;;AmDpuXA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnDuuXF;AmDruXE;;EACE,kBAAA;EACA,cAAA;AnDwuXJ;AmDnuXE;;;;;;;;;;;;EAME,UAAA;AnD2uXJ;;AmDtuXA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnDyuXF;AmDvuXE;EACE,WAAA;AnDyuXJ;;AmDruXA;E5BhBI,sCAAA;AvByvXJ;AmDruXE;;EAEE,8CAAA;AnDuuXJ;AmDnuXE;;;E5BVE,0BAAA;EACA,6BAAA;AvBkvXJ;AmD/tXE;;;E5BNE,yBAAA;EACA,4BAAA;AvB0uXJ;;AmDltXA;EACE,wBAAA;EACA,uBAAA;AnDqtXF;AmDntXE;EAGE,cAAA;AnDmtXJ;AmDhtXE;EACE,eAAA;AnDktXJ;;AmD9sXA;EACE,uBAAA;EACA,sBAAA;AnDitXF;;AmD9sXA;EACE,sBAAA;EACA,qBAAA;AnDitXF;;AmD7rXA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnDgsXF;AmD9rXE;;EAEE,WAAA;AnDgsXJ;AmD7rXE;;EAEE,6CAAA;AnD+rXJ;AmD3rXE;;E5B1FE,6BAAA;EACA,4BAAA;AvByxXJ;AmDvrXE;;;E5BjHE,yBAAA;EACA,0BAAA;AvB6yXJ;;AoDr0XA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApDo0XF;;AoDj0XA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApDo0XF;AsCh1XM;EcGN;IdFQ,gBAAA;EtCm1XN;AACF;AoDv0XE;EAEE,qCAAA;ApDw0XJ;AoDp0XE;EACE,UAAA;EACA,kD9BkhBoB;AtBozWxB;AoDl0XE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApDm0XJ;;AoD3zXA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApD2zXF;AoDzzXE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AvBy2XJ;AoD1zXI;EAGE,kBAAA;EACA,wDAAA;ApD0zXN;AoDtzXE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApDwzXJ;AoDrzXE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AvBw3XJ;;AoD7yXA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApD+yXF;AoD5yXE;E7B5FE,gDAAA;AvB24XJ;AoD3yXE;;EAEE,4CAAA;EbjHF,oDakHuB;ApD6yXzB;;AoDpyXA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApDoyXF;AoDlyXE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApDoyXJ;AoDlyXI;EAEE,iCAAA;ApDmyXN;AoD/xXE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApDiyXJ;;AoDvxXE;;EAEE,cAAA;EACA,kBAAA;ApD0xXJ;;AoDrxXE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ApDwxXJ;;AoDlxXE;;EACE,WAAA;ApDsxXJ;;AoD5wXE;EACE,aAAA;ApD+wXJ;AoD7wXE;EACE,cAAA;ApD+wXJ;;AqD58XA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArD48XF;AqDt8XE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArD88XJ;AqD17XA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArD47XF;AqD17XE;EAEE,yCAAA;ArD27XJ;;AqDj7XA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArDg7XF;AqD76XI;EAEE,oCAAA;ArD86XN;AqD16XE;EACE,gBAAA;ArD46XJ;;AqDn6XA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArDs6XF;AqDp6XE;;;EAGE,oCAAA;ArDs6XJ;;AqDz5XA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ArD05XF;;AqDt5XA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArDy5XF;AsCliYM;EeiIN;IfhIQ,gBAAA;EtCqiYN;AACF;AqD55XE;EACE,qBAAA;ArD85XJ;AqD35XE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArD65XJ;;AqDv5XA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArD05XF;;AqDv5XA;EACE,yCAAA;EACA,gBAAA;ArD05XF;;A8BphYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErDi5XN;EqD/4XM;IACE,mBAAA;ErDi5XR;EqD/4XQ;IACE,kBAAA;ErDi5XV;EqD94XQ;IACE,kDAAA;IACA,iDAAA;ErDg5XV;EqD54XM;IACE,iBAAA;ErD84XR;EqD34XM;IACE,wBAAA;IACA,gBAAA;ErD64XR;EqD14XM;IACE,aAAA;ErD44XR;EqDz4XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDy4XR;EqDt4XQ;IACE,aAAA;ErDw4XV;EqDr4XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDu4XV;AACF;A8BpkYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErDg8XN;EqD97XM;IACE,mBAAA;ErDg8XR;EqD97XQ;IACE,kBAAA;ErDg8XV;EqD77XQ;IACE,kDAAA;IACA,iDAAA;ErD+7XV;EqD37XM;IACE,iBAAA;ErD67XR;EqD17XM;IACE,wBAAA;IACA,gBAAA;ErD47XR;EqDz7XM;IACE,aAAA;ErD27XR;EqDx7XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDw7XR;EqDr7XQ;IACE,aAAA;ErDu7XV;EqDp7XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDs7XV;AACF;A8BnnYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD++XN;EqD7+XM;IACE,mBAAA;ErD++XR;EqD7+XQ;IACE,kBAAA;ErD++XV;EqD5+XQ;IACE,kDAAA;IACA,iDAAA;ErD8+XV;EqD1+XM;IACE,iBAAA;ErD4+XR;EqDz+XM;IACE,wBAAA;IACA,gBAAA;ErD2+XR;EqDx+XM;IACE,aAAA;ErD0+XR;EqDv+XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDu+XR;EqDp+XQ;IACE,aAAA;ErDs+XV;EqDn+XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDq+XV;AACF;A8BlqYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD8hYN;EqD5hYM;IACE,mBAAA;ErD8hYR;EqD5hYQ;IACE,kBAAA;ErD8hYV;EqD3hYQ;IACE,kDAAA;IACA,iDAAA;ErD6hYV;EqDzhYM;IACE,iBAAA;ErD2hYR;EqDxhYM;IACE,wBAAA;IACA,gBAAA;ErD0hYR;EqDvhYM;IACE,aAAA;ErDyhYR;EqDthYM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDshYR;EqDnhYQ;IACE,aAAA;ErDqhYV;EqDlhYQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDohYV;AACF;A8BjtYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD6kYN;EqD3kYM;IACE,mBAAA;ErD6kYR;EqD3kYQ;IACE,kBAAA;ErD6kYV;EqD1kYQ;IACE,kDAAA;IACA,iDAAA;ErD4kYV;EqDxkYM;IACE,iBAAA;ErD0kYR;EqDvkYM;IACE,wBAAA;IACA,gBAAA;ErDykYR;EqDtkYM;IACE,aAAA;ErDwkYR;EqDrkYM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDqkYR;EqDlkYQ;IACE,aAAA;ErDokYV;EqDjkYQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDmkYV;AACF;AqD1nYI;EAEI,iBAAA;EACA,2BAAA;ArD2nYR;AqDznYQ;EACE,mBAAA;ArD2nYV;AqDznYU;EACE,kBAAA;ArD2nYZ;AqDxnYU;EACE,kDAAA;EACA,iDAAA;ArD0nYZ;AqDtnYQ;EACE,iBAAA;ArDwnYV;AqDrnYQ;EACE,wBAAA;EACA,gBAAA;ArDunYV;AqDpnYQ;EACE,aAAA;ArDsnYV;AqDnnYQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArDmnYV;AqDhnYU;EACE,aAAA;ArDknYZ;AqD/mYU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArDinYZ;;AqDhmYA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArDkmYF;;AqD5lYI;EACE,qEAAA;ArD+lYN;;AsDx3YA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AvB04YJ;AsDr3YE;EACE,eAAA;EACA,cAAA;AtDu3YJ;AsDp3YE;EACE,mBAAA;EACA,sBAAA;AtDs3YJ;AsDp3YI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AvB64YJ;AsDp3YI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AvBo4YJ;AsDj3YE;;EAEE,aAAA;AtDm3YJ;;AsD/2YA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtDg3YF;;AsD72YA;EACE,4CAAA;EACA,iCAAA;AtDg3YF;;AsD72YA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtDg3YF;;AsD72YA;EACE,gBAAA;AtDg3YF;;AsDx2YE;EACE,oCAAA;AtD22YJ;;AsDn2YA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtDs2YF;AsDp2YE;E/B7FE,wFAAA;AvBo8YJ;;AsDl2YA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtDq2YF;AsDn2YE;E/BxGE,wFAAA;AvB88YJ;;AsD51YA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtD+1YF;AsD71YE;EACE,mCAAA;EACA,sCAAA;AtD+1YJ;;AsD31YA;EACE,uDAAA;EACA,sDAAA;AtD81YF;;AsD11YA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AvBw+YJ;;AsD11YA;;;EAGE,WAAA;AtD61YF;;AsD11YA;;E/B3II,0DAAA;EACA,2DAAA;AvB0+YJ;;AsD31YA;;E/BlII,8DAAA;EACA,6DAAA;AvBk+YJ;;AsDp1YE;EACE,0CAAA;AtDu1YJ;A8Bl9YI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtDu1YF;EsDp1YE;IACE,WAAA;IACA,gBAAA;EtDs1YJ;EsDp1YI;IACE,cAAA;IACA,cAAA;EtDs1YN;EsDj1YM;I/B1KJ,0BAAA;IACA,6BAAA;EvB8/YF;EsDl1YQ;;IAGE,0BAAA;EtDm1YV;EsDj1YQ;;IAGE,6BAAA;EtDk1YV;EsD90YM;I/B3KJ,yBAAA;IACA,4BAAA;EvB4/YF;EsD/0YQ;;IAGE,yBAAA;EtDg1YV;EsD90YQ;;IAGE,4BAAA;EtD+0YV;AACF;;AuDnjZA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,2RAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvDqjZF;;AuDjjZA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvDojZF;AsC3kZM;EiBUN;IjBTQ,gBAAA;EtC8kZN;AACF;AuDvjZE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvDyjZJ;AuDvjZI;EACE,qDAAA;EACA,iDAAA;AvDyjZN;AuDpjZE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvDsjZJ;AsCpmZM;EiBqCJ;IjBpCM,gBAAA;EtCumZN;AACF;AuDxjZE;EACE,UAAA;AvD0jZJ;AuDvjZE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvDyjZJ;;AuDrjZA;EACE,gBAAA;AvDwjZF;;AuDrjZA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvDwjZF;AuDtjZE;EhC7DE,yDAAA;EACA,0DAAA;AvBsnZJ;AuDvjZI;EhChEA,+DAAA;EACA,gEAAA;AvB0nZJ;AuDtjZE;EACE,aAAA;AvDwjZJ;AuDpjZE;EhC5DE,6DAAA;EACA,4DAAA;AvBmnZJ;AuDpjZM;EhChEF,mEAAA;EACA,kEAAA;AvBunZJ;AuDnjZI;EhCrEA,6DAAA;EACA,4DAAA;AvB2nZJ;;AuDjjZA;EACE,8EAAA;AvDojZF;;AuD3iZE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AvB6pZJ;AuD5iZI;EAAgB,aAAA;AvD+iZpB;AuD9iZI;EAAe,gBAAA;AvDijZnB;AuD9iZI;;;EhCrHA,gBAAA;AvBwqZJ;;AuDxiZI;EACE,qVAAA;EACA,4VAAA;AvD2iZN;;AwDhsZA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AvBgsZJ;;AwD1rZE;EACE,iDAAA;AxD6rZJ;AwD3rZI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxD6rZN;AwDzrZE;EACE,6CAAA;AxD2rZJ;;AyDhuZA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AzBqvZF;;AyD9tZA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzDiuZF;AsClvZM;EmBQN;InBPQ,gBAAA;EtCqvZN;AACF;AyDpuZE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzDquZJ;AyDluZE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzDouZJ;AyDjuZE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzDkuZJ;AyD/tZE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzDguZJ;;AyD3tZE;EACE,8CnC8sCgC;AtBghXpC;AyDztZM;ElC9BF,0DAAA;EACA,6DAAA;AvB0vZJ;AyDvtZM;ElClDF,2DAAA;EACA,8DAAA;AvB4wZJ;;AyD1sZA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1DgzZF;;AyD7sZA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1DuzZF;;A2DzzZA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AvB8zZJ;A2DrzZE;EACE,aAAA;A3DuzZJ;;A2DlzZA;EACE,kBAAA;EACA,SAAA;A3DqzZF;;A4Dr1ZA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AvBy1ZJ;;A4Dj1ZA;EAEE,cAAA;A5Dm1ZF;;A4D/0ZA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5Dk1ZF;;A4D10ZA;EACE,mBtCs+C8B;AtBu2WhC;A4D10ZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5D40ZJ;;A4Dp0ZE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5Du0ZJ;;A4D30ZE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5D80ZJ;;A4Dl1ZE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5Dq1ZJ;;A4Dz1ZE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5D41ZJ;;A4Dh2ZE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5Dm2ZJ;;A4Dv2ZE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5D02ZJ;;A4D92ZE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5Di3ZJ;;A4Dr3ZE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5Dw3ZJ;;A6Dp7ZE;EACE;IAAK,gDAAA;E7Dw7ZP;AACF;A6Dp7ZA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AvB47ZJ;;A6D/6ZA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7Dk7ZF;AsCv8ZM;EuBYN;IvBXQ,gBAAA;EtC08ZN;AACF;;A6Dp7ZA;EtBAE,qMAAA;EsBEA,oEAAA;A7Du7ZF;;A6Dp7ZA;EACE,iBAAA;A7Du7ZF;;A6Dp7ZA;EACE,WAAA;A7Du7ZF;;A6Dn7ZE;EACE,kDAAA;A7Ds7ZJ;A6Dn7ZM;EAJJ;IAKM,eAAA;E7Ds7ZN;AACF;;A8Dl/ZA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AvB4/ZJ;;A8D7+ZA;EACE,qBAAA;EACA,sBAAA;A9Dg/ZF;A8D9+ZE;EAEE,oCAAA;EACA,0BAAA;A9D++ZJ;;A8Dv+ZA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9D0+ZF;A8Dx+ZE;EvC9BE,+BAAA;EACA,gCAAA;AvBygaJ;A8Dx+ZE;EvCpBE,mCAAA;EACA,kCAAA;AvB+/ZJ;A8Dx+ZE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9Dy+ZJ;A8Dr+ZE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9Du+ZJ;A8Dn+ZE;EACE,mBAAA;A9Dq+ZJ;A8Dn+ZI;EACE,wDAAA;EACA,mDAAA;A9Dq+ZN;;A8D39ZA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9D89ZF;A8D19ZI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9D29ZN;A8Dx9ZI;EACE,+CAAA;EACA,uDAAA;A9D09ZN;;A8D78ZI;EACE,mBAAA;A9Dg9ZN;A8D78ZQ;EvCzDJ,6DAAA;EAZA,0BAAA;AvBshaJ;A8D58ZQ;EvC1EJ,2DAAA;EAYA,4BAAA;AvB8gaJ;A8D38ZQ;EACE,aAAA;A9D68ZV;A8D18ZQ;EACE,mDAAA;EACA,oBAAA;A9D48ZV;A8D18ZU;EACE,yDAAA;EACA,oDAAA;A9D48ZZ;;A8BpiaI;EgCgEA;IACE,mBAAA;E9Dw+ZJ;E8Dr+ZM;IvCzDJ,6DAAA;IAZA,0BAAA;EvB8iaF;E8Dp+ZM;IvC1EJ,2DAAA;IAYA,4BAAA;EvBsiaF;E8Dn+ZM;IACE,aAAA;E9Dq+ZR;E8Dl+ZM;IACE,mDAAA;IACA,oBAAA;E9Do+ZR;E8Dl+ZQ;IACE,yDAAA;IACA,oDAAA;E9Do+ZV;AACF;A8B7jaI;EgCgEA;IACE,mBAAA;E9DggaJ;E8D7/ZM;IvCzDJ,6DAAA;IAZA,0BAAA;EvBskaF;E8D5/ZM;IvC1EJ,2DAAA;IAYA,4BAAA;EvB8jaF;E8D3/ZM;IACE,aAAA;E9D6/ZR;E8D1/ZM;IACE,mDAAA;IACA,oBAAA;E9D4/ZR;E8D1/ZQ;IACE,yDAAA;IACA,oDAAA;E9D4/ZV;AACF;A8BrlaI;EgCgEA;IACE,mBAAA;E9DwhaJ;E8DrhaM;IvCzDJ,6DAAA;IAZA,0BAAA;EvB8laF;E8DphaM;IvC1EJ,2DAAA;IAYA,4BAAA;EvBslaF;E8DnhaM;IACE,aAAA;E9DqhaR;E8DlhaM;IACE,mDAAA;IACA,oBAAA;E9DohaR;E8DlhaQ;IACE,yDAAA;IACA,oDAAA;E9DohaV;AACF;A8B7maI;EgCgEA;IACE,mBAAA;E9DgjaJ;E8D7iaM;IvCzDJ,6DAAA;IAZA,0BAAA;EvBsnaF;E8D5iaM;IvC1EJ,2DAAA;IAYA,4BAAA;EvB8maF;E8D3iaM;IACE,aAAA;E9D6iaR;E8D1iaM;IACE,mDAAA;IACA,oBAAA;E9D4iaR;E8D1iaQ;IACE,yDAAA;IACA,oDAAA;E9D4iaV;AACF;A8BroaI;EgCgEA;IACE,mBAAA;E9DwkaJ;E8DrkaM;IvCzDJ,6DAAA;IAZA,0BAAA;EvB8oaF;E8DpkaM;IvC1EJ,2DAAA;IAYA,4BAAA;EvBsoaF;E8DnkaM;IACE,aAAA;E9DqkaR;E8DlkaM;IACE,mDAAA;IACA,oBAAA;E9DokaR;E8DlkaQ;IACE,yDAAA;IACA,oDAAA;E9DokaV;AACF;A8DvjaA;EvClJI,gBAAA;AvB4saJ;A8DvjaE;EACE,mDAAA;A9DyjaJ;A8DvjaI;EACE,sBAAA;A9DyjaN;;A8D5iaE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9D+iaJ;;A8DzjaE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9D4jaJ;;A8DtkaE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9DykaJ;;A8DnlaE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9DslaJ;;A8DhmaE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9DmmaJ;;A8D7maE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9DgnaJ;;A8D1naE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9D6naJ;;A8DvoaE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9D0oaJ;;A+Dx0aA;EAEE,sCAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/Dw0aF;A+Dr0aE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/Du0aJ;A+Dp0aE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/Ds0aJ;A+Dn0aE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;A/Do0aJ;;A+D5zaA;EAHE,iEAAA;A/Dm0aF;;A+D5zaA;;EAEE,uBAAA;A/D+zaF;;AoB12aI;E2CkCF,iEAAA;A/D40aF;;AgE73aA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AvBs4aJ;AgE33aE;EACE,UAAA;AhE63aJ;AgE13aE;EACE,aAAA;AhE43aJ;;AgEx3aA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhE03aF;AgEx3aE;EACE,sCAAA;AhE03aJ;;AgEt3aA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AvB05aJ;AgEx3aE;EACE,oDAAA;EACA,sCAAA;AhE03aJ;;AgEt3aA;EACE,kCAAA;EACA,qBAAA;AhEy3aF;;AiEv7aA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjEq7aF;;AiE96aA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjEg7aF;AiE76aE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AjE+6aJ;AsCz9aM;E2BwCJ;I3BvCM,gBAAA;EtC49aN;AACF;AiEl7aE;EACE,e3Cg8CgC;AtBo/XpC;AiEh7aE;EACE,sB3C67CgC;AtBq/XpC;;AiE96aA;EACE,+CAAA;AjEi7aF;AiE/6aE;EACE,gBAAA;EACA,gBAAA;AjEi7aJ;AiE96aE;EACE,gBAAA;AjEg7aJ;;AiE56aA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjE+6aF;;AiE36aA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjE26aF;;AiEv6aA;EAEE,0BAAA;EACA,kCAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjE66a9D;AkEzhbE;EAAS,UAAA;AlE4hbX;AkE3hbE;EAAS,mCD2GiF;AjEm7a5F;;AiE96aA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AvBuhbJ;AiEh7aE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AjEi7aJ;;AiE56aA;EACE,gBAAA;EACA,8CAAA;AjE+6aF;;AiE16aA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjE26aF;;AiEv6aA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;AvBwibJ;AiEt6aE;EACE,8CAAA;AjEw6aJ;;A8BvhbI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EjEs6aF;EiEl6aA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjEo6aF;EiEj6aA;IACE,uBAAA;EjEm6aF;AACF;A8BtibI;EmCuIF;;IAEE,uBAAA;EjEk6aF;AACF;A8B5ibI;EmC8IF;IACE,wBAAA;EjEi6aF;AACF;AiEx5aI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjE05aN;AiEx5aM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;AvBwmbJ;AiEv5aM;;E1CjNF,gBAAA;AvB4mbJ;AiEt5aM;EACE,gBAAA;AjEw5aR;;A8BtjbI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjE86aJ;EiE56aI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EvB4nbF;EiE36aI;;I1CjNF,gBAAA;EvBgobF;EiE16aI;IACE,gBAAA;EjE46aN;AACF;A8B3kbI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjEk8aJ;EiEh8aI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EvBgpbF;EiE/7aI;;I1CjNF,gBAAA;EvBopbF;EiE97aI;IACE,gBAAA;EjEg8aN;AACF;A8B/lbI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjEs9aJ;EiEp9aI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EvBoqbF;EiEn9aI;;I1CjNF,gBAAA;EvBwqbF;EiEl9aI;IACE,gBAAA;EjEo9aN;AACF;A8BnnbI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjE0+aJ;EiEx+aI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EvBwrbF;EiEv+aI;;I1CjNF,gBAAA;EvB4rbF;EiEt+aI;IACE,gBAAA;EjEw+aN;AACF;A8BvobI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjE8/aJ;EiE5/aI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EvB4sbF;EiE3/aI;;I1CjNF,gBAAA;EvBgtbF;EiE1/aI;IACE,gBAAA;EjE4/aN;AACF;AmEtubA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnE8ubF;AmE5ubE;EAAS,kCAAA;AnE+ubX;AmE7ubE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnE+ubJ;AmE7ubI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnE+ubN;;AmE1ubA;EACE,iDAAA;AnE6ubF;AmE3ubE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnE6ubJ;;AmEzubA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnE4ubF;AmE1ubE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnE4ubJ;;AmExubA,mBAAA;AAEA;EACE,8CAAA;AnE0ubF;AmExubE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnE0ubJ;;AmEtubA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnEyubF;AmEvubE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnEyubJ;;AmErubA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AvByzbJ;;AqE50bA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AvBu2bJ;AqEn1bE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArEq1bJ;AqEn1bI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArEo1bN;;AqE90bE;EACE,oFAAA;ArEi1bJ;AqE/0bI;EAEE,wFAAA;ArEg1bN;AqE70bI;EACE,SAAA;EACA,gDAAA;ArE+0bN;AqE50bI;EACE,sCAAA;EACA,sCAAA;ArE80bN;;AqEz0bA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArE20bJ;AqEz0bI;EAEE,kIAAA;ArE00bN;AqEv0bI;EACE,OAAA;EACA,kDAAA;ArEy0bN;AqEt0bI;EACE,oCAAA;EACA,wCAAA;ArEw0bN;;AqEn0bA,mBAAA;AAGE;EACE,iFAAA;ArEo0bJ;AqEl0bI;EAEE,wFAAA;ArEm0bN;AqEh0bI;EACE,MAAA;EACA,mDAAA;ArEk0bN;AqE/zbI;EACE,mCAAA;EACA,yCAAA;ArEi0bN;AqE5zbE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArE8zbJ;;AqE1zbA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArE4zbJ;AqE1zbI;EAEE,kIAAA;ArE2zbN;AqExzbI;EACE,QAAA;EACA,iDAAA;ArE0zbN;AqEvzbI;EACE,qCAAA;EACA,uCAAA;ArEyzbN;;AqEpzbA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AvBm8bJ;AqErybE;EACE,aAAA;ArEuybJ;;AqEnybA;EACE,0EAAA;EACA,mCAAA;ArEsybF;;AsE39bA;EACE,kBAAA;AtE89bF;;AsE39bA;EACE,mBAAA;AtE89bF;;AsE39bA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtE89bF;AuEp/bE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvEs/bJ;;AsE/9bA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtEk+bF;AsCj/bM;EgCQN;IhCPQ,gBAAA;EtCo/bN;AACF;;AsEp+bA;;;EAGE,cAAA;AtEu+bF;;AsEp+bA;;EAEE,2BAAA;AtEu+bF;;AsEp+bA;;EAEE,4BAAA;AtEu+bF;;AsE99bE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtEi+bJ;AsE99bE;;;EAGE,UAAA;EACA,UAAA;AtEg+bJ;AsE79bE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtE+9bJ;AsCxhcM;EgCqDJ;;IhCpDM,gBAAA;EtC4hcN;AACF;;AsE59bA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AtE89bF;AsCljcM;EgCkEN;;IhCjEQ,gBAAA;EtCsjcN;AACF;AsEj+bE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;AtBg+YrC;;AsEj+bA;EACE,OAAA;AtEo+bF;;AsEj+bA;EACE,QAAA;AtEo+bF;;AsE/9bA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtEk+bF;;AsE/9bA;EACE,0TAAA;AtEk+bF;;AsEh+bA;EACE,yTAAA;AtEm+bF;;AsE39bA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;AtB0gZrC;AsE39bE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AtE49bJ;AsC1ncM;EgC6IJ;IhC5IM,gBAAA;EtC6ncN;AACF;AsE99bE;EACE,UhDw8CiC;AtBwhZrC;;AsEv9bA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AtE09bF;;AsE/8bA;EALE,mDAAA;EACA,6CAAA;EACA,2DAAA;AtEw9bF;;AsEj9bA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AtEo9bF;;AoB/pcI;EkD8LF,mDAAA;EACA,6CAAA;EACA,2DAAA;AtEq+bF;;AwEhrcA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxEkrcF;;AwE9qcA;EACE;IAAK,0CAAA;ExEkrcL;AACF;AwE/qcA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxE8qcF;;AwE3qcA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxE6qcF;;AwEpqcA;EACE;IACE,mBAAA;ExEuqcF;EwErqcA;IACE,UAAA;IACA,eAAA;ExEuqcF;AACF;AwEnqcA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxEkqcF;;AwE/pcA;EACE,wBAAA;EACA,yBAAA;AxEkqcF;;AwE9pcE;EACE;;IAEE,kCAAA;ExEiqcJ;AACF;AyElvcA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzEmvcF;;A8BtrcI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzEoucJ;AACF;AsC/vcM;EmCYJ;InCXM,gBAAA;EtCkwcN;AACF;A8B5scI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzE2ucN;EyExucI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzE0ucN;EyEvucI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEyucN;EyEtucI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEwucN;EyErucI;IAEE,eAAA;EzEsucN;EyEnucI;IAGE,mBAAA;EzEmucN;AACF;A8BhwcI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzEkucN;EyEhucM;IACE,aAAA;EzEkucR;EyE/tcM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzEgucR;AACF;;A8BpwcI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzEkzcJ;AACF;AsC70cM;EmCYJ;InCXM,gBAAA;EtCg1cN;AACF;A8B1xcI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEyzcN;EyEtzcI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEwzcN;EyErzcI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEuzcN;EyEpzcI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEszcN;EyEnzcI;IAEE,eAAA;EzEozcN;EyEjzcI;IAGE,mBAAA;EzEizcN;AACF;A8B90cI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzEgzcN;EyE9ycM;IACE,aAAA;EzEgzcR;EyE7ycM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzE8ycR;AACF;;A8Bl1cI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzEg4cJ;AACF;AsC35cM;EmCYJ;InCXM,gBAAA;EtC85cN;AACF;A8Bx2cI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEu4cN;EyEp4cI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEs4cN;EyEn4cI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEq4cN;EyEl4cI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEo4cN;EyEj4cI;IAEE,eAAA;EzEk4cN;EyE/3cI;IAGE,mBAAA;EzE+3cN;AACF;A8B55cI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzE83cN;EyE53cM;IACE,aAAA;EzE83cR;EyE33cM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzE43cR;AACF;;A8Bh6cI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzE88cJ;AACF;AsCz+cM;EmCYJ;InCXM,gBAAA;EtC4+cN;AACF;A8Bt7cI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEq9cN;EyEl9cI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEo9cN;EyEj9cI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEm9cN;EyEh9cI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEk9cN;EyE/8cI;IAEE,eAAA;EzEg9cN;EyE78cI;IAGE,mBAAA;EzE68cN;AACF;A8B1+cI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzE48cN;EyE18cM;IACE,aAAA;EzE48cR;EyEz8cM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzE08cR;AACF;;A8B9+cI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzE4hdJ;AACF;AsCvjdM;EmCYJ;InCXM,gBAAA;EtC0jdN;AACF;A8BpgdI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEmidN;EyEhidI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEkidN;EyE/hdI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEiidN;EyE9hdI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEgidN;EyE7hdI;IAEE,eAAA;EzE8hdN;EyE3hdI;IAGE,mBAAA;EzE2hdN;AACF;A8BxjdI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzE0hdN;EyExhdM;IACE,aAAA;EzE0hdR;EyEvhdM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzEwhdR;AACF;;AyExmdE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzEymdN;AsCnodM;EmCYJ;InCXM,gBAAA;EtCsodN;AACF;AyE5mdM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzE8mdR;AyE3mdM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzE6mdR;AyE1mdM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzE4mdR;AyEzmdM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzE2mdR;AyExmdM;EAEE,eAAA;AzEymdR;AyEtmdM;EAGE,mBAAA;AzEsmdR;;AyE3kdA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,kCQNM;A1EysdR;AkEhsdE;EAAS,UAAA;AlEmsdX;AkElsdE;EAAS,Y5Cm+CyB;AtBkuapC;;AyEvldA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzE0ldF;AyExldE;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AzEyldJ;;AyErldA;EACE,gBAAA;EACA,kDAAA;AzEwldF;;AyErldA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzEwldF;;A2EzudA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrDgzCkC;AtB47apC;A2E1udE;EACE,qBAAA;EACA,WAAA;A3E4udJ;;A2EvudA;EACE,iBAAA;A3E0udF;;A2EvudA;EACE,iBAAA;A3E0udF;;A2EvudA;EACE,iBAAA;A3E0udF;;A2ErudE;EACE,mDAAA;A3EwudJ;;A2EpudA;EACE;IACE,YrDmxCgC;EtBo9alC;AACF;A2EpudA;EACE,uGAAA;EACA,oBAAA;EACA,8CAAA;A3EsudF;;A2EnudA;EACE;IACE,uBAAA;E3EsudF;AACF;AuErxdE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvEuxdJ;;A4E1xdE;EACE,sBAAA;EACA,iFAAA;A5E6xdJ;;A4E/xdE;EACE,sBAAA;EACA,mFAAA;A5EkydJ;;A4EpydE;EACE,sBAAA;EACA,iFAAA;A5EuydJ;;A4EzydE;EACE,sBAAA;EACA,8EAAA;A5E4ydJ;;A4E9ydE;EACE,sBAAA;EACA,iFAAA;A5EizdJ;;A4EnzdE;EACE,sBAAA;EACA,gFAAA;A5EszdJ;;A4ExzdE;EACE,sBAAA;EACA,+EAAA;A5E2zdJ;;A4E7zdE;EACE,sBAAA;EACA,8EAAA;A5Eg0dJ;;A6El0dE;EACE,wEAAA;EACA,kGAAA;A7Eq0dJ;A6El0dM;EAGE,8DAAA;EACA,wFAAA;A7Ek0dR;;A6E30dE;EACE,0EAAA;EACA,oGAAA;A7E80dJ;A6E30dM;EAGE,8DAAA;EACA,wFAAA;A7E20dR;;A6Ep1dE;EACE,wEAAA;EACA,kGAAA;A7Eu1dJ;A6Ep1dM;EAGE,8DAAA;EACA,wFAAA;A7Eo1dR;;A6E71dE;EACE,qEAAA;EACA,+FAAA;A7Eg2dJ;A6E71dM;EAGE,+DAAA;EACA,yFAAA;A7E61dR;;A6Et2dE;EACE,wEAAA;EACA,kGAAA;A7Ey2dJ;A6Et2dM;EAGE,8DAAA;EACA,wFAAA;A7Es2dR;;A6E/2dE;EACE,uEAAA;EACA,iGAAA;A7Ek3dJ;A6E/2dM;EAGE,8DAAA;EACA,wFAAA;A7E+2dR;;A6Ex3dE;EACE,sEAAA;EACA,gGAAA;A7E23dJ;A6Ex3dM;EAGE,gEAAA;EACA,0FAAA;A7Ew3dR;;A6Ej4dE;EACE,qEAAA;EACA,+FAAA;A7Eo4dJ;A6Ej4dM;EAGE,6DAAA;EACA,uFAAA;A7Ei4dR;;A6E13dA;EACE,+EAAA;EACA,yGAAA;A7E63dF;A6E13dI;EAEE,kFAAA;EACA,4GAAA;A7E23dN;;A8Er5dA;EACE,UAAA;EAEA,kJAAA;A9Eu5dF;;A+E15dA;EACE,oBAAA;EACA,azD6c4B;EyD5c5B,mBAAA;EACA,kFAAA;EACA,6BzD2c4B;EyD1c5B,2BAAA;A/E65dF;A+E35dE;EACE,cAAA;EACA,UzDuc0B;EyDtc1B,WzDsc0B;EyDrc1B,kBAAA;EzCIE,sCyCHF;A/E65dJ;AsCt5dM;EyCZJ;IzCaM,gBAAA;EtCy5dN;AACF;;A+E35dI;EACE,mEAAA;A/E85dN;;AgFj7dA;EACE,kBAAA;EACA,WAAA;AhFo7dF;AgFl7dE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhFo7dJ;AgFj7dE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhFm7dJ;;AgF96dE;EACE,uBAAA;AhFi7dJ;;AgFl7dE;EACE,sBAAA;AhFq7dJ;;AgFt7dE;EACE,yBAAA;AhFy7dJ;;AgF17dE;EACE,iCAAA;AhF67dJ;;AiFl9dA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a3DumCkC;AtB82bpC;;AiFl9dA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3D+lCkC;AtBs3bpC;;AiF78dI;EACE,gBAAA;EACA,MAAA;EACA,a3DmlC8B;AtB63bpC;;AiF78dI;EACE,gBAAA;EACA,SAAA;EACA,a3D6kC8B;AtBm4bpC;;A8Bj7dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtB04blC;EiF19dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtB+4blC;AACF;A8B97dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtBs5blC;EiFt+dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtB25blC;AACF;A8B18dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtBk6blC;EiFl/dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtBu6blC;AACF;A8Bt9dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtB86blC;EiF9/dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtBm7blC;AACF;A8Bl+dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtB07blC;EiF1geE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtB+7blC;AACF;AkF5ieA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlF8ieF;;AkF3ieA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlF8ieF;;AmFtjeA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApFujeF;AoFpjeE;;EACE,6BAAA;ApFujeJ;AoFnjeE;;EACE,2BAAA;ApFsjeJ;;AqFzkeE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U/DgcsC;E+D/btC,WAAA;ArF4keJ;;AsFpleA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvFwleF;;AwF9leA;EACE,qBAAA;EACA,mBAAA;EACA,6BlEisB4B;EkEhsB5B,eAAA;EACA,8BAAA;EACA,alE2rB4B;AtBs6c9B;;AyFrieQ;EAOI,mCAAA;AzFkieZ;;AyFzieQ;EAOI,8BAAA;AzFsieZ;;AyF7ieQ;EAOI,iCAAA;AzF0ieZ;;AyFjjeQ;EAOI,iCAAA;AzF8ieZ;;AyFrjeQ;EAOI,sCAAA;AzFkjeZ;;AyFzjeQ;EAOI,mCAAA;AzFsjeZ;;AyF7jeQ;EAOI,sBAAA;AzF0jeZ;;AyFjkeQ;EAOI,uBAAA;AzF8jeZ;;AyFrkeQ;EAOI,sBAAA;AzFkkeZ;;AyFzkeQ;EAOI,8BAAA;AzFskeZ;;AyF7keQ;EAOI,4BAAA;AzF0keZ;;AyFjleQ;EAOI,2BAAA;AzF8keZ;;AyFrleQ;EAOI,iCAAA;AzFkleZ;;AyFzleQ;EAOI,2BAAA;AzFsleZ;;AyF7leQ;EAOI,qBAAA;AzF0leZ;;AyFjmeQ;EAOI,wBAAA;AzF8leZ;;AyFrmeQ;EAOI,uBAAA;AzFkmeZ;;AyFzmeQ;EAOI,wBAAA;AzFsmeZ;;AyF7meQ;EAOI,qBAAA;AzF0meZ;;AyFjneQ;EAOI,yBAAA;AzF8meZ;;AyFrneQ;EAOI,2BAAA;AzFkneZ;;AyFzneQ;EAOI,4BAAA;AzFsneZ;;AyF7neQ;EAOI,2BAAA;AzF0neZ;;AyFjoeQ;EAOI,2BAAA;AzF8neZ;;AyFroeQ;EAOI,6BAAA;AzFkoeZ;;AyFzoeQ;EAOI,8BAAA;AzFsoeZ;;AyF7oeQ;EAOI,6BAAA;AzF0oeZ;;AyFjpeQ;EAOI,2BAAA;AzF8oeZ;;AyFrpeQ;EAOI,6BAAA;AzFkpeZ;;AyFzpeQ;EAOI,8BAAA;AzFspeZ;;AyF7peQ;EAOI,6BAAA;AzF0peZ;;AyFjqeQ;EAOI,0BAAA;AzF8peZ;;AyFrqeQ;EAOI,gCAAA;AzFkqeZ;;AyFzqeQ;EAOI,yBAAA;AzFsqeZ;;AyF7qeQ;EAOI,wBAAA;AzF0qeZ;;AyFjreQ;EAOI,+BAAA;AzF8qeZ;;AyFrreQ;EAOI,yBAAA;AzFkreZ;;AyFzreQ;EAOI,6BAAA;AzFsreZ;;AyF7reQ;EAOI,8BAAA;AzF0reZ;;AyFjseQ;EAOI,wBAAA;AzF8reZ;;AyFrseQ;EAOI,+BAAA;AzFkseZ;;AyFzseQ;EAOI,wBAAA;AzFsseZ;;AyF7seQ;EAOI,2CAAA;AzF0seZ;;AyFjteQ;EAOI,8CAAA;AzF8seZ;;AyFrteQ;EAOI,8CAAA;AzFkteZ;;AyFzteQ;EAOI,2BAAA;AzFsteZ;;AyFvueQ;EACE,gFAAA;AzF0ueV;;AyF3ueQ;EACE,kFAAA;AzF8ueV;;AyF/ueQ;EACE,gFAAA;AzFkveV;;AyFnveQ;EACE,6EAAA;AzFsveV;;AyFvveQ;EACE,gFAAA;AzF0veV;;AyF3veQ;EACE,+EAAA;AzF8veV;;AyF/veQ;EACE,8EAAA;AzFkweV;;AyFnweQ;EACE,6EAAA;AzFsweV;;AyF7veQ;EAOI,2BAAA;AzF0veZ;;AyFjweQ;EAOI,6BAAA;AzF8veZ;;AyFrweQ;EAOI,6BAAA;AzFkweZ;;AyFzweQ;EAOI,0BAAA;AzFsweZ;;AyF7weQ;EAOI,2BAAA;AzF0weZ;;AyFjxeQ;EAOI,iBAAA;AzF8weZ;;AyFrxeQ;EAOI,mBAAA;AzFkxeZ;;AyFzxeQ;EAOI,oBAAA;AzFsxeZ;;AyF7xeQ;EAOI,oBAAA;AzF0xeZ;;AyFjyeQ;EAOI,sBAAA;AzF8xeZ;;AyFryeQ;EAOI,uBAAA;AzFkyeZ;;AyFzyeQ;EAOI,kBAAA;AzFsyeZ;;AyF7yeQ;EAOI,oBAAA;AzF0yeZ;;AyFjzeQ;EAOI,qBAAA;AzF8yeZ;;AyFrzeQ;EAOI,mBAAA;AzFkzeZ;;AyFzzeQ;EAOI,qBAAA;AzFszeZ;;AyF7zeQ;EAOI,sBAAA;AzF0zeZ;;AyFj0eQ;EAOI,2CAAA;AzF8zeZ;;AyFr0eQ;EAOI,sCAAA;AzFk0eZ;;AyFz0eQ;EAOI,sCAAA;AzFs0eZ;;AyF70eQ;EAOI,uFAAA;AzF00eZ;;AyFj1eQ;EAOI,oBAAA;AzF80eZ;;AyFr1eQ;EAOI,2FAAA;AzFk1eZ;;AyFz1eQ;EAOI,wBAAA;AzFs1eZ;;AyF71eQ;EAOI,6FAAA;AzF01eZ;;AyFj2eQ;EAOI,0BAAA;AzF81eZ;;AyFr2eQ;EAOI,8FAAA;AzFk2eZ;;AyFz2eQ;EAOI,2BAAA;AzFs2eZ;;AyF72eQ;EAOI,4FAAA;AzF02eZ;;AyFj3eQ;EAOI,yBAAA;AzF82eZ;;AyFr3eQ;EAIQ,sBAAA;EAGJ,8EAAA;AzFm3eZ;;AyF13eQ;EAIQ,sBAAA;EAGJ,gFAAA;AzFw3eZ;;AyF/3eQ;EAIQ,sBAAA;EAGJ,8EAAA;AzF63eZ;;AyFp4eQ;EAIQ,sBAAA;EAGJ,2EAAA;AzFk4eZ;;AyFz4eQ;EAIQ,sBAAA;EAGJ,8EAAA;AzFu4eZ;;AyF94eQ;EAIQ,sBAAA;EAGJ,6EAAA;AzF44eZ;;AyFn5eQ;EAIQ,sBAAA;EAGJ,4EAAA;AzFi5eZ;;AyFx5eQ;EAIQ,sBAAA;EAGJ,2EAAA;AzFs5eZ;;AyF75eQ;EAIQ,sBAAA;EAGJ,4EAAA;AzF25eZ;;AyFl6eQ;EAIQ,sBAAA;EAGJ,4EAAA;AzFg6eZ;;AyFv6eQ;EAOI,wDAAA;AzFo6eZ;;AyF36eQ;EAOI,0DAAA;AzFw6eZ;;AyF/6eQ;EAOI,wDAAA;AzF46eZ;;AyFn7eQ;EAOI,qDAAA;AzFg7eZ;;AyFv7eQ;EAOI,wDAAA;AzFo7eZ;;AyF37eQ;EAOI,uDAAA;AzFw7eZ;;AyF/7eQ;EAOI,sDAAA;AzF47eZ;;AyFn8eQ;EAOI,qDAAA;AzFg8eZ;;AyFv8eQ;EAOI,4BAAA;AzFo8eZ;;AyF38eQ;EAOI,4BAAA;AzFw8eZ;;AyF/8eQ;EAOI,4BAAA;AzF48eZ;;AyFn9eQ;EAOI,4BAAA;AzFg9eZ;;AyFv9eQ;EAOI,4BAAA;AzFo9eZ;;AyFr+eQ;EACE,wBAAA;AzFw+eV;;AyFz+eQ;EACE,yBAAA;AzF4+eV;;AyF7+eQ;EACE,wBAAA;AzFg/eV;;AyFj/eQ;EACE,yBAAA;AzFo/eV;;AyFr/eQ;EACE,sBAAA;AzFw/eV;;AyF/+eQ;EAOI,qBAAA;AzF4+eZ;;AyFn/eQ;EAOI,qBAAA;AzFg/eZ;;AyFv/eQ;EAOI,qBAAA;AzFo/eZ;;AyF3/eQ;EAOI,sBAAA;AzFw/eZ;;AyF//eQ;EAOI,sBAAA;AzF4/eZ;;AyFngfQ;EAOI,0BAAA;AzFggfZ;;AyFvgfQ;EAOI,uBAAA;AzFogfZ;;AyF3gfQ;EAOI,2BAAA;AzFwgfZ;;AyF/gfQ;EAOI,sBAAA;AzF4gfZ;;AyFnhfQ;EAOI,sBAAA;AzFghfZ;;AyFvhfQ;EAOI,sBAAA;AzFohfZ;;AyF3hfQ;EAOI,uBAAA;AzFwhfZ;;AyF/hfQ;EAOI,uBAAA;AzF4hfZ;;AyFnifQ;EAOI,2BAAA;AzFgifZ;;AyFvifQ;EAOI,wBAAA;AzFoifZ;;AyF3ifQ;EAOI,4BAAA;AzFwifZ;;AyF/ifQ;EAOI,yBAAA;AzF4ifZ;;AyFnjfQ;EAOI,8BAAA;AzFgjfZ;;AyFvjfQ;EAOI,iCAAA;AzFojfZ;;AyF3jfQ;EAOI,sCAAA;AzFwjfZ;;AyF/jfQ;EAOI,yCAAA;AzF4jfZ;;AyFnkfQ;EAOI,uBAAA;AzFgkfZ;;AyFvkfQ;EAOI,uBAAA;AzFokfZ;;AyF3kfQ;EAOI,yBAAA;AzFwkfZ;;AyF/kfQ;EAOI,yBAAA;AzF4kfZ;;AyFnlfQ;EAOI,0BAAA;AzFglfZ;;AyFvlfQ;EAOI,4BAAA;AzFolfZ;;AyF3lfQ;EAOI,kCAAA;AzFwlfZ;;AyF/lfQ;EAOI,sCAAA;AzF4lfZ;;AyFnmfQ;EAOI,oCAAA;AzFgmfZ;;AyFvmfQ;EAOI,kCAAA;AzFomfZ;;AyF3mfQ;EAOI,yCAAA;AzFwmfZ;;AyF/mfQ;EAOI,wCAAA;AzF4mfZ;;AyFnnfQ;EAOI,wCAAA;AzFgnfZ;;AyFvnfQ;EAOI,kCAAA;AzFonfZ;;AyF3nfQ;EAOI,gCAAA;AzFwnfZ;;AyF/nfQ;EAOI,8BAAA;AzF4nfZ;;AyFnofQ;EAOI,gCAAA;AzFgofZ;;AyFvofQ;EAOI,+BAAA;AzFoofZ;;AyF3ofQ;EAOI,oCAAA;AzFwofZ;;AyF/ofQ;EAOI,kCAAA;AzF4ofZ;;AyFnpfQ;EAOI,gCAAA;AzFgpfZ;;AyFvpfQ;EAOI,uCAAA;AzFopfZ;;AyF3pfQ;EAOI,sCAAA;AzFwpfZ;;AyF/pfQ;EAOI,iCAAA;AzF4pfZ;;AyFnqfQ;EAOI,2BAAA;AzFgqfZ;;AyFvqfQ;EAOI,iCAAA;AzFoqfZ;;AyF3qfQ;EAOI,+BAAA;AzFwqfZ;;AyF/qfQ;EAOI,6BAAA;AzF4qfZ;;AyFnrfQ;EAOI,+BAAA;AzFgrfZ;;AyFvrfQ;EAOI,8BAAA;AzForfZ;;AyF3rfQ;EAOI,oBAAA;AzFwrfZ;;AyF/rfQ;EAOI,mBAAA;AzF4rfZ;;AyFnsfQ;EAOI,mBAAA;AzFgsfZ;;AyFvsfQ;EAOI,mBAAA;AzFosfZ;;AyF3sfQ;EAOI,mBAAA;AzFwsfZ;;AyF/sfQ;EAOI,mBAAA;AzF4sfZ;;AyFntfQ;EAOI,mBAAA;AzFgtfZ;;AyFvtfQ;EAOI,mBAAA;AzFotfZ;;AyF3tfQ;EAOI,oBAAA;AzFwtfZ;;AyF/tfQ;EAOI,0BAAA;AzF4tfZ;;AyFnufQ;EAOI,yBAAA;AzFgufZ;;AyFvufQ;EAOI,uBAAA;AzFoufZ;;AyF3ufQ;EAOI,yBAAA;AzFwufZ;;AyF/ufQ;EAOI,uBAAA;AzF4ufZ;;AyFnvfQ;EAOI,uBAAA;AzFgvfZ;;AyFvvfQ;EAOI,0BAAA;EAAA,yBAAA;AzFqvfZ;;AyF5vfQ;EAOI,gCAAA;EAAA,+BAAA;AzF0vfZ;;AyFjwfQ;EAOI,+BAAA;EAAA,8BAAA;AzF+vfZ;;AyFtwfQ;EAOI,6BAAA;EAAA,4BAAA;AzFowfZ;;AyF3wfQ;EAOI,+BAAA;EAAA,8BAAA;AzFywfZ;;AyFhxfQ;EAOI,6BAAA;EAAA,4BAAA;AzF8wfZ;;AyFrxfQ;EAOI,6BAAA;EAAA,4BAAA;AzFmxfZ;;AyF1xfQ;EAOI,wBAAA;EAAA,2BAAA;AzFwxfZ;;AyF/xfQ;EAOI,8BAAA;EAAA,iCAAA;AzF6xfZ;;AyFpyfQ;EAOI,6BAAA;EAAA,gCAAA;AzFkyfZ;;AyFzyfQ;EAOI,2BAAA;EAAA,8BAAA;AzFuyfZ;;AyF9yfQ;EAOI,6BAAA;EAAA,gCAAA;AzF4yfZ;;AyFnzfQ;EAOI,2BAAA;EAAA,8BAAA;AzFizfZ;;AyFxzfQ;EAOI,2BAAA;EAAA,8BAAA;AzFszfZ;;AyF7zfQ;EAOI,wBAAA;AzF0zfZ;;AyFj0fQ;EAOI,8BAAA;AzF8zfZ;;AyFr0fQ;EAOI,6BAAA;AzFk0fZ;;AyFz0fQ;EAOI,2BAAA;AzFs0fZ;;AyF70fQ;EAOI,6BAAA;AzF00fZ;;AyFj1fQ;EAOI,2BAAA;AzF80fZ;;AyFr1fQ;EAOI,2BAAA;AzFk1fZ;;AyFz1fQ;EAOI,0BAAA;AzFs1fZ;;AyF71fQ;EAOI,gCAAA;AzF01fZ;;AyFj2fQ;EAOI,+BAAA;AzF81fZ;;AyFr2fQ;EAOI,6BAAA;AzFk2fZ;;AyFz2fQ;EAOI,+BAAA;AzFs2fZ;;AyF72fQ;EAOI,6BAAA;AzF02fZ;;AyFj3fQ;EAOI,6BAAA;AzF82fZ;;AyFr3fQ;EAOI,2BAAA;AzFk3fZ;;AyFz3fQ;EAOI,iCAAA;AzFs3fZ;;AyF73fQ;EAOI,gCAAA;AzF03fZ;;AyFj4fQ;EAOI,8BAAA;AzF83fZ;;AyFr4fQ;EAOI,gCAAA;AzFk4fZ;;AyFz4fQ;EAOI,8BAAA;AzFs4fZ;;AyF74fQ;EAOI,8BAAA;AzF04fZ;;AyFj5fQ;EAOI,yBAAA;AzF84fZ;;AyFr5fQ;EAOI,+BAAA;AzFk5fZ;;AyFz5fQ;EAOI,8BAAA;AzFs5fZ;;AyF75fQ;EAOI,4BAAA;AzF05fZ;;AyFj6fQ;EAOI,8BAAA;AzF85fZ;;AyFr6fQ;EAOI,4BAAA;AzFk6fZ;;AyFz6fQ;EAOI,4BAAA;AzFs6fZ;;AyF76fQ;EAOI,qBAAA;AzF06fZ;;AyFj7fQ;EAOI,2BAAA;AzF86fZ;;AyFr7fQ;EAOI,0BAAA;AzFk7fZ;;AyFz7fQ;EAOI,wBAAA;AzFs7fZ;;AyF77fQ;EAOI,0BAAA;AzF07fZ;;AyFj8fQ;EAOI,wBAAA;AzF87fZ;;AyFr8fQ;EAOI,2BAAA;EAAA,0BAAA;AzFm8fZ;;AyF18fQ;EAOI,iCAAA;EAAA,gCAAA;AzFw8fZ;;AyF/8fQ;EAOI,gCAAA;EAAA,+BAAA;AzF68fZ;;AyFp9fQ;EAOI,8BAAA;EAAA,6BAAA;AzFk9fZ;;AyFz9fQ;EAOI,gCAAA;EAAA,+BAAA;AzFu9fZ;;AyF99fQ;EAOI,8BAAA;EAAA,6BAAA;AzF49fZ;;AyFn+fQ;EAOI,yBAAA;EAAA,4BAAA;AzFi+fZ;;AyFx+fQ;EAOI,+BAAA;EAAA,kCAAA;AzFs+fZ;;AyF7+fQ;EAOI,8BAAA;EAAA,iCAAA;AzF2+fZ;;AyFl/fQ;EAOI,4BAAA;EAAA,+BAAA;AzFg/fZ;;AyFv/fQ;EAOI,8BAAA;EAAA,iCAAA;AzFq/fZ;;AyF5/fQ;EAOI,4BAAA;EAAA,+BAAA;AzF0/fZ;;AyFjggBQ;EAOI,yBAAA;AzF8/fZ;;AyFrggBQ;EAOI,+BAAA;AzFkggBZ;;AyFzggBQ;EAOI,8BAAA;AzFsggBZ;;AyF7ggBQ;EAOI,4BAAA;AzF0ggBZ;;AyFjhgBQ;EAOI,8BAAA;AzF8ggBZ;;AyFrhgBQ;EAOI,4BAAA;AzFkhgBZ;;AyFzhgBQ;EAOI,2BAAA;AzFshgBZ;;AyF7hgBQ;EAOI,iCAAA;AzF0hgBZ;;AyFjigBQ;EAOI,gCAAA;AzF8hgBZ;;AyFrigBQ;EAOI,8BAAA;AzFkigBZ;;AyFzigBQ;EAOI,gCAAA;AzFsigBZ;;AyF7igBQ;EAOI,8BAAA;AzF0igBZ;;AyFjjgBQ;EAOI,4BAAA;AzF8igBZ;;AyFrjgBQ;EAOI,kCAAA;AzFkjgBZ;;AyFzjgBQ;EAOI,iCAAA;AzFsjgBZ;;AyF7jgBQ;EAOI,+BAAA;AzF0jgBZ;;AyFjkgBQ;EAOI,iCAAA;AzF8jgBZ;;AyFrkgBQ;EAOI,+BAAA;AzFkkgBZ;;AyFzkgBQ;EAOI,0BAAA;AzFskgBZ;;AyF7kgBQ;EAOI,gCAAA;AzF0kgBZ;;AyFjlgBQ;EAOI,+BAAA;AzF8kgBZ;;AyFrlgBQ;EAOI,6BAAA;AzFklgBZ;;AyFzlgBQ;EAOI,+BAAA;AzFslgBZ;;AyF7lgBQ;EAOI,6BAAA;AzF0lgBZ;;AyFjmgBQ;EAOI,iBAAA;AzF8lgBZ;;AyFrmgBQ;EAOI,uBAAA;AzFkmgBZ;;AyFzmgBQ;EAOI,sBAAA;AzFsmgBZ;;AyF7mgBQ;EAOI,oBAAA;AzF0mgBZ;;AyFjngBQ;EAOI,sBAAA;AzF8mgBZ;;AyFrngBQ;EAOI,oBAAA;AzFkngBZ;;AyFzngBQ;EAOI,qBAAA;AzFsngBZ;;AyF7ngBQ;EAOI,2BAAA;AzF0ngBZ;;AyFjogBQ;EAOI,0BAAA;AzF8ngBZ;;AyFrogBQ;EAOI,wBAAA;AzFkogBZ;;AyFzogBQ;EAOI,0BAAA;AzFsogBZ;;AyF7ogBQ;EAOI,wBAAA;AzF0ogBZ;;AyFjpgBQ;EAOI,wBAAA;AzF8ogBZ;;AyFrpgBQ;EAOI,8BAAA;AzFkpgBZ;;AyFzpgBQ;EAOI,6BAAA;AzFspgBZ;;AyF7pgBQ;EAOI,2BAAA;AzF0pgBZ;;AyFjqgBQ;EAOI,6BAAA;AzF8pgBZ;;AyFrqgBQ;EAOI,2BAAA;AzFkqgBZ;;AyFzqgBQ;EAOI,gDAAA;AzFsqgBZ;;AyF7qgBQ;EAOI,4CAAA;AzF0qgBZ;;AyFjrgBQ;EAOI,4CAAA;AzF8qgBZ;;AyFrrgBQ;EAOI,0CAAA;AzFkrgBZ;;AyFzrgBQ;EAOI,4CAAA;AzFsrgBZ;;AyF7rgBQ;EAOI,6BAAA;AzF0rgBZ;;AyFjsgBQ;EAOI,0BAAA;AzF8rgBZ;;AyFrsgBQ;EAOI,6BAAA;AzFksgBZ;;AyFzsgBQ;EAOI,6BAAA;AzFssgBZ;;AyF7sgBQ;EAOI,+BAAA;AzF0sgBZ;;AyFjtgBQ;EAOI,2BAAA;AzF8sgBZ;;AyFrtgBQ;EAOI,2BAAA;AzFktgBZ;;AyFztgBQ;EAOI,2BAAA;AzFstgBZ;;AyF7tgBQ;EAOI,2BAAA;AzF0tgBZ;;AyFjugBQ;EAOI,2BAAA;AzF8tgBZ;;AyFrugBQ;EAOI,8BAAA;AzFkugBZ;;AyFzugBQ;EAOI,yBAAA;AzFsugBZ;;AyF7ugBQ;EAOI,4BAAA;AzF0ugBZ;;AyFjvgBQ;EAOI,2BAAA;AzF8ugBZ;;AyFrvgBQ;EAOI,yBAAA;AzFkvgBZ;;AyFzvgBQ;EAOI,2BAAA;AzFsvgBZ;;AyF7vgBQ;EAOI,4BAAA;AzF0vgBZ;;AyFjwgBQ;EAOI,6BAAA;AzF8vgBZ;;AyFrwgBQ;EAOI,gCAAA;AzFkwgBZ;;AyFzwgBQ;EAOI,qCAAA;AzFswgBZ;;AyF7wgBQ;EAOI,wCAAA;AzF0wgBZ;;AyFjxgBQ;EAOI,oCAAA;AzF8wgBZ;;AyFrxgBQ;EAOI,oCAAA;AzFkxgBZ;;AyFzxgBQ;EAOI,qCAAA;AzFsxgBZ;;AyF7xgBQ;EAOI,8BAAA;AzF0xgBZ;;AyFjygBQ;EAOI,8BAAA;AzF8xgBZ;;AyFnzgBQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzFoygBZ;;AyFjxgBQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AzF0ygBZ;;AyFjzgBQ;EAIQ,oBAAA;EAGJ,uEAAA;AzF+ygBZ;;AyFtzgBQ;EAIQ,oBAAA;EAGJ,qEAAA;AzFozgBZ;;AyF3zgBQ;EAIQ,oBAAA;EAGJ,kEAAA;AzFyzgBZ;;AyFh0gBQ;EAIQ,oBAAA;EAGJ,qEAAA;AzF8zgBZ;;AyFr0gBQ;EAIQ,oBAAA;EAGJ,oEAAA;AzFm0gBZ;;AyF10gBQ;EAIQ,oBAAA;EAGJ,mEAAA;AzFw0gBZ;;AyF/0gBQ;EAIQ,oBAAA;EAGJ,kEAAA;AzF60gBZ;;AyFp1gBQ;EAIQ,oBAAA;EAGJ,mEAAA;AzFk1gBZ;;AyFz1gBQ;EAIQ,oBAAA;EAGJ,mEAAA;AzFu1gBZ;;AyF91gBQ;EAIQ,oBAAA;EAGJ,wEAAA;AzF41gBZ;;AyFn2gBQ;EAIQ,oBAAA;EAGJ,2CAAA;AzFi2gBZ;;AyFx2gBQ;EAIQ,oBAAA;EAGJ,oCAAA;AzFs2gBZ;;AyF72gBQ;EAIQ,oBAAA;EAGJ,0CAAA;AzF22gBZ;;AyFl3gBQ;EAIQ,oBAAA;EAGJ,2CAAA;AzFg3gBZ;;AyFv3gBQ;EAIQ,oBAAA;EAGJ,0CAAA;AzFq3gBZ;;AyF53gBQ;EAIQ,oBAAA;EAGJ,0CAAA;AzF03gBZ;;AyFj4gBQ;EAIQ,oBAAA;EAGJ,yBAAA;AzF+3gBZ;;AyFh5gBQ;EACE,uBAAA;AzFm5gBV;;AyFp5gBQ;EACE,sBAAA;AzFu5gBV;;AyFx5gBQ;EACE,uBAAA;AzF25gBV;;AyF55gBQ;EACE,oBAAA;AzF+5gBV;;AyFt5gBQ;EAOI,iDAAA;AzFm5gBZ;;AyF15gBQ;EAOI,mDAAA;AzFu5gBZ;;AyF95gBQ;EAOI,iDAAA;AzF25gBZ;;AyFl6gBQ;EAOI,8CAAA;AzF+5gBZ;;AyFt6gBQ;EAOI,iDAAA;AzFm6gBZ;;AyF16gBQ;EAOI,gDAAA;AzFu6gBZ;;AyF96gBQ;EAOI,+CAAA;AzF26gBZ;;AyFl7gBQ;EAOI,8CAAA;AzF+6gBZ;;AyFh8gBQ;EACE,sBAAA;AzFm8gBV;;AyF/7gBU;EACE,sBAAA;AzFk8gBZ;;AyFx8gBQ;EACE,uBAAA;AzF28gBV;;AyFv8gBU;EACE,uBAAA;AzF08gBZ;;AyFh9gBQ;EACE,sBAAA;AzFm9gBV;;AyF/8gBU;EACE,sBAAA;AzFk9gBZ;;AyFx9gBQ;EACE,uBAAA;AzF29gBV;;AyFv9gBU;EACE,uBAAA;AzF09gBZ;;AyFh+gBQ;EACE,oBAAA;AzFm+gBV;;AyF/9gBU;EACE,oBAAA;AzFk+gBZ;;AyF99gBQ;EAOI,yCAAA;AzF29gBZ;;AyFt9gBU;EAOI,yCAAA;AzFm9gBd;;AyFt+gBQ;EAOI,wCAAA;AzFm+gBZ;;AyF99gBU;EAOI,wCAAA;AzF29gBd;;AyF9+gBQ;EAOI,yCAAA;AzF2+gBZ;;AyFt+gBU;EAOI,yCAAA;AzFm+gBd;;AyFt/gBQ;EAIQ,8BAAA;EAGJ,+FAAA;AzFo/gBZ;;AyF3/gBQ;EAIQ,8BAAA;EAGJ,iGAAA;AzFy/gBZ;;AyFhghBQ;EAIQ,8BAAA;EAGJ,+FAAA;AzF8/gBZ;;AyFrghBQ;EAIQ,8BAAA;EAGJ,4FAAA;AzFmghBZ;;AyF1ghBQ;EAIQ,8BAAA;EAGJ,+FAAA;AzFwghBZ;;AyF/ghBQ;EAIQ,8BAAA;EAGJ,8FAAA;AzF6ghBZ;;AyFphhBQ;EAIQ,8BAAA;EAGJ,6FAAA;AzFkhhBZ;;AyFzhhBQ;EAIQ,8BAAA;EAGJ,4FAAA;AzFuhhBZ;;AyF9hhBQ;EAIQ,8BAAA;EAGJ,qGAAA;AzF4hhBZ;;AyF7ihBQ;EACE,8BAAA;AzFgjhBV;;AyF5ihBU;EACE,8BAAA;AzF+ihBZ;;AyFrjhBQ;EACE,gCAAA;AzFwjhBV;;AyFpjhBU;EACE,gCAAA;AzFujhBZ;;AyF7jhBQ;EACE,iCAAA;AzFgkhBV;;AyF5jhBU;EACE,iCAAA;AzF+jhBZ;;AyFrkhBQ;EACE,gCAAA;AzFwkhBV;;AyFpkhBU;EACE,gCAAA;AzFukhBZ;;AyF7khBQ;EACE,iCAAA;AzFglhBV;;AyF5khBU;EACE,iCAAA;AzF+khBZ;;AyFrlhBQ;EACE,8BAAA;AzFwlhBV;;AyFplhBU;EACE,8BAAA;AzFulhBZ;;AyFnlhBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzFilhBZ;;AyFxlhBQ;EAIQ,kBAAA;EAGJ,gFAAA;AzFslhBZ;;AyF7lhBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzF2lhBZ;;AyFlmhBQ;EAIQ,kBAAA;EAGJ,2EAAA;AzFgmhBZ;;AyFvmhBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzFqmhBZ;;AyF5mhBQ;EAIQ,kBAAA;EAGJ,6EAAA;AzF0mhBZ;;AyFjnhBQ;EAIQ,kBAAA;EAGJ,4EAAA;AzF+mhBZ;;AyFtnhBQ;EAIQ,kBAAA;EAGJ,2EAAA;AzFonhBZ;;AyF3nhBQ;EAIQ,kBAAA;EAGJ,4EAAA;AzFynhBZ;;AyFhohBQ;EAIQ,kBAAA;EAGJ,4EAAA;AzF8nhBZ;;AyFrohBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzFmohBZ;;AyF1ohBQ;EAIQ,kBAAA;EAGJ,wCAAA;AzFwohBZ;;AyF/ohBQ;EAIQ,kBAAA;EAGJ,mFAAA;AzF6ohBZ;;AyFpphBQ;EAIQ,kBAAA;EAGJ,kFAAA;AzFkphBZ;;AyFnqhBQ;EACE,oBAAA;AzFsqhBV;;AyFvqhBQ;EACE,qBAAA;AzF0qhBV;;AyF3qhBQ;EACE,oBAAA;AzF8qhBV;;AyF/qhBQ;EACE,qBAAA;AzFkrhBV;;AyFnrhBQ;EACE,kBAAA;AzFsrhBV;;AyF7qhBQ;EAOI,wDAAA;AzF0qhBZ;;AyFjrhBQ;EAOI,0DAAA;AzF8qhBZ;;AyFrrhBQ;EAOI,wDAAA;AzFkrhBZ;;AyFzrhBQ;EAOI,qDAAA;AzFsrhBZ;;AyF7rhBQ;EAOI,wDAAA;AzF0rhBZ;;AyFjshBQ;EAOI,uDAAA;AzF8rhBZ;;AyFrshBQ;EAOI,sDAAA;AzFkshBZ;;AyFzshBQ;EAOI,qDAAA;AzFsshBZ;;AyF7shBQ;EAOI,+CAAA;AzF0shBZ;;AyFjthBQ;EAOI,2BAAA;AzF8shBZ;;AyFrthBQ;EAOI,4BAAA;AzFkthBZ;;AyFzthBQ;EAOI,4BAAA;AzFsthBZ;;AyF7thBQ;EAOI,+BAAA;AzF0thBZ;;AyFjuhBQ;EAOI,+BAAA;AzF8thBZ;;AyFruhBQ;EAOI,iDAAA;AzFkuhBZ;;AyFzuhBQ;EAOI,2BAAA;AzFsuhBZ;;AyF7uhBQ;EAOI,oDAAA;AzF0uhBZ;;AyFjvhBQ;EAOI,iDAAA;AzF8uhBZ;;AyFrvhBQ;EAOI,oDAAA;AzFkvhBZ;;AyFzvhBQ;EAOI,oDAAA;AzFsvhBZ;;AyF7vhBQ;EAOI,qDAAA;AzF0vhBZ;;AyFjwhBQ;EAOI,6BAAA;AzF8vhBZ;;AyFrwhBQ;EAOI,sDAAA;AzFkwhBZ;;AyFzwhBQ;EAOI,0DAAA;EAAA,2DAAA;AzFuwhBZ;;AyF9whBQ;EAOI,oCAAA;EAAA,qCAAA;AzF4whBZ;;AyFnxhBQ;EAOI,6DAAA;EAAA,8DAAA;AzFixhBZ;;AyFxxhBQ;EAOI,0DAAA;EAAA,2DAAA;AzFsxhBZ;;AyF7xhBQ;EAOI,6DAAA;EAAA,8DAAA;AzF2xhBZ;;AyFlyhBQ;EAOI,6DAAA;EAAA,8DAAA;AzFgyhBZ;;AyFvyhBQ;EAOI,8DAAA;EAAA,+DAAA;AzFqyhBZ;;AyF5yhBQ;EAOI,sCAAA;EAAA,uCAAA;AzF0yhBZ;;AyFjzhBQ;EAOI,+DAAA;EAAA,gEAAA;AzF+yhBZ;;AyFtzhBQ;EAOI,2DAAA;EAAA,8DAAA;AzFozhBZ;;AyF3zhBQ;EAOI,qCAAA;EAAA,wCAAA;AzFyzhBZ;;AyFh0hBQ;EAOI,8DAAA;EAAA,iEAAA;AzF8zhBZ;;AyFr0hBQ;EAOI,2DAAA;EAAA,8DAAA;AzFm0hBZ;;AyF10hBQ;EAOI,8DAAA;EAAA,iEAAA;AzFw0hBZ;;AyF/0hBQ;EAOI,8DAAA;EAAA,iEAAA;AzF60hBZ;;AyFp1hBQ;EAOI,+DAAA;EAAA,kEAAA;AzFk1hBZ;;AyFz1hBQ;EAOI,uCAAA;EAAA,0CAAA;AzFu1hBZ;;AyF91hBQ;EAOI,gEAAA;EAAA,mEAAA;AzF41hBZ;;AyFn2hBQ;EAOI,8DAAA;EAAA,6DAAA;AzFi2hBZ;;AyFx2hBQ;EAOI,wCAAA;EAAA,uCAAA;AzFs2hBZ;;AyF72hBQ;EAOI,iEAAA;EAAA,gEAAA;AzF22hBZ;;AyFl3hBQ;EAOI,8DAAA;EAAA,6DAAA;AzFg3hBZ;;AyFv3hBQ;EAOI,iEAAA;EAAA,gEAAA;AzFq3hBZ;;AyF53hBQ;EAOI,iEAAA;EAAA,gEAAA;AzF03hBZ;;AyFj4hBQ;EAOI,kEAAA;EAAA,iEAAA;AzF+3hBZ;;AyFt4hBQ;EAOI,0CAAA;EAAA,yCAAA;AzFo4hBZ;;AyF34hBQ;EAOI,mEAAA;EAAA,kEAAA;AzFy4hBZ;;AyFh5hBQ;EAOI,6DAAA;EAAA,0DAAA;AzF84hBZ;;AyFr5hBQ;EAOI,uCAAA;EAAA,oCAAA;AzFm5hBZ;;AyF15hBQ;EAOI,gEAAA;EAAA,6DAAA;AzFw5hBZ;;AyF/5hBQ;EAOI,6DAAA;EAAA,0DAAA;AzF65hBZ;;AyFp6hBQ;EAOI,gEAAA;EAAA,6DAAA;AzFk6hBZ;;AyFz6hBQ;EAOI,gEAAA;EAAA,6DAAA;AzFu6hBZ;;AyF96hBQ;EAOI,iEAAA;EAAA,8DAAA;AzF46hBZ;;AyFn7hBQ;EAOI,yCAAA;EAAA,sCAAA;AzFi7hBZ;;AyFx7hBQ;EAOI,kEAAA;EAAA,+DAAA;AzFs7hBZ;;AyF77hBQ;EAOI,8BAAA;AzF07hBZ;;AyFj8hBQ;EAOI,6BAAA;AzF87hBZ;;AyFr8hBQ;EAOI,sBAAA;AzFk8hBZ;;AyFz8hBQ;EAOI,qBAAA;AzFs8hBZ;;AyF78hBQ;EAOI,qBAAA;AzF08hBZ;;AyFj9hBQ;EAOI,qBAAA;AzF88hBZ;;AyFr9hBQ;EAOI,qBAAA;AzFk9hBZ;;A8B59hBI;E2DGI;IAOI,sBAAA;EzFu9hBV;EyF99hBM;IAOI,uBAAA;EzF09hBV;EyFj+hBM;IAOI,sBAAA;EzF69hBV;EyFp+hBM;IAOI,8BAAA;EzFg+hBV;EyFv+hBM;IAOI,4BAAA;EzFm+hBV;EyF1+hBM;IAOI,2BAAA;EzFs+hBV;EyF7+hBM;IAOI,iCAAA;EzFy+hBV;EyFh/hBM;IAOI,2BAAA;EzF4+hBV;EyFn/hBM;IAOI,0BAAA;EzF++hBV;EyFt/hBM;IAOI,gCAAA;EzFk/hBV;EyFz/hBM;IAOI,yBAAA;EzFq/hBV;EyF5/hBM;IAOI,wBAAA;EzFw/hBV;EyF//hBM;IAOI,+BAAA;EzF2/hBV;EyFlgiBM;IAOI,yBAAA;EzF8/hBV;EyFrgiBM;IAOI,6BAAA;EzFigiBV;EyFxgiBM;IAOI,8BAAA;EzFogiBV;EyF3giBM;IAOI,wBAAA;EzFugiBV;EyF9giBM;IAOI,+BAAA;EzF0giBV;EyFjhiBM;IAOI,wBAAA;EzF6giBV;EyFphiBM;IAOI,yBAAA;EzFghiBV;EyFvhiBM;IAOI,8BAAA;EzFmhiBV;EyF1hiBM;IAOI,iCAAA;EzFshiBV;EyF7hiBM;IAOI,sCAAA;EzFyhiBV;EyFhiiBM;IAOI,yCAAA;EzF4hiBV;EyFniiBM;IAOI,uBAAA;EzF+hiBV;EyFtiiBM;IAOI,uBAAA;EzFkiiBV;EyFziiBM;IAOI,yBAAA;EzFqiiBV;EyF5iiBM;IAOI,yBAAA;EzFwiiBV;EyF/iiBM;IAOI,0BAAA;EzF2iiBV;EyFljiBM;IAOI,4BAAA;EzF8iiBV;EyFrjiBM;IAOI,kCAAA;EzFijiBV;EyFxjiBM;IAOI,sCAAA;EzFojiBV;EyF3jiBM;IAOI,oCAAA;EzFujiBV;EyF9jiBM;IAOI,kCAAA;EzF0jiBV;EyFjkiBM;IAOI,yCAAA;EzF6jiBV;EyFpkiBM;IAOI,wCAAA;EzFgkiBV;EyFvkiBM;IAOI,wCAAA;EzFmkiBV;EyF1kiBM;IAOI,kCAAA;EzFskiBV;EyF7kiBM;IAOI,gCAAA;EzFykiBV;EyFhliBM;IAOI,8BAAA;EzF4kiBV;EyFnliBM;IAOI,gCAAA;EzF+kiBV;EyFtliBM;IAOI,+BAAA;EzFkliBV;EyFzliBM;IAOI,oCAAA;EzFqliBV;EyF5liBM;IAOI,kCAAA;EzFwliBV;EyF/liBM;IAOI,gCAAA;EzF2liBV;EyFlmiBM;IAOI,uCAAA;EzF8liBV;EyFrmiBM;IAOI,sCAAA;EzFimiBV;EyFxmiBM;IAOI,iCAAA;EzFomiBV;EyF3miBM;IAOI,2BAAA;EzFumiBV;EyF9miBM;IAOI,iCAAA;EzF0miBV;EyFjniBM;IAOI,+BAAA;EzF6miBV;EyFpniBM;IAOI,6BAAA;EzFgniBV;EyFvniBM;IAOI,+BAAA;EzFmniBV;EyF1niBM;IAOI,8BAAA;EzFsniBV;EyF7niBM;IAOI,oBAAA;EzFyniBV;EyFhoiBM;IAOI,mBAAA;EzF4niBV;EyFnoiBM;IAOI,mBAAA;EzF+niBV;EyFtoiBM;IAOI,mBAAA;EzFkoiBV;EyFzoiBM;IAOI,mBAAA;EzFqoiBV;EyF5oiBM;IAOI,mBAAA;EzFwoiBV;EyF/oiBM;IAOI,mBAAA;EzF2oiBV;EyFlpiBM;IAOI,mBAAA;EzF8oiBV;EyFrpiBM;IAOI,oBAAA;EzFipiBV;EyFxpiBM;IAOI,0BAAA;EzFopiBV;EyF3piBM;IAOI,yBAAA;EzFupiBV;EyF9piBM;IAOI,uBAAA;EzF0piBV;EyFjqiBM;IAOI,yBAAA;EzF6piBV;EyFpqiBM;IAOI,uBAAA;EzFgqiBV;EyFvqiBM;IAOI,uBAAA;EzFmqiBV;EyF1qiBM;IAOI,0BAAA;IAAA,yBAAA;EzFuqiBV;EyF9qiBM;IAOI,gCAAA;IAAA,+BAAA;EzF2qiBV;EyFlriBM;IAOI,+BAAA;IAAA,8BAAA;EzF+qiBV;EyFtriBM;IAOI,6BAAA;IAAA,4BAAA;EzFmriBV;EyF1riBM;IAOI,+BAAA;IAAA,8BAAA;EzFuriBV;EyF9riBM;IAOI,6BAAA;IAAA,4BAAA;EzF2riBV;EyFlsiBM;IAOI,6BAAA;IAAA,4BAAA;EzF+riBV;EyFtsiBM;IAOI,wBAAA;IAAA,2BAAA;EzFmsiBV;EyF1siBM;IAOI,8BAAA;IAAA,iCAAA;EzFusiBV;EyF9siBM;IAOI,6BAAA;IAAA,gCAAA;EzF2siBV;EyFltiBM;IAOI,2BAAA;IAAA,8BAAA;EzF+siBV;EyFttiBM;IAOI,6BAAA;IAAA,gCAAA;EzFmtiBV;EyF1tiBM;IAOI,2BAAA;IAAA,8BAAA;EzFutiBV;EyF9tiBM;IAOI,2BAAA;IAAA,8BAAA;EzF2tiBV;EyFluiBM;IAOI,wBAAA;EzF8tiBV;EyFruiBM;IAOI,8BAAA;EzFiuiBV;EyFxuiBM;IAOI,6BAAA;EzFouiBV;EyF3uiBM;IAOI,2BAAA;EzFuuiBV;EyF9uiBM;IAOI,6BAAA;EzF0uiBV;EyFjviBM;IAOI,2BAAA;EzF6uiBV;EyFpviBM;IAOI,2BAAA;EzFgviBV;EyFvviBM;IAOI,0BAAA;EzFmviBV;EyF1viBM;IAOI,gCAAA;EzFsviBV;EyF7viBM;IAOI,+BAAA;EzFyviBV;EyFhwiBM;IAOI,6BAAA;EzF4viBV;EyFnwiBM;IAOI,+BAAA;EzF+viBV;EyFtwiBM;IAOI,6BAAA;EzFkwiBV;EyFzwiBM;IAOI,6BAAA;EzFqwiBV;EyF5wiBM;IAOI,2BAAA;EzFwwiBV;EyF/wiBM;IAOI,iCAAA;EzF2wiBV;EyFlxiBM;IAOI,gCAAA;EzF8wiBV;EyFrxiBM;IAOI,8BAAA;EzFixiBV;EyFxxiBM;IAOI,gCAAA;EzFoxiBV;EyF3xiBM;IAOI,8BAAA;EzFuxiBV;EyF9xiBM;IAOI,8BAAA;EzF0xiBV;EyFjyiBM;IAOI,yBAAA;EzF6xiBV;EyFpyiBM;IAOI,+BAAA;EzFgyiBV;EyFvyiBM;IAOI,8BAAA;EzFmyiBV;EyF1yiBM;IAOI,4BAAA;EzFsyiBV;EyF7yiBM;IAOI,8BAAA;EzFyyiBV;EyFhziBM;IAOI,4BAAA;EzF4yiBV;EyFnziBM;IAOI,4BAAA;EzF+yiBV;EyFtziBM;IAOI,qBAAA;EzFkziBV;EyFzziBM;IAOI,2BAAA;EzFqziBV;EyF5ziBM;IAOI,0BAAA;EzFwziBV;EyF/ziBM;IAOI,wBAAA;EzF2ziBV;EyFl0iBM;IAOI,0BAAA;EzF8ziBV;EyFr0iBM;IAOI,wBAAA;EzFi0iBV;EyFx0iBM;IAOI,2BAAA;IAAA,0BAAA;EzFq0iBV;EyF50iBM;IAOI,iCAAA;IAAA,gCAAA;EzFy0iBV;EyFh1iBM;IAOI,gCAAA;IAAA,+BAAA;EzF60iBV;EyFp1iBM;IAOI,8BAAA;IAAA,6BAAA;EzFi1iBV;EyFx1iBM;IAOI,gCAAA;IAAA,+BAAA;EzFq1iBV;EyF51iBM;IAOI,8BAAA;IAAA,6BAAA;EzFy1iBV;EyFh2iBM;IAOI,yBAAA;IAAA,4BAAA;EzF61iBV;EyFp2iBM;IAOI,+BAAA;IAAA,kCAAA;EzFi2iBV;EyFx2iBM;IAOI,8BAAA;IAAA,iCAAA;EzFq2iBV;EyF52iBM;IAOI,4BAAA;IAAA,+BAAA;EzFy2iBV;EyFh3iBM;IAOI,8BAAA;IAAA,iCAAA;EzF62iBV;EyFp3iBM;IAOI,4BAAA;IAAA,+BAAA;EzFi3iBV;EyFx3iBM;IAOI,yBAAA;EzFo3iBV;EyF33iBM;IAOI,+BAAA;EzFu3iBV;EyF93iBM;IAOI,8BAAA;EzF03iBV;EyFj4iBM;IAOI,4BAAA;EzF63iBV;EyFp4iBM;IAOI,8BAAA;EzFg4iBV;EyFv4iBM;IAOI,4BAAA;EzFm4iBV;EyF14iBM;IAOI,2BAAA;EzFs4iBV;EyF74iBM;IAOI,iCAAA;EzFy4iBV;EyFh5iBM;IAOI,gCAAA;EzF44iBV;EyFn5iBM;IAOI,8BAAA;EzF+4iBV;EyFt5iBM;IAOI,gCAAA;EzFk5iBV;EyFz5iBM;IAOI,8BAAA;EzFq5iBV;EyF55iBM;IAOI,4BAAA;EzFw5iBV;EyF/5iBM;IAOI,kCAAA;EzF25iBV;EyFl6iBM;IAOI,iCAAA;EzF85iBV;EyFr6iBM;IAOI,+BAAA;EzFi6iBV;EyFx6iBM;IAOI,iCAAA;EzFo6iBV;EyF36iBM;IAOI,+BAAA;EzFu6iBV;EyF96iBM;IAOI,0BAAA;EzF06iBV;EyFj7iBM;IAOI,gCAAA;EzF66iBV;EyFp7iBM;IAOI,+BAAA;EzFg7iBV;EyFv7iBM;IAOI,6BAAA;EzFm7iBV;EyF17iBM;IAOI,+BAAA;EzFs7iBV;EyF77iBM;IAOI,6BAAA;EzFy7iBV;EyFh8iBM;IAOI,iBAAA;EzF47iBV;EyFn8iBM;IAOI,uBAAA;EzF+7iBV;EyFt8iBM;IAOI,sBAAA;EzFk8iBV;EyFz8iBM;IAOI,oBAAA;EzFq8iBV;EyF58iBM;IAOI,sBAAA;EzFw8iBV;EyF/8iBM;IAOI,oBAAA;EzF28iBV;EyFl9iBM;IAOI,qBAAA;EzF88iBV;EyFr9iBM;IAOI,2BAAA;EzFi9iBV;EyFx9iBM;IAOI,0BAAA;EzFo9iBV;EyF39iBM;IAOI,wBAAA;EzFu9iBV;EyF99iBM;IAOI,0BAAA;EzF09iBV;EyFj+iBM;IAOI,wBAAA;EzF69iBV;EyFp+iBM;IAOI,wBAAA;EzFg+iBV;EyFv+iBM;IAOI,8BAAA;EzFm+iBV;EyF1+iBM;IAOI,6BAAA;EzFs+iBV;EyF7+iBM;IAOI,2BAAA;EzFy+iBV;EyFh/iBM;IAOI,6BAAA;EzF4+iBV;EyFn/iBM;IAOI,2BAAA;EzF++iBV;EyFt/iBM;IAOI,2BAAA;EzFk/iBV;EyFz/iBM;IAOI,4BAAA;EzFq/iBV;EyF5/iBM;IAOI,6BAAA;EzFw/iBV;AACF;A8BngjBI;E2DGI;IAOI,sBAAA;EzF6/iBV;EyFpgjBM;IAOI,uBAAA;EzFggjBV;EyFvgjBM;IAOI,sBAAA;EzFmgjBV;EyF1gjBM;IAOI,8BAAA;EzFsgjBV;EyF7gjBM;IAOI,4BAAA;EzFygjBV;EyFhhjBM;IAOI,2BAAA;EzF4gjBV;EyFnhjBM;IAOI,iCAAA;EzF+gjBV;EyFthjBM;IAOI,2BAAA;EzFkhjBV;EyFzhjBM;IAOI,0BAAA;EzFqhjBV;EyF5hjBM;IAOI,gCAAA;EzFwhjBV;EyF/hjBM;IAOI,yBAAA;EzF2hjBV;EyFlijBM;IAOI,wBAAA;EzF8hjBV;EyFrijBM;IAOI,+BAAA;EzFiijBV;EyFxijBM;IAOI,yBAAA;EzFoijBV;EyF3ijBM;IAOI,6BAAA;EzFuijBV;EyF9ijBM;IAOI,8BAAA;EzF0ijBV;EyFjjjBM;IAOI,wBAAA;EzF6ijBV;EyFpjjBM;IAOI,+BAAA;EzFgjjBV;EyFvjjBM;IAOI,wBAAA;EzFmjjBV;EyF1jjBM;IAOI,yBAAA;EzFsjjBV;EyF7jjBM;IAOI,8BAAA;EzFyjjBV;EyFhkjBM;IAOI,iCAAA;EzF4jjBV;EyFnkjBM;IAOI,sCAAA;EzF+jjBV;EyFtkjBM;IAOI,yCAAA;EzFkkjBV;EyFzkjBM;IAOI,uBAAA;EzFqkjBV;EyF5kjBM;IAOI,uBAAA;EzFwkjBV;EyF/kjBM;IAOI,yBAAA;EzF2kjBV;EyFlljBM;IAOI,yBAAA;EzF8kjBV;EyFrljBM;IAOI,0BAAA;EzFiljBV;EyFxljBM;IAOI,4BAAA;EzFoljBV;EyF3ljBM;IAOI,kCAAA;EzFuljBV;EyF9ljBM;IAOI,sCAAA;EzF0ljBV;EyFjmjBM;IAOI,oCAAA;EzF6ljBV;EyFpmjBM;IAOI,kCAAA;EzFgmjBV;EyFvmjBM;IAOI,yCAAA;EzFmmjBV;EyF1mjBM;IAOI,wCAAA;EzFsmjBV;EyF7mjBM;IAOI,wCAAA;EzFymjBV;EyFhnjBM;IAOI,kCAAA;EzF4mjBV;EyFnnjBM;IAOI,gCAAA;EzF+mjBV;EyFtnjBM;IAOI,8BAAA;EzFknjBV;EyFznjBM;IAOI,gCAAA;EzFqnjBV;EyF5njBM;IAOI,+BAAA;EzFwnjBV;EyF/njBM;IAOI,oCAAA;EzF2njBV;EyFlojBM;IAOI,kCAAA;EzF8njBV;EyFrojBM;IAOI,gCAAA;EzFiojBV;EyFxojBM;IAOI,uCAAA;EzFoojBV;EyF3ojBM;IAOI,sCAAA;EzFuojBV;EyF9ojBM;IAOI,iCAAA;EzF0ojBV;EyFjpjBM;IAOI,2BAAA;EzF6ojBV;EyFppjBM;IAOI,iCAAA;EzFgpjBV;EyFvpjBM;IAOI,+BAAA;EzFmpjBV;EyF1pjBM;IAOI,6BAAA;EzFspjBV;EyF7pjBM;IAOI,+BAAA;EzFypjBV;EyFhqjBM;IAOI,8BAAA;EzF4pjBV;EyFnqjBM;IAOI,oBAAA;EzF+pjBV;EyFtqjBM;IAOI,mBAAA;EzFkqjBV;EyFzqjBM;IAOI,mBAAA;EzFqqjBV;EyF5qjBM;IAOI,mBAAA;EzFwqjBV;EyF/qjBM;IAOI,mBAAA;EzF2qjBV;EyFlrjBM;IAOI,mBAAA;EzF8qjBV;EyFrrjBM;IAOI,mBAAA;EzFirjBV;EyFxrjBM;IAOI,mBAAA;EzForjBV;EyF3rjBM;IAOI,oBAAA;EzFurjBV;EyF9rjBM;IAOI,0BAAA;EzF0rjBV;EyFjsjBM;IAOI,yBAAA;EzF6rjBV;EyFpsjBM;IAOI,uBAAA;EzFgsjBV;EyFvsjBM;IAOI,yBAAA;EzFmsjBV;EyF1sjBM;IAOI,uBAAA;EzFssjBV;EyF7sjBM;IAOI,uBAAA;EzFysjBV;EyFhtjBM;IAOI,0BAAA;IAAA,yBAAA;EzF6sjBV;EyFptjBM;IAOI,gCAAA;IAAA,+BAAA;EzFitjBV;EyFxtjBM;IAOI,+BAAA;IAAA,8BAAA;EzFqtjBV;EyF5tjBM;IAOI,6BAAA;IAAA,4BAAA;EzFytjBV;EyFhujBM;IAOI,+BAAA;IAAA,8BAAA;EzF6tjBV;EyFpujBM;IAOI,6BAAA;IAAA,4BAAA;EzFiujBV;EyFxujBM;IAOI,6BAAA;IAAA,4BAAA;EzFqujBV;EyF5ujBM;IAOI,wBAAA;IAAA,2BAAA;EzFyujBV;EyFhvjBM;IAOI,8BAAA;IAAA,iCAAA;EzF6ujBV;EyFpvjBM;IAOI,6BAAA;IAAA,gCAAA;EzFivjBV;EyFxvjBM;IAOI,2BAAA;IAAA,8BAAA;EzFqvjBV;EyF5vjBM;IAOI,6BAAA;IAAA,gCAAA;EzFyvjBV;EyFhwjBM;IAOI,2BAAA;IAAA,8BAAA;EzF6vjBV;EyFpwjBM;IAOI,2BAAA;IAAA,8BAAA;EzFiwjBV;EyFxwjBM;IAOI,wBAAA;EzFowjBV;EyF3wjBM;IAOI,8BAAA;EzFuwjBV;EyF9wjBM;IAOI,6BAAA;EzF0wjBV;EyFjxjBM;IAOI,2BAAA;EzF6wjBV;EyFpxjBM;IAOI,6BAAA;EzFgxjBV;EyFvxjBM;IAOI,2BAAA;EzFmxjBV;EyF1xjBM;IAOI,2BAAA;EzFsxjBV;EyF7xjBM;IAOI,0BAAA;EzFyxjBV;EyFhyjBM;IAOI,gCAAA;EzF4xjBV;EyFnyjBM;IAOI,+BAAA;EzF+xjBV;EyFtyjBM;IAOI,6BAAA;EzFkyjBV;EyFzyjBM;IAOI,+BAAA;EzFqyjBV;EyF5yjBM;IAOI,6BAAA;EzFwyjBV;EyF/yjBM;IAOI,6BAAA;EzF2yjBV;EyFlzjBM;IAOI,2BAAA;EzF8yjBV;EyFrzjBM;IAOI,iCAAA;EzFizjBV;EyFxzjBM;IAOI,gCAAA;EzFozjBV;EyF3zjBM;IAOI,8BAAA;EzFuzjBV;EyF9zjBM;IAOI,gCAAA;EzF0zjBV;EyFj0jBM;IAOI,8BAAA;EzF6zjBV;EyFp0jBM;IAOI,8BAAA;EzFg0jBV;EyFv0jBM;IAOI,yBAAA;EzFm0jBV;EyF10jBM;IAOI,+BAAA;EzFs0jBV;EyF70jBM;IAOI,8BAAA;EzFy0jBV;EyFh1jBM;IAOI,4BAAA;EzF40jBV;EyFn1jBM;IAOI,8BAAA;EzF+0jBV;EyFt1jBM;IAOI,4BAAA;EzFk1jBV;EyFz1jBM;IAOI,4BAAA;EzFq1jBV;EyF51jBM;IAOI,qBAAA;EzFw1jBV;EyF/1jBM;IAOI,2BAAA;EzF21jBV;EyFl2jBM;IAOI,0BAAA;EzF81jBV;EyFr2jBM;IAOI,wBAAA;EzFi2jBV;EyFx2jBM;IAOI,0BAAA;EzFo2jBV;EyF32jBM;IAOI,wBAAA;EzFu2jBV;EyF92jBM;IAOI,2BAAA;IAAA,0BAAA;EzF22jBV;EyFl3jBM;IAOI,iCAAA;IAAA,gCAAA;EzF+2jBV;EyFt3jBM;IAOI,gCAAA;IAAA,+BAAA;EzFm3jBV;EyF13jBM;IAOI,8BAAA;IAAA,6BAAA;EzFu3jBV;EyF93jBM;IAOI,gCAAA;IAAA,+BAAA;EzF23jBV;EyFl4jBM;IAOI,8BAAA;IAAA,6BAAA;EzF+3jBV;EyFt4jBM;IAOI,yBAAA;IAAA,4BAAA;EzFm4jBV;EyF14jBM;IAOI,+BAAA;IAAA,kCAAA;EzFu4jBV;EyF94jBM;IAOI,8BAAA;IAAA,iCAAA;EzF24jBV;EyFl5jBM;IAOI,4BAAA;IAAA,+BAAA;EzF+4jBV;EyFt5jBM;IAOI,8BAAA;IAAA,iCAAA;EzFm5jBV;EyF15jBM;IAOI,4BAAA;IAAA,+BAAA;EzFu5jBV;EyF95jBM;IAOI,yBAAA;EzF05jBV;EyFj6jBM;IAOI,+BAAA;EzF65jBV;EyFp6jBM;IAOI,8BAAA;EzFg6jBV;EyFv6jBM;IAOI,4BAAA;EzFm6jBV;EyF16jBM;IAOI,8BAAA;EzFs6jBV;EyF76jBM;IAOI,4BAAA;EzFy6jBV;EyFh7jBM;IAOI,2BAAA;EzF46jBV;EyFn7jBM;IAOI,iCAAA;EzF+6jBV;EyFt7jBM;IAOI,gCAAA;EzFk7jBV;EyFz7jBM;IAOI,8BAAA;EzFq7jBV;EyF57jBM;IAOI,gCAAA;EzFw7jBV;EyF/7jBM;IAOI,8BAAA;EzF27jBV;EyFl8jBM;IAOI,4BAAA;EzF87jBV;EyFr8jBM;IAOI,kCAAA;EzFi8jBV;EyFx8jBM;IAOI,iCAAA;EzFo8jBV;EyF38jBM;IAOI,+BAAA;EzFu8jBV;EyF98jBM;IAOI,iCAAA;EzF08jBV;EyFj9jBM;IAOI,+BAAA;EzF68jBV;EyFp9jBM;IAOI,0BAAA;EzFg9jBV;EyFv9jBM;IAOI,gCAAA;EzFm9jBV;EyF19jBM;IAOI,+BAAA;EzFs9jBV;EyF79jBM;IAOI,6BAAA;EzFy9jBV;EyFh+jBM;IAOI,+BAAA;EzF49jBV;EyFn+jBM;IAOI,6BAAA;EzF+9jBV;EyFt+jBM;IAOI,iBAAA;EzFk+jBV;EyFz+jBM;IAOI,uBAAA;EzFq+jBV;EyF5+jBM;IAOI,sBAAA;EzFw+jBV;EyF/+jBM;IAOI,oBAAA;EzF2+jBV;EyFl/jBM;IAOI,sBAAA;EzF8+jBV;EyFr/jBM;IAOI,oBAAA;EzFi/jBV;EyFx/jBM;IAOI,qBAAA;EzFo/jBV;EyF3/jBM;IAOI,2BAAA;EzFu/jBV;EyF9/jBM;IAOI,0BAAA;EzF0/jBV;EyFjgkBM;IAOI,wBAAA;EzF6/jBV;EyFpgkBM;IAOI,0BAAA;EzFggkBV;EyFvgkBM;IAOI,wBAAA;EzFmgkBV;EyF1gkBM;IAOI,wBAAA;EzFsgkBV;EyF7gkBM;IAOI,8BAAA;EzFygkBV;EyFhhkBM;IAOI,6BAAA;EzF4gkBV;EyFnhkBM;IAOI,2BAAA;EzF+gkBV;EyFthkBM;IAOI,6BAAA;EzFkhkBV;EyFzhkBM;IAOI,2BAAA;EzFqhkBV;EyF5hkBM;IAOI,2BAAA;EzFwhkBV;EyF/hkBM;IAOI,4BAAA;EzF2hkBV;EyFlikBM;IAOI,6BAAA;EzF8hkBV;AACF;A8BzikBI;E2DGI;IAOI,sBAAA;EzFmikBV;EyF1ikBM;IAOI,uBAAA;EzFsikBV;EyF7ikBM;IAOI,sBAAA;EzFyikBV;EyFhjkBM;IAOI,8BAAA;EzF4ikBV;EyFnjkBM;IAOI,4BAAA;EzF+ikBV;EyFtjkBM;IAOI,2BAAA;EzFkjkBV;EyFzjkBM;IAOI,iCAAA;EzFqjkBV;EyF5jkBM;IAOI,2BAAA;EzFwjkBV;EyF/jkBM;IAOI,0BAAA;EzF2jkBV;EyFlkkBM;IAOI,gCAAA;EzF8jkBV;EyFrkkBM;IAOI,yBAAA;EzFikkBV;EyFxkkBM;IAOI,wBAAA;EzFokkBV;EyF3kkBM;IAOI,+BAAA;EzFukkBV;EyF9kkBM;IAOI,yBAAA;EzF0kkBV;EyFjlkBM;IAOI,6BAAA;EzF6kkBV;EyFplkBM;IAOI,8BAAA;EzFglkBV;EyFvlkBM;IAOI,wBAAA;EzFmlkBV;EyF1lkBM;IAOI,+BAAA;EzFslkBV;EyF7lkBM;IAOI,wBAAA;EzFylkBV;EyFhmkBM;IAOI,yBAAA;EzF4lkBV;EyFnmkBM;IAOI,8BAAA;EzF+lkBV;EyFtmkBM;IAOI,iCAAA;EzFkmkBV;EyFzmkBM;IAOI,sCAAA;EzFqmkBV;EyF5mkBM;IAOI,yCAAA;EzFwmkBV;EyF/mkBM;IAOI,uBAAA;EzF2mkBV;EyFlnkBM;IAOI,uBAAA;EzF8mkBV;EyFrnkBM;IAOI,yBAAA;EzFinkBV;EyFxnkBM;IAOI,yBAAA;EzFonkBV;EyF3nkBM;IAOI,0BAAA;EzFunkBV;EyF9nkBM;IAOI,4BAAA;EzF0nkBV;EyFjokBM;IAOI,kCAAA;EzF6nkBV;EyFpokBM;IAOI,sCAAA;EzFgokBV;EyFvokBM;IAOI,oCAAA;EzFmokBV;EyF1okBM;IAOI,kCAAA;EzFsokBV;EyF7okBM;IAOI,yCAAA;EzFyokBV;EyFhpkBM;IAOI,wCAAA;EzF4okBV;EyFnpkBM;IAOI,wCAAA;EzF+okBV;EyFtpkBM;IAOI,kCAAA;EzFkpkBV;EyFzpkBM;IAOI,gCAAA;EzFqpkBV;EyF5pkBM;IAOI,8BAAA;EzFwpkBV;EyF/pkBM;IAOI,gCAAA;EzF2pkBV;EyFlqkBM;IAOI,+BAAA;EzF8pkBV;EyFrqkBM;IAOI,oCAAA;EzFiqkBV;EyFxqkBM;IAOI,kCAAA;EzFoqkBV;EyF3qkBM;IAOI,gCAAA;EzFuqkBV;EyF9qkBM;IAOI,uCAAA;EzF0qkBV;EyFjrkBM;IAOI,sCAAA;EzF6qkBV;EyFprkBM;IAOI,iCAAA;EzFgrkBV;EyFvrkBM;IAOI,2BAAA;EzFmrkBV;EyF1rkBM;IAOI,iCAAA;EzFsrkBV;EyF7rkBM;IAOI,+BAAA;EzFyrkBV;EyFhskBM;IAOI,6BAAA;EzF4rkBV;EyFnskBM;IAOI,+BAAA;EzF+rkBV;EyFtskBM;IAOI,8BAAA;EzFkskBV;EyFzskBM;IAOI,oBAAA;EzFqskBV;EyF5skBM;IAOI,mBAAA;EzFwskBV;EyF/skBM;IAOI,mBAAA;EzF2skBV;EyFltkBM;IAOI,mBAAA;EzF8skBV;EyFrtkBM;IAOI,mBAAA;EzFitkBV;EyFxtkBM;IAOI,mBAAA;EzFotkBV;EyF3tkBM;IAOI,mBAAA;EzFutkBV;EyF9tkBM;IAOI,mBAAA;EzF0tkBV;EyFjukBM;IAOI,oBAAA;EzF6tkBV;EyFpukBM;IAOI,0BAAA;EzFgukBV;EyFvukBM;IAOI,yBAAA;EzFmukBV;EyF1ukBM;IAOI,uBAAA;EzFsukBV;EyF7ukBM;IAOI,yBAAA;EzFyukBV;EyFhvkBM;IAOI,uBAAA;EzF4ukBV;EyFnvkBM;IAOI,uBAAA;EzF+ukBV;EyFtvkBM;IAOI,0BAAA;IAAA,yBAAA;EzFmvkBV;EyF1vkBM;IAOI,gCAAA;IAAA,+BAAA;EzFuvkBV;EyF9vkBM;IAOI,+BAAA;IAAA,8BAAA;EzF2vkBV;EyFlwkBM;IAOI,6BAAA;IAAA,4BAAA;EzF+vkBV;EyFtwkBM;IAOI,+BAAA;IAAA,8BAAA;EzFmwkBV;EyF1wkBM;IAOI,6BAAA;IAAA,4BAAA;EzFuwkBV;EyF9wkBM;IAOI,6BAAA;IAAA,4BAAA;EzF2wkBV;EyFlxkBM;IAOI,wBAAA;IAAA,2BAAA;EzF+wkBV;EyFtxkBM;IAOI,8BAAA;IAAA,iCAAA;EzFmxkBV;EyF1xkBM;IAOI,6BAAA;IAAA,gCAAA;EzFuxkBV;EyF9xkBM;IAOI,2BAAA;IAAA,8BAAA;EzF2xkBV;EyFlykBM;IAOI,6BAAA;IAAA,gCAAA;EzF+xkBV;EyFtykBM;IAOI,2BAAA;IAAA,8BAAA;EzFmykBV;EyF1ykBM;IAOI,2BAAA;IAAA,8BAAA;EzFuykBV;EyF9ykBM;IAOI,wBAAA;EzF0ykBV;EyFjzkBM;IAOI,8BAAA;EzF6ykBV;EyFpzkBM;IAOI,6BAAA;EzFgzkBV;EyFvzkBM;IAOI,2BAAA;EzFmzkBV;EyF1zkBM;IAOI,6BAAA;EzFszkBV;EyF7zkBM;IAOI,2BAAA;EzFyzkBV;EyFh0kBM;IAOI,2BAAA;EzF4zkBV;EyFn0kBM;IAOI,0BAAA;EzF+zkBV;EyFt0kBM;IAOI,gCAAA;EzFk0kBV;EyFz0kBM;IAOI,+BAAA;EzFq0kBV;EyF50kBM;IAOI,6BAAA;EzFw0kBV;EyF/0kBM;IAOI,+BAAA;EzF20kBV;EyFl1kBM;IAOI,6BAAA;EzF80kBV;EyFr1kBM;IAOI,6BAAA;EzFi1kBV;EyFx1kBM;IAOI,2BAAA;EzFo1kBV;EyF31kBM;IAOI,iCAAA;EzFu1kBV;EyF91kBM;IAOI,gCAAA;EzF01kBV;EyFj2kBM;IAOI,8BAAA;EzF61kBV;EyFp2kBM;IAOI,gCAAA;EzFg2kBV;EyFv2kBM;IAOI,8BAAA;EzFm2kBV;EyF12kBM;IAOI,8BAAA;EzFs2kBV;EyF72kBM;IAOI,yBAAA;EzFy2kBV;EyFh3kBM;IAOI,+BAAA;EzF42kBV;EyFn3kBM;IAOI,8BAAA;EzF+2kBV;EyFt3kBM;IAOI,4BAAA;EzFk3kBV;EyFz3kBM;IAOI,8BAAA;EzFq3kBV;EyF53kBM;IAOI,4BAAA;EzFw3kBV;EyF/3kBM;IAOI,4BAAA;EzF23kBV;EyFl4kBM;IAOI,qBAAA;EzF83kBV;EyFr4kBM;IAOI,2BAAA;EzFi4kBV;EyFx4kBM;IAOI,0BAAA;EzFo4kBV;EyF34kBM;IAOI,wBAAA;EzFu4kBV;EyF94kBM;IAOI,0BAAA;EzF04kBV;EyFj5kBM;IAOI,wBAAA;EzF64kBV;EyFp5kBM;IAOI,2BAAA;IAAA,0BAAA;EzFi5kBV;EyFx5kBM;IAOI,iCAAA;IAAA,gCAAA;EzFq5kBV;EyF55kBM;IAOI,gCAAA;IAAA,+BAAA;EzFy5kBV;EyFh6kBM;IAOI,8BAAA;IAAA,6BAAA;EzF65kBV;EyFp6kBM;IAOI,gCAAA;IAAA,+BAAA;EzFi6kBV;EyFx6kBM;IAOI,8BAAA;IAAA,6BAAA;EzFq6kBV;EyF56kBM;IAOI,yBAAA;IAAA,4BAAA;EzFy6kBV;EyFh7kBM;IAOI,+BAAA;IAAA,kCAAA;EzF66kBV;EyFp7kBM;IAOI,8BAAA;IAAA,iCAAA;EzFi7kBV;EyFx7kBM;IAOI,4BAAA;IAAA,+BAAA;EzFq7kBV;EyF57kBM;IAOI,8BAAA;IAAA,iCAAA;EzFy7kBV;EyFh8kBM;IAOI,4BAAA;IAAA,+BAAA;EzF67kBV;EyFp8kBM;IAOI,yBAAA;EzFg8kBV;EyFv8kBM;IAOI,+BAAA;EzFm8kBV;EyF18kBM;IAOI,8BAAA;EzFs8kBV;EyF78kBM;IAOI,4BAAA;EzFy8kBV;EyFh9kBM;IAOI,8BAAA;EzF48kBV;EyFn9kBM;IAOI,4BAAA;EzF+8kBV;EyFt9kBM;IAOI,2BAAA;EzFk9kBV;EyFz9kBM;IAOI,iCAAA;EzFq9kBV;EyF59kBM;IAOI,gCAAA;EzFw9kBV;EyF/9kBM;IAOI,8BAAA;EzF29kBV;EyFl+kBM;IAOI,gCAAA;EzF89kBV;EyFr+kBM;IAOI,8BAAA;EzFi+kBV;EyFx+kBM;IAOI,4BAAA;EzFo+kBV;EyF3+kBM;IAOI,kCAAA;EzFu+kBV;EyF9+kBM;IAOI,iCAAA;EzF0+kBV;EyFj/kBM;IAOI,+BAAA;EzF6+kBV;EyFp/kBM;IAOI,iCAAA;EzFg/kBV;EyFv/kBM;IAOI,+BAAA;EzFm/kBV;EyF1/kBM;IAOI,0BAAA;EzFs/kBV;EyF7/kBM;IAOI,gCAAA;EzFy/kBV;EyFhglBM;IAOI,+BAAA;EzF4/kBV;EyFnglBM;IAOI,6BAAA;EzF+/kBV;EyFtglBM;IAOI,+BAAA;EzFkglBV;EyFzglBM;IAOI,6BAAA;EzFqglBV;EyF5glBM;IAOI,iBAAA;EzFwglBV;EyF/glBM;IAOI,uBAAA;EzF2glBV;EyFlhlBM;IAOI,sBAAA;EzF8glBV;EyFrhlBM;IAOI,oBAAA;EzFihlBV;EyFxhlBM;IAOI,sBAAA;EzFohlBV;EyF3hlBM;IAOI,oBAAA;EzFuhlBV;EyF9hlBM;IAOI,qBAAA;EzF0hlBV;EyFjilBM;IAOI,2BAAA;EzF6hlBV;EyFpilBM;IAOI,0BAAA;EzFgilBV;EyFvilBM;IAOI,wBAAA;EzFmilBV;EyF1ilBM;IAOI,0BAAA;EzFsilBV;EyF7ilBM;IAOI,wBAAA;EzFyilBV;EyFhjlBM;IAOI,wBAAA;EzF4ilBV;EyFnjlBM;IAOI,8BAAA;EzF+ilBV;EyFtjlBM;IAOI,6BAAA;EzFkjlBV;EyFzjlBM;IAOI,2BAAA;EzFqjlBV;EyF5jlBM;IAOI,6BAAA;EzFwjlBV;EyF/jlBM;IAOI,2BAAA;EzF2jlBV;EyFlklBM;IAOI,2BAAA;EzF8jlBV;EyFrklBM;IAOI,4BAAA;EzFiklBV;EyFxklBM;IAOI,6BAAA;EzFoklBV;AACF;A8B/klBI;E2DGI;IAOI,sBAAA;EzFyklBV;EyFhllBM;IAOI,uBAAA;EzF4klBV;EyFnllBM;IAOI,sBAAA;EzF+klBV;EyFtllBM;IAOI,8BAAA;EzFkllBV;EyFzllBM;IAOI,4BAAA;EzFqllBV;EyF5llBM;IAOI,2BAAA;EzFwllBV;EyF/llBM;IAOI,iCAAA;EzF2llBV;EyFlmlBM;IAOI,2BAAA;EzF8llBV;EyFrmlBM;IAOI,0BAAA;EzFimlBV;EyFxmlBM;IAOI,gCAAA;EzFomlBV;EyF3mlBM;IAOI,yBAAA;EzFumlBV;EyF9mlBM;IAOI,wBAAA;EzF0mlBV;EyFjnlBM;IAOI,+BAAA;EzF6mlBV;EyFpnlBM;IAOI,yBAAA;EzFgnlBV;EyFvnlBM;IAOI,6BAAA;EzFmnlBV;EyF1nlBM;IAOI,8BAAA;EzFsnlBV;EyF7nlBM;IAOI,wBAAA;EzFynlBV;EyFholBM;IAOI,+BAAA;EzF4nlBV;EyFnolBM;IAOI,wBAAA;EzF+nlBV;EyFtolBM;IAOI,yBAAA;EzFkolBV;EyFzolBM;IAOI,8BAAA;EzFqolBV;EyF5olBM;IAOI,iCAAA;EzFwolBV;EyF/olBM;IAOI,sCAAA;EzF2olBV;EyFlplBM;IAOI,yCAAA;EzF8olBV;EyFrplBM;IAOI,uBAAA;EzFiplBV;EyFxplBM;IAOI,uBAAA;EzFoplBV;EyF3plBM;IAOI,yBAAA;EzFuplBV;EyF9plBM;IAOI,yBAAA;EzF0plBV;EyFjqlBM;IAOI,0BAAA;EzF6plBV;EyFpqlBM;IAOI,4BAAA;EzFgqlBV;EyFvqlBM;IAOI,kCAAA;EzFmqlBV;EyF1qlBM;IAOI,sCAAA;EzFsqlBV;EyF7qlBM;IAOI,oCAAA;EzFyqlBV;EyFhrlBM;IAOI,kCAAA;EzF4qlBV;EyFnrlBM;IAOI,yCAAA;EzF+qlBV;EyFtrlBM;IAOI,wCAAA;EzFkrlBV;EyFzrlBM;IAOI,wCAAA;EzFqrlBV;EyF5rlBM;IAOI,kCAAA;EzFwrlBV;EyF/rlBM;IAOI,gCAAA;EzF2rlBV;EyFlslBM;IAOI,8BAAA;EzF8rlBV;EyFrslBM;IAOI,gCAAA;EzFislBV;EyFxslBM;IAOI,+BAAA;EzFoslBV;EyF3slBM;IAOI,oCAAA;EzFuslBV;EyF9slBM;IAOI,kCAAA;EzF0slBV;EyFjtlBM;IAOI,gCAAA;EzF6slBV;EyFptlBM;IAOI,uCAAA;EzFgtlBV;EyFvtlBM;IAOI,sCAAA;EzFmtlBV;EyF1tlBM;IAOI,iCAAA;EzFstlBV;EyF7tlBM;IAOI,2BAAA;EzFytlBV;EyFhulBM;IAOI,iCAAA;EzF4tlBV;EyFnulBM;IAOI,+BAAA;EzF+tlBV;EyFtulBM;IAOI,6BAAA;EzFkulBV;EyFzulBM;IAOI,+BAAA;EzFqulBV;EyF5ulBM;IAOI,8BAAA;EzFwulBV;EyF/ulBM;IAOI,oBAAA;EzF2ulBV;EyFlvlBM;IAOI,mBAAA;EzF8ulBV;EyFrvlBM;IAOI,mBAAA;EzFivlBV;EyFxvlBM;IAOI,mBAAA;EzFovlBV;EyF3vlBM;IAOI,mBAAA;EzFuvlBV;EyF9vlBM;IAOI,mBAAA;EzF0vlBV;EyFjwlBM;IAOI,mBAAA;EzF6vlBV;EyFpwlBM;IAOI,mBAAA;EzFgwlBV;EyFvwlBM;IAOI,oBAAA;EzFmwlBV;EyF1wlBM;IAOI,0BAAA;EzFswlBV;EyF7wlBM;IAOI,yBAAA;EzFywlBV;EyFhxlBM;IAOI,uBAAA;EzF4wlBV;EyFnxlBM;IAOI,yBAAA;EzF+wlBV;EyFtxlBM;IAOI,uBAAA;EzFkxlBV;EyFzxlBM;IAOI,uBAAA;EzFqxlBV;EyF5xlBM;IAOI,0BAAA;IAAA,yBAAA;EzFyxlBV;EyFhylBM;IAOI,gCAAA;IAAA,+BAAA;EzF6xlBV;EyFpylBM;IAOI,+BAAA;IAAA,8BAAA;EzFiylBV;EyFxylBM;IAOI,6BAAA;IAAA,4BAAA;EzFqylBV;EyF5ylBM;IAOI,+BAAA;IAAA,8BAAA;EzFyylBV;EyFhzlBM;IAOI,6BAAA;IAAA,4BAAA;EzF6ylBV;EyFpzlBM;IAOI,6BAAA;IAAA,4BAAA;EzFizlBV;EyFxzlBM;IAOI,wBAAA;IAAA,2BAAA;EzFqzlBV;EyF5zlBM;IAOI,8BAAA;IAAA,iCAAA;EzFyzlBV;EyFh0lBM;IAOI,6BAAA;IAAA,gCAAA;EzF6zlBV;EyFp0lBM;IAOI,2BAAA;IAAA,8BAAA;EzFi0lBV;EyFx0lBM;IAOI,6BAAA;IAAA,gCAAA;EzFq0lBV;EyF50lBM;IAOI,2BAAA;IAAA,8BAAA;EzFy0lBV;EyFh1lBM;IAOI,2BAAA;IAAA,8BAAA;EzF60lBV;EyFp1lBM;IAOI,wBAAA;EzFg1lBV;EyFv1lBM;IAOI,8BAAA;EzFm1lBV;EyF11lBM;IAOI,6BAAA;EzFs1lBV;EyF71lBM;IAOI,2BAAA;EzFy1lBV;EyFh2lBM;IAOI,6BAAA;EzF41lBV;EyFn2lBM;IAOI,2BAAA;EzF+1lBV;EyFt2lBM;IAOI,2BAAA;EzFk2lBV;EyFz2lBM;IAOI,0BAAA;EzFq2lBV;EyF52lBM;IAOI,gCAAA;EzFw2lBV;EyF/2lBM;IAOI,+BAAA;EzF22lBV;EyFl3lBM;IAOI,6BAAA;EzF82lBV;EyFr3lBM;IAOI,+BAAA;EzFi3lBV;EyFx3lBM;IAOI,6BAAA;EzFo3lBV;EyF33lBM;IAOI,6BAAA;EzFu3lBV;EyF93lBM;IAOI,2BAAA;EzF03lBV;EyFj4lBM;IAOI,iCAAA;EzF63lBV;EyFp4lBM;IAOI,gCAAA;EzFg4lBV;EyFv4lBM;IAOI,8BAAA;EzFm4lBV;EyF14lBM;IAOI,gCAAA;EzFs4lBV;EyF74lBM;IAOI,8BAAA;EzFy4lBV;EyFh5lBM;IAOI,8BAAA;EzF44lBV;EyFn5lBM;IAOI,yBAAA;EzF+4lBV;EyFt5lBM;IAOI,+BAAA;EzFk5lBV;EyFz5lBM;IAOI,8BAAA;EzFq5lBV;EyF55lBM;IAOI,4BAAA;EzFw5lBV;EyF/5lBM;IAOI,8BAAA;EzF25lBV;EyFl6lBM;IAOI,4BAAA;EzF85lBV;EyFr6lBM;IAOI,4BAAA;EzFi6lBV;EyFx6lBM;IAOI,qBAAA;EzFo6lBV;EyF36lBM;IAOI,2BAAA;EzFu6lBV;EyF96lBM;IAOI,0BAAA;EzF06lBV;EyFj7lBM;IAOI,wBAAA;EzF66lBV;EyFp7lBM;IAOI,0BAAA;EzFg7lBV;EyFv7lBM;IAOI,wBAAA;EzFm7lBV;EyF17lBM;IAOI,2BAAA;IAAA,0BAAA;EzFu7lBV;EyF97lBM;IAOI,iCAAA;IAAA,gCAAA;EzF27lBV;EyFl8lBM;IAOI,gCAAA;IAAA,+BAAA;EzF+7lBV;EyFt8lBM;IAOI,8BAAA;IAAA,6BAAA;EzFm8lBV;EyF18lBM;IAOI,gCAAA;IAAA,+BAAA;EzFu8lBV;EyF98lBM;IAOI,8BAAA;IAAA,6BAAA;EzF28lBV;EyFl9lBM;IAOI,yBAAA;IAAA,4BAAA;EzF+8lBV;EyFt9lBM;IAOI,+BAAA;IAAA,kCAAA;EzFm9lBV;EyF19lBM;IAOI,8BAAA;IAAA,iCAAA;EzFu9lBV;EyF99lBM;IAOI,4BAAA;IAAA,+BAAA;EzF29lBV;EyFl+lBM;IAOI,8BAAA;IAAA,iCAAA;EzF+9lBV;EyFt+lBM;IAOI,4BAAA;IAAA,+BAAA;EzFm+lBV;EyF1+lBM;IAOI,yBAAA;EzFs+lBV;EyF7+lBM;IAOI,+BAAA;EzFy+lBV;EyFh/lBM;IAOI,8BAAA;EzF4+lBV;EyFn/lBM;IAOI,4BAAA;EzF++lBV;EyFt/lBM;IAOI,8BAAA;EzFk/lBV;EyFz/lBM;IAOI,4BAAA;EzFq/lBV;EyF5/lBM;IAOI,2BAAA;EzFw/lBV;EyF//lBM;IAOI,iCAAA;EzF2/lBV;EyFlgmBM;IAOI,gCAAA;EzF8/lBV;EyFrgmBM;IAOI,8BAAA;EzFigmBV;EyFxgmBM;IAOI,gCAAA;EzFogmBV;EyF3gmBM;IAOI,8BAAA;EzFugmBV;EyF9gmBM;IAOI,4BAAA;EzF0gmBV;EyFjhmBM;IAOI,kCAAA;EzF6gmBV;EyFphmBM;IAOI,iCAAA;EzFghmBV;EyFvhmBM;IAOI,+BAAA;EzFmhmBV;EyF1hmBM;IAOI,iCAAA;EzFshmBV;EyF7hmBM;IAOI,+BAAA;EzFyhmBV;EyFhimBM;IAOI,0BAAA;EzF4hmBV;EyFnimBM;IAOI,gCAAA;EzF+hmBV;EyFtimBM;IAOI,+BAAA;EzFkimBV;EyFzimBM;IAOI,6BAAA;EzFqimBV;EyF5imBM;IAOI,+BAAA;EzFwimBV;EyF/imBM;IAOI,6BAAA;EzF2imBV;EyFljmBM;IAOI,iBAAA;EzF8imBV;EyFrjmBM;IAOI,uBAAA;EzFijmBV;EyFxjmBM;IAOI,sBAAA;EzFojmBV;EyF3jmBM;IAOI,oBAAA;EzFujmBV;EyF9jmBM;IAOI,sBAAA;EzF0jmBV;EyFjkmBM;IAOI,oBAAA;EzF6jmBV;EyFpkmBM;IAOI,qBAAA;EzFgkmBV;EyFvkmBM;IAOI,2BAAA;EzFmkmBV;EyF1kmBM;IAOI,0BAAA;EzFskmBV;EyF7kmBM;IAOI,wBAAA;EzFykmBV;EyFhlmBM;IAOI,0BAAA;EzF4kmBV;EyFnlmBM;IAOI,wBAAA;EzF+kmBV;EyFtlmBM;IAOI,wBAAA;EzFklmBV;EyFzlmBM;IAOI,8BAAA;EzFqlmBV;EyF5lmBM;IAOI,6BAAA;EzFwlmBV;EyF/lmBM;IAOI,2BAAA;EzF2lmBV;EyFlmmBM;IAOI,6BAAA;EzF8lmBV;EyFrmmBM;IAOI,2BAAA;EzFimmBV;EyFxmmBM;IAOI,2BAAA;EzFommBV;EyF3mmBM;IAOI,4BAAA;EzFummBV;EyF9mmBM;IAOI,6BAAA;EzF0mmBV;AACF;A8BrnmBI;E2DGI;IAOI,sBAAA;EzF+mmBV;EyFtnmBM;IAOI,uBAAA;EzFknmBV;EyFznmBM;IAOI,sBAAA;EzFqnmBV;EyF5nmBM;IAOI,8BAAA;EzFwnmBV;EyF/nmBM;IAOI,4BAAA;EzF2nmBV;EyFlomBM;IAOI,2BAAA;EzF8nmBV;EyFromBM;IAOI,iCAAA;EzFiomBV;EyFxomBM;IAOI,2BAAA;EzFoomBV;EyF3omBM;IAOI,0BAAA;EzFuomBV;EyF9omBM;IAOI,gCAAA;EzF0omBV;EyFjpmBM;IAOI,yBAAA;EzF6omBV;EyFppmBM;IAOI,wBAAA;EzFgpmBV;EyFvpmBM;IAOI,+BAAA;EzFmpmBV;EyF1pmBM;IAOI,yBAAA;EzFspmBV;EyF7pmBM;IAOI,6BAAA;EzFypmBV;EyFhqmBM;IAOI,8BAAA;EzF4pmBV;EyFnqmBM;IAOI,wBAAA;EzF+pmBV;EyFtqmBM;IAOI,+BAAA;EzFkqmBV;EyFzqmBM;IAOI,wBAAA;EzFqqmBV;EyF5qmBM;IAOI,yBAAA;EzFwqmBV;EyF/qmBM;IAOI,8BAAA;EzF2qmBV;EyFlrmBM;IAOI,iCAAA;EzF8qmBV;EyFrrmBM;IAOI,sCAAA;EzFirmBV;EyFxrmBM;IAOI,yCAAA;EzFormBV;EyF3rmBM;IAOI,uBAAA;EzFurmBV;EyF9rmBM;IAOI,uBAAA;EzF0rmBV;EyFjsmBM;IAOI,yBAAA;EzF6rmBV;EyFpsmBM;IAOI,yBAAA;EzFgsmBV;EyFvsmBM;IAOI,0BAAA;EzFmsmBV;EyF1smBM;IAOI,4BAAA;EzFssmBV;EyF7smBM;IAOI,kCAAA;EzFysmBV;EyFhtmBM;IAOI,sCAAA;EzF4smBV;EyFntmBM;IAOI,oCAAA;EzF+smBV;EyFttmBM;IAOI,kCAAA;EzFktmBV;EyFztmBM;IAOI,yCAAA;EzFqtmBV;EyF5tmBM;IAOI,wCAAA;EzFwtmBV;EyF/tmBM;IAOI,wCAAA;EzF2tmBV;EyFlumBM;IAOI,kCAAA;EzF8tmBV;EyFrumBM;IAOI,gCAAA;EzFiumBV;EyFxumBM;IAOI,8BAAA;EzFoumBV;EyF3umBM;IAOI,gCAAA;EzFuumBV;EyF9umBM;IAOI,+BAAA;EzF0umBV;EyFjvmBM;IAOI,oCAAA;EzF6umBV;EyFpvmBM;IAOI,kCAAA;EzFgvmBV;EyFvvmBM;IAOI,gCAAA;EzFmvmBV;EyF1vmBM;IAOI,uCAAA;EzFsvmBV;EyF7vmBM;IAOI,sCAAA;EzFyvmBV;EyFhwmBM;IAOI,iCAAA;EzF4vmBV;EyFnwmBM;IAOI,2BAAA;EzF+vmBV;EyFtwmBM;IAOI,iCAAA;EzFkwmBV;EyFzwmBM;IAOI,+BAAA;EzFqwmBV;EyF5wmBM;IAOI,6BAAA;EzFwwmBV;EyF/wmBM;IAOI,+BAAA;EzF2wmBV;EyFlxmBM;IAOI,8BAAA;EzF8wmBV;EyFrxmBM;IAOI,oBAAA;EzFixmBV;EyFxxmBM;IAOI,mBAAA;EzFoxmBV;EyF3xmBM;IAOI,mBAAA;EzFuxmBV;EyF9xmBM;IAOI,mBAAA;EzF0xmBV;EyFjymBM;IAOI,mBAAA;EzF6xmBV;EyFpymBM;IAOI,mBAAA;EzFgymBV;EyFvymBM;IAOI,mBAAA;EzFmymBV;EyF1ymBM;IAOI,mBAAA;EzFsymBV;EyF7ymBM;IAOI,oBAAA;EzFyymBV;EyFhzmBM;IAOI,0BAAA;EzF4ymBV;EyFnzmBM;IAOI,yBAAA;EzF+ymBV;EyFtzmBM;IAOI,uBAAA;EzFkzmBV;EyFzzmBM;IAOI,yBAAA;EzFqzmBV;EyF5zmBM;IAOI,uBAAA;EzFwzmBV;EyF/zmBM;IAOI,uBAAA;EzF2zmBV;EyFl0mBM;IAOI,0BAAA;IAAA,yBAAA;EzF+zmBV;EyFt0mBM;IAOI,gCAAA;IAAA,+BAAA;EzFm0mBV;EyF10mBM;IAOI,+BAAA;IAAA,8BAAA;EzFu0mBV;EyF90mBM;IAOI,6BAAA;IAAA,4BAAA;EzF20mBV;EyFl1mBM;IAOI,+BAAA;IAAA,8BAAA;EzF+0mBV;EyFt1mBM;IAOI,6BAAA;IAAA,4BAAA;EzFm1mBV;EyF11mBM;IAOI,6BAAA;IAAA,4BAAA;EzFu1mBV;EyF91mBM;IAOI,wBAAA;IAAA,2BAAA;EzF21mBV;EyFl2mBM;IAOI,8BAAA;IAAA,iCAAA;EzF+1mBV;EyFt2mBM;IAOI,6BAAA;IAAA,gCAAA;EzFm2mBV;EyF12mBM;IAOI,2BAAA;IAAA,8BAAA;EzFu2mBV;EyF92mBM;IAOI,6BAAA;IAAA,gCAAA;EzF22mBV;EyFl3mBM;IAOI,2BAAA;IAAA,8BAAA;EzF+2mBV;EyFt3mBM;IAOI,2BAAA;IAAA,8BAAA;EzFm3mBV;EyF13mBM;IAOI,wBAAA;EzFs3mBV;EyF73mBM;IAOI,8BAAA;EzFy3mBV;EyFh4mBM;IAOI,6BAAA;EzF43mBV;EyFn4mBM;IAOI,2BAAA;EzF+3mBV;EyFt4mBM;IAOI,6BAAA;EzFk4mBV;EyFz4mBM;IAOI,2BAAA;EzFq4mBV;EyF54mBM;IAOI,2BAAA;EzFw4mBV;EyF/4mBM;IAOI,0BAAA;EzF24mBV;EyFl5mBM;IAOI,gCAAA;EzF84mBV;EyFr5mBM;IAOI,+BAAA;EzFi5mBV;EyFx5mBM;IAOI,6BAAA;EzFo5mBV;EyF35mBM;IAOI,+BAAA;EzFu5mBV;EyF95mBM;IAOI,6BAAA;EzF05mBV;EyFj6mBM;IAOI,6BAAA;EzF65mBV;EyFp6mBM;IAOI,2BAAA;EzFg6mBV;EyFv6mBM;IAOI,iCAAA;EzFm6mBV;EyF16mBM;IAOI,gCAAA;EzFs6mBV;EyF76mBM;IAOI,8BAAA;EzFy6mBV;EyFh7mBM;IAOI,gCAAA;EzF46mBV;EyFn7mBM;IAOI,8BAAA;EzF+6mBV;EyFt7mBM;IAOI,8BAAA;EzFk7mBV;EyFz7mBM;IAOI,yBAAA;EzFq7mBV;EyF57mBM;IAOI,+BAAA;EzFw7mBV;EyF/7mBM;IAOI,8BAAA;EzF27mBV;EyFl8mBM;IAOI,4BAAA;EzF87mBV;EyFr8mBM;IAOI,8BAAA;EzFi8mBV;EyFx8mBM;IAOI,4BAAA;EzFo8mBV;EyF38mBM;IAOI,4BAAA;EzFu8mBV;EyF98mBM;IAOI,qBAAA;EzF08mBV;EyFj9mBM;IAOI,2BAAA;EzF68mBV;EyFp9mBM;IAOI,0BAAA;EzFg9mBV;EyFv9mBM;IAOI,wBAAA;EzFm9mBV;EyF19mBM;IAOI,0BAAA;EzFs9mBV;EyF79mBM;IAOI,wBAAA;EzFy9mBV;EyFh+mBM;IAOI,2BAAA;IAAA,0BAAA;EzF69mBV;EyFp+mBM;IAOI,iCAAA;IAAA,gCAAA;EzFi+mBV;EyFx+mBM;IAOI,gCAAA;IAAA,+BAAA;EzFq+mBV;EyF5+mBM;IAOI,8BAAA;IAAA,6BAAA;EzFy+mBV;EyFh/mBM;IAOI,gCAAA;IAAA,+BAAA;EzF6+mBV;EyFp/mBM;IAOI,8BAAA;IAAA,6BAAA;EzFi/mBV;EyFx/mBM;IAOI,yBAAA;IAAA,4BAAA;EzFq/mBV;EyF5/mBM;IAOI,+BAAA;IAAA,kCAAA;EzFy/mBV;EyFhgnBM;IAOI,8BAAA;IAAA,iCAAA;EzF6/mBV;EyFpgnBM;IAOI,4BAAA;IAAA,+BAAA;EzFignBV;EyFxgnBM;IAOI,8BAAA;IAAA,iCAAA;EzFqgnBV;EyF5gnBM;IAOI,4BAAA;IAAA,+BAAA;EzFygnBV;EyFhhnBM;IAOI,yBAAA;EzF4gnBV;EyFnhnBM;IAOI,+BAAA;EzF+gnBV;EyFthnBM;IAOI,8BAAA;EzFkhnBV;EyFzhnBM;IAOI,4BAAA;EzFqhnBV;EyF5hnBM;IAOI,8BAAA;EzFwhnBV;EyF/hnBM;IAOI,4BAAA;EzF2hnBV;EyFlinBM;IAOI,2BAAA;EzF8hnBV;EyFrinBM;IAOI,iCAAA;EzFiinBV;EyFxinBM;IAOI,gCAAA;EzFoinBV;EyF3inBM;IAOI,8BAAA;EzFuinBV;EyF9inBM;IAOI,gCAAA;EzF0inBV;EyFjjnBM;IAOI,8BAAA;EzF6inBV;EyFpjnBM;IAOI,4BAAA;EzFgjnBV;EyFvjnBM;IAOI,kCAAA;EzFmjnBV;EyF1jnBM;IAOI,iCAAA;EzFsjnBV;EyF7jnBM;IAOI,+BAAA;EzFyjnBV;EyFhknBM;IAOI,iCAAA;EzF4jnBV;EyFnknBM;IAOI,+BAAA;EzF+jnBV;EyFtknBM;IAOI,0BAAA;EzFkknBV;EyFzknBM;IAOI,gCAAA;EzFqknBV;EyF5knBM;IAOI,+BAAA;EzFwknBV;EyF/knBM;IAOI,6BAAA;EzF2knBV;EyFllnBM;IAOI,+BAAA;EzF8knBV;EyFrlnBM;IAOI,6BAAA;EzFilnBV;EyFxlnBM;IAOI,iBAAA;EzFolnBV;EyF3lnBM;IAOI,uBAAA;EzFulnBV;EyF9lnBM;IAOI,sBAAA;EzF0lnBV;EyFjmnBM;IAOI,oBAAA;EzF6lnBV;EyFpmnBM;IAOI,sBAAA;EzFgmnBV;EyFvmnBM;IAOI,oBAAA;EzFmmnBV;EyF1mnBM;IAOI,qBAAA;EzFsmnBV;EyF7mnBM;IAOI,2BAAA;EzFymnBV;EyFhnnBM;IAOI,0BAAA;EzF4mnBV;EyFnnnBM;IAOI,wBAAA;EzF+mnBV;EyFtnnBM;IAOI,0BAAA;EzFknnBV;EyFznnBM;IAOI,wBAAA;EzFqnnBV;EyF5nnBM;IAOI,wBAAA;EzFwnnBV;EyF/nnBM;IAOI,8BAAA;EzF2nnBV;EyFlonBM;IAOI,6BAAA;EzF8nnBV;EyFronBM;IAOI,2BAAA;EzFionBV;EyFxonBM;IAOI,6BAAA;EzFoonBV;EyF3onBM;IAOI,2BAAA;EzFuonBV;EyF9onBM;IAOI,2BAAA;EzF0onBV;EyFjpnBM;IAOI,4BAAA;EzF6onBV;EyFppnBM;IAOI,6BAAA;EzFgpnBV;AACF;A0FvsnBA;ED+CQ;IAOI,4BAAA;EzFqpnBV;EyF5pnBM;IAOI,0BAAA;EzFwpnBV;EyF/pnBM;IAOI,6BAAA;EzF2pnBV;EyFlqnBM;IAOI,4BAAA;EzF8pnBV;AACF;A0FlsnBA;ED4BQ;IAOI,0BAAA;EzFmqnBV;EyF1qnBM;IAOI,gCAAA;EzFsqnBV;EyF7qnBM;IAOI,yBAAA;EzFyqnBV;EyFhrnBM;IAOI,wBAAA;EzF4qnBV;EyFnrnBM;IAOI,+BAAA;EzF+qnBV;EyFtrnBM;IAOI,yBAAA;EzFkrnBV;EyFzrnBM;IAOI,6BAAA;EzFqrnBV;EyF5rnBM;IAOI,8BAAA;EzFwrnBV;EyF/rnBM;IAOI,wBAAA;EzF2rnBV;EyFlsnBM;IAOI,+BAAA;EzF8rnBV;EyFrsnBM;IAOI,wBAAA;EzFisnBV;AACF;AApwnBA;EACE,2C0EgBW;A1EsvnBb;;AAnwnBA;EACE,WAAA;EACA,uBAAA;AAswnBF;;AAnwnBA;EACE,uBAAA;AAswnBF;;AAnwnBA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;AAswnBF;;AAnwnBA;EACE,sBAAA;EACA,gCAAA;AAswnBF;AApwnBE;EACE,sBAAA;AAswnBJ;;AAlwnBA;EACE,WAAA;AAqwnBF;;AAlwnBA;EACE,yBAAA;AAqwnBF;;AAlwnBA;;EAEE,aAAA;EACA,kBAAA;EAEA,8BAAA;AAownBF;;AAjwnBA;EACE,aAAA;AAownBF;;AAjwnBA;EACE,WAAA;AAownBF;;AAjwnBA;EACE,aAAA;EACA,gBAAA;AAownBF;;AAjwnBA;EACE,WAAA;AAownBF;;AAjwnBA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAownBF;;AAjwnBA;EACE,6DAAA;EACA,uCAAA;EACA,iCAAA;EACA,yBAAA;AAownBF;AAlwnBE;EACE,YAAA;EACA,YAAA;AAownBJ;AAjwnBE;EACE,WAAA;EACA,eAAA;EACA,8C0E9Da;E1E+Db,iBAAA;EACA,kBAAA;AAmwnBJ;AAhwnBE;EACE,gBAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,2C0E1ES;E1E2ET,iBAAA;EACA,kBAAA;AAkwnBJ;AAhwnBI;EACE,cAAA;AAkwnBN;AA9vnBE;EACE,UAAA;AAgwnBJ;AA7vnBE;EACE,WAAA;EACA,eAAA;EACA,2C0E1FS;E1E2FT,iBAAA;AA+vnBJ;;AA3vnBA;EAEI;IACE,YAAA;IACA,YAAA;EA6vnBJ;EA1vnBE;IACE,eAAA;EA4vnBJ;EAzvnBE;IACE,eAAA;EA2vnBJ;EAxvnBE;IACE,UAAA;EA0vnBJ;AACF;AAtvnBA;EAEI;IACE,UAAA;EAuvnBJ;AACF;AAnvnBA;EACE;IACE,6GACE;IAEF,uCAAA;IACA,iCAAA;IACA,+BAAA;EAmvnBF;AACF;AAhvnBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAkvnBF;;AA/unBA;EACE,2BAAA;EACA,mBAAA;EACA,cAAA;AAkvnBF;A8Bh1nBI;E9B2FJ;IAMI,0BAAA;EAmvnBF;AACF;;AAhvnBA;EACE,0BAAA;EACA,2CAAA;AAmvnBF;;AAhvnBA;EACE,iBAAA;EACA,2CAAA;AAmvnBF;;AAhvnBA;EACE,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;AAmvnBF;;AAhvnBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;AAmvnBF;AAjvnBE;EACE,iCAAA;AAmvnBJ;;AA/unBA;EACE,4BAAA;AAkvnBF;;AA/unBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;AAkvnBF;AAhvnBE;EACE,iCAAA;AAkvnBJ;;AA9unBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAivnBF;;AA9unBA;EACE,sBAAA;EACA,YAAA;EACA,4BAAA;AAivnBF;;AA9unBA;EACE,sBAAA;EACA,YAAA;EACA,4BAAA;AAivnBF;;AA9unBA;EACE,4BAAA;AAivnBF;;AA9unBA;EACE;IACE,0BAAA;IACA,6BAAA;EAivnBF;AACF;A8B55nBI;E9B+KF;IACE,4BAAA;IACA,2BAAA;EAgvnBF;AACF;AA7unBA;EACE,iBAAA;AA+unBF;;AA5unBA;EACE,2BAAA;AA+unBF;;AA5unBA;EACE,eAAA;AA+unBF;;AA5unBA;EACE,8BAAA;EACA,4BAAA;EACA,8BAAA;AA+unBF;;AA3unBE;EACE,iBAAA;EACA,mBAAA;AA8unBJ;AA3unBE;EACE,uBAAA;EACA,mBAAA;AA6unBJ;;A8B57nBI;E9BoNF;IACE,gBAAA;EA4unBF;AACF;AAzunBA;EACE,iBAAA;AA2unBF;A8Br8nBI;E9ByNJ;IAII,iBAAA;EA4unBF;AACF;;AAzunBA;EACE,aAAA;EACA,yBAAA;AA4unBF;;AAzunBA;;EAEE,aAAA;AA4unBF;;AAzunBA;EACE,2BAAA;AA4unBF;A8Bx9nBI;E9B2OJ;IAII,YAAA;IACA,0CAAA;EA6unBF;AACF;;AA1unBA;EACE,0BAAA;AA6unBF;;AA1unBA;EACE,0BAAA;AA6unBF;;AA1unBA;EACE,6BAAA;AA6unBF;;AA1unBA;EACE,0BAAA;AA6unBF;;AA1unBA;EACE,0BAAA;AA6unBF;;AA1unBA;EACE,0BAAA;AA6unBF;;AA1unBA;EACE,0BAAA;AA6unBF;;AA1unBA;EACE,UAAA;AA6unBF;;AA1unBA;EACE,2BAAA;EACA,2BAAA;AA6unBF;AA3unBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA6unBJ;;AAzunBA;EACE,yCAAA;AA4unBF;;AAzunBA;EACE,+BAAA;EACA,gBAAA;EACA,cAAA;AA4unBF;;AAzunBA;EACE,mBAAA;AA4unBF;;AAzunBA;EACE,YAAA;AA4unBF;AA1unBE;EACE,sBAAA;AA4unBJ;AA1unBI;EACE,qBAAA;EACA,sBAAA;EACA,yCAAA;EACA,8BAAA;AA4unBN;AAxunBE;EACE,sBAAA;AA0unBJ;AAxunBI;EACE,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;AA0unBN;AAtunBE;EACE,YAAA;AAwunBJ;AArunBE;EACE,wBAAA;AAuunBJ;;AAnunBA;EACE,WAAA;AAsunBF;;AAnunBA;EACE,4BAAA;AAsunBF;;AAnunBA;EACE,oCAAA;AAsunBF;;AAnunBA;EACE,0BAAA;AAsunBF;;AAnunBA;EACI,wBAAA;EACA,2BAAA;AAsunBJ","sourcesContent":["@import './fonts';\n@import './variables';\n@import '~@fortawesome/fontawesome-free/scss/fontawesome';\n@import '~@fortawesome/fontawesome-free/scss/regular';\n@import '~@fortawesome/fontawesome-free/scss/solid';\n@import '~bootstrap/scss/bootstrap';\n\n* {\n  font-family: $pl-regular;\n}\n\niframe ::-webkit-scrollbar {\n  width: 16px;\n  background: transparent;\n}\n\niframe::-webkit-scrollbar-track {\n  background: transparent;\n}\n\niframe::-webkit-scrollbar-thumb {\n  background-color: #787878;\n  border: 3px solid #f7f7f7;\n  border-radius: 10px;\n}\n\na {\n  color: #000 !important;\n  text-decoration: none !important;\n\n  .anticon {\n    vertical-align: middle;\n  }\n}\n\n.text-white {\n  color: #fff;\n}\n\n.text-pink {\n  color: #e2407e !important;\n}\n\nbody,\nhtml {\n  height: 100vh;\n  overflow-x: hidden;\n  // overflow-y: hidden;\n  background: $body-bg !important;\n}\n\n.full-height {\n  height: 100vh;\n}\n\n.nav-logo {\n  float: left;\n}\n\n.nav-bar {\n  height: 130px;\n  padding: 0 140px;\n}\n\n.ant-col {\n  width: 100%;\n}\n\n.about-scrollable {\n  height: 400px;\n  padding-top: 24px;\n  overflow-y: auto;\n}\n\n.login-bg {\n  background: $login-bg, #37033c;\n  background-repeat: no-repeat, no-repeat;\n  background-position: right center;\n  background-size: auto 75%;\n\n  .logo {\n    width: 200px;\n    height: auto;\n  }\n\n  h1 {\n    color: #fff;\n    font-size: 34px;\n    font-family: $pl-bold-italic;\n    line-height: 46px;\n    text-align: center;\n  }\n\n  p {\n    max-width: 480px;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 16px;\n    font-family: $pl-regular;\n    line-height: 22px;\n    text-align: center;\n\n    a {\n      color: #e2407e;\n    }\n  }\n\n  .login_button_container {\n    width: 56%;\n  }\n\n  small {\n    color: #fff;\n    font-size: 12px;\n    font-family: $pl-regular;\n    line-height: 22px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .login-bg {\n    .logo {\n      width: 150px;\n      height: auto;\n    }\n\n    h1 {\n      font-size: 28px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n\n    .login_button_container {\n      width: 89%;\n    }\n  }\n}\n\n@media only screen and (min-width: 577px) and (max-width: 768px) {\n  .login-bg {\n    .login_button_container {\n      width: 64%;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .login-bg {\n    background:\n      url(../asset/img/login-bg.png),\n      linear-gradient(140deg, #37033c 0%, #e2407e 100%) 0% 0%;\n    background-repeat: no-repeat, no-repeat;\n    background-position: bottom right;\n    background-size: cover, contain;\n  }\n}\n\n.card_shadow {\n  width: 100%;\n  margin-bottom: 32px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 12px;\n}\n\n.card_shadow_posts {\n  height: calc(100vh - 390px);\n  margin-bottom: 16px;\n  overflow: auto;\n\n  @include media-breakpoint-down(lg) {\n    height: calc(50vh - 140px);\n  }\n}\n\nh4 {\n  font-size: 12px !important;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n\n.bold {\n  font-weight: bold;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n\n.avatar-insight {\n  float: right;\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n}\n\n.avatar {\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n  cursor: pointer;\n  transition: 0.3s ease-in-out;\n\n  .anticon {\n    vertical-align: middle !important;\n  }\n}\n\n.anticon {\n  vertical-align: 0 !important;\n}\n\n.avatar-initials {\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n  transition: 0.3s ease-in-out;\n\n  .anticon {\n    vertical-align: middle !important;\n  }\n}\n\n.ant-menu .anticon {\n  width: 14px;\n  height: 14px;\n  vertical-align: middle;\n}\n\n.avatar:hover {\n  transform: scale(1.02);\n  opacity: 0.8;\n  transition: 0.3s ease-in-out;\n}\n\n.avatar-insight:hover {\n  transform: scale(1.02);\n  opacity: 0.8;\n  transition: 0.3s ease-in-out;\n}\n\n.first-avatar {\n  margin-right: 5px !important;\n}\n\n@media only screen and (max-width: 1305px) {\n  .first-avatar {\n    margin-right: 0 !important;\n    margin-bottom: 5px !important;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .first-avatar {\n    margin-right: 5px !important;\n    margin-bottom: 0 !important;\n  }\n}\n\n.text-right {\n  text-align: right;\n}\n\np:last-child {\n  margin-bottom: 0 !important;\n}\n\n.font-fourteen {\n  font-size: 12px;\n}\n\n.flex-flow {\n  flex-direction: row !important;\n  flex-flow: nowrap !important;\n  justify-content: space-between;\n}\n\n.ant-row {\n  *::-webkit-scrollbar-track {\n    background: white;\n    border-radius: 10px;\n  }\n\n  *::-webkit-scrollbar-thumb {\n    border: 3px solid white;\n    border-radius: 10px;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .article_meta {\n    margin-top: 32px;\n  }\n}\n\n.site_padding {\n  padding-top: 26px;\n\n  @include media-breakpoint-down(lg) {\n    padding-top: 10px;\n  }\n}\n\n.ant-tabs-tabpane {\n  padding: 20px;\n  background-color: #f7f7f7;\n}\n\n.ant-tabs > .ant-tabs-nav,\n.ant-tabs > div > .ant-tabs-nav {\n  padding: 20px;\n}\n\n.ant-table-body {\n  height: calc(100vh - 452px);\n\n  @include media-breakpoint-down(md) {\n    height: auto;\n    max-height: calc(100vh - 415px) !important;\n  }\n}\n\n.ant-table {\n  font-size: 12px !important;\n}\n\n.ant-menu {\n  font-size: 12px !important;\n}\n\n.ant-table-cell {\n  padding: 13px 16px !important;\n}\n\n.font-12 {\n  font-size: 12px !important;\n}\n\n.ant-form {\n  font-size: 12px !important;\n}\n\n.ant-form label {\n  font-size: 12px !important;\n}\n\n.ant-select-lg {\n  font-size: 12px !important;\n}\n\n.ant-table .ant-table-thead .ant-table-column-sorters {\n  padding: 0;\n}\n\n.ant-table-pagination.ant-pagination {\n  margin-top: 16px !important;\n  margin-bottom: 0 !important;\n\n  .ant-pagination-item-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {\n  margin: -13px -16px -16px 34px !important;\n}\n\n.max-height {\n  max-height: calc(100vh - 530px);\n  margin-bottom: 0;\n  overflow: auto;\n}\n\n.about-tables {\n  padding-right: 24px;\n}\n\n.ant-carousel {\n  height: 100%;\n\n  .slick-dots li {\n    width: 10px !important;\n\n    button {\n      width: 7px !important;\n      height: 7px !important;\n      background: rgba(0, 0, 0, 0.8) !important;\n      border-radius: 100% !important;\n    }\n  }\n\n  .slick-dots li.slick-active {\n    width: 10px !important;\n\n    button {\n      width: 7px !important;\n      height: 7px !important;\n      background: #000 !important;\n      border-radius: 100% !important;\n    }\n  }\n\n  .slick-slider {\n    height: 100%;\n  }\n\n  .slick-dots-bottom {\n    bottom: -38px !important;\n  }\n}\n\n.mce-preview-object {\n  width: 100%;\n}\n\nh2 {\n  font-size: 1.5rem !important;\n}\n\n.bg-purple {\n  background-color: #490c4e !important;\n}\n\n.plcp-bg-height {\n  height: calc(100vh - 60px);\n}\n\n.campaign-modal {\n    width: 1000px !important;\n    max-width: 800px !important;\n}\n","@font-face {\n  font-family: 'PremierLeague-Regular';\n  src: url('../asset/font/PremierLeagueW01-Regular.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Regular.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Regular.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Regular.woff') format('woff'), url('../asset/font/PremierLeagueW01-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Light';\n  src: url('../asset/font/PremierLeagueW01-Light.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Light.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Light.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Light.woff') format('woff'), url('../asset/font/PremierLeagueW01-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Bold';\n  src: url('../asset/font/PremierLeagueW01-Bold.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Bold.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Bold.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Bold.woff') format('woff'), url('../asset/font/PremierLeagueW01-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Condensed';\n  src: url('../asset/font/PremierLeagueW01-Condensed.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Condensed.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Condensed.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Condensed.woff') format('woff'), url('../asset/font/PremierLeagueW01-Condensed.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-CondBold';\n  src: url('../asset/font/PremierLeagueW01-CondBold.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-CondBold.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-CondBold.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-CondBold.woff') format('woff'), url('../asset/font/PremierLeagueW01-CondBold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Italic';\n  src: url('../asset/font/PremierLeagueW01-Italic.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Italic.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Italic.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Italic.woff') format('woff'), url('../asset/font/PremierLeagueW01-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-LightIt';\n  src: url('../asset/font/PremierLeagueW01-LightIt.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-LightIt.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-LightIt.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-LightIt.woff') format('woff'), url('../asset/font/PremierLeagueW01-LightIt.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-BoldItalic';\n  src: url('../asset/font/PremierLeagueW01-BoldItalic.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-BoldItalic.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-BoldItalic.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-BoldItalic.woff') format('woff'), url('../asset/font/PremierLeagueW01-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Heavy';\n  src: url('../asset/font/PremierLeagueW01-Heavy.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Heavy.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Heavy.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Heavy.woff') format('woff'), url('../asset/font/PremierLeagueW01-Heavy.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-HeavyIt';\n  src: url('../asset/font/PremierLeagueW01-HeavyIt.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-HeavyIt.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-HeavyIt.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-HeavyIt.woff') format('woff'), url('../asset/font/PremierLeagueW01-HeavyIt.ttf') format('truetype');\n}\n","/*!\n * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.fas,\n.far,\n.fab,\n.#{$fa-css-prefix}-solid,\n.#{$fa-css-prefix}-regular,\n.#{$fa-css-prefix}-brands,\n.#{$fa-css-prefix} {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n.fas::before,\n.far::before,\n.fab::before,\n.#{$fa-css-prefix}-solid::before,\n.#{$fa-css-prefix}-regular::before,\n.#{$fa-css-prefix}-brands::before,\n.#{$fa-css-prefix}::before {\n  content: var(#{$fa-icon-property});\n}\n\n.#{$fa-css-prefix}-classic,\n.fas,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular {\n  font-family: 'Font Awesome 6 Free';\n}\n.#{$fa-css-prefix}-brands,\n.fab {\n  font-family: 'Font Awesome 6 Brands';\n}\n\n%fa-icon {\n  @include fa-icon;\n}\n","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: fa-divide($font-size, $fa-size-scale-base) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: fa-divide(1, $font-size) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: (fa-divide(6, $font-size) - fa-divide(3, 8)) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n\n// sets a specific icon family to use alongside style + icon mixins\n@mixin fa-family-classic() {\n  @extend .fa-classic;\n}\n\n// convenience mixins for declaring pseudo-elements by CSS variable,\n// including all style-specific font properties\n@mixin fa-icon-solid($fa-var) {\n  @extend .fa-solid;\n\n  & { #{$fa-icon-property}: unquote(\"\\\"#{ $fa-var }\\\"\"); #{$fa-duotone-icon-property}: unquote(\"\\\"#{ $fa-var }#{ $fa-var }\\\"\"); }\n}\n@mixin fa-icon-regular($fa-var) {\n  @extend .fa-regular;\n\n  & { #{$fa-icon-property}: unquote(\"\\\"#{ $fa-var }\\\"\"); #{$fa-duotone-icon-property}: unquote(\"\\\"#{ $fa-var }#{ $fa-var }\\\"\"); }\n}\n@mixin fa-icon-brands($fa-var) {\n  @extend .fa-brands;\n\n  & { #{$fa-icon-property}: unquote(\"\\\"#{ $fa-var }\\\"\"); #{$fa-duotone-icon-property}: unquote(\"\\\"#{ $fa-var }#{ $fa-var }\\\"\"); }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix            : fa !default;\n$fa-style                 : 900 !default;\n$fa-style-family          : \"Font Awesome 6 Free\" !default;\n\n$fa-icon-property         : --fa;\n$fa-duotone-icon-property : --fa--fa;\n\n$fa-display               : inline-block !default;\n\n$fa-fw-width              : fa-divide(20em, 16) !default;\n$fa-inverse               : #fff !default;\n\n$fa-border-color          : #eee !default;\n$fa-border-padding        : .2em .25em .15em !default;\n$fa-border-radius         : .1em !default;\n$fa-border-style          : solid !default;\n$fa-border-width          : .08em !default;\n\n$fa-size-scale-2xs        : 10 !default;\n$fa-size-scale-xs         : 12 !default;\n$fa-size-scale-sm         : 14 !default;\n$fa-size-scale-base       : 16 !default;\n$fa-size-scale-lg         : 20 !default;\n$fa-size-scale-xl         : 24 !default;\n$fa-size-scale-2xl        : 32 !default;\n\n$fa-sizes: (\n  \"2xs\"                   : $fa-size-scale-2xs,\n  \"xs\"                    : $fa-size-scale-xs,\n  \"sm\"                    : $fa-size-scale-sm,\n  \"lg\"                    : $fa-size-scale-lg,\n  \"xl\"                    : $fa-size-scale-xl,\n  \"2xl\"                   : $fa-size-scale-2xl\n) !default;\n\n$fa-li-width              : 2em !default;\n$fa-li-margin             : $fa-li-width * fa-divide(5, 4) !default;\n\n$fa-pull-margin           : .3em !default;\n\n$fa-primary-opacity       : 1 !default;\n$fa-secondary-opacity     : .4 !default;\n\n$fa-stack-vertical-align  : middle !default;\n$fa-stack-width           : ($fa-fw-width * 2) !default;\n$fa-stack-z-index         : auto !default;\n\n$fa-font-display          : block !default;\n$fa-font-path             : \"../webfonts\" !default;\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-fill-drip: \\f576;\n$fa-var-arrows-to-circle: \\e4bd;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-at: \\40;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-text-height: \\f034;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-info: \\f129;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-explosion: \\e4e9;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-wave-square: \\f83e;\n$fa-var-ring: \\f70b;\n$fa-var-building-un: \\e4d9;\n$fa-var-dice-three: \\f527;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-anchor-circle-check: \\e4aa;\n$fa-var-building-circle-arrow-right: \\e4d1;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-arrows-up-to-line: \\e4c2;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-door-open: \\f52b;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-atom: \\f5d2;\n$fa-var-soap: \\e06e;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-bridge-circle-check: \\e4c9;\n$fa-var-pump-medical: \\e06a;\n$fa-var-fingerprint: \\f577;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-school-circle-exclamation: \\e56c;\n$fa-var-crop: \\f125;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-users-rectangle: \\e594;\n$fa-var-people-roof: \\e537;\n$fa-var-people-line: \\e534;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-diagram-predecessor: \\e477;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-laptop: \\f109;\n$fa-var-file-csv: \\f6dd;\n$fa-var-menorah: \\f676;\n$fa-var-truck-plane: \\e58f;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-bong: \\f55c;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-arrow-down-up-across-line: \\e4af;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-jar-wheat: \\e517;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-file-circle-exclamation: \\e4eb;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-pager: \\f815;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-k: \\4b;\n$fa-var-landmark-flag: \\e51c;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-backward: \\f04a;\n$fa-var-caret-right: \\f0da;\n$fa-var-comments: \\f086;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-user-check: \\f4fc;\n$fa-var-vial-virus: \\e597;\n$fa-var-sheet-plastic: \\e571;\n$fa-var-blog: \\f781;\n$fa-var-user-ninja: \\f504;\n$fa-var-person-arrow-up-from-line: \\e539;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-toggle-off: \\f204;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-person-drowning: \\e545;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-spray-can: \\f5bd;\n$fa-var-truck-monster: \\f63b;\n$fa-var-w: \\57;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-rainbow: \\f75b;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-paw: \\f1b0;\n$fa-var-cloud: \\f0c2;\n$fa-var-trowel-bricks: \\e58a;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-hospital-user: \\f80d;\n$fa-var-tent-arrow-left-right: \\e57f;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-binoculars: \\f1e5;\n$fa-var-microphone-slash: \\f131;\n$fa-var-box-tissue: \\e05b;\n$fa-var-motorcycle: \\f21c;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-mars-and-venus-burst: \\e523;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-sun-plant-wilt: \\e57a;\n$fa-var-toilets-portable: \\e584;\n$fa-var-hockey-puck: \\f453;\n$fa-var-table: \\f0ce;\n$fa-var-magnifying-glass-arrow-right: \\e521;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-users-slash: \\e073;\n$fa-var-clover: \\e139;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-house-fire: \\e50c;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-helicopter: \\f533;\n$fa-var-compass: \\f14e;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-file-circle-question: \\e4ef;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-people-group: \\e533;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-film: \\f008;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-people-robbery: \\e536;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-caret-left: \\f0d9;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-school-circle-xmark: \\e56d;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-sitemap: \\f0e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-memory: \\f538;\n$fa-var-road-spikes: \\e568;\n$fa-var-fire-burner: \\e4f1;\n$fa-var-flag: \\f024;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-feather: \\f52d;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-compress: \\f066;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-ankh: \\f644;\n$fa-var-hands-holding-child: \\e4fa;\n$fa-var-asterisk: \\2a;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-peseta-sign: \\e221;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-ghost: \\f6e2;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-cart-plus: \\f217;\n$fa-var-gamepad: \\f11b;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-egg: \\f7fb;\n$fa-var-house-medical-circle-xmark: \\e513;\n$fa-var-campground: \\f6bb;\n$fa-var-folder-plus: \\f65e;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-paintbrush: \\f1fc;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-lock: \\f023;\n$fa-var-gas-pump: \\f52f;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-house-flood-water: \\e50e;\n$fa-var-tree: \\f1bb;\n$fa-var-bridge-lock: \\e4cc;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-car-side: \\f5e4;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-heart-circle-minus: \\e4ff;\n$fa-var-hourglass-half: \\f252;\n$fa-var-hourglass-2: \\f252;\n$fa-var-microscope: \\f610;\n$fa-var-sink: \\e06d;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-mitten: \\f7b5;\n$fa-var-person-rays: \\e54d;\n$fa-var-users: \\f0c0;\n$fa-var-eye-slash: \\f070;\n$fa-var-flask-vial: \\e4f3;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-om: \\f679;\n$fa-var-worm: \\e599;\n$fa-var-house-circle-xmark: \\e50b;\n$fa-var-plug: \\f1e6;\n$fa-var-chevron-up: \\f077;\n$fa-var-hand-spock: \\f259;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-bridge-circle-xmark: \\e4cb;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-road-circle-check: \\e564;\n$fa-var-dice-five: \\f523;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-land-mine-on: \\e51b;\n$fa-var-i-cursor: \\f246;\n$fa-var-stamp: \\f5bf;\n$fa-var-stairs: \\e289;\n$fa-var-i: \\49;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-pills: \\f484;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-tooth: \\f5c9;\n$fa-var-v: \\56;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-bicycle: \\f206;\n$fa-var-staff-snake: \\e579;\n$fa-var-rod-asclepius: \\e579;\n$fa-var-rod-snake: \\e579;\n$fa-var-staff-aesculapius: \\e579;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-wheat-awn-circle-exclamation: \\e598;\n$fa-var-snowman: \\f7d0;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-road-barrier: \\e562;\n$fa-var-school: \\f549;\n$fa-var-igloo: \\f7ae;\n$fa-var-joint: \\f595;\n$fa-var-angle-right: \\f105;\n$fa-var-horse: \\f6f0;\n$fa-var-q: \\51;\n$fa-var-g: \\47;\n$fa-var-notes-medical: \\f481;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-dong-sign: \\e169;\n$fa-var-capsules: \\f46b;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-money-bill: \\f0d6;\n$fa-var-bookmark: \\f02e;\n$fa-var-align-justify: \\f039;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-helmet-un: \\e503;\n$fa-var-bullseye: \\f140;\n$fa-var-bacon: \\f7e5;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-folder: \\f07b;\n$fa-var-folder-blank: \\f07b;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-radiation: \\f7b9;\n$fa-var-chart-simple: \\e473;\n$fa-var-mars-stroke: \\f229;\n$fa-var-vial: \\f492;\n$fa-var-gauge: \\f624;\n$fa-var-dashboard: \\f624;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-e: \\45;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-bridge-circle-exclamation: \\e4ca;\n$fa-var-user: \\f007;\n$fa-var-school-circle-check: \\e56b;\n$fa-var-dumpster: \\f793;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-building-user: \\e4da;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-highlighter: \\f591;\n$fa-var-key: \\f084;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-globe: \\f0ac;\n$fa-var-synagogue: \\f69b;\n$fa-var-person-half-dress: \\e548;\n$fa-var-road-bridge: \\e563;\n$fa-var-location-arrow: \\f124;\n$fa-var-c: \\43;\n$fa-var-tablet-button: \\f10a;\n$fa-var-building-lock: \\e4d6;\n$fa-var-pizza-slice: \\f818;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-house-flag: \\e50d;\n$fa-var-person-circle-minus: \\e540;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-star: \\f005;\n$fa-var-repeat: \\f363;\n$fa-var-cross: \\f654;\n$fa-var-box: \\f466;\n$fa-var-venus-mars: \\f228;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-charging-station: \\f5e7;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-mobile-retro: \\e527;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-spider: \\f717;\n$fa-var-hands-bound: \\e4f9;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-plane-circle-exclamation: \\e556;\n$fa-var-x-ray: \\f497;\n$fa-var-spell-check: \\f891;\n$fa-var-slash: \\f715;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-server: \\f233;\n$fa-var-virus-covid-slash: \\e4a9;\n$fa-var-shop-lock: \\e4a5;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-building-wheat: \\e4db;\n$fa-var-person-breastfeeding: \\e53a;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-venus: \\f221;\n$fa-var-passport: \\f5ab;\n$fa-var-thumbtack-slash: \\e68f;\n$fa-var-thumb-tack-slash: \\e68f;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-temperature-high: \\f769;\n$fa-var-microchip: \\f2db;\n$fa-var-crown: \\f521;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-xmarks-lines: \\e59a;\n$fa-var-file-prescription: \\f572;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-chess-knight: \\f441;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-wheelchair: \\f193;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-toggle-on: \\f205;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-l: \\4c;\n$fa-var-fire: \\f06d;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-folder-open: \\f07c;\n$fa-var-heart-circle-plus: \\e500;\n$fa-var-code-fork: \\e13b;\n$fa-var-city: \\f64f;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-pepper-hot: \\f816;\n$fa-var-unlock: \\f09c;\n$fa-var-colon-sign: \\e140;\n$fa-var-headset: \\f590;\n$fa-var-store-slash: \\e071;\n$fa-var-road-circle-xmark: \\e566;\n$fa-var-user-minus: \\f503;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-clipboard: \\f328;\n$fa-var-house-circle-exclamation: \\e50a;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-underline: \\f0cd;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-signature: \\f5b7;\n$fa-var-stroopwafel: \\f551;\n$fa-var-bold: \\f032;\n$fa-var-anchor-lock: \\e4ad;\n$fa-var-building-ngo: \\e4d7;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-not-equal: \\f53e;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-jedi: \\f669;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-gift: \\f06b;\n$fa-var-dice-two: \\f528;\n$fa-var-chess-queen: \\f445;\n$fa-var-glasses: \\f530;\n$fa-var-chess-board: \\f43c;\n$fa-var-building-circle-check: \\e4d2;\n$fa-var-person-chalkboard: \\e53d;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-cloud-showers-water: \\e4e4;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-less-than-equal: \\f537;\n$fa-var-train: \\f238;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-crow: \\f520;\n$fa-var-sailboat: \\e445;\n$fa-var-window-restore: \\f2d2;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-frog: \\f52e;\n$fa-var-bucket: \\e4cf;\n$fa-var-image: \\f03e;\n$fa-var-microphone: \\f130;\n$fa-var-cow: \\f6c8;\n$fa-var-caret-up: \\f0d8;\n$fa-var-screwdriver: \\f54a;\n$fa-var-folder-closed: \\e185;\n$fa-var-house-tsunami: \\e515;\n$fa-var-square-nfi: \\e576;\n$fa-var-arrow-up-from-ground-water: \\e4b5;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-square-binary: \\e69b;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-lemon: \\f094;\n$fa-var-head-side-mask: \\e063;\n$fa-var-handshake: \\f2b5;\n$fa-var-gem: \\f3a5;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-smoking: \\f48d;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-monument: \\f5a6;\n$fa-var-snowplow: \\f7d2;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-cannabis: \\f55f;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-tablets: \\f490;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-chair: \\f6c0;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-plate-wheat: \\e55a;\n$fa-var-icicles: \\f7ad;\n$fa-var-person-shelter: \\e54f;\n$fa-var-neuter: \\f22c;\n$fa-var-id-badge: \\f2c1;\n$fa-var-marker: \\f5a1;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-helicopter-symbol: \\e502;\n$fa-var-universal-access: \\f29a;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-volcano: \\f770;\n$fa-var-person-walking-dashed-line-arrow-right: \\e553;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-viruses: \\e076;\n$fa-var-square-person-confined: \\e577;\n$fa-var-user-tie: \\f508;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-tent-arrow-down-to-line: \\e57e;\n$fa-var-certificate: \\f0a3;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-suitcase: \\f0f2;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-camera-retro: \\f083;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-box-open: \\f49e;\n$fa-var-scroll: \\f70e;\n$fa-var-spa: \\f5bb;\n$fa-var-location-pin-lock: \\e51f;\n$fa-var-pause: \\f04c;\n$fa-var-hill-avalanche: \\e507;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-bomb: \\f1e2;\n$fa-var-registered: \\f25d;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-subscript: \\f12c;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-burst: \\e4dc;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-money-bills: \\e1f3;\n$fa-var-smog: \\f75f;\n$fa-var-crutch: \\f7f7;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-palette: \\f53f;\n$fa-var-arrows-turn-right: \\e4c0;\n$fa-var-vest: \\e085;\n$fa-var-ferry: \\e4ea;\n$fa-var-arrows-down-to-people: \\e4b9;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-boxes-packing: \\e4c7;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-group-arrows-rotate: \\e4f6;\n$fa-var-bowl-food: \\e4c6;\n$fa-var-candy-cane: \\f786;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-house-lock: \\e510;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-children: \\e4e1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-mattress-pillow: \\e525;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-shield-halved: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-virus: \\e074;\n$fa-var-envelope-circle-check: \\e4e8;\n$fa-var-layer-group: \\f5fd;\n$fa-var-arrows-to-dot: \\e4be;\n$fa-var-archway: \\f557;\n$fa-var-heart-circle-check: \\e4fd;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-square: \\f0c8;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-couch: \\f4b8;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-italic: \\f033;\n$fa-var-table-cells-column-lock: \\e678;\n$fa-var-church: \\f51d;\n$fa-var-comments-dollar: \\f653;\n$fa-var-democrat: \\f747;\n$fa-var-z: \\5a;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-road-lock: \\e567;\n$fa-var-a: \\41;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-p: \\50;\n$fa-var-snowflake: \\f2dc;\n$fa-var-newspaper: \\f1ea;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-locust: \\e520;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-person-dress-burst: \\e544;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-vector-square: \\f5cb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-language: \\f1ab;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-filter: \\f0b0;\n$fa-var-question: \\3f;\n$fa-var-file-signature: \\f573;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-money-check: \\f53c;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-code: \\f121;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-building-circle-exclamation: \\e4d3;\n$fa-var-magnifying-glass-chart: \\e522;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-cubes-stacked: \\e4e6;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-virus-covid: \\e4a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-f: \\46;\n$fa-var-leaf: \\f06c;\n$fa-var-road: \\f018;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-person-circle-plus: \\e541;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-sack-xmark: \\e56a;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-contract: \\f56c;\n$fa-var-fish-fins: \\e4f2;\n$fa-var-building-flag: \\e4d5;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-object-ungroup: \\f248;\n$fa-var-poop: \\f619;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-kaaba: \\f66b;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-eject: \\f052;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-plane-circle-check: \\e555;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-object-group: \\f247;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-mask-ventilator: \\e524;\n$fa-var-arrow-right: \\f061;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-cash-register: \\f788;\n$fa-var-person-circle-question: \\e542;\n$fa-var-h: \\48;\n$fa-var-tarp: \\e57b;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-arrows-to-eye: \\e4bf;\n$fa-var-plug-circle-bolt: \\e55b;\n$fa-var-heart: \\f004;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-house-crack: \\e3b1;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-bottle-water: \\e4c5;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-kitchen-set: \\e51a;\n$fa-var-r: \\52;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-cube: \\f1b2;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-shield-dog: \\e573;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-lock-open: \\f3c1;\n$fa-var-elevator: \\e16d;\n$fa-var-money-bill-transfer: \\e528;\n$fa-var-money-bill-trend-up: \\e529;\n$fa-var-house-flood-water-circle-arrow-right: \\e50f;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-circle: \\f111;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-recycle: \\f1b8;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-plane-slash: \\e069;\n$fa-var-trademark: \\f25c;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-users-rays: \\e593;\n$fa-var-wallet: \\f555;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-file-audio: \\f1c7;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-wrench: \\f0ad;\n$fa-var-bugs: \\e4d0;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-file-image: \\f1c5;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-handshake-slash: \\e060;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-code-branch: \\f126;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-bridge: \\e4c8;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-truck-front: \\e2b7;\n$fa-var-cat: \\f6be;\n$fa-var-anchor-circle-exclamation: \\e4ab;\n$fa-var-truck-field: \\e58d;\n$fa-var-route: \\f4d7;\n$fa-var-clipboard-question: \\e4e3;\n$fa-var-panorama: \\e209;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-teeth-open: \\f62f;\n$fa-var-file-circle-minus: \\e4ed;\n$fa-var-tags: \\f02c;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-house-signal: \\e012;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-faucet-drip: \\e006;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-terminal: \\f120;\n$fa-var-mobile-button: \\f10b;\n$fa-var-house-medical-flag: \\e514;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-tape: \\f4db;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-eye: \\f06e;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-audio-description: \\f29e;\n$fa-var-person-military-to-person: \\e54c;\n$fa-var-file-shield: \\e4f0;\n$fa-var-user-slash: \\f506;\n$fa-var-pen: \\f304;\n$fa-var-tower-observation: \\e586;\n$fa-var-file-code: \\f1c9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-bus: \\f207;\n$fa-var-heart-circle-xmark: \\e501;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-prescription: \\f5b1;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-vihara: \\f6a7;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-plant-wilt: \\e5aa;\n$fa-var-diamond: \\f219;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-chart-diagram: \\e695;\n$fa-var-bacterium: \\e05a;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-biohazard: \\f780;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-mars-double: \\f227;\n$fa-var-child-dress: \\e59c;\n$fa-var-users-between-lines: \\e591;\n$fa-var-lungs-virus: \\e067;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-phone: \\f095;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-child-reaching: \\e59d;\n$fa-var-head-side-virus: \\e064;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-door-closed: \\f52a;\n$fa-var-shield-virus: \\e06c;\n$fa-var-dice-six: \\f526;\n$fa-var-mosquito-net: \\e52c;\n$fa-var-file-fragment: \\e697;\n$fa-var-bridge-water: \\e4ce;\n$fa-var-person-booth: \\f756;\n$fa-var-text-width: \\f035;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-trash: \\f1f8;\n$fa-var-gauge-simple: \\f629;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-book-medical: \\f7e6;\n$fa-var-poo: \\f2fe;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-cubes: \\f1b3;\n$fa-var-divide: \\f529;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-headphones: \\f025;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-republican: \\f75e;\n$fa-var-arrow-left: \\f060;\n$fa-var-person-circle-xmark: \\e543;\n$fa-var-ruler: \\f545;\n$fa-var-align-left: \\f036;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-restroom: \\f7bd;\n$fa-var-j: \\4a;\n$fa-var-users-viewfinder: \\e595;\n$fa-var-file-video: \\f1c8;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-o: \\4f;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-user-secret: \\f21b;\n$fa-var-otter: \\f700;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-comment-dollar: \\f651;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-child: \\f1ae;\n$fa-var-lira-sign: \\f195;\n$fa-var-satellite: \\f7bf;\n$fa-var-plane-lock: \\e558;\n$fa-var-tag: \\f02b;\n$fa-var-comment: \\f075;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake: \\f1fd;\n$fa-var-envelope: \\f0e0;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-paperclip: \\f0c6;\n$fa-var-arrow-right-to-city: \\e4b3;\n$fa-var-ribbon: \\f4d6;\n$fa-var-lungs: \\f604;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-border-none: \\f850;\n$fa-var-circle-nodes: \\e4e2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-indent: \\f03c;\n$fa-var-truck-field-un: \\e58e;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-empty: \\f254;\n$fa-var-mountain: \\f6fc;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-square-virus: \\e578;\n$fa-var-meteor: \\f753;\n$fa-var-car-on: \\e4dd;\n$fa-var-sleigh: \\f7cc;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-water: \\f773;\n$fa-var-calendar-check: \\f274;\n$fa-var-braille: \\f2a1;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-landmark: \\f66f;\n$fa-var-truck: \\f0d1;\n$fa-var-crosshairs: \\f05b;\n$fa-var-person-cane: \\e53c;\n$fa-var-tent: \\e57d;\n$fa-var-vest-patches: \\e086;\n$fa-var-check-double: \\f560;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-money-bill-wheat: \\e52a;\n$fa-var-cookie: \\f563;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-dumbbell: \\f44b;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-tarp-droplet: \\e57c;\n$fa-var-house-medical-circle-check: \\e511;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-calendar-plus: \\f271;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-dna: \\f471;\n$fa-var-virus-slash: \\e075;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-chess: \\f439;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-plug-circle-check: \\e55c;\n$fa-var-street-view: \\f21d;\n$fa-var-franc-sign: \\e18f;\n$fa-var-volume-off: \\f026;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-mosque: \\f678;\n$fa-var-mosquito: \\e52b;\n$fa-var-star-of-david: \\f69a;\n$fa-var-person-military-rifle: \\e54b;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-vials: \\f493;\n$fa-var-plug-circle-plus: \\e55f;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-hexagon-nodes: \\e699;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-u: \\55;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-pallet: \\f482;\n$fa-var-faucet: \\e005;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-s: \\53;\n$fa-var-timeline: \\e29c;\n$fa-var-keyboard: \\f11c;\n$fa-var-caret-down: \\f0d7;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-plane-up: \\e22d;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-mountain-city: \\e52e;\n$fa-var-coins: \\f51e;\n$fa-var-khanda: \\f66d;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-folder-tree: \\f802;\n$fa-var-network-wired: \\f6ff;\n$fa-var-map-pin: \\f276;\n$fa-var-hamsa: \\f665;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-flask: \\f0c3;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-ticket: \\f145;\n$fa-var-power-off: \\f011;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-flag-usa: \\f74d;\n$fa-var-laptop-file: \\e51d;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-diagram-next: \\e476;\n$fa-var-person-rifle: \\e54e;\n$fa-var-house-medical-circle-exclamation: \\e512;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-venus-double: \\f226;\n$fa-var-images: \\f302;\n$fa-var-calculator: \\f1ec;\n$fa-var-people-pulling: \\e535;\n$fa-var-n: \\4e;\n$fa-var-cable-car: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-building-circle-xmark: \\e4d4;\n$fa-var-ship: \\f21a;\n$fa-var-arrows-down-to-line: \\e4b8;\n$fa-var-download: \\f019;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-file-circle-check: \\e5a0;\n$fa-var-forward: \\f04e;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-align-center: \\f037;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-heart-circle-exclamation: \\e4fe;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-home-alt: \\f015;\n$fa-var-home-lg-alt: \\f015;\n$fa-var-calendar-week: \\f784;\n$fa-var-laptop-medical: \\f812;\n$fa-var-b: \\42;\n$fa-var-file-medical: \\f477;\n$fa-var-dice-one: \\f525;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-skull: \\f54c;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-stop: \\f04d;\n$fa-var-code-merge: \\f387;\n$fa-var-upload: \\f093;\n$fa-var-hurricane: \\f751;\n$fa-var-mound: \\e52d;\n$fa-var-toilet-portable: \\e583;\n$fa-var-compact-disc: \\f51f;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-caravan: \\f8ff;\n$fa-var-shield-cat: \\e572;\n$fa-var-bolt: \\f0e7;\n$fa-var-zap: \\f0e7;\n$fa-var-glass-water: \\e4f4;\n$fa-var-oil-well: \\e532;\n$fa-var-vault: \\e2c5;\n$fa-var-mars: \\f222;\n$fa-var-toilet: \\f7d8;\n$fa-var-plane-circle-xmark: \\e557;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-sun: \\f185;\n$fa-var-guitar: \\f7a6;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-horse-head: \\f7ab;\n$fa-var-bore-hole: \\e4c3;\n$fa-var-industry: \\f275;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-arrows-turn-to-dots: \\e4c1;\n$fa-var-florin-sign: \\e184;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-less-than: \\3c;\n$fa-var-angle-down: \\f107;\n$fa-var-car-tunnel: \\e4de;\n$fa-var-head-side-cough: \\e061;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-thumbs-down: \\f165;\n$fa-var-user-lock: \\f502;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-anchor-circle-xmark: \\e4ac;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-chess-pawn: \\f443;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-person-through-window: \\e5a9;\n$fa-var-toolbox: \\f552;\n$fa-var-hands-holding-circle: \\e4fb;\n$fa-var-bug: \\f188;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-hand-holding-hand: \\e4f7;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-mountain-sun: \\e52f;\n$fa-var-arrows-left-right-to-line: \\e4ba;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-truck-droplet: \\e58c;\n$fa-var-file-circle-xmark: \\e5a1;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-medal: \\f5a2;\n$fa-var-bed: \\f236;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-podcast: \\f2ce;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-bell: \\f0f3;\n$fa-var-superscript: \\f12b;\n$fa-var-plug-circle-xmark: \\e560;\n$fa-var-star-of-life: \\f621;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-file: \\f15b;\n$fa-var-greater-than: \\3e;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-arrow-down: \\f063;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-eraser: \\f12d;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-earth-america: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-person-burst: \\e53b;\n$fa-var-dove: \\f4ba;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-socks: \\f696;\n$fa-var-inbox: \\f01c;\n$fa-var-section: \\e447;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-alt: \\f0f8;\n$fa-var-hospital-wide: \\f0f8;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-chess-rook: \\f447;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-dharmachakra: \\f655;\n$fa-var-hotdog: \\f80f;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-drum: \\f569;\n$fa-var-ice-cream: \\f810;\n$fa-var-heart-circle-bolt: \\e4fc;\n$fa-var-fax: \\f1ac;\n$fa-var-paragraph: \\f1dd;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-star-half: \\f089;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-tree-city: \\e587;\n$fa-var-play: \\f04b;\n$fa-var-font: \\f031;\n$fa-var-table-cells-row-lock: \\e67a;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-receipt: \\f543;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-person-circle-exclamation: \\e53f;\n$fa-var-chevron-down: \\f078;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-code-compare: \\e13a;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-school-lock: \\e56f;\n$fa-var-tower-cell: \\e585;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-ranking-star: \\e561;\n$fa-var-chess-king: \\f43f;\n$fa-var-person-harassing: \\e549;\n$fa-var-brazilian-real-sign: \\e46c;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-arrow-up: \\f062;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-shrimp: \\e448;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-jug-detergent: \\e519;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-user-shield: \\f505;\n$fa-var-wind: \\f72e;\n$fa-var-car-burst: \\f5e1;\n$fa-var-car-crash: \\f5e1;\n$fa-var-y: \\59;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-fish: \\f578;\n$fa-var-user-graduate: \\f501;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-clapperboard: \\e131;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-jet-fighter-up: \\e518;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-copy: \\f0c5;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-child-combatant: \\e4e0;\n$fa-var-child-rifle: \\e4e0;\n$fa-var-gun: \\e19b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-expand: \\f065;\n$fa-var-computer: \\e4e5;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-peso-sign: \\e222;\n$fa-var-building-shield: \\e4d8;\n$fa-var-baby: \\f77c;\n$fa-var-users-line: \\e592;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-tractor: \\f722;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-arrow-down-up-lock: \\e4b0;\n$fa-var-lines-leaning: \\e51e;\n$fa-var-ruler-combined: \\f546;\n$fa-var-copyright: \\f1f9;\n$fa-var-equals: \\3d;\n$fa-var-blender: \\f517;\n$fa-var-teeth: \\f62e;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-map: \\f279;\n$fa-var-rocket: \\f135;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-hexagon-nodes-bolt: \\e69a;\n$fa-var-store: \\f54e;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-plug-circle-minus: \\e55e;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-school-flag: \\e56e;\n$fa-var-fill: \\f575;\n$fa-var-angle-up: \\f106;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-chevron-left: \\f053;\n$fa-var-bacteria: \\e059;\n$fa-var-hand-lizard: \\f258;\n$fa-var-notdef: \\e1fe;\n$fa-var-disease: \\f7fa;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-genderless: \\f22d;\n$fa-var-chevron-right: \\f054;\n$fa-var-retweet: \\f079;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-pump-soap: \\e06b;\n$fa-var-video-slash: \\f4e2;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-radio: \\f8d7;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-traffic-light: \\f637;\n$fa-var-thermometer: \\f491;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-truck-moving: \\f4df;\n$fa-var-glass-water-droplet: \\e4f5;\n$fa-var-display: \\e163;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-trophy: \\f091;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-hammer: \\f6e3;\n$fa-var-hand-peace: \\f25b;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-spinner: \\f110;\n$fa-var-robot: \\f544;\n$fa-var-peace: \\f67c;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-warehouse: \\f494;\n$fa-var-arrow-up-right-dots: \\e4b7;\n$fa-var-splotch: \\f5bc;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-dice-four: \\f524;\n$fa-var-sim-card: \\f7c4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-mercury: \\f223;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-person-falling-burst: \\e547;\n$fa-var-award: \\f559;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-building: \\f1ad;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-qrcode: \\f029;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f132;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-comment-nodes: \\e696;\n$fa-var-house-medical: \\e3b2;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-tent-arrow-turn-left: \\e580;\n$fa-var-tents: \\e582;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-dog: \\f6d3;\n$fa-var-carrot: \\f787;\n$fa-var-moon: \\f186;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-cheese: \\f7ef;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-music: \\f001;\n$fa-var-code-commit: \\f386;\n$fa-var-temperature-low: \\f76b;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-broom: \\f51a;\n$fa-var-shield-heart: \\e574;\n$fa-var-gopuram: \\f664;\n$fa-var-earth-oceania: \\e47b;\n$fa-var-globe-oceania: \\e47b;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-hashtag: \\23;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-oil-can: \\f613;\n$fa-var-t: \\54;\n$fa-var-hippo: \\f6ed;\n$fa-var-chart-column: \\e0e3;\n$fa-var-infinity: \\f534;\n$fa-var-vial-circle-check: \\e596;\n$fa-var-person-arrow-down-to-line: \\e538;\n$fa-var-voicemail: \\f897;\n$fa-var-fan: \\f863;\n$fa-var-person-walking-luggage: \\e554;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-calendar: \\f133;\n$fa-var-trailer: \\e041;\n$fa-var-bahai: \\f666;\n$fa-var-haykal: \\f666;\n$fa-var-sd-card: \\f7c2;\n$fa-var-dragon: \\f6d5;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-plug-circle-exclamation: \\e55d;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-clone: \\f24d;\n$fa-var-person-walking-arrow-loop-left: \\e551;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-tornado: \\f76f;\n$fa-var-file-circle-plus: \\e494;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-anchor: \\f13d;\n$fa-var-border-all: \\f84c;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-cookie-bite: \\f564;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-tachometer-fast: \\f62a;\n$fa-var-shower: \\f2cc;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-m: \\4d;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-book: \\f02d;\n$fa-var-user-plus: \\f234;\n$fa-var-check: \\f00c;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-house-circle-check: \\e509;\n$fa-var-angle-left: \\f104;\n$fa-var-diagram-successor: \\e47a;\n$fa-var-truck-arrow-right: \\e58b;\n$fa-var-arrows-split-up-and-left: \\e4bc;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-briefcase: \\f0b1;\n$fa-var-person-falling: \\e546;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-user-tag: \\f507;\n$fa-var-rug: \\e569;\n$fa-var-earth-europe: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-book-open: \\f518;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-handcuffs: \\e4f8;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-database: \\f1c0;\n$fa-var-share: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-bottle-droplet: \\e4c4;\n$fa-var-mask-face: \\e1d7;\n$fa-var-hill-rockslide: \\e508;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-road-circle-exclamation: \\e565;\n$fa-var-dungeon: \\f6d9;\n$fa-var-align-right: \\f038;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-life-ring: \\f1cd;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-calendar-day: \\f783;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-person-walking-arrow-right: \\e552;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-dice: \\f522;\n$fa-var-bowling-ball: \\f436;\n$fa-var-brain: \\f5dc;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-calendar-minus: \\f272;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-gifts: \\f79c;\n$fa-var-hotel: \\f594;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-thumbs-up: \\f164;\n$fa-var-user-clock: \\f4fd;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-file-invoice: \\f570;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-brush: \\f55d;\n$fa-var-file-half-dashed: \\e698;\n$fa-var-mask: \\f6fa;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-train-tram: \\e5b4;\n$fa-var-user-nurse: \\f82f;\n$fa-var-syringe: \\f48e;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-square-full: \\f45c;\n$fa-var-magnet: \\f076;\n$fa-var-jar: \\e516;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-bug-slash: \\e490;\n$fa-var-arrow-up-from-water-pump: \\e4b6;\n$fa-var-bone: \\f5d7;\n$fa-var-table-cells-row-unlock: \\e691;\n$fa-var-user-injured: \\f728;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-plane: \\f072;\n$fa-var-tent-arrows-down: \\e581;\n$fa-var-exclamation: \\21;\n$fa-var-arrows-spin: \\e4bb;\n$fa-var-print: \\f02f;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-x: \\58;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-person-military-pointing: \\e54a;\n$fa-var-building-columns: \\f19c;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-museum: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-umbrella: \\f0e9;\n$fa-var-trowel: \\e589;\n$fa-var-d: \\44;\n$fa-var-stapler: \\e5af;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-barcode: \\f02a;\n$fa-var-plus-minus: \\e43c;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-person-circle-check: \\e53e;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n\n$fa-var-monero: \\f3d0;\n$fa-var-hooli: \\f427;\n$fa-var-yelp: \\f1e9;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-lastfm: \\f202;\n$fa-var-shopware: \\f5b5;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-aws: \\f375;\n$fa-var-redhat: \\f7bc;\n$fa-var-yoast: \\f2b1;\n$fa-var-cloudflare: \\e07d;\n$fa-var-ups: \\f7e0;\n$fa-var-pixiv: \\e640;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-dyalog: \\f399;\n$fa-var-bity: \\f37a;\n$fa-var-stackpath: \\f842;\n$fa-var-buysellads: \\f20d;\n$fa-var-first-order: \\f2b0;\n$fa-var-modx: \\f285;\n$fa-var-guilded: \\e07e;\n$fa-var-vnv: \\f40b;\n$fa-var-square-js: \\f3b9;\n$fa-var-js-square: \\f3b9;\n$fa-var-microsoft: \\f3ca;\n$fa-var-qq: \\f1d6;\n$fa-var-orcid: \\f8d2;\n$fa-var-java: \\f4e4;\n$fa-var-invision: \\f7b0;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-centercode: \\f380;\n$fa-var-glide-g: \\f2a6;\n$fa-var-drupal: \\f1a9;\n$fa-var-jxl: \\e67b;\n$fa-var-dart-lang: \\e693;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-unity: \\e049;\n$fa-var-whmcs: \\f40d;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-vk: \\f189;\n$fa-var-untappd: \\f405;\n$fa-var-mailchimp: \\f59e;\n$fa-var-css3-alt: \\f38b;\n$fa-var-square-reddit: \\f1a2;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-contao: \\f26d;\n$fa-var-square-font-awesome: \\e5ad;\n$fa-var-deskpro: \\f38f;\n$fa-var-brave: \\e63c;\n$fa-var-sistrix: \\f3ee;\n$fa-var-square-instagram: \\e055;\n$fa-var-instagram-square: \\e055;\n$fa-var-battle-net: \\f835;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-square-hacker-news: \\f3af;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-edge: \\f282;\n$fa-var-threads: \\e618;\n$fa-var-napster: \\f3d2;\n$fa-var-square-snapchat: \\f2ad;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-artstation: \\f77a;\n$fa-var-markdown: \\f60f;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-google-plus: \\f2b3;\n$fa-var-diaspora: \\f791;\n$fa-var-foursquare: \\f180;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-github-alt: \\f113;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-pagelines: \\f18c;\n$fa-var-algolia: \\f36c;\n$fa-var-red-river: \\f3e3;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-safari: \\f267;\n$fa-var-google: \\f1a0;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-atlassian: \\f77b;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-digital-ocean: \\f391;\n$fa-var-nimblr: \\f5a8;\n$fa-var-chromecast: \\f838;\n$fa-var-evernote: \\f839;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-adversal: \\f36a;\n$fa-var-creative-commons: \\f25e;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-fonticons: \\f280;\n$fa-var-weixin: \\f1d7;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-codepen: \\f1cb;\n$fa-var-git-alt: \\f841;\n$fa-var-lyft: \\f3c3;\n$fa-var-rev: \\f5b2;\n$fa-var-windows: \\f17a;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-square-viadeo: \\f2aa;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-meetup: \\f2e0;\n$fa-var-centos: \\f789;\n$fa-var-adn: \\f170;\n$fa-var-cloudsmith: \\f384;\n$fa-var-opensuse: \\e62b;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-square-dribbble: \\f397;\n$fa-var-dribbble-square: \\f397;\n$fa-var-codiepie: \\f284;\n$fa-var-node: \\f419;\n$fa-var-mix: \\f3cb;\n$fa-var-steam: \\f1b6;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-scribd: \\f28a;\n$fa-var-debian: \\e60b;\n$fa-var-openid: \\f19b;\n$fa-var-instalod: \\e081;\n$fa-var-files-pinwheel: \\e69f;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-sellcast: \\f2da;\n$fa-var-square-twitter: \\f081;\n$fa-var-twitter-square: \\f081;\n$fa-var-r-project: \\f4f7;\n$fa-var-delicious: \\f1a5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-vuejs: \\f41f;\n$fa-var-accusoft: \\f369;\n$fa-var-ioxhost: \\f208;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-app-store: \\f36f;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-golang: \\e40f;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-square-kickstarter: \\f3bb;\n$fa-var-grav: \\f2d6;\n$fa-var-weibo: \\f18a;\n$fa-var-uncharted: \\e084;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-square-youtube: \\f431;\n$fa-var-youtube-square: \\f431;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-wpressr: \\f3e4;\n$fa-var-rendact: \\f3e4;\n$fa-var-angellist: \\f209;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-nfc-directional: \\e530;\n$fa-var-skype: \\f17e;\n$fa-var-joget: \\f3b7;\n$fa-var-fedora: \\f798;\n$fa-var-stripe-s: \\f42a;\n$fa-var-meta: \\e49b;\n$fa-var-laravel: \\f3bd;\n$fa-var-hotjar: \\f3b1;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-square-letterboxd: \\e62e;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-hips: \\f452;\n$fa-var-css: \\e6a2;\n$fa-var-behance: \\f1b4;\n$fa-var-reddit: \\f1a1;\n$fa-var-discord: \\f392;\n$fa-var-chrome: \\f268;\n$fa-var-app-store-ios: \\f370;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-wpbeginner: \\f297;\n$fa-var-confluence: \\f78d;\n$fa-var-shoelace: \\e60c;\n$fa-var-mdb: \\f8ca;\n$fa-var-dochub: \\f394;\n$fa-var-accessible-icon: \\f368;\n$fa-var-ebay: \\f4f4;\n$fa-var-amazon: \\f270;\n$fa-var-unsplash: \\e07c;\n$fa-var-yarn: \\f7e3;\n$fa-var-square-steam: \\f1b7;\n$fa-var-steam-square: \\f1b7;\n$fa-var-500px: \\f26e;\n$fa-var-square-vimeo: \\f194;\n$fa-var-vimeo-square: \\f194;\n$fa-var-asymmetrik: \\f372;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-gratipay: \\f184;\n$fa-var-apple: \\f179;\n$fa-var-hive: \\e07f;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-keybase: \\f4f5;\n$fa-var-apple-pay: \\f415;\n$fa-var-padlet: \\e4a0;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-square-github: \\f092;\n$fa-var-github-square: \\f092;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-fedex: \\f797;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-shopify: \\e057;\n$fa-var-neos: \\f612;\n$fa-var-square-threads: \\e619;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-researchgate: \\f4f8;\n$fa-var-swift: \\f8e1;\n$fa-var-angular: \\f420;\n$fa-var-speakap: \\f3f3;\n$fa-var-angrycreative: \\f36e;\n$fa-var-y-combinator: \\f23b;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-google-scholar: \\e63b;\n$fa-var-square-gitlab: \\e5ae;\n$fa-var-gitlab-square: \\e5ae;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-wordpress: \\f19a;\n$fa-var-product-hunt: \\f288;\n$fa-var-firefox: \\f269;\n$fa-var-linode: \\f2b8;\n$fa-var-goodreads: \\f3a8;\n$fa-var-square-odnoklassniki: \\f264;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-sith: \\f512;\n$fa-var-themeisle: \\f2b2;\n$fa-var-page4: \\f3d7;\n$fa-var-hashnode: \\e499;\n$fa-var-react: \\f41b;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-squarespace: \\f5be;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-bitcoin: \\f379;\n$fa-var-keycdn: \\f3ba;\n$fa-var-opera: \\f26a;\n$fa-var-itch-io: \\f83a;\n$fa-var-umbraco: \\f8e8;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-ubuntu: \\f7df;\n$fa-var-draft2digital: \\f396;\n$fa-var-stripe: \\f429;\n$fa-var-houzz: \\f27c;\n$fa-var-gg: \\f260;\n$fa-var-dhl: \\f790;\n$fa-var-square-pinterest: \\f0d3;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-xing: \\f168;\n$fa-var-blackberry: \\f37b;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-playstation: \\f3df;\n$fa-var-quinscape: \\f459;\n$fa-var-less: \\f41d;\n$fa-var-blogger-b: \\f37d;\n$fa-var-opencart: \\f23d;\n$fa-var-vine: \\f1ca;\n$fa-var-signal-messenger: \\e663;\n$fa-var-paypal: \\f1ed;\n$fa-var-gitlab: \\f296;\n$fa-var-typo3: \\f42b;\n$fa-var-reddit-alien: \\f281;\n$fa-var-yahoo: \\f19e;\n$fa-var-dailymotion: \\e052;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-bootstrap: \\f836;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-nfc-symbol: \\e531;\n$fa-var-mintbit: \\e62f;\n$fa-var-ethereum: \\f42e;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-patreon: \\f3d9;\n$fa-var-avianex: \\f374;\n$fa-var-ello: \\f5f1;\n$fa-var-gofore: \\f3a7;\n$fa-var-bimobject: \\f378;\n$fa-var-brave-reverse: \\e63d;\n$fa-var-facebook-f: \\f39e;\n$fa-var-square-google-plus: \\f0d4;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-web-awesome: \\e682;\n$fa-var-mandalorian: \\f50f;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-osi: \\f41a;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-periscope: \\f3da;\n$fa-var-fulcrum: \\f50b;\n$fa-var-cloudscale: \\f383;\n$fa-var-forumbee: \\f211;\n$fa-var-mizuni: \\f3cc;\n$fa-var-schlix: \\f3ea;\n$fa-var-square-xing: \\f169;\n$fa-var-xing-square: \\f169;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-wpforms: \\f298;\n$fa-var-cloudversify: \\f385;\n$fa-var-usps: \\f7e1;\n$fa-var-megaport: \\f5a3;\n$fa-var-magento: \\f3c4;\n$fa-var-spotify: \\f1bc;\n$fa-var-optin-monster: \\f23c;\n$fa-var-fly: \\f417;\n$fa-var-square-bluesky: \\e6a3;\n$fa-var-aviato: \\f421;\n$fa-var-itunes: \\f3b4;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-blogger: \\f37c;\n$fa-var-flickr: \\f16e;\n$fa-var-viber: \\f409;\n$fa-var-soundcloud: \\f1be;\n$fa-var-digg: \\f1a6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-letterboxd: \\e62d;\n$fa-var-symfony: \\f83d;\n$fa-var-maxcdn: \\f136;\n$fa-var-etsy: \\f2d7;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-audible: \\f373;\n$fa-var-think-peaks: \\f731;\n$fa-var-bilibili: \\e3d9;\n$fa-var-erlang: \\f39d;\n$fa-var-x-twitter: \\e61b;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-dashcube: \\f210;\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-elementor: \\f430;\n$fa-var-square-pied-piper: \\e01e;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-palfed: \\f3d8;\n$fa-var-superpowers: \\f2dd;\n$fa-var-resolving: \\f3e7;\n$fa-var-xbox: \\f412;\n$fa-var-square-web-awesome-stroke: \\e684;\n$fa-var-searchengin: \\f3eb;\n$fa-var-tiktok: \\e07b;\n$fa-var-square-facebook: \\f082;\n$fa-var-facebook-square: \\f082;\n$fa-var-renren: \\f18b;\n$fa-var-linux: \\f17c;\n$fa-var-glide: \\f2a5;\n$fa-var-linkedin: \\f08c;\n$fa-var-hubspot: \\f3b2;\n$fa-var-deploydog: \\f38e;\n$fa-var-twitch: \\f1e8;\n$fa-var-flutter: \\e694;\n$fa-var-ravelry: \\f2d9;\n$fa-var-mixer: \\e056;\n$fa-var-square-lastfm: \\f203;\n$fa-var-lastfm-square: \\f203;\n$fa-var-vimeo: \\f40a;\n$fa-var-mendeley: \\f7b3;\n$fa-var-uniregistry: \\f404;\n$fa-var-figma: \\f799;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-dropbox: \\f16b;\n$fa-var-instagram: \\f16d;\n$fa-var-cmplid: \\e360;\n$fa-var-upwork: \\e641;\n$fa-var-facebook: \\f09a;\n$fa-var-gripfire: \\f3ac;\n$fa-var-jedi-order: \\f50e;\n$fa-var-uikit: \\f403;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-phabricator: \\f3db;\n$fa-var-ussunnah: \\f407;\n$fa-var-earlybirds: \\f39a;\n$fa-var-trade-federation: \\f513;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-whatsapp: \\f232;\n$fa-var-square-upwork: \\e67c;\n$fa-var-slideshare: \\f1e7;\n$fa-var-google-play: \\f3ab;\n$fa-var-viadeo: \\f2a9;\n$fa-var-line: \\f3c0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-servicestack: \\f3ec;\n$fa-var-simplybuilt: \\f215;\n$fa-var-bitbucket: \\f171;\n$fa-var-imdb: \\f2d8;\n$fa-var-deezer: \\e077;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-jira: \\f7b1;\n$fa-var-docker: \\f395;\n$fa-var-screenpal: \\e570;\n$fa-var-bluetooth: \\f293;\n$fa-var-gitter: \\f426;\n$fa-var-d-and-d: \\f38d;\n$fa-var-microblog: \\e01a;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-gg-circle: \\f261;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-yandex: \\f413;\n$fa-var-readme: \\f4d5;\n$fa-var-html5: \\f13b;\n$fa-var-sellsy: \\f213;\n$fa-var-square-web-awesome: \\e683;\n$fa-var-sass: \\f41e;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-salesforce: \\f83b;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-medapps: \\f3c6;\n$fa-var-ns8: \\f3d5;\n$fa-var-pinterest-p: \\f231;\n$fa-var-apper: \\f371;\n$fa-var-fort-awesome: \\f286;\n$fa-var-waze: \\f83f;\n$fa-var-bluesky: \\e671;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-rust: \\e07a;\n$fa-var-wix: \\f5cf;\n$fa-var-square-behance: \\f1b5;\n$fa-var-behance-square: \\f1b5;\n$fa-var-supple: \\f3f9;\n$fa-var-webflow: \\e65c;\n$fa-var-rebel: \\f1d0;\n$fa-var-css3: \\f13c;\n$fa-var-staylinked: \\f3f5;\n$fa-var-kaggle: \\f5fa;\n$fa-var-space-awesome: \\e5ac;\n$fa-var-deviantart: \\f1bd;\n$fa-var-cpanel: \\f388;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-square-git: \\f1d2;\n$fa-var-git-square: \\f1d2;\n$fa-var-square-tumblr: \\f174;\n$fa-var-tumblr-square: \\f174;\n$fa-var-trello: \\f181;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-get-pocket: \\f265;\n$fa-var-perbyte: \\e083;\n$fa-var-grunt: \\f3ad;\n$fa-var-weebly: \\f5cc;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-leanpub: \\f212;\n$fa-var-black-tie: \\f27e;\n$fa-var-themeco: \\f5c6;\n$fa-var-python: \\f3e2;\n$fa-var-android: \\f17b;\n$fa-var-bots: \\e340;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-hornbill: \\f592;\n$fa-var-js: \\f3b8;\n$fa-var-ideal: \\e013;\n$fa-var-git: \\f1d3;\n$fa-var-dev: \\f6cc;\n$fa-var-sketch: \\f7c6;\n$fa-var-yandex-international: \\f414;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-uber: \\f402;\n$fa-var-github: \\f09b;\n$fa-var-php: \\f457;\n$fa-var-alipay: \\f642;\n$fa-var-youtube: \\f167;\n$fa-var-skyatlas: \\f216;\n$fa-var-firefox-browser: \\e007;\n$fa-var-replyd: \\f3e6;\n$fa-var-suse: \\f7d6;\n$fa-var-jenkins: \\f3b6;\n$fa-var-twitter: \\f099;\n$fa-var-rockrms: \\f3e9;\n$fa-var-pinterest: \\f0d2;\n$fa-var-buffer: \\f837;\n$fa-var-npm: \\f3d4;\n$fa-var-yammer: \\f840;\n$fa-var-btc: \\f15a;\n$fa-var-dribbble: \\f17d;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-stubber: \\e5c7;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-old-republic: \\f510;\n$fa-var-odysee: \\e5c6;\n$fa-var-square-whatsapp: \\f40c;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-node-js: \\f3d3;\n$fa-var-edge-legacy: \\e078;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-medrt: \\f3c8;\n$fa-var-usb: \\f287;\n$fa-var-tumblr: \\f173;\n$fa-var-vaadin: \\f408;\n$fa-var-quora: \\f2c4;\n$fa-var-square-x-twitter: \\e61a;\n$fa-var-reacteurope: \\f75d;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-amilia: \\f36d;\n$fa-var-mixcloud: \\f289;\n$fa-var-flipboard: \\f44d;\n$fa-var-viacoin: \\f237;\n$fa-var-critical-role: \\f6c9;\n$fa-var-sitrox: \\e44a;\n$fa-var-discourse: \\f393;\n$fa-var-joomla: \\f1aa;\n$fa-var-mastodon: \\f4f6;\n$fa-var-airbnb: \\f834;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-gulp: \\f3ae;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-strava: \\f428;\n$fa-var-ember: \\f423;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-pushed: \\f3e1;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-wodu: \\e088;\n$fa-var-google-pay: \\e079;\n$fa-var-intercom: \\f7af;\n$fa-var-zhihu: \\f63f;\n$fa-var-korvue: \\f42f;\n$fa-var-pix: \\e43a;\n$fa-var-steam-symbol: \\f3f6;\n\n$fa-icons: (\n  \"0\": $fa-var-0,\n  \"1\": $fa-var-1,\n  \"2\": $fa-var-2,\n  \"3\": $fa-var-3,\n  \"4\": $fa-var-4,\n  \"5\": $fa-var-5,\n  \"6\": $fa-var-6,\n  \"7\": $fa-var-7,\n  \"8\": $fa-var-8,\n  \"9\": $fa-var-9,\n  \"fill-drip\": $fa-var-fill-drip,\n  \"arrows-to-circle\": $fa-var-arrows-to-circle,\n  \"circle-chevron-right\": $fa-var-circle-chevron-right,\n  \"chevron-circle-right\": $fa-var-chevron-circle-right,\n  \"at\": $fa-var-at,\n  \"trash-can\": $fa-var-trash-can,\n  \"trash-alt\": $fa-var-trash-alt,\n  \"text-height\": $fa-var-text-height,\n  \"user-xmark\": $fa-var-user-xmark,\n  \"user-times\": $fa-var-user-times,\n  \"stethoscope\": $fa-var-stethoscope,\n  \"message\": $fa-var-message,\n  \"comment-alt\": $fa-var-comment-alt,\n  \"info\": $fa-var-info,\n  \"down-left-and-up-right-to-center\": $fa-var-down-left-and-up-right-to-center,\n  \"compress-alt\": $fa-var-compress-alt,\n  \"explosion\": $fa-var-explosion,\n  \"file-lines\": $fa-var-file-lines,\n  \"file-alt\": $fa-var-file-alt,\n  \"file-text\": $fa-var-file-text,\n  \"wave-square\": $fa-var-wave-square,\n  \"ring\": $fa-var-ring,\n  \"building-un\": $fa-var-building-un,\n  \"dice-three\": $fa-var-dice-three,\n  \"calendar-days\": $fa-var-calendar-days,\n  \"calendar-alt\": $fa-var-calendar-alt,\n  \"anchor-circle-check\": $fa-var-anchor-circle-check,\n  \"building-circle-arrow-right\": $fa-var-building-circle-arrow-right,\n  \"volleyball\": $fa-var-volleyball,\n  \"volleyball-ball\": $fa-var-volleyball-ball,\n  \"arrows-up-to-line\": $fa-var-arrows-up-to-line,\n  \"sort-down\": $fa-var-sort-down,\n  \"sort-desc\": $fa-var-sort-desc,\n  \"circle-minus\": $fa-var-circle-minus,\n  \"minus-circle\": $fa-var-minus-circle,\n  \"door-open\": $fa-var-door-open,\n  \"right-from-bracket\": $fa-var-right-from-bracket,\n  \"sign-out-alt\": $fa-var-sign-out-alt,\n  \"atom\": $fa-var-atom,\n  \"soap\": $fa-var-soap,\n  \"icons\": $fa-var-icons,\n  \"heart-music-camera-bolt\": $fa-var-heart-music-camera-bolt,\n  \"microphone-lines-slash\": $fa-var-microphone-lines-slash,\n  \"microphone-alt-slash\": $fa-var-microphone-alt-slash,\n  \"bridge-circle-check\": $fa-var-bridge-circle-check,\n  \"pump-medical\": $fa-var-pump-medical,\n  \"fingerprint\": $fa-var-fingerprint,\n  \"hand-point-right\": $fa-var-hand-point-right,\n  \"magnifying-glass-location\": $fa-var-magnifying-glass-location,\n  \"search-location\": $fa-var-search-location,\n  \"forward-step\": $fa-var-forward-step,\n  \"step-forward\": $fa-var-step-forward,\n  \"face-smile-beam\": $fa-var-face-smile-beam,\n  \"smile-beam\": $fa-var-smile-beam,\n  \"flag-checkered\": $fa-var-flag-checkered,\n  \"football\": $fa-var-football,\n  \"football-ball\": $fa-var-football-ball,\n  \"school-circle-exclamation\": $fa-var-school-circle-exclamation,\n  \"crop\": $fa-var-crop,\n  \"angles-down\": $fa-var-angles-down,\n  \"angle-double-down\": $fa-var-angle-double-down,\n  \"users-rectangle\": $fa-var-users-rectangle,\n  \"people-roof\": $fa-var-people-roof,\n  \"people-line\": $fa-var-people-line,\n  \"beer-mug-empty\": $fa-var-beer-mug-empty,\n  \"beer\": $fa-var-beer,\n  \"diagram-predecessor\": $fa-var-diagram-predecessor,\n  \"arrow-up-long\": $fa-var-arrow-up-long,\n  \"long-arrow-up\": $fa-var-long-arrow-up,\n  \"fire-flame-simple\": $fa-var-fire-flame-simple,\n  \"burn\": $fa-var-burn,\n  \"person\": $fa-var-person,\n  \"male\": $fa-var-male,\n  \"laptop\": $fa-var-laptop,\n  \"file-csv\": $fa-var-file-csv,\n  \"menorah\": $fa-var-menorah,\n  \"truck-plane\": $fa-var-truck-plane,\n  \"record-vinyl\": $fa-var-record-vinyl,\n  \"face-grin-stars\": $fa-var-face-grin-stars,\n  \"grin-stars\": $fa-var-grin-stars,\n  \"bong\": $fa-var-bong,\n  \"spaghetti-monster-flying\": $fa-var-spaghetti-monster-flying,\n  \"pastafarianism\": $fa-var-pastafarianism,\n  \"arrow-down-up-across-line\": $fa-var-arrow-down-up-across-line,\n  \"spoon\": $fa-var-spoon,\n  \"utensil-spoon\": $fa-var-utensil-spoon,\n  \"jar-wheat\": $fa-var-jar-wheat,\n  \"envelopes-bulk\": $fa-var-envelopes-bulk,\n  \"mail-bulk\": $fa-var-mail-bulk,\n  \"file-circle-exclamation\": $fa-var-file-circle-exclamation,\n  \"circle-h\": $fa-var-circle-h,\n  \"hospital-symbol\": $fa-var-hospital-symbol,\n  \"pager\": $fa-var-pager,\n  \"address-book\": $fa-var-address-book,\n  \"contact-book\": $fa-var-contact-book,\n  \"strikethrough\": $fa-var-strikethrough,\n  \"k\": $fa-var-k,\n  \"landmark-flag\": $fa-var-landmark-flag,\n  \"pencil\": $fa-var-pencil,\n  \"pencil-alt\": $fa-var-pencil-alt,\n  \"backward\": $fa-var-backward,\n  \"caret-right\": $fa-var-caret-right,\n  \"comments\": $fa-var-comments,\n  \"paste\": $fa-var-paste,\n  \"file-clipboard\": $fa-var-file-clipboard,\n  \"code-pull-request\": $fa-var-code-pull-request,\n  \"clipboard-list\": $fa-var-clipboard-list,\n  \"truck-ramp-box\": $fa-var-truck-ramp-box,\n  \"truck-loading\": $fa-var-truck-loading,\n  \"user-check\": $fa-var-user-check,\n  \"vial-virus\": $fa-var-vial-virus,\n  \"sheet-plastic\": $fa-var-sheet-plastic,\n  \"blog\": $fa-var-blog,\n  \"user-ninja\": $fa-var-user-ninja,\n  \"person-arrow-up-from-line\": $fa-var-person-arrow-up-from-line,\n  \"scroll-torah\": $fa-var-scroll-torah,\n  \"torah\": $fa-var-torah,\n  \"broom-ball\": $fa-var-broom-ball,\n  \"quidditch\": $fa-var-quidditch,\n  \"quidditch-broom-ball\": $fa-var-quidditch-broom-ball,\n  \"toggle-off\": $fa-var-toggle-off,\n  \"box-archive\": $fa-var-box-archive,\n  \"archive\": $fa-var-archive,\n  \"person-drowning\": $fa-var-person-drowning,\n  \"arrow-down-9-1\": $fa-var-arrow-down-9-1,\n  \"sort-numeric-desc\": $fa-var-sort-numeric-desc,\n  \"sort-numeric-down-alt\": $fa-var-sort-numeric-down-alt,\n  \"face-grin-tongue-squint\": $fa-var-face-grin-tongue-squint,\n  \"grin-tongue-squint\": $fa-var-grin-tongue-squint,\n  \"spray-can\": $fa-var-spray-can,\n  \"truck-monster\": $fa-var-truck-monster,\n  \"w\": $fa-var-w,\n  \"earth-africa\": $fa-var-earth-africa,\n  \"globe-africa\": $fa-var-globe-africa,\n  \"rainbow\": $fa-var-rainbow,\n  \"circle-notch\": $fa-var-circle-notch,\n  \"tablet-screen-button\": $fa-var-tablet-screen-button,\n  \"tablet-alt\": $fa-var-tablet-alt,\n  \"paw\": $fa-var-paw,\n  \"cloud\": $fa-var-cloud,\n  \"trowel-bricks\": $fa-var-trowel-bricks,\n  \"face-flushed\": $fa-var-face-flushed,\n  \"flushed\": $fa-var-flushed,\n  \"hospital-user\": $fa-var-hospital-user,\n  \"tent-arrow-left-right\": $fa-var-tent-arrow-left-right,\n  \"gavel\": $fa-var-gavel,\n  \"legal\": $fa-var-legal,\n  \"binoculars\": $fa-var-binoculars,\n  \"microphone-slash\": $fa-var-microphone-slash,\n  \"box-tissue\": $fa-var-box-tissue,\n  \"motorcycle\": $fa-var-motorcycle,\n  \"bell-concierge\": $fa-var-bell-concierge,\n  \"concierge-bell\": $fa-var-concierge-bell,\n  \"pen-ruler\": $fa-var-pen-ruler,\n  \"pencil-ruler\": $fa-var-pencil-ruler,\n  \"people-arrows\": $fa-var-people-arrows,\n  \"people-arrows-left-right\": $fa-var-people-arrows-left-right,\n  \"mars-and-venus-burst\": $fa-var-mars-and-venus-burst,\n  \"square-caret-right\": $fa-var-square-caret-right,\n  \"caret-square-right\": $fa-var-caret-square-right,\n  \"scissors\": $fa-var-scissors,\n  \"cut\": $fa-var-cut,\n  \"sun-plant-wilt\": $fa-var-sun-plant-wilt,\n  \"toilets-portable\": $fa-var-toilets-portable,\n  \"hockey-puck\": $fa-var-hockey-puck,\n  \"table\": $fa-var-table,\n  \"magnifying-glass-arrow-right\": $fa-var-magnifying-glass-arrow-right,\n  \"tachograph-digital\": $fa-var-tachograph-digital,\n  \"digital-tachograph\": $fa-var-digital-tachograph,\n  \"users-slash\": $fa-var-users-slash,\n  \"clover\": $fa-var-clover,\n  \"reply\": $fa-var-reply,\n  \"mail-reply\": $fa-var-mail-reply,\n  \"star-and-crescent\": $fa-var-star-and-crescent,\n  \"house-fire\": $fa-var-house-fire,\n  \"square-minus\": $fa-var-square-minus,\n  \"minus-square\": $fa-var-minus-square,\n  \"helicopter\": $fa-var-helicopter,\n  \"compass\": $fa-var-compass,\n  \"square-caret-down\": $fa-var-square-caret-down,\n  \"caret-square-down\": $fa-var-caret-square-down,\n  \"file-circle-question\": $fa-var-file-circle-question,\n  \"laptop-code\": $fa-var-laptop-code,\n  \"swatchbook\": $fa-var-swatchbook,\n  \"prescription-bottle\": $fa-var-prescription-bottle,\n  \"bars\": $fa-var-bars,\n  \"navicon\": $fa-var-navicon,\n  \"people-group\": $fa-var-people-group,\n  \"hourglass-end\": $fa-var-hourglass-end,\n  \"hourglass-3\": $fa-var-hourglass-3,\n  \"heart-crack\": $fa-var-heart-crack,\n  \"heart-broken\": $fa-var-heart-broken,\n  \"square-up-right\": $fa-var-square-up-right,\n  \"external-link-square-alt\": $fa-var-external-link-square-alt,\n  \"face-kiss-beam\": $fa-var-face-kiss-beam,\n  \"kiss-beam\": $fa-var-kiss-beam,\n  \"film\": $fa-var-film,\n  \"ruler-horizontal\": $fa-var-ruler-horizontal,\n  \"people-robbery\": $fa-var-people-robbery,\n  \"lightbulb\": $fa-var-lightbulb,\n  \"caret-left\": $fa-var-caret-left,\n  \"circle-exclamation\": $fa-var-circle-exclamation,\n  \"exclamation-circle\": $fa-var-exclamation-circle,\n  \"school-circle-xmark\": $fa-var-school-circle-xmark,\n  \"arrow-right-from-bracket\": $fa-var-arrow-right-from-bracket,\n  \"sign-out\": $fa-var-sign-out,\n  \"circle-chevron-down\": $fa-var-circle-chevron-down,\n  \"chevron-circle-down\": $fa-var-chevron-circle-down,\n  \"unlock-keyhole\": $fa-var-unlock-keyhole,\n  \"unlock-alt\": $fa-var-unlock-alt,\n  \"cloud-showers-heavy\": $fa-var-cloud-showers-heavy,\n  \"headphones-simple\": $fa-var-headphones-simple,\n  \"headphones-alt\": $fa-var-headphones-alt,\n  \"sitemap\": $fa-var-sitemap,\n  \"circle-dollar-to-slot\": $fa-var-circle-dollar-to-slot,\n  \"donate\": $fa-var-donate,\n  \"memory\": $fa-var-memory,\n  \"road-spikes\": $fa-var-road-spikes,\n  \"fire-burner\": $fa-var-fire-burner,\n  \"flag\": $fa-var-flag,\n  \"hanukiah\": $fa-var-hanukiah,\n  \"feather\": $fa-var-feather,\n  \"volume-low\": $fa-var-volume-low,\n  \"volume-down\": $fa-var-volume-down,\n  \"comment-slash\": $fa-var-comment-slash,\n  \"cloud-sun-rain\": $fa-var-cloud-sun-rain,\n  \"compress\": $fa-var-compress,\n  \"wheat-awn\": $fa-var-wheat-awn,\n  \"wheat-alt\": $fa-var-wheat-alt,\n  \"ankh\": $fa-var-ankh,\n  \"hands-holding-child\": $fa-var-hands-holding-child,\n  \"asterisk\": $fa-var-asterisk,\n  \"square-check\": $fa-var-square-check,\n  \"check-square\": $fa-var-check-square,\n  \"peseta-sign\": $fa-var-peseta-sign,\n  \"heading\": $fa-var-heading,\n  \"header\": $fa-var-header,\n  \"ghost\": $fa-var-ghost,\n  \"list\": $fa-var-list,\n  \"list-squares\": $fa-var-list-squares,\n  \"square-phone-flip\": $fa-var-square-phone-flip,\n  \"phone-square-alt\": $fa-var-phone-square-alt,\n  \"cart-plus\": $fa-var-cart-plus,\n  \"gamepad\": $fa-var-gamepad,\n  \"circle-dot\": $fa-var-circle-dot,\n  \"dot-circle\": $fa-var-dot-circle,\n  \"face-dizzy\": $fa-var-face-dizzy,\n  \"dizzy\": $fa-var-dizzy,\n  \"egg\": $fa-var-egg,\n  \"house-medical-circle-xmark\": $fa-var-house-medical-circle-xmark,\n  \"campground\": $fa-var-campground,\n  \"folder-plus\": $fa-var-folder-plus,\n  \"futbol\": $fa-var-futbol,\n  \"futbol-ball\": $fa-var-futbol-ball,\n  \"soccer-ball\": $fa-var-soccer-ball,\n  \"paintbrush\": $fa-var-paintbrush,\n  \"paint-brush\": $fa-var-paint-brush,\n  \"lock\": $fa-var-lock,\n  \"gas-pump\": $fa-var-gas-pump,\n  \"hot-tub-person\": $fa-var-hot-tub-person,\n  \"hot-tub\": $fa-var-hot-tub,\n  \"map-location\": $fa-var-map-location,\n  \"map-marked\": $fa-var-map-marked,\n  \"house-flood-water\": $fa-var-house-flood-water,\n  \"tree\": $fa-var-tree,\n  \"bridge-lock\": $fa-var-bridge-lock,\n  \"sack-dollar\": $fa-var-sack-dollar,\n  \"pen-to-square\": $fa-var-pen-to-square,\n  \"edit\": $fa-var-edit,\n  \"car-side\": $fa-var-car-side,\n  \"share-nodes\": $fa-var-share-nodes,\n  \"share-alt\": $fa-var-share-alt,\n  \"heart-circle-minus\": $fa-var-heart-circle-minus,\n  \"hourglass-half\": $fa-var-hourglass-half,\n  \"hourglass-2\": $fa-var-hourglass-2,\n  \"microscope\": $fa-var-microscope,\n  \"sink\": $fa-var-sink,\n  \"bag-shopping\": $fa-var-bag-shopping,\n  \"shopping-bag\": $fa-var-shopping-bag,\n  \"arrow-down-z-a\": $fa-var-arrow-down-z-a,\n  \"sort-alpha-desc\": $fa-var-sort-alpha-desc,\n  \"sort-alpha-down-alt\": $fa-var-sort-alpha-down-alt,\n  \"mitten\": $fa-var-mitten,\n  \"person-rays\": $fa-var-person-rays,\n  \"users\": $fa-var-users,\n  \"eye-slash\": $fa-var-eye-slash,\n  \"flask-vial\": $fa-var-flask-vial,\n  \"hand\": $fa-var-hand,\n  \"hand-paper\": $fa-var-hand-paper,\n  \"om\": $fa-var-om,\n  \"worm\": $fa-var-worm,\n  \"house-circle-xmark\": $fa-var-house-circle-xmark,\n  \"plug\": $fa-var-plug,\n  \"chevron-up\": $fa-var-chevron-up,\n  \"hand-spock\": $fa-var-hand-spock,\n  \"stopwatch\": $fa-var-stopwatch,\n  \"face-kiss\": $fa-var-face-kiss,\n  \"kiss\": $fa-var-kiss,\n  \"bridge-circle-xmark\": $fa-var-bridge-circle-xmark,\n  \"face-grin-tongue\": $fa-var-face-grin-tongue,\n  \"grin-tongue\": $fa-var-grin-tongue,\n  \"chess-bishop\": $fa-var-chess-bishop,\n  \"face-grin-wink\": $fa-var-face-grin-wink,\n  \"grin-wink\": $fa-var-grin-wink,\n  \"ear-deaf\": $fa-var-ear-deaf,\n  \"deaf\": $fa-var-deaf,\n  \"deafness\": $fa-var-deafness,\n  \"hard-of-hearing\": $fa-var-hard-of-hearing,\n  \"road-circle-check\": $fa-var-road-circle-check,\n  \"dice-five\": $fa-var-dice-five,\n  \"square-rss\": $fa-var-square-rss,\n  \"rss-square\": $fa-var-rss-square,\n  \"land-mine-on\": $fa-var-land-mine-on,\n  \"i-cursor\": $fa-var-i-cursor,\n  \"stamp\": $fa-var-stamp,\n  \"stairs\": $fa-var-stairs,\n  \"i\": $fa-var-i,\n  \"hryvnia-sign\": $fa-var-hryvnia-sign,\n  \"hryvnia\": $fa-var-hryvnia,\n  \"pills\": $fa-var-pills,\n  \"face-grin-wide\": $fa-var-face-grin-wide,\n  \"grin-alt\": $fa-var-grin-alt,\n  \"tooth\": $fa-var-tooth,\n  \"v\": $fa-var-v,\n  \"bangladeshi-taka-sign\": $fa-var-bangladeshi-taka-sign,\n  \"bicycle\": $fa-var-bicycle,\n  \"staff-snake\": $fa-var-staff-snake,\n  \"rod-asclepius\": $fa-var-rod-asclepius,\n  \"rod-snake\": $fa-var-rod-snake,\n  \"staff-aesculapius\": $fa-var-staff-aesculapius,\n  \"head-side-cough-slash\": $fa-var-head-side-cough-slash,\n  \"truck-medical\": $fa-var-truck-medical,\n  \"ambulance\": $fa-var-ambulance,\n  \"wheat-awn-circle-exclamation\": $fa-var-wheat-awn-circle-exclamation,\n  \"snowman\": $fa-var-snowman,\n  \"mortar-pestle\": $fa-var-mortar-pestle,\n  \"road-barrier\": $fa-var-road-barrier,\n  \"school\": $fa-var-school,\n  \"igloo\": $fa-var-igloo,\n  \"joint\": $fa-var-joint,\n  \"angle-right\": $fa-var-angle-right,\n  \"horse\": $fa-var-horse,\n  \"q\": $fa-var-q,\n  \"g\": $fa-var-g,\n  \"notes-medical\": $fa-var-notes-medical,\n  \"temperature-half\": $fa-var-temperature-half,\n  \"temperature-2\": $fa-var-temperature-2,\n  \"thermometer-2\": $fa-var-thermometer-2,\n  \"thermometer-half\": $fa-var-thermometer-half,\n  \"dong-sign\": $fa-var-dong-sign,\n  \"capsules\": $fa-var-capsules,\n  \"poo-storm\": $fa-var-poo-storm,\n  \"poo-bolt\": $fa-var-poo-bolt,\n  \"face-frown-open\": $fa-var-face-frown-open,\n  \"frown-open\": $fa-var-frown-open,\n  \"hand-point-up\": $fa-var-hand-point-up,\n  \"money-bill\": $fa-var-money-bill,\n  \"bookmark\": $fa-var-bookmark,\n  \"align-justify\": $fa-var-align-justify,\n  \"umbrella-beach\": $fa-var-umbrella-beach,\n  \"helmet-un\": $fa-var-helmet-un,\n  \"bullseye\": $fa-var-bullseye,\n  \"bacon\": $fa-var-bacon,\n  \"hand-point-down\": $fa-var-hand-point-down,\n  \"arrow-up-from-bracket\": $fa-var-arrow-up-from-bracket,\n  \"folder\": $fa-var-folder,\n  \"folder-blank\": $fa-var-folder-blank,\n  \"file-waveform\": $fa-var-file-waveform,\n  \"file-medical-alt\": $fa-var-file-medical-alt,\n  \"radiation\": $fa-var-radiation,\n  \"chart-simple\": $fa-var-chart-simple,\n  \"mars-stroke\": $fa-var-mars-stroke,\n  \"vial\": $fa-var-vial,\n  \"gauge\": $fa-var-gauge,\n  \"dashboard\": $fa-var-dashboard,\n  \"gauge-med\": $fa-var-gauge-med,\n  \"tachometer-alt-average\": $fa-var-tachometer-alt-average,\n  \"wand-magic-sparkles\": $fa-var-wand-magic-sparkles,\n  \"magic-wand-sparkles\": $fa-var-magic-wand-sparkles,\n  \"e\": $fa-var-e,\n  \"pen-clip\": $fa-var-pen-clip,\n  \"pen-alt\": $fa-var-pen-alt,\n  \"bridge-circle-exclamation\": $fa-var-bridge-circle-exclamation,\n  \"user\": $fa-var-user,\n  \"school-circle-check\": $fa-var-school-circle-check,\n  \"dumpster\": $fa-var-dumpster,\n  \"van-shuttle\": $fa-var-van-shuttle,\n  \"shuttle-van\": $fa-var-shuttle-van,\n  \"building-user\": $fa-var-building-user,\n  \"square-caret-left\": $fa-var-square-caret-left,\n  \"caret-square-left\": $fa-var-caret-square-left,\n  \"highlighter\": $fa-var-highlighter,\n  \"key\": $fa-var-key,\n  \"bullhorn\": $fa-var-bullhorn,\n  \"globe\": $fa-var-globe,\n  \"synagogue\": $fa-var-synagogue,\n  \"person-half-dress\": $fa-var-person-half-dress,\n  \"road-bridge\": $fa-var-road-bridge,\n  \"location-arrow\": $fa-var-location-arrow,\n  \"c\": $fa-var-c,\n  \"tablet-button\": $fa-var-tablet-button,\n  \"building-lock\": $fa-var-building-lock,\n  \"pizza-slice\": $fa-var-pizza-slice,\n  \"money-bill-wave\": $fa-var-money-bill-wave,\n  \"chart-area\": $fa-var-chart-area,\n  \"area-chart\": $fa-var-area-chart,\n  \"house-flag\": $fa-var-house-flag,\n  \"person-circle-minus\": $fa-var-person-circle-minus,\n  \"ban\": $fa-var-ban,\n  \"cancel\": $fa-var-cancel,\n  \"camera-rotate\": $fa-var-camera-rotate,\n  \"spray-can-sparkles\": $fa-var-spray-can-sparkles,\n  \"air-freshener\": $fa-var-air-freshener,\n  \"star\": $fa-var-star,\n  \"repeat\": $fa-var-repeat,\n  \"cross\": $fa-var-cross,\n  \"box\": $fa-var-box,\n  \"venus-mars\": $fa-var-venus-mars,\n  \"arrow-pointer\": $fa-var-arrow-pointer,\n  \"mouse-pointer\": $fa-var-mouse-pointer,\n  \"maximize\": $fa-var-maximize,\n  \"expand-arrows-alt\": $fa-var-expand-arrows-alt,\n  \"charging-station\": $fa-var-charging-station,\n  \"shapes\": $fa-var-shapes,\n  \"triangle-circle-square\": $fa-var-triangle-circle-square,\n  \"shuffle\": $fa-var-shuffle,\n  \"random\": $fa-var-random,\n  \"person-running\": $fa-var-person-running,\n  \"running\": $fa-var-running,\n  \"mobile-retro\": $fa-var-mobile-retro,\n  \"grip-lines-vertical\": $fa-var-grip-lines-vertical,\n  \"spider\": $fa-var-spider,\n  \"hands-bound\": $fa-var-hands-bound,\n  \"file-invoice-dollar\": $fa-var-file-invoice-dollar,\n  \"plane-circle-exclamation\": $fa-var-plane-circle-exclamation,\n  \"x-ray\": $fa-var-x-ray,\n  \"spell-check\": $fa-var-spell-check,\n  \"slash\": $fa-var-slash,\n  \"computer-mouse\": $fa-var-computer-mouse,\n  \"mouse\": $fa-var-mouse,\n  \"arrow-right-to-bracket\": $fa-var-arrow-right-to-bracket,\n  \"sign-in\": $fa-var-sign-in,\n  \"shop-slash\": $fa-var-shop-slash,\n  \"store-alt-slash\": $fa-var-store-alt-slash,\n  \"server\": $fa-var-server,\n  \"virus-covid-slash\": $fa-var-virus-covid-slash,\n  \"shop-lock\": $fa-var-shop-lock,\n  \"hourglass-start\": $fa-var-hourglass-start,\n  \"hourglass-1\": $fa-var-hourglass-1,\n  \"blender-phone\": $fa-var-blender-phone,\n  \"building-wheat\": $fa-var-building-wheat,\n  \"person-breastfeeding\": $fa-var-person-breastfeeding,\n  \"right-to-bracket\": $fa-var-right-to-bracket,\n  \"sign-in-alt\": $fa-var-sign-in-alt,\n  \"venus\": $fa-var-venus,\n  \"passport\": $fa-var-passport,\n  \"thumbtack-slash\": $fa-var-thumbtack-slash,\n  \"thumb-tack-slash\": $fa-var-thumb-tack-slash,\n  \"heart-pulse\": $fa-var-heart-pulse,\n  \"heartbeat\": $fa-var-heartbeat,\n  \"people-carry-box\": $fa-var-people-carry-box,\n  \"people-carry\": $fa-var-people-carry,\n  \"temperature-high\": $fa-var-temperature-high,\n  \"microchip\": $fa-var-microchip,\n  \"crown\": $fa-var-crown,\n  \"weight-hanging\": $fa-var-weight-hanging,\n  \"xmarks-lines\": $fa-var-xmarks-lines,\n  \"file-prescription\": $fa-var-file-prescription,\n  \"weight-scale\": $fa-var-weight-scale,\n  \"weight\": $fa-var-weight,\n  \"user-group\": $fa-var-user-group,\n  \"user-friends\": $fa-var-user-friends,\n  \"arrow-up-a-z\": $fa-var-arrow-up-a-z,\n  \"sort-alpha-up\": $fa-var-sort-alpha-up,\n  \"chess-knight\": $fa-var-chess-knight,\n  \"face-laugh-squint\": $fa-var-face-laugh-squint,\n  \"laugh-squint\": $fa-var-laugh-squint,\n  \"wheelchair\": $fa-var-wheelchair,\n  \"circle-arrow-up\": $fa-var-circle-arrow-up,\n  \"arrow-circle-up\": $fa-var-arrow-circle-up,\n  \"toggle-on\": $fa-var-toggle-on,\n  \"person-walking\": $fa-var-person-walking,\n  \"walking\": $fa-var-walking,\n  \"l\": $fa-var-l,\n  \"fire\": $fa-var-fire,\n  \"bed-pulse\": $fa-var-bed-pulse,\n  \"procedures\": $fa-var-procedures,\n  \"shuttle-space\": $fa-var-shuttle-space,\n  \"space-shuttle\": $fa-var-space-shuttle,\n  \"face-laugh\": $fa-var-face-laugh,\n  \"laugh\": $fa-var-laugh,\n  \"folder-open\": $fa-var-folder-open,\n  \"heart-circle-plus\": $fa-var-heart-circle-plus,\n  \"code-fork\": $fa-var-code-fork,\n  \"city\": $fa-var-city,\n  \"microphone-lines\": $fa-var-microphone-lines,\n  \"microphone-alt\": $fa-var-microphone-alt,\n  \"pepper-hot\": $fa-var-pepper-hot,\n  \"unlock\": $fa-var-unlock,\n  \"colon-sign\": $fa-var-colon-sign,\n  \"headset\": $fa-var-headset,\n  \"store-slash\": $fa-var-store-slash,\n  \"road-circle-xmark\": $fa-var-road-circle-xmark,\n  \"user-minus\": $fa-var-user-minus,\n  \"mars-stroke-up\": $fa-var-mars-stroke-up,\n  \"mars-stroke-v\": $fa-var-mars-stroke-v,\n  \"champagne-glasses\": $fa-var-champagne-glasses,\n  \"glass-cheers\": $fa-var-glass-cheers,\n  \"clipboard\": $fa-var-clipboard,\n  \"house-circle-exclamation\": $fa-var-house-circle-exclamation,\n  \"file-arrow-up\": $fa-var-file-arrow-up,\n  \"file-upload\": $fa-var-file-upload,\n  \"wifi\": $fa-var-wifi,\n  \"wifi-3\": $fa-var-wifi-3,\n  \"wifi-strong\": $fa-var-wifi-strong,\n  \"bath\": $fa-var-bath,\n  \"bathtub\": $fa-var-bathtub,\n  \"underline\": $fa-var-underline,\n  \"user-pen\": $fa-var-user-pen,\n  \"user-edit\": $fa-var-user-edit,\n  \"signature\": $fa-var-signature,\n  \"stroopwafel\": $fa-var-stroopwafel,\n  \"bold\": $fa-var-bold,\n  \"anchor-lock\": $fa-var-anchor-lock,\n  \"building-ngo\": $fa-var-building-ngo,\n  \"manat-sign\": $fa-var-manat-sign,\n  \"not-equal\": $fa-var-not-equal,\n  \"border-top-left\": $fa-var-border-top-left,\n  \"border-style\": $fa-var-border-style,\n  \"map-location-dot\": $fa-var-map-location-dot,\n  \"map-marked-alt\": $fa-var-map-marked-alt,\n  \"jedi\": $fa-var-jedi,\n  \"square-poll-vertical\": $fa-var-square-poll-vertical,\n  \"poll\": $fa-var-poll,\n  \"mug-hot\": $fa-var-mug-hot,\n  \"car-battery\": $fa-var-car-battery,\n  \"battery-car\": $fa-var-battery-car,\n  \"gift\": $fa-var-gift,\n  \"dice-two\": $fa-var-dice-two,\n  \"chess-queen\": $fa-var-chess-queen,\n  \"glasses\": $fa-var-glasses,\n  \"chess-board\": $fa-var-chess-board,\n  \"building-circle-check\": $fa-var-building-circle-check,\n  \"person-chalkboard\": $fa-var-person-chalkboard,\n  \"mars-stroke-right\": $fa-var-mars-stroke-right,\n  \"mars-stroke-h\": $fa-var-mars-stroke-h,\n  \"hand-back-fist\": $fa-var-hand-back-fist,\n  \"hand-rock\": $fa-var-hand-rock,\n  \"square-caret-up\": $fa-var-square-caret-up,\n  \"caret-square-up\": $fa-var-caret-square-up,\n  \"cloud-showers-water\": $fa-var-cloud-showers-water,\n  \"chart-bar\": $fa-var-chart-bar,\n  \"bar-chart\": $fa-var-bar-chart,\n  \"hands-bubbles\": $fa-var-hands-bubbles,\n  \"hands-wash\": $fa-var-hands-wash,\n  \"less-than-equal\": $fa-var-less-than-equal,\n  \"train\": $fa-var-train,\n  \"eye-low-vision\": $fa-var-eye-low-vision,\n  \"low-vision\": $fa-var-low-vision,\n  \"crow\": $fa-var-crow,\n  \"sailboat\": $fa-var-sailboat,\n  \"window-restore\": $fa-var-window-restore,\n  \"square-plus\": $fa-var-square-plus,\n  \"plus-square\": $fa-var-plus-square,\n  \"torii-gate\": $fa-var-torii-gate,\n  \"frog\": $fa-var-frog,\n  \"bucket\": $fa-var-bucket,\n  \"image\": $fa-var-image,\n  \"microphone\": $fa-var-microphone,\n  \"cow\": $fa-var-cow,\n  \"caret-up\": $fa-var-caret-up,\n  \"screwdriver\": $fa-var-screwdriver,\n  \"folder-closed\": $fa-var-folder-closed,\n  \"house-tsunami\": $fa-var-house-tsunami,\n  \"square-nfi\": $fa-var-square-nfi,\n  \"arrow-up-from-ground-water\": $fa-var-arrow-up-from-ground-water,\n  \"martini-glass\": $fa-var-martini-glass,\n  \"glass-martini-alt\": $fa-var-glass-martini-alt,\n  \"square-binary\": $fa-var-square-binary,\n  \"rotate-left\": $fa-var-rotate-left,\n  \"rotate-back\": $fa-var-rotate-back,\n  \"rotate-backward\": $fa-var-rotate-backward,\n  \"undo-alt\": $fa-var-undo-alt,\n  \"table-columns\": $fa-var-table-columns,\n  \"columns\": $fa-var-columns,\n  \"lemon\": $fa-var-lemon,\n  \"head-side-mask\": $fa-var-head-side-mask,\n  \"handshake\": $fa-var-handshake,\n  \"gem\": $fa-var-gem,\n  \"dolly\": $fa-var-dolly,\n  \"dolly-box\": $fa-var-dolly-box,\n  \"smoking\": $fa-var-smoking,\n  \"minimize\": $fa-var-minimize,\n  \"compress-arrows-alt\": $fa-var-compress-arrows-alt,\n  \"monument\": $fa-var-monument,\n  \"snowplow\": $fa-var-snowplow,\n  \"angles-right\": $fa-var-angles-right,\n  \"angle-double-right\": $fa-var-angle-double-right,\n  \"cannabis\": $fa-var-cannabis,\n  \"circle-play\": $fa-var-circle-play,\n  \"play-circle\": $fa-var-play-circle,\n  \"tablets\": $fa-var-tablets,\n  \"ethernet\": $fa-var-ethernet,\n  \"euro-sign\": $fa-var-euro-sign,\n  \"eur\": $fa-var-eur,\n  \"euro\": $fa-var-euro,\n  \"chair\": $fa-var-chair,\n  \"circle-check\": $fa-var-circle-check,\n  \"check-circle\": $fa-var-check-circle,\n  \"circle-stop\": $fa-var-circle-stop,\n  \"stop-circle\": $fa-var-stop-circle,\n  \"compass-drafting\": $fa-var-compass-drafting,\n  \"drafting-compass\": $fa-var-drafting-compass,\n  \"plate-wheat\": $fa-var-plate-wheat,\n  \"icicles\": $fa-var-icicles,\n  \"person-shelter\": $fa-var-person-shelter,\n  \"neuter\": $fa-var-neuter,\n  \"id-badge\": $fa-var-id-badge,\n  \"marker\": $fa-var-marker,\n  \"face-laugh-beam\": $fa-var-face-laugh-beam,\n  \"laugh-beam\": $fa-var-laugh-beam,\n  \"helicopter-symbol\": $fa-var-helicopter-symbol,\n  \"universal-access\": $fa-var-universal-access,\n  \"circle-chevron-up\": $fa-var-circle-chevron-up,\n  \"chevron-circle-up\": $fa-var-chevron-circle-up,\n  \"lari-sign\": $fa-var-lari-sign,\n  \"volcano\": $fa-var-volcano,\n  \"person-walking-dashed-line-arrow-right\": $fa-var-person-walking-dashed-line-arrow-right,\n  \"sterling-sign\": $fa-var-sterling-sign,\n  \"gbp\": $fa-var-gbp,\n  \"pound-sign\": $fa-var-pound-sign,\n  \"viruses\": $fa-var-viruses,\n  \"square-person-confined\": $fa-var-square-person-confined,\n  \"user-tie\": $fa-var-user-tie,\n  \"arrow-down-long\": $fa-var-arrow-down-long,\n  \"long-arrow-down\": $fa-var-long-arrow-down,\n  \"tent-arrow-down-to-line\": $fa-var-tent-arrow-down-to-line,\n  \"certificate\": $fa-var-certificate,\n  \"reply-all\": $fa-var-reply-all,\n  \"mail-reply-all\": $fa-var-mail-reply-all,\n  \"suitcase\": $fa-var-suitcase,\n  \"person-skating\": $fa-var-person-skating,\n  \"skating\": $fa-var-skating,\n  \"filter-circle-dollar\": $fa-var-filter-circle-dollar,\n  \"funnel-dollar\": $fa-var-funnel-dollar,\n  \"camera-retro\": $fa-var-camera-retro,\n  \"circle-arrow-down\": $fa-var-circle-arrow-down,\n  \"arrow-circle-down\": $fa-var-arrow-circle-down,\n  \"file-import\": $fa-var-file-import,\n  \"arrow-right-to-file\": $fa-var-arrow-right-to-file,\n  \"square-arrow-up-right\": $fa-var-square-arrow-up-right,\n  \"external-link-square\": $fa-var-external-link-square,\n  \"box-open\": $fa-var-box-open,\n  \"scroll\": $fa-var-scroll,\n  \"spa\": $fa-var-spa,\n  \"location-pin-lock\": $fa-var-location-pin-lock,\n  \"pause\": $fa-var-pause,\n  \"hill-avalanche\": $fa-var-hill-avalanche,\n  \"temperature-empty\": $fa-var-temperature-empty,\n  \"temperature-0\": $fa-var-temperature-0,\n  \"thermometer-0\": $fa-var-thermometer-0,\n  \"thermometer-empty\": $fa-var-thermometer-empty,\n  \"bomb\": $fa-var-bomb,\n  \"registered\": $fa-var-registered,\n  \"address-card\": $fa-var-address-card,\n  \"contact-card\": $fa-var-contact-card,\n  \"vcard\": $fa-var-vcard,\n  \"scale-unbalanced-flip\": $fa-var-scale-unbalanced-flip,\n  \"balance-scale-right\": $fa-var-balance-scale-right,\n  \"subscript\": $fa-var-subscript,\n  \"diamond-turn-right\": $fa-var-diamond-turn-right,\n  \"directions\": $fa-var-directions,\n  \"burst\": $fa-var-burst,\n  \"house-laptop\": $fa-var-house-laptop,\n  \"laptop-house\": $fa-var-laptop-house,\n  \"face-tired\": $fa-var-face-tired,\n  \"tired\": $fa-var-tired,\n  \"money-bills\": $fa-var-money-bills,\n  \"smog\": $fa-var-smog,\n  \"crutch\": $fa-var-crutch,\n  \"cloud-arrow-up\": $fa-var-cloud-arrow-up,\n  \"cloud-upload\": $fa-var-cloud-upload,\n  \"cloud-upload-alt\": $fa-var-cloud-upload-alt,\n  \"palette\": $fa-var-palette,\n  \"arrows-turn-right\": $fa-var-arrows-turn-right,\n  \"vest\": $fa-var-vest,\n  \"ferry\": $fa-var-ferry,\n  \"arrows-down-to-people\": $fa-var-arrows-down-to-people,\n  \"seedling\": $fa-var-seedling,\n  \"sprout\": $fa-var-sprout,\n  \"left-right\": $fa-var-left-right,\n  \"arrows-alt-h\": $fa-var-arrows-alt-h,\n  \"boxes-packing\": $fa-var-boxes-packing,\n  \"circle-arrow-left\": $fa-var-circle-arrow-left,\n  \"arrow-circle-left\": $fa-var-arrow-circle-left,\n  \"group-arrows-rotate\": $fa-var-group-arrows-rotate,\n  \"bowl-food\": $fa-var-bowl-food,\n  \"candy-cane\": $fa-var-candy-cane,\n  \"arrow-down-wide-short\": $fa-var-arrow-down-wide-short,\n  \"sort-amount-asc\": $fa-var-sort-amount-asc,\n  \"sort-amount-down\": $fa-var-sort-amount-down,\n  \"cloud-bolt\": $fa-var-cloud-bolt,\n  \"thunderstorm\": $fa-var-thunderstorm,\n  \"text-slash\": $fa-var-text-slash,\n  \"remove-format\": $fa-var-remove-format,\n  \"face-smile-wink\": $fa-var-face-smile-wink,\n  \"smile-wink\": $fa-var-smile-wink,\n  \"file-word\": $fa-var-file-word,\n  \"file-powerpoint\": $fa-var-file-powerpoint,\n  \"arrows-left-right\": $fa-var-arrows-left-right,\n  \"arrows-h\": $fa-var-arrows-h,\n  \"house-lock\": $fa-var-house-lock,\n  \"cloud-arrow-down\": $fa-var-cloud-arrow-down,\n  \"cloud-download\": $fa-var-cloud-download,\n  \"cloud-download-alt\": $fa-var-cloud-download-alt,\n  \"children\": $fa-var-children,\n  \"chalkboard\": $fa-var-chalkboard,\n  \"blackboard\": $fa-var-blackboard,\n  \"user-large-slash\": $fa-var-user-large-slash,\n  \"user-alt-slash\": $fa-var-user-alt-slash,\n  \"envelope-open\": $fa-var-envelope-open,\n  \"handshake-simple-slash\": $fa-var-handshake-simple-slash,\n  \"handshake-alt-slash\": $fa-var-handshake-alt-slash,\n  \"mattress-pillow\": $fa-var-mattress-pillow,\n  \"guarani-sign\": $fa-var-guarani-sign,\n  \"arrows-rotate\": $fa-var-arrows-rotate,\n  \"refresh\": $fa-var-refresh,\n  \"sync\": $fa-var-sync,\n  \"fire-extinguisher\": $fa-var-fire-extinguisher,\n  \"cruzeiro-sign\": $fa-var-cruzeiro-sign,\n  \"greater-than-equal\": $fa-var-greater-than-equal,\n  \"shield-halved\": $fa-var-shield-halved,\n  \"shield-alt\": $fa-var-shield-alt,\n  \"book-atlas\": $fa-var-book-atlas,\n  \"atlas\": $fa-var-atlas,\n  \"virus\": $fa-var-virus,\n  \"envelope-circle-check\": $fa-var-envelope-circle-check,\n  \"layer-group\": $fa-var-layer-group,\n  \"arrows-to-dot\": $fa-var-arrows-to-dot,\n  \"archway\": $fa-var-archway,\n  \"heart-circle-check\": $fa-var-heart-circle-check,\n  \"house-chimney-crack\": $fa-var-house-chimney-crack,\n  \"house-damage\": $fa-var-house-damage,\n  \"file-zipper\": $fa-var-file-zipper,\n  \"file-archive\": $fa-var-file-archive,\n  \"square\": $fa-var-square,\n  \"martini-glass-empty\": $fa-var-martini-glass-empty,\n  \"glass-martini\": $fa-var-glass-martini,\n  \"couch\": $fa-var-couch,\n  \"cedi-sign\": $fa-var-cedi-sign,\n  \"italic\": $fa-var-italic,\n  \"table-cells-column-lock\": $fa-var-table-cells-column-lock,\n  \"church\": $fa-var-church,\n  \"comments-dollar\": $fa-var-comments-dollar,\n  \"democrat\": $fa-var-democrat,\n  \"z\": $fa-var-z,\n  \"person-skiing\": $fa-var-person-skiing,\n  \"skiing\": $fa-var-skiing,\n  \"road-lock\": $fa-var-road-lock,\n  \"a\": $fa-var-a,\n  \"temperature-arrow-down\": $fa-var-temperature-arrow-down,\n  \"temperature-down\": $fa-var-temperature-down,\n  \"feather-pointed\": $fa-var-feather-pointed,\n  \"feather-alt\": $fa-var-feather-alt,\n  \"p\": $fa-var-p,\n  \"snowflake\": $fa-var-snowflake,\n  \"newspaper\": $fa-var-newspaper,\n  \"rectangle-ad\": $fa-var-rectangle-ad,\n  \"ad\": $fa-var-ad,\n  \"circle-arrow-right\": $fa-var-circle-arrow-right,\n  \"arrow-circle-right\": $fa-var-arrow-circle-right,\n  \"filter-circle-xmark\": $fa-var-filter-circle-xmark,\n  \"locust\": $fa-var-locust,\n  \"sort\": $fa-var-sort,\n  \"unsorted\": $fa-var-unsorted,\n  \"list-ol\": $fa-var-list-ol,\n  \"list-1-2\": $fa-var-list-1-2,\n  \"list-numeric\": $fa-var-list-numeric,\n  \"person-dress-burst\": $fa-var-person-dress-burst,\n  \"money-check-dollar\": $fa-var-money-check-dollar,\n  \"money-check-alt\": $fa-var-money-check-alt,\n  \"vector-square\": $fa-var-vector-square,\n  \"bread-slice\": $fa-var-bread-slice,\n  \"language\": $fa-var-language,\n  \"face-kiss-wink-heart\": $fa-var-face-kiss-wink-heart,\n  \"kiss-wink-heart\": $fa-var-kiss-wink-heart,\n  \"filter\": $fa-var-filter,\n  \"question\": $fa-var-question,\n  \"file-signature\": $fa-var-file-signature,\n  \"up-down-left-right\": $fa-var-up-down-left-right,\n  \"arrows-alt\": $fa-var-arrows-alt,\n  \"house-chimney-user\": $fa-var-house-chimney-user,\n  \"hand-holding-heart\": $fa-var-hand-holding-heart,\n  \"puzzle-piece\": $fa-var-puzzle-piece,\n  \"money-check\": $fa-var-money-check,\n  \"star-half-stroke\": $fa-var-star-half-stroke,\n  \"star-half-alt\": $fa-var-star-half-alt,\n  \"code\": $fa-var-code,\n  \"whiskey-glass\": $fa-var-whiskey-glass,\n  \"glass-whiskey\": $fa-var-glass-whiskey,\n  \"building-circle-exclamation\": $fa-var-building-circle-exclamation,\n  \"magnifying-glass-chart\": $fa-var-magnifying-glass-chart,\n  \"arrow-up-right-from-square\": $fa-var-arrow-up-right-from-square,\n  \"external-link\": $fa-var-external-link,\n  \"cubes-stacked\": $fa-var-cubes-stacked,\n  \"won-sign\": $fa-var-won-sign,\n  \"krw\": $fa-var-krw,\n  \"won\": $fa-var-won,\n  \"virus-covid\": $fa-var-virus-covid,\n  \"austral-sign\": $fa-var-austral-sign,\n  \"f\": $fa-var-f,\n  \"leaf\": $fa-var-leaf,\n  \"road\": $fa-var-road,\n  \"taxi\": $fa-var-taxi,\n  \"cab\": $fa-var-cab,\n  \"person-circle-plus\": $fa-var-person-circle-plus,\n  \"chart-pie\": $fa-var-chart-pie,\n  \"pie-chart\": $fa-var-pie-chart,\n  \"bolt-lightning\": $fa-var-bolt-lightning,\n  \"sack-xmark\": $fa-var-sack-xmark,\n  \"file-excel\": $fa-var-file-excel,\n  \"file-contract\": $fa-var-file-contract,\n  \"fish-fins\": $fa-var-fish-fins,\n  \"building-flag\": $fa-var-building-flag,\n  \"face-grin-beam\": $fa-var-face-grin-beam,\n  \"grin-beam\": $fa-var-grin-beam,\n  \"object-ungroup\": $fa-var-object-ungroup,\n  \"poop\": $fa-var-poop,\n  \"location-pin\": $fa-var-location-pin,\n  \"map-marker\": $fa-var-map-marker,\n  \"kaaba\": $fa-var-kaaba,\n  \"toilet-paper\": $fa-var-toilet-paper,\n  \"helmet-safety\": $fa-var-helmet-safety,\n  \"hard-hat\": $fa-var-hard-hat,\n  \"hat-hard\": $fa-var-hat-hard,\n  \"eject\": $fa-var-eject,\n  \"circle-right\": $fa-var-circle-right,\n  \"arrow-alt-circle-right\": $fa-var-arrow-alt-circle-right,\n  \"plane-circle-check\": $fa-var-plane-circle-check,\n  \"face-rolling-eyes\": $fa-var-face-rolling-eyes,\n  \"meh-rolling-eyes\": $fa-var-meh-rolling-eyes,\n  \"object-group\": $fa-var-object-group,\n  \"chart-line\": $fa-var-chart-line,\n  \"line-chart\": $fa-var-line-chart,\n  \"mask-ventilator\": $fa-var-mask-ventilator,\n  \"arrow-right\": $fa-var-arrow-right,\n  \"signs-post\": $fa-var-signs-post,\n  \"map-signs\": $fa-var-map-signs,\n  \"cash-register\": $fa-var-cash-register,\n  \"person-circle-question\": $fa-var-person-circle-question,\n  \"h\": $fa-var-h,\n  \"tarp\": $fa-var-tarp,\n  \"screwdriver-wrench\": $fa-var-screwdriver-wrench,\n  \"tools\": $fa-var-tools,\n  \"arrows-to-eye\": $fa-var-arrows-to-eye,\n  \"plug-circle-bolt\": $fa-var-plug-circle-bolt,\n  \"heart\": $fa-var-heart,\n  \"mars-and-venus\": $fa-var-mars-and-venus,\n  \"house-user\": $fa-var-house-user,\n  \"home-user\": $fa-var-home-user,\n  \"dumpster-fire\": $fa-var-dumpster-fire,\n  \"house-crack\": $fa-var-house-crack,\n  \"martini-glass-citrus\": $fa-var-martini-glass-citrus,\n  \"cocktail\": $fa-var-cocktail,\n  \"face-surprise\": $fa-var-face-surprise,\n  \"surprise\": $fa-var-surprise,\n  \"bottle-water\": $fa-var-bottle-water,\n  \"circle-pause\": $fa-var-circle-pause,\n  \"pause-circle\": $fa-var-pause-circle,\n  \"toilet-paper-slash\": $fa-var-toilet-paper-slash,\n  \"apple-whole\": $fa-var-apple-whole,\n  \"apple-alt\": $fa-var-apple-alt,\n  \"kitchen-set\": $fa-var-kitchen-set,\n  \"r\": $fa-var-r,\n  \"temperature-quarter\": $fa-var-temperature-quarter,\n  \"temperature-1\": $fa-var-temperature-1,\n  \"thermometer-1\": $fa-var-thermometer-1,\n  \"thermometer-quarter\": $fa-var-thermometer-quarter,\n  \"cube\": $fa-var-cube,\n  \"bitcoin-sign\": $fa-var-bitcoin-sign,\n  \"shield-dog\": $fa-var-shield-dog,\n  \"solar-panel\": $fa-var-solar-panel,\n  \"lock-open\": $fa-var-lock-open,\n  \"elevator\": $fa-var-elevator,\n  \"money-bill-transfer\": $fa-var-money-bill-transfer,\n  \"money-bill-trend-up\": $fa-var-money-bill-trend-up,\n  \"house-flood-water-circle-arrow-right\": $fa-var-house-flood-water-circle-arrow-right,\n  \"square-poll-horizontal\": $fa-var-square-poll-horizontal,\n  \"poll-h\": $fa-var-poll-h,\n  \"circle\": $fa-var-circle,\n  \"backward-fast\": $fa-var-backward-fast,\n  \"fast-backward\": $fa-var-fast-backward,\n  \"recycle\": $fa-var-recycle,\n  \"user-astronaut\": $fa-var-user-astronaut,\n  \"plane-slash\": $fa-var-plane-slash,\n  \"trademark\": $fa-var-trademark,\n  \"basketball\": $fa-var-basketball,\n  \"basketball-ball\": $fa-var-basketball-ball,\n  \"satellite-dish\": $fa-var-satellite-dish,\n  \"circle-up\": $fa-var-circle-up,\n  \"arrow-alt-circle-up\": $fa-var-arrow-alt-circle-up,\n  \"mobile-screen-button\": $fa-var-mobile-screen-button,\n  \"mobile-alt\": $fa-var-mobile-alt,\n  \"volume-high\": $fa-var-volume-high,\n  \"volume-up\": $fa-var-volume-up,\n  \"users-rays\": $fa-var-users-rays,\n  \"wallet\": $fa-var-wallet,\n  \"clipboard-check\": $fa-var-clipboard-check,\n  \"file-audio\": $fa-var-file-audio,\n  \"burger\": $fa-var-burger,\n  \"hamburger\": $fa-var-hamburger,\n  \"wrench\": $fa-var-wrench,\n  \"bugs\": $fa-var-bugs,\n  \"rupee-sign\": $fa-var-rupee-sign,\n  \"rupee\": $fa-var-rupee,\n  \"file-image\": $fa-var-file-image,\n  \"circle-question\": $fa-var-circle-question,\n  \"question-circle\": $fa-var-question-circle,\n  \"plane-departure\": $fa-var-plane-departure,\n  \"handshake-slash\": $fa-var-handshake-slash,\n  \"book-bookmark\": $fa-var-book-bookmark,\n  \"code-branch\": $fa-var-code-branch,\n  \"hat-cowboy\": $fa-var-hat-cowboy,\n  \"bridge\": $fa-var-bridge,\n  \"phone-flip\": $fa-var-phone-flip,\n  \"phone-alt\": $fa-var-phone-alt,\n  \"truck-front\": $fa-var-truck-front,\n  \"cat\": $fa-var-cat,\n  \"anchor-circle-exclamation\": $fa-var-anchor-circle-exclamation,\n  \"truck-field\": $fa-var-truck-field,\n  \"route\": $fa-var-route,\n  \"clipboard-question\": $fa-var-clipboard-question,\n  \"panorama\": $fa-var-panorama,\n  \"comment-medical\": $fa-var-comment-medical,\n  \"teeth-open\": $fa-var-teeth-open,\n  \"file-circle-minus\": $fa-var-file-circle-minus,\n  \"tags\": $fa-var-tags,\n  \"wine-glass\": $fa-var-wine-glass,\n  \"forward-fast\": $fa-var-forward-fast,\n  \"fast-forward\": $fa-var-fast-forward,\n  \"face-meh-blank\": $fa-var-face-meh-blank,\n  \"meh-blank\": $fa-var-meh-blank,\n  \"square-parking\": $fa-var-square-parking,\n  \"parking\": $fa-var-parking,\n  \"house-signal\": $fa-var-house-signal,\n  \"bars-progress\": $fa-var-bars-progress,\n  \"tasks-alt\": $fa-var-tasks-alt,\n  \"faucet-drip\": $fa-var-faucet-drip,\n  \"cart-flatbed\": $fa-var-cart-flatbed,\n  \"dolly-flatbed\": $fa-var-dolly-flatbed,\n  \"ban-smoking\": $fa-var-ban-smoking,\n  \"smoking-ban\": $fa-var-smoking-ban,\n  \"terminal\": $fa-var-terminal,\n  \"mobile-button\": $fa-var-mobile-button,\n  \"house-medical-flag\": $fa-var-house-medical-flag,\n  \"basket-shopping\": $fa-var-basket-shopping,\n  \"shopping-basket\": $fa-var-shopping-basket,\n  \"tape\": $fa-var-tape,\n  \"bus-simple\": $fa-var-bus-simple,\n  \"bus-alt\": $fa-var-bus-alt,\n  \"eye\": $fa-var-eye,\n  \"face-sad-cry\": $fa-var-face-sad-cry,\n  \"sad-cry\": $fa-var-sad-cry,\n  \"audio-description\": $fa-var-audio-description,\n  \"person-military-to-person\": $fa-var-person-military-to-person,\n  \"file-shield\": $fa-var-file-shield,\n  \"user-slash\": $fa-var-user-slash,\n  \"pen\": $fa-var-pen,\n  \"tower-observation\": $fa-var-tower-observation,\n  \"file-code\": $fa-var-file-code,\n  \"signal\": $fa-var-signal,\n  \"signal-5\": $fa-var-signal-5,\n  \"signal-perfect\": $fa-var-signal-perfect,\n  \"bus\": $fa-var-bus,\n  \"heart-circle-xmark\": $fa-var-heart-circle-xmark,\n  \"house-chimney\": $fa-var-house-chimney,\n  \"home-lg\": $fa-var-home-lg,\n  \"window-maximize\": $fa-var-window-maximize,\n  \"face-frown\": $fa-var-face-frown,\n  \"frown\": $fa-var-frown,\n  \"prescription\": $fa-var-prescription,\n  \"shop\": $fa-var-shop,\n  \"store-alt\": $fa-var-store-alt,\n  \"floppy-disk\": $fa-var-floppy-disk,\n  \"save\": $fa-var-save,\n  \"vihara\": $fa-var-vihara,\n  \"scale-unbalanced\": $fa-var-scale-unbalanced,\n  \"balance-scale-left\": $fa-var-balance-scale-left,\n  \"sort-up\": $fa-var-sort-up,\n  \"sort-asc\": $fa-var-sort-asc,\n  \"comment-dots\": $fa-var-comment-dots,\n  \"commenting\": $fa-var-commenting,\n  \"plant-wilt\": $fa-var-plant-wilt,\n  \"diamond\": $fa-var-diamond,\n  \"face-grin-squint\": $fa-var-face-grin-squint,\n  \"grin-squint\": $fa-var-grin-squint,\n  \"hand-holding-dollar\": $fa-var-hand-holding-dollar,\n  \"hand-holding-usd\": $fa-var-hand-holding-usd,\n  \"chart-diagram\": $fa-var-chart-diagram,\n  \"bacterium\": $fa-var-bacterium,\n  \"hand-pointer\": $fa-var-hand-pointer,\n  \"drum-steelpan\": $fa-var-drum-steelpan,\n  \"hand-scissors\": $fa-var-hand-scissors,\n  \"hands-praying\": $fa-var-hands-praying,\n  \"praying-hands\": $fa-var-praying-hands,\n  \"arrow-rotate-right\": $fa-var-arrow-rotate-right,\n  \"arrow-right-rotate\": $fa-var-arrow-right-rotate,\n  \"arrow-rotate-forward\": $fa-var-arrow-rotate-forward,\n  \"redo\": $fa-var-redo,\n  \"biohazard\": $fa-var-biohazard,\n  \"location-crosshairs\": $fa-var-location-crosshairs,\n  \"location\": $fa-var-location,\n  \"mars-double\": $fa-var-mars-double,\n  \"child-dress\": $fa-var-child-dress,\n  \"users-between-lines\": $fa-var-users-between-lines,\n  \"lungs-virus\": $fa-var-lungs-virus,\n  \"face-grin-tears\": $fa-var-face-grin-tears,\n  \"grin-tears\": $fa-var-grin-tears,\n  \"phone\": $fa-var-phone,\n  \"calendar-xmark\": $fa-var-calendar-xmark,\n  \"calendar-times\": $fa-var-calendar-times,\n  \"child-reaching\": $fa-var-child-reaching,\n  \"head-side-virus\": $fa-var-head-side-virus,\n  \"user-gear\": $fa-var-user-gear,\n  \"user-cog\": $fa-var-user-cog,\n  \"arrow-up-1-9\": $fa-var-arrow-up-1-9,\n  \"sort-numeric-up\": $fa-var-sort-numeric-up,\n  \"door-closed\": $fa-var-door-closed,\n  \"shield-virus\": $fa-var-shield-virus,\n  \"dice-six\": $fa-var-dice-six,\n  \"mosquito-net\": $fa-var-mosquito-net,\n  \"file-fragment\": $fa-var-file-fragment,\n  \"bridge-water\": $fa-var-bridge-water,\n  \"person-booth\": $fa-var-person-booth,\n  \"text-width\": $fa-var-text-width,\n  \"hat-wizard\": $fa-var-hat-wizard,\n  \"pen-fancy\": $fa-var-pen-fancy,\n  \"person-digging\": $fa-var-person-digging,\n  \"digging\": $fa-var-digging,\n  \"trash\": $fa-var-trash,\n  \"gauge-simple\": $fa-var-gauge-simple,\n  \"gauge-simple-med\": $fa-var-gauge-simple-med,\n  \"tachometer-average\": $fa-var-tachometer-average,\n  \"book-medical\": $fa-var-book-medical,\n  \"poo\": $fa-var-poo,\n  \"quote-right\": $fa-var-quote-right,\n  \"quote-right-alt\": $fa-var-quote-right-alt,\n  \"shirt\": $fa-var-shirt,\n  \"t-shirt\": $fa-var-t-shirt,\n  \"tshirt\": $fa-var-tshirt,\n  \"cubes\": $fa-var-cubes,\n  \"divide\": $fa-var-divide,\n  \"tenge-sign\": $fa-var-tenge-sign,\n  \"tenge\": $fa-var-tenge,\n  \"headphones\": $fa-var-headphones,\n  \"hands-holding\": $fa-var-hands-holding,\n  \"hands-clapping\": $fa-var-hands-clapping,\n  \"republican\": $fa-var-republican,\n  \"arrow-left\": $fa-var-arrow-left,\n  \"person-circle-xmark\": $fa-var-person-circle-xmark,\n  \"ruler\": $fa-var-ruler,\n  \"align-left\": $fa-var-align-left,\n  \"dice-d6\": $fa-var-dice-d6,\n  \"restroom\": $fa-var-restroom,\n  \"j\": $fa-var-j,\n  \"users-viewfinder\": $fa-var-users-viewfinder,\n  \"file-video\": $fa-var-file-video,\n  \"up-right-from-square\": $fa-var-up-right-from-square,\n  \"external-link-alt\": $fa-var-external-link-alt,\n  \"table-cells\": $fa-var-table-cells,\n  \"th\": $fa-var-th,\n  \"file-pdf\": $fa-var-file-pdf,\n  \"book-bible\": $fa-var-book-bible,\n  \"bible\": $fa-var-bible,\n  \"o\": $fa-var-o,\n  \"suitcase-medical\": $fa-var-suitcase-medical,\n  \"medkit\": $fa-var-medkit,\n  \"user-secret\": $fa-var-user-secret,\n  \"otter\": $fa-var-otter,\n  \"person-dress\": $fa-var-person-dress,\n  \"female\": $fa-var-female,\n  \"comment-dollar\": $fa-var-comment-dollar,\n  \"business-time\": $fa-var-business-time,\n  \"briefcase-clock\": $fa-var-briefcase-clock,\n  \"table-cells-large\": $fa-var-table-cells-large,\n  \"th-large\": $fa-var-th-large,\n  \"book-tanakh\": $fa-var-book-tanakh,\n  \"tanakh\": $fa-var-tanakh,\n  \"phone-volume\": $fa-var-phone-volume,\n  \"volume-control-phone\": $fa-var-volume-control-phone,\n  \"hat-cowboy-side\": $fa-var-hat-cowboy-side,\n  \"clipboard-user\": $fa-var-clipboard-user,\n  \"child\": $fa-var-child,\n  \"lira-sign\": $fa-var-lira-sign,\n  \"satellite\": $fa-var-satellite,\n  \"plane-lock\": $fa-var-plane-lock,\n  \"tag\": $fa-var-tag,\n  \"comment\": $fa-var-comment,\n  \"cake-candles\": $fa-var-cake-candles,\n  \"birthday-cake\": $fa-var-birthday-cake,\n  \"cake\": $fa-var-cake,\n  \"envelope\": $fa-var-envelope,\n  \"angles-up\": $fa-var-angles-up,\n  \"angle-double-up\": $fa-var-angle-double-up,\n  \"paperclip\": $fa-var-paperclip,\n  \"arrow-right-to-city\": $fa-var-arrow-right-to-city,\n  \"ribbon\": $fa-var-ribbon,\n  \"lungs\": $fa-var-lungs,\n  \"arrow-up-9-1\": $fa-var-arrow-up-9-1,\n  \"sort-numeric-up-alt\": $fa-var-sort-numeric-up-alt,\n  \"litecoin-sign\": $fa-var-litecoin-sign,\n  \"border-none\": $fa-var-border-none,\n  \"circle-nodes\": $fa-var-circle-nodes,\n  \"parachute-box\": $fa-var-parachute-box,\n  \"indent\": $fa-var-indent,\n  \"truck-field-un\": $fa-var-truck-field-un,\n  \"hourglass\": $fa-var-hourglass,\n  \"hourglass-empty\": $fa-var-hourglass-empty,\n  \"mountain\": $fa-var-mountain,\n  \"user-doctor\": $fa-var-user-doctor,\n  \"user-md\": $fa-var-user-md,\n  \"circle-info\": $fa-var-circle-info,\n  \"info-circle\": $fa-var-info-circle,\n  \"cloud-meatball\": $fa-var-cloud-meatball,\n  \"camera\": $fa-var-camera,\n  \"camera-alt\": $fa-var-camera-alt,\n  \"square-virus\": $fa-var-square-virus,\n  \"meteor\": $fa-var-meteor,\n  \"car-on\": $fa-var-car-on,\n  \"sleigh\": $fa-var-sleigh,\n  \"arrow-down-1-9\": $fa-var-arrow-down-1-9,\n  \"sort-numeric-asc\": $fa-var-sort-numeric-asc,\n  \"sort-numeric-down\": $fa-var-sort-numeric-down,\n  \"hand-holding-droplet\": $fa-var-hand-holding-droplet,\n  \"hand-holding-water\": $fa-var-hand-holding-water,\n  \"water\": $fa-var-water,\n  \"calendar-check\": $fa-var-calendar-check,\n  \"braille\": $fa-var-braille,\n  \"prescription-bottle-medical\": $fa-var-prescription-bottle-medical,\n  \"prescription-bottle-alt\": $fa-var-prescription-bottle-alt,\n  \"landmark\": $fa-var-landmark,\n  \"truck\": $fa-var-truck,\n  \"crosshairs\": $fa-var-crosshairs,\n  \"person-cane\": $fa-var-person-cane,\n  \"tent\": $fa-var-tent,\n  \"vest-patches\": $fa-var-vest-patches,\n  \"check-double\": $fa-var-check-double,\n  \"arrow-down-a-z\": $fa-var-arrow-down-a-z,\n  \"sort-alpha-asc\": $fa-var-sort-alpha-asc,\n  \"sort-alpha-down\": $fa-var-sort-alpha-down,\n  \"money-bill-wheat\": $fa-var-money-bill-wheat,\n  \"cookie\": $fa-var-cookie,\n  \"arrow-rotate-left\": $fa-var-arrow-rotate-left,\n  \"arrow-left-rotate\": $fa-var-arrow-left-rotate,\n  \"arrow-rotate-back\": $fa-var-arrow-rotate-back,\n  \"arrow-rotate-backward\": $fa-var-arrow-rotate-backward,\n  \"undo\": $fa-var-undo,\n  \"hard-drive\": $fa-var-hard-drive,\n  \"hdd\": $fa-var-hdd,\n  \"face-grin-squint-tears\": $fa-var-face-grin-squint-tears,\n  \"grin-squint-tears\": $fa-var-grin-squint-tears,\n  \"dumbbell\": $fa-var-dumbbell,\n  \"rectangle-list\": $fa-var-rectangle-list,\n  \"list-alt\": $fa-var-list-alt,\n  \"tarp-droplet\": $fa-var-tarp-droplet,\n  \"house-medical-circle-check\": $fa-var-house-medical-circle-check,\n  \"person-skiing-nordic\": $fa-var-person-skiing-nordic,\n  \"skiing-nordic\": $fa-var-skiing-nordic,\n  \"calendar-plus\": $fa-var-calendar-plus,\n  \"plane-arrival\": $fa-var-plane-arrival,\n  \"circle-left\": $fa-var-circle-left,\n  \"arrow-alt-circle-left\": $fa-var-arrow-alt-circle-left,\n  \"train-subway\": $fa-var-train-subway,\n  \"subway\": $fa-var-subway,\n  \"chart-gantt\": $fa-var-chart-gantt,\n  \"indian-rupee-sign\": $fa-var-indian-rupee-sign,\n  \"indian-rupee\": $fa-var-indian-rupee,\n  \"inr\": $fa-var-inr,\n  \"crop-simple\": $fa-var-crop-simple,\n  \"crop-alt\": $fa-var-crop-alt,\n  \"money-bill-1\": $fa-var-money-bill-1,\n  \"money-bill-alt\": $fa-var-money-bill-alt,\n  \"left-long\": $fa-var-left-long,\n  \"long-arrow-alt-left\": $fa-var-long-arrow-alt-left,\n  \"dna\": $fa-var-dna,\n  \"virus-slash\": $fa-var-virus-slash,\n  \"minus\": $fa-var-minus,\n  \"subtract\": $fa-var-subtract,\n  \"chess\": $fa-var-chess,\n  \"arrow-left-long\": $fa-var-arrow-left-long,\n  \"long-arrow-left\": $fa-var-long-arrow-left,\n  \"plug-circle-check\": $fa-var-plug-circle-check,\n  \"street-view\": $fa-var-street-view,\n  \"franc-sign\": $fa-var-franc-sign,\n  \"volume-off\": $fa-var-volume-off,\n  \"hands-asl-interpreting\": $fa-var-hands-asl-interpreting,\n  \"american-sign-language-interpreting\": $fa-var-american-sign-language-interpreting,\n  \"asl-interpreting\": $fa-var-asl-interpreting,\n  \"hands-american-sign-language-interpreting\": $fa-var-hands-american-sign-language-interpreting,\n  \"gear\": $fa-var-gear,\n  \"cog\": $fa-var-cog,\n  \"droplet-slash\": $fa-var-droplet-slash,\n  \"tint-slash\": $fa-var-tint-slash,\n  \"mosque\": $fa-var-mosque,\n  \"mosquito\": $fa-var-mosquito,\n  \"star-of-david\": $fa-var-star-of-david,\n  \"person-military-rifle\": $fa-var-person-military-rifle,\n  \"cart-shopping\": $fa-var-cart-shopping,\n  \"shopping-cart\": $fa-var-shopping-cart,\n  \"vials\": $fa-var-vials,\n  \"plug-circle-plus\": $fa-var-plug-circle-plus,\n  \"place-of-worship\": $fa-var-place-of-worship,\n  \"grip-vertical\": $fa-var-grip-vertical,\n  \"hexagon-nodes\": $fa-var-hexagon-nodes,\n  \"arrow-turn-up\": $fa-var-arrow-turn-up,\n  \"level-up\": $fa-var-level-up,\n  \"u\": $fa-var-u,\n  \"square-root-variable\": $fa-var-square-root-variable,\n  \"square-root-alt\": $fa-var-square-root-alt,\n  \"clock\": $fa-var-clock,\n  \"clock-four\": $fa-var-clock-four,\n  \"backward-step\": $fa-var-backward-step,\n  \"step-backward\": $fa-var-step-backward,\n  \"pallet\": $fa-var-pallet,\n  \"faucet\": $fa-var-faucet,\n  \"baseball-bat-ball\": $fa-var-baseball-bat-ball,\n  \"s\": $fa-var-s,\n  \"timeline\": $fa-var-timeline,\n  \"keyboard\": $fa-var-keyboard,\n  \"caret-down\": $fa-var-caret-down,\n  \"house-chimney-medical\": $fa-var-house-chimney-medical,\n  \"clinic-medical\": $fa-var-clinic-medical,\n  \"temperature-three-quarters\": $fa-var-temperature-three-quarters,\n  \"temperature-3\": $fa-var-temperature-3,\n  \"thermometer-3\": $fa-var-thermometer-3,\n  \"thermometer-three-quarters\": $fa-var-thermometer-three-quarters,\n  \"mobile-screen\": $fa-var-mobile-screen,\n  \"mobile-android-alt\": $fa-var-mobile-android-alt,\n  \"plane-up\": $fa-var-plane-up,\n  \"piggy-bank\": $fa-var-piggy-bank,\n  \"battery-half\": $fa-var-battery-half,\n  \"battery-3\": $fa-var-battery-3,\n  \"mountain-city\": $fa-var-mountain-city,\n  \"coins\": $fa-var-coins,\n  \"khanda\": $fa-var-khanda,\n  \"sliders\": $fa-var-sliders,\n  \"sliders-h\": $fa-var-sliders-h,\n  \"folder-tree\": $fa-var-folder-tree,\n  \"network-wired\": $fa-var-network-wired,\n  \"map-pin\": $fa-var-map-pin,\n  \"hamsa\": $fa-var-hamsa,\n  \"cent-sign\": $fa-var-cent-sign,\n  \"flask\": $fa-var-flask,\n  \"person-pregnant\": $fa-var-person-pregnant,\n  \"wand-sparkles\": $fa-var-wand-sparkles,\n  \"ellipsis-vertical\": $fa-var-ellipsis-vertical,\n  \"ellipsis-v\": $fa-var-ellipsis-v,\n  \"ticket\": $fa-var-ticket,\n  \"power-off\": $fa-var-power-off,\n  \"right-long\": $fa-var-right-long,\n  \"long-arrow-alt-right\": $fa-var-long-arrow-alt-right,\n  \"flag-usa\": $fa-var-flag-usa,\n  \"laptop-file\": $fa-var-laptop-file,\n  \"tty\": $fa-var-tty,\n  \"teletype\": $fa-var-teletype,\n  \"diagram-next\": $fa-var-diagram-next,\n  \"person-rifle\": $fa-var-person-rifle,\n  \"house-medical-circle-exclamation\": $fa-var-house-medical-circle-exclamation,\n  \"closed-captioning\": $fa-var-closed-captioning,\n  \"person-hiking\": $fa-var-person-hiking,\n  \"hiking\": $fa-var-hiking,\n  \"venus-double\": $fa-var-venus-double,\n  \"images\": $fa-var-images,\n  \"calculator\": $fa-var-calculator,\n  \"people-pulling\": $fa-var-people-pulling,\n  \"n\": $fa-var-n,\n  \"cable-car\": $fa-var-cable-car,\n  \"tram\": $fa-var-tram,\n  \"cloud-rain\": $fa-var-cloud-rain,\n  \"building-circle-xmark\": $fa-var-building-circle-xmark,\n  \"ship\": $fa-var-ship,\n  \"arrows-down-to-line\": $fa-var-arrows-down-to-line,\n  \"download\": $fa-var-download,\n  \"face-grin\": $fa-var-face-grin,\n  \"grin\": $fa-var-grin,\n  \"delete-left\": $fa-var-delete-left,\n  \"backspace\": $fa-var-backspace,\n  \"eye-dropper\": $fa-var-eye-dropper,\n  \"eye-dropper-empty\": $fa-var-eye-dropper-empty,\n  \"eyedropper\": $fa-var-eyedropper,\n  \"file-circle-check\": $fa-var-file-circle-check,\n  \"forward\": $fa-var-forward,\n  \"mobile\": $fa-var-mobile,\n  \"mobile-android\": $fa-var-mobile-android,\n  \"mobile-phone\": $fa-var-mobile-phone,\n  \"face-meh\": $fa-var-face-meh,\n  \"meh\": $fa-var-meh,\n  \"align-center\": $fa-var-align-center,\n  \"book-skull\": $fa-var-book-skull,\n  \"book-dead\": $fa-var-book-dead,\n  \"id-card\": $fa-var-id-card,\n  \"drivers-license\": $fa-var-drivers-license,\n  \"outdent\": $fa-var-outdent,\n  \"dedent\": $fa-var-dedent,\n  \"heart-circle-exclamation\": $fa-var-heart-circle-exclamation,\n  \"house\": $fa-var-house,\n  \"home\": $fa-var-home,\n  \"home-alt\": $fa-var-home-alt,\n  \"home-lg-alt\": $fa-var-home-lg-alt,\n  \"calendar-week\": $fa-var-calendar-week,\n  \"laptop-medical\": $fa-var-laptop-medical,\n  \"b\": $fa-var-b,\n  \"file-medical\": $fa-var-file-medical,\n  \"dice-one\": $fa-var-dice-one,\n  \"kiwi-bird\": $fa-var-kiwi-bird,\n  \"arrow-right-arrow-left\": $fa-var-arrow-right-arrow-left,\n  \"exchange\": $fa-var-exchange,\n  \"rotate-right\": $fa-var-rotate-right,\n  \"redo-alt\": $fa-var-redo-alt,\n  \"rotate-forward\": $fa-var-rotate-forward,\n  \"utensils\": $fa-var-utensils,\n  \"cutlery\": $fa-var-cutlery,\n  \"arrow-up-wide-short\": $fa-var-arrow-up-wide-short,\n  \"sort-amount-up\": $fa-var-sort-amount-up,\n  \"mill-sign\": $fa-var-mill-sign,\n  \"bowl-rice\": $fa-var-bowl-rice,\n  \"skull\": $fa-var-skull,\n  \"tower-broadcast\": $fa-var-tower-broadcast,\n  \"broadcast-tower\": $fa-var-broadcast-tower,\n  \"truck-pickup\": $fa-var-truck-pickup,\n  \"up-long\": $fa-var-up-long,\n  \"long-arrow-alt-up\": $fa-var-long-arrow-alt-up,\n  \"stop\": $fa-var-stop,\n  \"code-merge\": $fa-var-code-merge,\n  \"upload\": $fa-var-upload,\n  \"hurricane\": $fa-var-hurricane,\n  \"mound\": $fa-var-mound,\n  \"toilet-portable\": $fa-var-toilet-portable,\n  \"compact-disc\": $fa-var-compact-disc,\n  \"file-arrow-down\": $fa-var-file-arrow-down,\n  \"file-download\": $fa-var-file-download,\n  \"caravan\": $fa-var-caravan,\n  \"shield-cat\": $fa-var-shield-cat,\n  \"bolt\": $fa-var-bolt,\n  \"zap\": $fa-var-zap,\n  \"glass-water\": $fa-var-glass-water,\n  \"oil-well\": $fa-var-oil-well,\n  \"vault\": $fa-var-vault,\n  \"mars\": $fa-var-mars,\n  \"toilet\": $fa-var-toilet,\n  \"plane-circle-xmark\": $fa-var-plane-circle-xmark,\n  \"yen-sign\": $fa-var-yen-sign,\n  \"cny\": $fa-var-cny,\n  \"jpy\": $fa-var-jpy,\n  \"rmb\": $fa-var-rmb,\n  \"yen\": $fa-var-yen,\n  \"ruble-sign\": $fa-var-ruble-sign,\n  \"rouble\": $fa-var-rouble,\n  \"rub\": $fa-var-rub,\n  \"ruble\": $fa-var-ruble,\n  \"sun\": $fa-var-sun,\n  \"guitar\": $fa-var-guitar,\n  \"face-laugh-wink\": $fa-var-face-laugh-wink,\n  \"laugh-wink\": $fa-var-laugh-wink,\n  \"horse-head\": $fa-var-horse-head,\n  \"bore-hole\": $fa-var-bore-hole,\n  \"industry\": $fa-var-industry,\n  \"circle-down\": $fa-var-circle-down,\n  \"arrow-alt-circle-down\": $fa-var-arrow-alt-circle-down,\n  \"arrows-turn-to-dots\": $fa-var-arrows-turn-to-dots,\n  \"florin-sign\": $fa-var-florin-sign,\n  \"arrow-down-short-wide\": $fa-var-arrow-down-short-wide,\n  \"sort-amount-desc\": $fa-var-sort-amount-desc,\n  \"sort-amount-down-alt\": $fa-var-sort-amount-down-alt,\n  \"less-than\": $fa-var-less-than,\n  \"angle-down\": $fa-var-angle-down,\n  \"car-tunnel\": $fa-var-car-tunnel,\n  \"head-side-cough\": $fa-var-head-side-cough,\n  \"grip-lines\": $fa-var-grip-lines,\n  \"thumbs-down\": $fa-var-thumbs-down,\n  \"user-lock\": $fa-var-user-lock,\n  \"arrow-right-long\": $fa-var-arrow-right-long,\n  \"long-arrow-right\": $fa-var-long-arrow-right,\n  \"anchor-circle-xmark\": $fa-var-anchor-circle-xmark,\n  \"ellipsis\": $fa-var-ellipsis,\n  \"ellipsis-h\": $fa-var-ellipsis-h,\n  \"chess-pawn\": $fa-var-chess-pawn,\n  \"kit-medical\": $fa-var-kit-medical,\n  \"first-aid\": $fa-var-first-aid,\n  \"person-through-window\": $fa-var-person-through-window,\n  \"toolbox\": $fa-var-toolbox,\n  \"hands-holding-circle\": $fa-var-hands-holding-circle,\n  \"bug\": $fa-var-bug,\n  \"credit-card\": $fa-var-credit-card,\n  \"credit-card-alt\": $fa-var-credit-card-alt,\n  \"car\": $fa-var-car,\n  \"automobile\": $fa-var-automobile,\n  \"hand-holding-hand\": $fa-var-hand-holding-hand,\n  \"book-open-reader\": $fa-var-book-open-reader,\n  \"book-reader\": $fa-var-book-reader,\n  \"mountain-sun\": $fa-var-mountain-sun,\n  \"arrows-left-right-to-line\": $fa-var-arrows-left-right-to-line,\n  \"dice-d20\": $fa-var-dice-d20,\n  \"truck-droplet\": $fa-var-truck-droplet,\n  \"file-circle-xmark\": $fa-var-file-circle-xmark,\n  \"temperature-arrow-up\": $fa-var-temperature-arrow-up,\n  \"temperature-up\": $fa-var-temperature-up,\n  \"medal\": $fa-var-medal,\n  \"bed\": $fa-var-bed,\n  \"square-h\": $fa-var-square-h,\n  \"h-square\": $fa-var-h-square,\n  \"podcast\": $fa-var-podcast,\n  \"temperature-full\": $fa-var-temperature-full,\n  \"temperature-4\": $fa-var-temperature-4,\n  \"thermometer-4\": $fa-var-thermometer-4,\n  \"thermometer-full\": $fa-var-thermometer-full,\n  \"bell\": $fa-var-bell,\n  \"superscript\": $fa-var-superscript,\n  \"plug-circle-xmark\": $fa-var-plug-circle-xmark,\n  \"star-of-life\": $fa-var-star-of-life,\n  \"phone-slash\": $fa-var-phone-slash,\n  \"paint-roller\": $fa-var-paint-roller,\n  \"handshake-angle\": $fa-var-handshake-angle,\n  \"hands-helping\": $fa-var-hands-helping,\n  \"location-dot\": $fa-var-location-dot,\n  \"map-marker-alt\": $fa-var-map-marker-alt,\n  \"file\": $fa-var-file,\n  \"greater-than\": $fa-var-greater-than,\n  \"person-swimming\": $fa-var-person-swimming,\n  \"swimmer\": $fa-var-swimmer,\n  \"arrow-down\": $fa-var-arrow-down,\n  \"droplet\": $fa-var-droplet,\n  \"tint\": $fa-var-tint,\n  \"eraser\": $fa-var-eraser,\n  \"earth-americas\": $fa-var-earth-americas,\n  \"earth\": $fa-var-earth,\n  \"earth-america\": $fa-var-earth-america,\n  \"globe-americas\": $fa-var-globe-americas,\n  \"person-burst\": $fa-var-person-burst,\n  \"dove\": $fa-var-dove,\n  \"battery-empty\": $fa-var-battery-empty,\n  \"battery-0\": $fa-var-battery-0,\n  \"socks\": $fa-var-socks,\n  \"inbox\": $fa-var-inbox,\n  \"section\": $fa-var-section,\n  \"gauge-high\": $fa-var-gauge-high,\n  \"tachometer-alt\": $fa-var-tachometer-alt,\n  \"tachometer-alt-fast\": $fa-var-tachometer-alt-fast,\n  \"envelope-open-text\": $fa-var-envelope-open-text,\n  \"hospital\": $fa-var-hospital,\n  \"hospital-alt\": $fa-var-hospital-alt,\n  \"hospital-wide\": $fa-var-hospital-wide,\n  \"wine-bottle\": $fa-var-wine-bottle,\n  \"chess-rook\": $fa-var-chess-rook,\n  \"bars-staggered\": $fa-var-bars-staggered,\n  \"reorder\": $fa-var-reorder,\n  \"stream\": $fa-var-stream,\n  \"dharmachakra\": $fa-var-dharmachakra,\n  \"hotdog\": $fa-var-hotdog,\n  \"person-walking-with-cane\": $fa-var-person-walking-with-cane,\n  \"blind\": $fa-var-blind,\n  \"drum\": $fa-var-drum,\n  \"ice-cream\": $fa-var-ice-cream,\n  \"heart-circle-bolt\": $fa-var-heart-circle-bolt,\n  \"fax\": $fa-var-fax,\n  \"paragraph\": $fa-var-paragraph,\n  \"check-to-slot\": $fa-var-check-to-slot,\n  \"vote-yea\": $fa-var-vote-yea,\n  \"star-half\": $fa-var-star-half,\n  \"boxes-stacked\": $fa-var-boxes-stacked,\n  \"boxes\": $fa-var-boxes,\n  \"boxes-alt\": $fa-var-boxes-alt,\n  \"link\": $fa-var-link,\n  \"chain\": $fa-var-chain,\n  \"ear-listen\": $fa-var-ear-listen,\n  \"assistive-listening-systems\": $fa-var-assistive-listening-systems,\n  \"tree-city\": $fa-var-tree-city,\n  \"play\": $fa-var-play,\n  \"font\": $fa-var-font,\n  \"table-cells-row-lock\": $fa-var-table-cells-row-lock,\n  \"rupiah-sign\": $fa-var-rupiah-sign,\n  \"magnifying-glass\": $fa-var-magnifying-glass,\n  \"search\": $fa-var-search,\n  \"table-tennis-paddle-ball\": $fa-var-table-tennis-paddle-ball,\n  \"ping-pong-paddle-ball\": $fa-var-ping-pong-paddle-ball,\n  \"table-tennis\": $fa-var-table-tennis,\n  \"person-dots-from-line\": $fa-var-person-dots-from-line,\n  \"diagnoses\": $fa-var-diagnoses,\n  \"trash-can-arrow-up\": $fa-var-trash-can-arrow-up,\n  \"trash-restore-alt\": $fa-var-trash-restore-alt,\n  \"naira-sign\": $fa-var-naira-sign,\n  \"cart-arrow-down\": $fa-var-cart-arrow-down,\n  \"walkie-talkie\": $fa-var-walkie-talkie,\n  \"file-pen\": $fa-var-file-pen,\n  \"file-edit\": $fa-var-file-edit,\n  \"receipt\": $fa-var-receipt,\n  \"square-pen\": $fa-var-square-pen,\n  \"pen-square\": $fa-var-pen-square,\n  \"pencil-square\": $fa-var-pencil-square,\n  \"suitcase-rolling\": $fa-var-suitcase-rolling,\n  \"person-circle-exclamation\": $fa-var-person-circle-exclamation,\n  \"chevron-down\": $fa-var-chevron-down,\n  \"battery-full\": $fa-var-battery-full,\n  \"battery\": $fa-var-battery,\n  \"battery-5\": $fa-var-battery-5,\n  \"skull-crossbones\": $fa-var-skull-crossbones,\n  \"code-compare\": $fa-var-code-compare,\n  \"list-ul\": $fa-var-list-ul,\n  \"list-dots\": $fa-var-list-dots,\n  \"school-lock\": $fa-var-school-lock,\n  \"tower-cell\": $fa-var-tower-cell,\n  \"down-long\": $fa-var-down-long,\n  \"long-arrow-alt-down\": $fa-var-long-arrow-alt-down,\n  \"ranking-star\": $fa-var-ranking-star,\n  \"chess-king\": $fa-var-chess-king,\n  \"person-harassing\": $fa-var-person-harassing,\n  \"brazilian-real-sign\": $fa-var-brazilian-real-sign,\n  \"landmark-dome\": $fa-var-landmark-dome,\n  \"landmark-alt\": $fa-var-landmark-alt,\n  \"arrow-up\": $fa-var-arrow-up,\n  \"tv\": $fa-var-tv,\n  \"television\": $fa-var-television,\n  \"tv-alt\": $fa-var-tv-alt,\n  \"shrimp\": $fa-var-shrimp,\n  \"list-check\": $fa-var-list-check,\n  \"tasks\": $fa-var-tasks,\n  \"jug-detergent\": $fa-var-jug-detergent,\n  \"circle-user\": $fa-var-circle-user,\n  \"user-circle\": $fa-var-user-circle,\n  \"user-shield\": $fa-var-user-shield,\n  \"wind\": $fa-var-wind,\n  \"car-burst\": $fa-var-car-burst,\n  \"car-crash\": $fa-var-car-crash,\n  \"y\": $fa-var-y,\n  \"person-snowboarding\": $fa-var-person-snowboarding,\n  \"snowboarding\": $fa-var-snowboarding,\n  \"truck-fast\": $fa-var-truck-fast,\n  \"shipping-fast\": $fa-var-shipping-fast,\n  \"fish\": $fa-var-fish,\n  \"user-graduate\": $fa-var-user-graduate,\n  \"circle-half-stroke\": $fa-var-circle-half-stroke,\n  \"adjust\": $fa-var-adjust,\n  \"clapperboard\": $fa-var-clapperboard,\n  \"circle-radiation\": $fa-var-circle-radiation,\n  \"radiation-alt\": $fa-var-radiation-alt,\n  \"baseball\": $fa-var-baseball,\n  \"baseball-ball\": $fa-var-baseball-ball,\n  \"jet-fighter-up\": $fa-var-jet-fighter-up,\n  \"diagram-project\": $fa-var-diagram-project,\n  \"project-diagram\": $fa-var-project-diagram,\n  \"copy\": $fa-var-copy,\n  \"volume-xmark\": $fa-var-volume-xmark,\n  \"volume-mute\": $fa-var-volume-mute,\n  \"volume-times\": $fa-var-volume-times,\n  \"hand-sparkles\": $fa-var-hand-sparkles,\n  \"grip\": $fa-var-grip,\n  \"grip-horizontal\": $fa-var-grip-horizontal,\n  \"share-from-square\": $fa-var-share-from-square,\n  \"share-square\": $fa-var-share-square,\n  \"child-combatant\": $fa-var-child-combatant,\n  \"child-rifle\": $fa-var-child-rifle,\n  \"gun\": $fa-var-gun,\n  \"square-phone\": $fa-var-square-phone,\n  \"phone-square\": $fa-var-phone-square,\n  \"plus\": $fa-var-plus,\n  \"add\": $fa-var-add,\n  \"expand\": $fa-var-expand,\n  \"computer\": $fa-var-computer,\n  \"xmark\": $fa-var-xmark,\n  \"close\": $fa-var-close,\n  \"multiply\": $fa-var-multiply,\n  \"remove\": $fa-var-remove,\n  \"times\": $fa-var-times,\n  \"arrows-up-down-left-right\": $fa-var-arrows-up-down-left-right,\n  \"arrows\": $fa-var-arrows,\n  \"chalkboard-user\": $fa-var-chalkboard-user,\n  \"chalkboard-teacher\": $fa-var-chalkboard-teacher,\n  \"peso-sign\": $fa-var-peso-sign,\n  \"building-shield\": $fa-var-building-shield,\n  \"baby\": $fa-var-baby,\n  \"users-line\": $fa-var-users-line,\n  \"quote-left\": $fa-var-quote-left,\n  \"quote-left-alt\": $fa-var-quote-left-alt,\n  \"tractor\": $fa-var-tractor,\n  \"trash-arrow-up\": $fa-var-trash-arrow-up,\n  \"trash-restore\": $fa-var-trash-restore,\n  \"arrow-down-up-lock\": $fa-var-arrow-down-up-lock,\n  \"lines-leaning\": $fa-var-lines-leaning,\n  \"ruler-combined\": $fa-var-ruler-combined,\n  \"copyright\": $fa-var-copyright,\n  \"equals\": $fa-var-equals,\n  \"blender\": $fa-var-blender,\n  \"teeth\": $fa-var-teeth,\n  \"shekel-sign\": $fa-var-shekel-sign,\n  \"ils\": $fa-var-ils,\n  \"shekel\": $fa-var-shekel,\n  \"sheqel\": $fa-var-sheqel,\n  \"sheqel-sign\": $fa-var-sheqel-sign,\n  \"map\": $fa-var-map,\n  \"rocket\": $fa-var-rocket,\n  \"photo-film\": $fa-var-photo-film,\n  \"photo-video\": $fa-var-photo-video,\n  \"folder-minus\": $fa-var-folder-minus,\n  \"hexagon-nodes-bolt\": $fa-var-hexagon-nodes-bolt,\n  \"store\": $fa-var-store,\n  \"arrow-trend-up\": $fa-var-arrow-trend-up,\n  \"plug-circle-minus\": $fa-var-plug-circle-minus,\n  \"sign-hanging\": $fa-var-sign-hanging,\n  \"sign\": $fa-var-sign,\n  \"bezier-curve\": $fa-var-bezier-curve,\n  \"bell-slash\": $fa-var-bell-slash,\n  \"tablet\": $fa-var-tablet,\n  \"tablet-android\": $fa-var-tablet-android,\n  \"school-flag\": $fa-var-school-flag,\n  \"fill\": $fa-var-fill,\n  \"angle-up\": $fa-var-angle-up,\n  \"drumstick-bite\": $fa-var-drumstick-bite,\n  \"holly-berry\": $fa-var-holly-berry,\n  \"chevron-left\": $fa-var-chevron-left,\n  \"bacteria\": $fa-var-bacteria,\n  \"hand-lizard\": $fa-var-hand-lizard,\n  \"notdef\": $fa-var-notdef,\n  \"disease\": $fa-var-disease,\n  \"briefcase-medical\": $fa-var-briefcase-medical,\n  \"genderless\": $fa-var-genderless,\n  \"chevron-right\": $fa-var-chevron-right,\n  \"retweet\": $fa-var-retweet,\n  \"car-rear\": $fa-var-car-rear,\n  \"car-alt\": $fa-var-car-alt,\n  \"pump-soap\": $fa-var-pump-soap,\n  \"video-slash\": $fa-var-video-slash,\n  \"battery-quarter\": $fa-var-battery-quarter,\n  \"battery-2\": $fa-var-battery-2,\n  \"radio\": $fa-var-radio,\n  \"baby-carriage\": $fa-var-baby-carriage,\n  \"carriage-baby\": $fa-var-carriage-baby,\n  \"traffic-light\": $fa-var-traffic-light,\n  \"thermometer\": $fa-var-thermometer,\n  \"vr-cardboard\": $fa-var-vr-cardboard,\n  \"hand-middle-finger\": $fa-var-hand-middle-finger,\n  \"percent\": $fa-var-percent,\n  \"percentage\": $fa-var-percentage,\n  \"truck-moving\": $fa-var-truck-moving,\n  \"glass-water-droplet\": $fa-var-glass-water-droplet,\n  \"display\": $fa-var-display,\n  \"face-smile\": $fa-var-face-smile,\n  \"smile\": $fa-var-smile,\n  \"thumbtack\": $fa-var-thumbtack,\n  \"thumb-tack\": $fa-var-thumb-tack,\n  \"trophy\": $fa-var-trophy,\n  \"person-praying\": $fa-var-person-praying,\n  \"pray\": $fa-var-pray,\n  \"hammer\": $fa-var-hammer,\n  \"hand-peace\": $fa-var-hand-peace,\n  \"rotate\": $fa-var-rotate,\n  \"sync-alt\": $fa-var-sync-alt,\n  \"spinner\": $fa-var-spinner,\n  \"robot\": $fa-var-robot,\n  \"peace\": $fa-var-peace,\n  \"gears\": $fa-var-gears,\n  \"cogs\": $fa-var-cogs,\n  \"warehouse\": $fa-var-warehouse,\n  \"arrow-up-right-dots\": $fa-var-arrow-up-right-dots,\n  \"splotch\": $fa-var-splotch,\n  \"face-grin-hearts\": $fa-var-face-grin-hearts,\n  \"grin-hearts\": $fa-var-grin-hearts,\n  \"dice-four\": $fa-var-dice-four,\n  \"sim-card\": $fa-var-sim-card,\n  \"transgender\": $fa-var-transgender,\n  \"transgender-alt\": $fa-var-transgender-alt,\n  \"mercury\": $fa-var-mercury,\n  \"arrow-turn-down\": $fa-var-arrow-turn-down,\n  \"level-down\": $fa-var-level-down,\n  \"person-falling-burst\": $fa-var-person-falling-burst,\n  \"award\": $fa-var-award,\n  \"ticket-simple\": $fa-var-ticket-simple,\n  \"ticket-alt\": $fa-var-ticket-alt,\n  \"building\": $fa-var-building,\n  \"angles-left\": $fa-var-angles-left,\n  \"angle-double-left\": $fa-var-angle-double-left,\n  \"qrcode\": $fa-var-qrcode,\n  \"clock-rotate-left\": $fa-var-clock-rotate-left,\n  \"history\": $fa-var-history,\n  \"face-grin-beam-sweat\": $fa-var-face-grin-beam-sweat,\n  \"grin-beam-sweat\": $fa-var-grin-beam-sweat,\n  \"file-export\": $fa-var-file-export,\n  \"arrow-right-from-file\": $fa-var-arrow-right-from-file,\n  \"shield\": $fa-var-shield,\n  \"shield-blank\": $fa-var-shield-blank,\n  \"arrow-up-short-wide\": $fa-var-arrow-up-short-wide,\n  \"sort-amount-up-alt\": $fa-var-sort-amount-up-alt,\n  \"comment-nodes\": $fa-var-comment-nodes,\n  \"house-medical\": $fa-var-house-medical,\n  \"golf-ball-tee\": $fa-var-golf-ball-tee,\n  \"golf-ball\": $fa-var-golf-ball,\n  \"circle-chevron-left\": $fa-var-circle-chevron-left,\n  \"chevron-circle-left\": $fa-var-chevron-circle-left,\n  \"house-chimney-window\": $fa-var-house-chimney-window,\n  \"pen-nib\": $fa-var-pen-nib,\n  \"tent-arrow-turn-left\": $fa-var-tent-arrow-turn-left,\n  \"tents\": $fa-var-tents,\n  \"wand-magic\": $fa-var-wand-magic,\n  \"magic\": $fa-var-magic,\n  \"dog\": $fa-var-dog,\n  \"carrot\": $fa-var-carrot,\n  \"moon\": $fa-var-moon,\n  \"wine-glass-empty\": $fa-var-wine-glass-empty,\n  \"wine-glass-alt\": $fa-var-wine-glass-alt,\n  \"cheese\": $fa-var-cheese,\n  \"yin-yang\": $fa-var-yin-yang,\n  \"music\": $fa-var-music,\n  \"code-commit\": $fa-var-code-commit,\n  \"temperature-low\": $fa-var-temperature-low,\n  \"person-biking\": $fa-var-person-biking,\n  \"biking\": $fa-var-biking,\n  \"broom\": $fa-var-broom,\n  \"shield-heart\": $fa-var-shield-heart,\n  \"gopuram\": $fa-var-gopuram,\n  \"earth-oceania\": $fa-var-earth-oceania,\n  \"globe-oceania\": $fa-var-globe-oceania,\n  \"square-xmark\": $fa-var-square-xmark,\n  \"times-square\": $fa-var-times-square,\n  \"xmark-square\": $fa-var-xmark-square,\n  \"hashtag\": $fa-var-hashtag,\n  \"up-right-and-down-left-from-center\": $fa-var-up-right-and-down-left-from-center,\n  \"expand-alt\": $fa-var-expand-alt,\n  \"oil-can\": $fa-var-oil-can,\n  \"t\": $fa-var-t,\n  \"hippo\": $fa-var-hippo,\n  \"chart-column\": $fa-var-chart-column,\n  \"infinity\": $fa-var-infinity,\n  \"vial-circle-check\": $fa-var-vial-circle-check,\n  \"person-arrow-down-to-line\": $fa-var-person-arrow-down-to-line,\n  \"voicemail\": $fa-var-voicemail,\n  \"fan\": $fa-var-fan,\n  \"person-walking-luggage\": $fa-var-person-walking-luggage,\n  \"up-down\": $fa-var-up-down,\n  \"arrows-alt-v\": $fa-var-arrows-alt-v,\n  \"cloud-moon-rain\": $fa-var-cloud-moon-rain,\n  \"calendar\": $fa-var-calendar,\n  \"trailer\": $fa-var-trailer,\n  \"bahai\": $fa-var-bahai,\n  \"haykal\": $fa-var-haykal,\n  \"sd-card\": $fa-var-sd-card,\n  \"dragon\": $fa-var-dragon,\n  \"shoe-prints\": $fa-var-shoe-prints,\n  \"circle-plus\": $fa-var-circle-plus,\n  \"plus-circle\": $fa-var-plus-circle,\n  \"face-grin-tongue-wink\": $fa-var-face-grin-tongue-wink,\n  \"grin-tongue-wink\": $fa-var-grin-tongue-wink,\n  \"hand-holding\": $fa-var-hand-holding,\n  \"plug-circle-exclamation\": $fa-var-plug-circle-exclamation,\n  \"link-slash\": $fa-var-link-slash,\n  \"chain-broken\": $fa-var-chain-broken,\n  \"chain-slash\": $fa-var-chain-slash,\n  \"unlink\": $fa-var-unlink,\n  \"clone\": $fa-var-clone,\n  \"person-walking-arrow-loop-left\": $fa-var-person-walking-arrow-loop-left,\n  \"arrow-up-z-a\": $fa-var-arrow-up-z-a,\n  \"sort-alpha-up-alt\": $fa-var-sort-alpha-up-alt,\n  \"fire-flame-curved\": $fa-var-fire-flame-curved,\n  \"fire-alt\": $fa-var-fire-alt,\n  \"tornado\": $fa-var-tornado,\n  \"file-circle-plus\": $fa-var-file-circle-plus,\n  \"book-quran\": $fa-var-book-quran,\n  \"quran\": $fa-var-quran,\n  \"anchor\": $fa-var-anchor,\n  \"border-all\": $fa-var-border-all,\n  \"face-angry\": $fa-var-face-angry,\n  \"angry\": $fa-var-angry,\n  \"cookie-bite\": $fa-var-cookie-bite,\n  \"arrow-trend-down\": $fa-var-arrow-trend-down,\n  \"rss\": $fa-var-rss,\n  \"feed\": $fa-var-feed,\n  \"draw-polygon\": $fa-var-draw-polygon,\n  \"scale-balanced\": $fa-var-scale-balanced,\n  \"balance-scale\": $fa-var-balance-scale,\n  \"gauge-simple-high\": $fa-var-gauge-simple-high,\n  \"tachometer\": $fa-var-tachometer,\n  \"tachometer-fast\": $fa-var-tachometer-fast,\n  \"shower\": $fa-var-shower,\n  \"desktop\": $fa-var-desktop,\n  \"desktop-alt\": $fa-var-desktop-alt,\n  \"m\": $fa-var-m,\n  \"table-list\": $fa-var-table-list,\n  \"th-list\": $fa-var-th-list,\n  \"comment-sms\": $fa-var-comment-sms,\n  \"sms\": $fa-var-sms,\n  \"book\": $fa-var-book,\n  \"user-plus\": $fa-var-user-plus,\n  \"check\": $fa-var-check,\n  \"battery-three-quarters\": $fa-var-battery-three-quarters,\n  \"battery-4\": $fa-var-battery-4,\n  \"house-circle-check\": $fa-var-house-circle-check,\n  \"angle-left\": $fa-var-angle-left,\n  \"diagram-successor\": $fa-var-diagram-successor,\n  \"truck-arrow-right\": $fa-var-truck-arrow-right,\n  \"arrows-split-up-and-left\": $fa-var-arrows-split-up-and-left,\n  \"hand-fist\": $fa-var-hand-fist,\n  \"fist-raised\": $fa-var-fist-raised,\n  \"cloud-moon\": $fa-var-cloud-moon,\n  \"briefcase\": $fa-var-briefcase,\n  \"person-falling\": $fa-var-person-falling,\n  \"image-portrait\": $fa-var-image-portrait,\n  \"portrait\": $fa-var-portrait,\n  \"user-tag\": $fa-var-user-tag,\n  \"rug\": $fa-var-rug,\n  \"earth-europe\": $fa-var-earth-europe,\n  \"globe-europe\": $fa-var-globe-europe,\n  \"cart-flatbed-suitcase\": $fa-var-cart-flatbed-suitcase,\n  \"luggage-cart\": $fa-var-luggage-cart,\n  \"rectangle-xmark\": $fa-var-rectangle-xmark,\n  \"rectangle-times\": $fa-var-rectangle-times,\n  \"times-rectangle\": $fa-var-times-rectangle,\n  \"window-close\": $fa-var-window-close,\n  \"baht-sign\": $fa-var-baht-sign,\n  \"book-open\": $fa-var-book-open,\n  \"book-journal-whills\": $fa-var-book-journal-whills,\n  \"journal-whills\": $fa-var-journal-whills,\n  \"handcuffs\": $fa-var-handcuffs,\n  \"triangle-exclamation\": $fa-var-triangle-exclamation,\n  \"exclamation-triangle\": $fa-var-exclamation-triangle,\n  \"warning\": $fa-var-warning,\n  \"database\": $fa-var-database,\n  \"share\": $fa-var-share,\n  \"mail-forward\": $fa-var-mail-forward,\n  \"bottle-droplet\": $fa-var-bottle-droplet,\n  \"mask-face\": $fa-var-mask-face,\n  \"hill-rockslide\": $fa-var-hill-rockslide,\n  \"right-left\": $fa-var-right-left,\n  \"exchange-alt\": $fa-var-exchange-alt,\n  \"paper-plane\": $fa-var-paper-plane,\n  \"road-circle-exclamation\": $fa-var-road-circle-exclamation,\n  \"dungeon\": $fa-var-dungeon,\n  \"align-right\": $fa-var-align-right,\n  \"money-bill-1-wave\": $fa-var-money-bill-1-wave,\n  \"money-bill-wave-alt\": $fa-var-money-bill-wave-alt,\n  \"life-ring\": $fa-var-life-ring,\n  \"hands\": $fa-var-hands,\n  \"sign-language\": $fa-var-sign-language,\n  \"signing\": $fa-var-signing,\n  \"calendar-day\": $fa-var-calendar-day,\n  \"water-ladder\": $fa-var-water-ladder,\n  \"ladder-water\": $fa-var-ladder-water,\n  \"swimming-pool\": $fa-var-swimming-pool,\n  \"arrows-up-down\": $fa-var-arrows-up-down,\n  \"arrows-v\": $fa-var-arrows-v,\n  \"face-grimace\": $fa-var-face-grimace,\n  \"grimace\": $fa-var-grimace,\n  \"wheelchair-move\": $fa-var-wheelchair-move,\n  \"wheelchair-alt\": $fa-var-wheelchair-alt,\n  \"turn-down\": $fa-var-turn-down,\n  \"level-down-alt\": $fa-var-level-down-alt,\n  \"person-walking-arrow-right\": $fa-var-person-walking-arrow-right,\n  \"square-envelope\": $fa-var-square-envelope,\n  \"envelope-square\": $fa-var-envelope-square,\n  \"dice\": $fa-var-dice,\n  \"bowling-ball\": $fa-var-bowling-ball,\n  \"brain\": $fa-var-brain,\n  \"bandage\": $fa-var-bandage,\n  \"band-aid\": $fa-var-band-aid,\n  \"calendar-minus\": $fa-var-calendar-minus,\n  \"circle-xmark\": $fa-var-circle-xmark,\n  \"times-circle\": $fa-var-times-circle,\n  \"xmark-circle\": $fa-var-xmark-circle,\n  \"gifts\": $fa-var-gifts,\n  \"hotel\": $fa-var-hotel,\n  \"earth-asia\": $fa-var-earth-asia,\n  \"globe-asia\": $fa-var-globe-asia,\n  \"id-card-clip\": $fa-var-id-card-clip,\n  \"id-card-alt\": $fa-var-id-card-alt,\n  \"magnifying-glass-plus\": $fa-var-magnifying-glass-plus,\n  \"search-plus\": $fa-var-search-plus,\n  \"thumbs-up\": $fa-var-thumbs-up,\n  \"user-clock\": $fa-var-user-clock,\n  \"hand-dots\": $fa-var-hand-dots,\n  \"allergies\": $fa-var-allergies,\n  \"file-invoice\": $fa-var-file-invoice,\n  \"window-minimize\": $fa-var-window-minimize,\n  \"mug-saucer\": $fa-var-mug-saucer,\n  \"coffee\": $fa-var-coffee,\n  \"brush\": $fa-var-brush,\n  \"file-half-dashed\": $fa-var-file-half-dashed,\n  \"mask\": $fa-var-mask,\n  \"magnifying-glass-minus\": $fa-var-magnifying-glass-minus,\n  \"search-minus\": $fa-var-search-minus,\n  \"ruler-vertical\": $fa-var-ruler-vertical,\n  \"user-large\": $fa-var-user-large,\n  \"user-alt\": $fa-var-user-alt,\n  \"train-tram\": $fa-var-train-tram,\n  \"user-nurse\": $fa-var-user-nurse,\n  \"syringe\": $fa-var-syringe,\n  \"cloud-sun\": $fa-var-cloud-sun,\n  \"stopwatch-20\": $fa-var-stopwatch-20,\n  \"square-full\": $fa-var-square-full,\n  \"magnet\": $fa-var-magnet,\n  \"jar\": $fa-var-jar,\n  \"note-sticky\": $fa-var-note-sticky,\n  \"sticky-note\": $fa-var-sticky-note,\n  \"bug-slash\": $fa-var-bug-slash,\n  \"arrow-up-from-water-pump\": $fa-var-arrow-up-from-water-pump,\n  \"bone\": $fa-var-bone,\n  \"table-cells-row-unlock\": $fa-var-table-cells-row-unlock,\n  \"user-injured\": $fa-var-user-injured,\n  \"face-sad-tear\": $fa-var-face-sad-tear,\n  \"sad-tear\": $fa-var-sad-tear,\n  \"plane\": $fa-var-plane,\n  \"tent-arrows-down\": $fa-var-tent-arrows-down,\n  \"exclamation\": $fa-var-exclamation,\n  \"arrows-spin\": $fa-var-arrows-spin,\n  \"print\": $fa-var-print,\n  \"turkish-lira-sign\": $fa-var-turkish-lira-sign,\n  \"try\": $fa-var-try,\n  \"turkish-lira\": $fa-var-turkish-lira,\n  \"dollar-sign\": $fa-var-dollar-sign,\n  \"dollar\": $fa-var-dollar,\n  \"usd\": $fa-var-usd,\n  \"x\": $fa-var-x,\n  \"magnifying-glass-dollar\": $fa-var-magnifying-glass-dollar,\n  \"search-dollar\": $fa-var-search-dollar,\n  \"users-gear\": $fa-var-users-gear,\n  \"users-cog\": $fa-var-users-cog,\n  \"person-military-pointing\": $fa-var-person-military-pointing,\n  \"building-columns\": $fa-var-building-columns,\n  \"bank\": $fa-var-bank,\n  \"institution\": $fa-var-institution,\n  \"museum\": $fa-var-museum,\n  \"university\": $fa-var-university,\n  \"umbrella\": $fa-var-umbrella,\n  \"trowel\": $fa-var-trowel,\n  \"d\": $fa-var-d,\n  \"stapler\": $fa-var-stapler,\n  \"masks-theater\": $fa-var-masks-theater,\n  \"theater-masks\": $fa-var-theater-masks,\n  \"kip-sign\": $fa-var-kip-sign,\n  \"hand-point-left\": $fa-var-hand-point-left,\n  \"handshake-simple\": $fa-var-handshake-simple,\n  \"handshake-alt\": $fa-var-handshake-alt,\n  \"jet-fighter\": $fa-var-jet-fighter,\n  \"fighter-jet\": $fa-var-fighter-jet,\n  \"square-share-nodes\": $fa-var-square-share-nodes,\n  \"share-alt-square\": $fa-var-share-alt-square,\n  \"barcode\": $fa-var-barcode,\n  \"plus-minus\": $fa-var-plus-minus,\n  \"video\": $fa-var-video,\n  \"video-camera\": $fa-var-video-camera,\n  \"graduation-cap\": $fa-var-graduation-cap,\n  \"mortar-board\": $fa-var-mortar-board,\n  \"hand-holding-medical\": $fa-var-hand-holding-medical,\n  \"person-circle-check\": $fa-var-person-circle-check,\n  \"turn-up\": $fa-var-turn-up,\n  \"level-up-alt\": $fa-var-level-up-alt,\n);\n\n$fa-brand-icons: (\n  \"monero\": $fa-var-monero,\n  \"hooli\": $fa-var-hooli,\n  \"yelp\": $fa-var-yelp,\n  \"cc-visa\": $fa-var-cc-visa,\n  \"lastfm\": $fa-var-lastfm,\n  \"shopware\": $fa-var-shopware,\n  \"creative-commons-nc\": $fa-var-creative-commons-nc,\n  \"aws\": $fa-var-aws,\n  \"redhat\": $fa-var-redhat,\n  \"yoast\": $fa-var-yoast,\n  \"cloudflare\": $fa-var-cloudflare,\n  \"ups\": $fa-var-ups,\n  \"pixiv\": $fa-var-pixiv,\n  \"wpexplorer\": $fa-var-wpexplorer,\n  \"dyalog\": $fa-var-dyalog,\n  \"bity\": $fa-var-bity,\n  \"stackpath\": $fa-var-stackpath,\n  \"buysellads\": $fa-var-buysellads,\n  \"first-order\": $fa-var-first-order,\n  \"modx\": $fa-var-modx,\n  \"guilded\": $fa-var-guilded,\n  \"vnv\": $fa-var-vnv,\n  \"square-js\": $fa-var-square-js,\n  \"js-square\": $fa-var-js-square,\n  \"microsoft\": $fa-var-microsoft,\n  \"qq\": $fa-var-qq,\n  \"orcid\": $fa-var-orcid,\n  \"java\": $fa-var-java,\n  \"invision\": $fa-var-invision,\n  \"creative-commons-pd-alt\": $fa-var-creative-commons-pd-alt,\n  \"centercode\": $fa-var-centercode,\n  \"glide-g\": $fa-var-glide-g,\n  \"drupal\": $fa-var-drupal,\n  \"jxl\": $fa-var-jxl,\n  \"dart-lang\": $fa-var-dart-lang,\n  \"hire-a-helper\": $fa-var-hire-a-helper,\n  \"creative-commons-by\": $fa-var-creative-commons-by,\n  \"unity\": $fa-var-unity,\n  \"whmcs\": $fa-var-whmcs,\n  \"rocketchat\": $fa-var-rocketchat,\n  \"vk\": $fa-var-vk,\n  \"untappd\": $fa-var-untappd,\n  \"mailchimp\": $fa-var-mailchimp,\n  \"css3-alt\": $fa-var-css3-alt,\n  \"square-reddit\": $fa-var-square-reddit,\n  \"reddit-square\": $fa-var-reddit-square,\n  \"vimeo-v\": $fa-var-vimeo-v,\n  \"contao\": $fa-var-contao,\n  \"square-font-awesome\": $fa-var-square-font-awesome,\n  \"deskpro\": $fa-var-deskpro,\n  \"brave\": $fa-var-brave,\n  \"sistrix\": $fa-var-sistrix,\n  \"square-instagram\": $fa-var-square-instagram,\n  \"instagram-square\": $fa-var-instagram-square,\n  \"battle-net\": $fa-var-battle-net,\n  \"the-red-yeti\": $fa-var-the-red-yeti,\n  \"square-hacker-news\": $fa-var-square-hacker-news,\n  \"hacker-news-square\": $fa-var-hacker-news-square,\n  \"edge\": $fa-var-edge,\n  \"threads\": $fa-var-threads,\n  \"napster\": $fa-var-napster,\n  \"square-snapchat\": $fa-var-square-snapchat,\n  \"snapchat-square\": $fa-var-snapchat-square,\n  \"google-plus-g\": $fa-var-google-plus-g,\n  \"artstation\": $fa-var-artstation,\n  \"markdown\": $fa-var-markdown,\n  \"sourcetree\": $fa-var-sourcetree,\n  \"google-plus\": $fa-var-google-plus,\n  \"diaspora\": $fa-var-diaspora,\n  \"foursquare\": $fa-var-foursquare,\n  \"stack-overflow\": $fa-var-stack-overflow,\n  \"github-alt\": $fa-var-github-alt,\n  \"phoenix-squadron\": $fa-var-phoenix-squadron,\n  \"pagelines\": $fa-var-pagelines,\n  \"algolia\": $fa-var-algolia,\n  \"red-river\": $fa-var-red-river,\n  \"creative-commons-sa\": $fa-var-creative-commons-sa,\n  \"safari\": $fa-var-safari,\n  \"google\": $fa-var-google,\n  \"square-font-awesome-stroke\": $fa-var-square-font-awesome-stroke,\n  \"font-awesome-alt\": $fa-var-font-awesome-alt,\n  \"atlassian\": $fa-var-atlassian,\n  \"linkedin-in\": $fa-var-linkedin-in,\n  \"digital-ocean\": $fa-var-digital-ocean,\n  \"nimblr\": $fa-var-nimblr,\n  \"chromecast\": $fa-var-chromecast,\n  \"evernote\": $fa-var-evernote,\n  \"hacker-news\": $fa-var-hacker-news,\n  \"creative-commons-sampling\": $fa-var-creative-commons-sampling,\n  \"adversal\": $fa-var-adversal,\n  \"creative-commons\": $fa-var-creative-commons,\n  \"watchman-monitoring\": $fa-var-watchman-monitoring,\n  \"fonticons\": $fa-var-fonticons,\n  \"weixin\": $fa-var-weixin,\n  \"shirtsinbulk\": $fa-var-shirtsinbulk,\n  \"codepen\": $fa-var-codepen,\n  \"git-alt\": $fa-var-git-alt,\n  \"lyft\": $fa-var-lyft,\n  \"rev\": $fa-var-rev,\n  \"windows\": $fa-var-windows,\n  \"wizards-of-the-coast\": $fa-var-wizards-of-the-coast,\n  \"square-viadeo\": $fa-var-square-viadeo,\n  \"viadeo-square\": $fa-var-viadeo-square,\n  \"meetup\": $fa-var-meetup,\n  \"centos\": $fa-var-centos,\n  \"adn\": $fa-var-adn,\n  \"cloudsmith\": $fa-var-cloudsmith,\n  \"opensuse\": $fa-var-opensuse,\n  \"pied-piper-alt\": $fa-var-pied-piper-alt,\n  \"square-dribbble\": $fa-var-square-dribbble,\n  \"dribbble-square\": $fa-var-dribbble-square,\n  \"codiepie\": $fa-var-codiepie,\n  \"node\": $fa-var-node,\n  \"mix\": $fa-var-mix,\n  \"steam\": $fa-var-steam,\n  \"cc-apple-pay\": $fa-var-cc-apple-pay,\n  \"scribd\": $fa-var-scribd,\n  \"debian\": $fa-var-debian,\n  \"openid\": $fa-var-openid,\n  \"instalod\": $fa-var-instalod,\n  \"files-pinwheel\": $fa-var-files-pinwheel,\n  \"expeditedssl\": $fa-var-expeditedssl,\n  \"sellcast\": $fa-var-sellcast,\n  \"square-twitter\": $fa-var-square-twitter,\n  \"twitter-square\": $fa-var-twitter-square,\n  \"r-project\": $fa-var-r-project,\n  \"delicious\": $fa-var-delicious,\n  \"freebsd\": $fa-var-freebsd,\n  \"vuejs\": $fa-var-vuejs,\n  \"accusoft\": $fa-var-accusoft,\n  \"ioxhost\": $fa-var-ioxhost,\n  \"fonticons-fi\": $fa-var-fonticons-fi,\n  \"app-store\": $fa-var-app-store,\n  \"cc-mastercard\": $fa-var-cc-mastercard,\n  \"itunes-note\": $fa-var-itunes-note,\n  \"golang\": $fa-var-golang,\n  \"kickstarter\": $fa-var-kickstarter,\n  \"square-kickstarter\": $fa-var-square-kickstarter,\n  \"grav\": $fa-var-grav,\n  \"weibo\": $fa-var-weibo,\n  \"uncharted\": $fa-var-uncharted,\n  \"firstdraft\": $fa-var-firstdraft,\n  \"square-youtube\": $fa-var-square-youtube,\n  \"youtube-square\": $fa-var-youtube-square,\n  \"wikipedia-w\": $fa-var-wikipedia-w,\n  \"wpressr\": $fa-var-wpressr,\n  \"rendact\": $fa-var-rendact,\n  \"angellist\": $fa-var-angellist,\n  \"galactic-republic\": $fa-var-galactic-republic,\n  \"nfc-directional\": $fa-var-nfc-directional,\n  \"skype\": $fa-var-skype,\n  \"joget\": $fa-var-joget,\n  \"fedora\": $fa-var-fedora,\n  \"stripe-s\": $fa-var-stripe-s,\n  \"meta\": $fa-var-meta,\n  \"laravel\": $fa-var-laravel,\n  \"hotjar\": $fa-var-hotjar,\n  \"bluetooth-b\": $fa-var-bluetooth-b,\n  \"square-letterboxd\": $fa-var-square-letterboxd,\n  \"sticker-mule\": $fa-var-sticker-mule,\n  \"creative-commons-zero\": $fa-var-creative-commons-zero,\n  \"hips\": $fa-var-hips,\n  \"css\": $fa-var-css,\n  \"behance\": $fa-var-behance,\n  \"reddit\": $fa-var-reddit,\n  \"discord\": $fa-var-discord,\n  \"chrome\": $fa-var-chrome,\n  \"app-store-ios\": $fa-var-app-store-ios,\n  \"cc-discover\": $fa-var-cc-discover,\n  \"wpbeginner\": $fa-var-wpbeginner,\n  \"confluence\": $fa-var-confluence,\n  \"shoelace\": $fa-var-shoelace,\n  \"mdb\": $fa-var-mdb,\n  \"dochub\": $fa-var-dochub,\n  \"accessible-icon\": $fa-var-accessible-icon,\n  \"ebay\": $fa-var-ebay,\n  \"amazon\": $fa-var-amazon,\n  \"unsplash\": $fa-var-unsplash,\n  \"yarn\": $fa-var-yarn,\n  \"square-steam\": $fa-var-square-steam,\n  \"steam-square\": $fa-var-steam-square,\n  \"500px\": $fa-var-500px,\n  \"square-vimeo\": $fa-var-square-vimeo,\n  \"vimeo-square\": $fa-var-vimeo-square,\n  \"asymmetrik\": $fa-var-asymmetrik,\n  \"font-awesome\": $fa-var-font-awesome,\n  \"font-awesome-flag\": $fa-var-font-awesome-flag,\n  \"font-awesome-logo-full\": $fa-var-font-awesome-logo-full,\n  \"gratipay\": $fa-var-gratipay,\n  \"apple\": $fa-var-apple,\n  \"hive\": $fa-var-hive,\n  \"gitkraken\": $fa-var-gitkraken,\n  \"keybase\": $fa-var-keybase,\n  \"apple-pay\": $fa-var-apple-pay,\n  \"padlet\": $fa-var-padlet,\n  \"amazon-pay\": $fa-var-amazon-pay,\n  \"square-github\": $fa-var-square-github,\n  \"github-square\": $fa-var-github-square,\n  \"stumbleupon\": $fa-var-stumbleupon,\n  \"fedex\": $fa-var-fedex,\n  \"phoenix-framework\": $fa-var-phoenix-framework,\n  \"shopify\": $fa-var-shopify,\n  \"neos\": $fa-var-neos,\n  \"square-threads\": $fa-var-square-threads,\n  \"hackerrank\": $fa-var-hackerrank,\n  \"researchgate\": $fa-var-researchgate,\n  \"swift\": $fa-var-swift,\n  \"angular\": $fa-var-angular,\n  \"speakap\": $fa-var-speakap,\n  \"angrycreative\": $fa-var-angrycreative,\n  \"y-combinator\": $fa-var-y-combinator,\n  \"empire\": $fa-var-empire,\n  \"envira\": $fa-var-envira,\n  \"google-scholar\": $fa-var-google-scholar,\n  \"square-gitlab\": $fa-var-square-gitlab,\n  \"gitlab-square\": $fa-var-gitlab-square,\n  \"studiovinari\": $fa-var-studiovinari,\n  \"pied-piper\": $fa-var-pied-piper,\n  \"wordpress\": $fa-var-wordpress,\n  \"product-hunt\": $fa-var-product-hunt,\n  \"firefox\": $fa-var-firefox,\n  \"linode\": $fa-var-linode,\n  \"goodreads\": $fa-var-goodreads,\n  \"square-odnoklassniki\": $fa-var-square-odnoklassniki,\n  \"odnoklassniki-square\": $fa-var-odnoklassniki-square,\n  \"jsfiddle\": $fa-var-jsfiddle,\n  \"sith\": $fa-var-sith,\n  \"themeisle\": $fa-var-themeisle,\n  \"page4\": $fa-var-page4,\n  \"hashnode\": $fa-var-hashnode,\n  \"react\": $fa-var-react,\n  \"cc-paypal\": $fa-var-cc-paypal,\n  \"squarespace\": $fa-var-squarespace,\n  \"cc-stripe\": $fa-var-cc-stripe,\n  \"creative-commons-share\": $fa-var-creative-commons-share,\n  \"bitcoin\": $fa-var-bitcoin,\n  \"keycdn\": $fa-var-keycdn,\n  \"opera\": $fa-var-opera,\n  \"itch-io\": $fa-var-itch-io,\n  \"umbraco\": $fa-var-umbraco,\n  \"galactic-senate\": $fa-var-galactic-senate,\n  \"ubuntu\": $fa-var-ubuntu,\n  \"draft2digital\": $fa-var-draft2digital,\n  \"stripe\": $fa-var-stripe,\n  \"houzz\": $fa-var-houzz,\n  \"gg\": $fa-var-gg,\n  \"dhl\": $fa-var-dhl,\n  \"square-pinterest\": $fa-var-square-pinterest,\n  \"pinterest-square\": $fa-var-pinterest-square,\n  \"xing\": $fa-var-xing,\n  \"blackberry\": $fa-var-blackberry,\n  \"creative-commons-pd\": $fa-var-creative-commons-pd,\n  \"playstation\": $fa-var-playstation,\n  \"quinscape\": $fa-var-quinscape,\n  \"less\": $fa-var-less,\n  \"blogger-b\": $fa-var-blogger-b,\n  \"opencart\": $fa-var-opencart,\n  \"vine\": $fa-var-vine,\n  \"signal-messenger\": $fa-var-signal-messenger,\n  \"paypal\": $fa-var-paypal,\n  \"gitlab\": $fa-var-gitlab,\n  \"typo3\": $fa-var-typo3,\n  \"reddit-alien\": $fa-var-reddit-alien,\n  \"yahoo\": $fa-var-yahoo,\n  \"dailymotion\": $fa-var-dailymotion,\n  \"affiliatetheme\": $fa-var-affiliatetheme,\n  \"pied-piper-pp\": $fa-var-pied-piper-pp,\n  \"bootstrap\": $fa-var-bootstrap,\n  \"odnoklassniki\": $fa-var-odnoklassniki,\n  \"nfc-symbol\": $fa-var-nfc-symbol,\n  \"mintbit\": $fa-var-mintbit,\n  \"ethereum\": $fa-var-ethereum,\n  \"speaker-deck\": $fa-var-speaker-deck,\n  \"creative-commons-nc-eu\": $fa-var-creative-commons-nc-eu,\n  \"patreon\": $fa-var-patreon,\n  \"avianex\": $fa-var-avianex,\n  \"ello\": $fa-var-ello,\n  \"gofore\": $fa-var-gofore,\n  \"bimobject\": $fa-var-bimobject,\n  \"brave-reverse\": $fa-var-brave-reverse,\n  \"facebook-f\": $fa-var-facebook-f,\n  \"square-google-plus\": $fa-var-square-google-plus,\n  \"google-plus-square\": $fa-var-google-plus-square,\n  \"web-awesome\": $fa-var-web-awesome,\n  \"mandalorian\": $fa-var-mandalorian,\n  \"first-order-alt\": $fa-var-first-order-alt,\n  \"osi\": $fa-var-osi,\n  \"google-wallet\": $fa-var-google-wallet,\n  \"d-and-d-beyond\": $fa-var-d-and-d-beyond,\n  \"periscope\": $fa-var-periscope,\n  \"fulcrum\": $fa-var-fulcrum,\n  \"cloudscale\": $fa-var-cloudscale,\n  \"forumbee\": $fa-var-forumbee,\n  \"mizuni\": $fa-var-mizuni,\n  \"schlix\": $fa-var-schlix,\n  \"square-xing\": $fa-var-square-xing,\n  \"xing-square\": $fa-var-xing-square,\n  \"bandcamp\": $fa-var-bandcamp,\n  \"wpforms\": $fa-var-wpforms,\n  \"cloudversify\": $fa-var-cloudversify,\n  \"usps\": $fa-var-usps,\n  \"megaport\": $fa-var-megaport,\n  \"magento\": $fa-var-magento,\n  \"spotify\": $fa-var-spotify,\n  \"optin-monster\": $fa-var-optin-monster,\n  \"fly\": $fa-var-fly,\n  \"square-bluesky\": $fa-var-square-bluesky,\n  \"aviato\": $fa-var-aviato,\n  \"itunes\": $fa-var-itunes,\n  \"cuttlefish\": $fa-var-cuttlefish,\n  \"blogger\": $fa-var-blogger,\n  \"flickr\": $fa-var-flickr,\n  \"viber\": $fa-var-viber,\n  \"soundcloud\": $fa-var-soundcloud,\n  \"digg\": $fa-var-digg,\n  \"tencent-weibo\": $fa-var-tencent-weibo,\n  \"letterboxd\": $fa-var-letterboxd,\n  \"symfony\": $fa-var-symfony,\n  \"maxcdn\": $fa-var-maxcdn,\n  \"etsy\": $fa-var-etsy,\n  \"facebook-messenger\": $fa-var-facebook-messenger,\n  \"audible\": $fa-var-audible,\n  \"think-peaks\": $fa-var-think-peaks,\n  \"bilibili\": $fa-var-bilibili,\n  \"erlang\": $fa-var-erlang,\n  \"x-twitter\": $fa-var-x-twitter,\n  \"cotton-bureau\": $fa-var-cotton-bureau,\n  \"dashcube\": $fa-var-dashcube,\n  \"42-group\": $fa-var-42-group,\n  \"innosoft\": $fa-var-innosoft,\n  \"stack-exchange\": $fa-var-stack-exchange,\n  \"elementor\": $fa-var-elementor,\n  \"square-pied-piper\": $fa-var-square-pied-piper,\n  \"pied-piper-square\": $fa-var-pied-piper-square,\n  \"creative-commons-nd\": $fa-var-creative-commons-nd,\n  \"palfed\": $fa-var-palfed,\n  \"superpowers\": $fa-var-superpowers,\n  \"resolving\": $fa-var-resolving,\n  \"xbox\": $fa-var-xbox,\n  \"square-web-awesome-stroke\": $fa-var-square-web-awesome-stroke,\n  \"searchengin\": $fa-var-searchengin,\n  \"tiktok\": $fa-var-tiktok,\n  \"square-facebook\": $fa-var-square-facebook,\n  \"facebook-square\": $fa-var-facebook-square,\n  \"renren\": $fa-var-renren,\n  \"linux\": $fa-var-linux,\n  \"glide\": $fa-var-glide,\n  \"linkedin\": $fa-var-linkedin,\n  \"hubspot\": $fa-var-hubspot,\n  \"deploydog\": $fa-var-deploydog,\n  \"twitch\": $fa-var-twitch,\n  \"flutter\": $fa-var-flutter,\n  \"ravelry\": $fa-var-ravelry,\n  \"mixer\": $fa-var-mixer,\n  \"square-lastfm\": $fa-var-square-lastfm,\n  \"lastfm-square\": $fa-var-lastfm-square,\n  \"vimeo\": $fa-var-vimeo,\n  \"mendeley\": $fa-var-mendeley,\n  \"uniregistry\": $fa-var-uniregistry,\n  \"figma\": $fa-var-figma,\n  \"creative-commons-remix\": $fa-var-creative-commons-remix,\n  \"cc-amazon-pay\": $fa-var-cc-amazon-pay,\n  \"dropbox\": $fa-var-dropbox,\n  \"instagram\": $fa-var-instagram,\n  \"cmplid\": $fa-var-cmplid,\n  \"upwork\": $fa-var-upwork,\n  \"facebook\": $fa-var-facebook,\n  \"gripfire\": $fa-var-gripfire,\n  \"jedi-order\": $fa-var-jedi-order,\n  \"uikit\": $fa-var-uikit,\n  \"fort-awesome-alt\": $fa-var-fort-awesome-alt,\n  \"phabricator\": $fa-var-phabricator,\n  \"ussunnah\": $fa-var-ussunnah,\n  \"earlybirds\": $fa-var-earlybirds,\n  \"trade-federation\": $fa-var-trade-federation,\n  \"autoprefixer\": $fa-var-autoprefixer,\n  \"whatsapp\": $fa-var-whatsapp,\n  \"square-upwork\": $fa-var-square-upwork,\n  \"slideshare\": $fa-var-slideshare,\n  \"google-play\": $fa-var-google-play,\n  \"viadeo\": $fa-var-viadeo,\n  \"line\": $fa-var-line,\n  \"google-drive\": $fa-var-google-drive,\n  \"servicestack\": $fa-var-servicestack,\n  \"simplybuilt\": $fa-var-simplybuilt,\n  \"bitbucket\": $fa-var-bitbucket,\n  \"imdb\": $fa-var-imdb,\n  \"deezer\": $fa-var-deezer,\n  \"raspberry-pi\": $fa-var-raspberry-pi,\n  \"jira\": $fa-var-jira,\n  \"docker\": $fa-var-docker,\n  \"screenpal\": $fa-var-screenpal,\n  \"bluetooth\": $fa-var-bluetooth,\n  \"gitter\": $fa-var-gitter,\n  \"d-and-d\": $fa-var-d-and-d,\n  \"microblog\": $fa-var-microblog,\n  \"cc-diners-club\": $fa-var-cc-diners-club,\n  \"gg-circle\": $fa-var-gg-circle,\n  \"pied-piper-hat\": $fa-var-pied-piper-hat,\n  \"kickstarter-k\": $fa-var-kickstarter-k,\n  \"yandex\": $fa-var-yandex,\n  \"readme\": $fa-var-readme,\n  \"html5\": $fa-var-html5,\n  \"sellsy\": $fa-var-sellsy,\n  \"square-web-awesome\": $fa-var-square-web-awesome,\n  \"sass\": $fa-var-sass,\n  \"wirsindhandwerk\": $fa-var-wirsindhandwerk,\n  \"wsh\": $fa-var-wsh,\n  \"buromobelexperte\": $fa-var-buromobelexperte,\n  \"salesforce\": $fa-var-salesforce,\n  \"octopus-deploy\": $fa-var-octopus-deploy,\n  \"medapps\": $fa-var-medapps,\n  \"ns8\": $fa-var-ns8,\n  \"pinterest-p\": $fa-var-pinterest-p,\n  \"apper\": $fa-var-apper,\n  \"fort-awesome\": $fa-var-fort-awesome,\n  \"waze\": $fa-var-waze,\n  \"bluesky\": $fa-var-bluesky,\n  \"cc-jcb\": $fa-var-cc-jcb,\n  \"snapchat\": $fa-var-snapchat,\n  \"snapchat-ghost\": $fa-var-snapchat-ghost,\n  \"fantasy-flight-games\": $fa-var-fantasy-flight-games,\n  \"rust\": $fa-var-rust,\n  \"wix\": $fa-var-wix,\n  \"square-behance\": $fa-var-square-behance,\n  \"behance-square\": $fa-var-behance-square,\n  \"supple\": $fa-var-supple,\n  \"webflow\": $fa-var-webflow,\n  \"rebel\": $fa-var-rebel,\n  \"css3\": $fa-var-css3,\n  \"staylinked\": $fa-var-staylinked,\n  \"kaggle\": $fa-var-kaggle,\n  \"space-awesome\": $fa-var-space-awesome,\n  \"deviantart\": $fa-var-deviantart,\n  \"cpanel\": $fa-var-cpanel,\n  \"goodreads-g\": $fa-var-goodreads-g,\n  \"square-git\": $fa-var-square-git,\n  \"git-square\": $fa-var-git-square,\n  \"square-tumblr\": $fa-var-square-tumblr,\n  \"tumblr-square\": $fa-var-tumblr-square,\n  \"trello\": $fa-var-trello,\n  \"creative-commons-nc-jp\": $fa-var-creative-commons-nc-jp,\n  \"get-pocket\": $fa-var-get-pocket,\n  \"perbyte\": $fa-var-perbyte,\n  \"grunt\": $fa-var-grunt,\n  \"weebly\": $fa-var-weebly,\n  \"connectdevelop\": $fa-var-connectdevelop,\n  \"leanpub\": $fa-var-leanpub,\n  \"black-tie\": $fa-var-black-tie,\n  \"themeco\": $fa-var-themeco,\n  \"python\": $fa-var-python,\n  \"android\": $fa-var-android,\n  \"bots\": $fa-var-bots,\n  \"free-code-camp\": $fa-var-free-code-camp,\n  \"hornbill\": $fa-var-hornbill,\n  \"js\": $fa-var-js,\n  \"ideal\": $fa-var-ideal,\n  \"git\": $fa-var-git,\n  \"dev\": $fa-var-dev,\n  \"sketch\": $fa-var-sketch,\n  \"yandex-international\": $fa-var-yandex-international,\n  \"cc-amex\": $fa-var-cc-amex,\n  \"uber\": $fa-var-uber,\n  \"github\": $fa-var-github,\n  \"php\": $fa-var-php,\n  \"alipay\": $fa-var-alipay,\n  \"youtube\": $fa-var-youtube,\n  \"skyatlas\": $fa-var-skyatlas,\n  \"firefox-browser\": $fa-var-firefox-browser,\n  \"replyd\": $fa-var-replyd,\n  \"suse\": $fa-var-suse,\n  \"jenkins\": $fa-var-jenkins,\n  \"twitter\": $fa-var-twitter,\n  \"rockrms\": $fa-var-rockrms,\n  \"pinterest\": $fa-var-pinterest,\n  \"buffer\": $fa-var-buffer,\n  \"npm\": $fa-var-npm,\n  \"yammer\": $fa-var-yammer,\n  \"btc\": $fa-var-btc,\n  \"dribbble\": $fa-var-dribbble,\n  \"stumbleupon-circle\": $fa-var-stumbleupon-circle,\n  \"internet-explorer\": $fa-var-internet-explorer,\n  \"stubber\": $fa-var-stubber,\n  \"telegram\": $fa-var-telegram,\n  \"telegram-plane\": $fa-var-telegram-plane,\n  \"old-republic\": $fa-var-old-republic,\n  \"odysee\": $fa-var-odysee,\n  \"square-whatsapp\": $fa-var-square-whatsapp,\n  \"whatsapp-square\": $fa-var-whatsapp-square,\n  \"node-js\": $fa-var-node-js,\n  \"edge-legacy\": $fa-var-edge-legacy,\n  \"slack\": $fa-var-slack,\n  \"slack-hash\": $fa-var-slack-hash,\n  \"medrt\": $fa-var-medrt,\n  \"usb\": $fa-var-usb,\n  \"tumblr\": $fa-var-tumblr,\n  \"vaadin\": $fa-var-vaadin,\n  \"quora\": $fa-var-quora,\n  \"square-x-twitter\": $fa-var-square-x-twitter,\n  \"reacteurope\": $fa-var-reacteurope,\n  \"medium\": $fa-var-medium,\n  \"medium-m\": $fa-var-medium-m,\n  \"amilia\": $fa-var-amilia,\n  \"mixcloud\": $fa-var-mixcloud,\n  \"flipboard\": $fa-var-flipboard,\n  \"viacoin\": $fa-var-viacoin,\n  \"critical-role\": $fa-var-critical-role,\n  \"sitrox\": $fa-var-sitrox,\n  \"discourse\": $fa-var-discourse,\n  \"joomla\": $fa-var-joomla,\n  \"mastodon\": $fa-var-mastodon,\n  \"airbnb\": $fa-var-airbnb,\n  \"wolf-pack-battalion\": $fa-var-wolf-pack-battalion,\n  \"buy-n-large\": $fa-var-buy-n-large,\n  \"gulp\": $fa-var-gulp,\n  \"creative-commons-sampling-plus\": $fa-var-creative-commons-sampling-plus,\n  \"strava\": $fa-var-strava,\n  \"ember\": $fa-var-ember,\n  \"canadian-maple-leaf\": $fa-var-canadian-maple-leaf,\n  \"teamspeak\": $fa-var-teamspeak,\n  \"pushed\": $fa-var-pushed,\n  \"wordpress-simple\": $fa-var-wordpress-simple,\n  \"nutritionix\": $fa-var-nutritionix,\n  \"wodu\": $fa-var-wodu,\n  \"google-pay\": $fa-var-google-pay,\n  \"intercom\": $fa-var-intercom,\n  \"zhihu\": $fa-var-zhihu,\n  \"korvue\": $fa-var-korvue,\n  \"pix\": $fa-var-pix,\n  \"steam-symbol\": $fa-var-steam-symbol,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(-1 * var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}));\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left {\n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right {\n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-bounce {\n  animation-name: #{$fa-css-prefix}-bounce;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(0.280, 0.840, 0.420, 1));\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-beat-fade {\n  animation-name: #{$fa-css-prefix}-beat-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-shake {\n  animation-name: #{$fa-css-prefix}-shake;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-bounce,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-beat-fade,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-shake,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-bounce {\n  0%   { transform: scale(1,1) translateY(0); }\n  10%  { transform: scale(var(--#{$fa-css-prefix}-bounce-start-scale-x, 1.1),var(--#{$fa-css-prefix}-bounce-start-scale-y, 0.9)) translateY(0); }\n  30%  { transform: scale(var(--#{$fa-css-prefix}-bounce-jump-scale-x, 0.9),var(--#{$fa-css-prefix}-bounce-jump-scale-y, 1.1)) translateY(var(--#{$fa-css-prefix}-bounce-height, -0.5em)); }\n  50%  { transform: scale(var(--#{$fa-css-prefix}-bounce-land-scale-x, 1.05),var(--#{$fa-css-prefix}-bounce-land-scale-y, 0.95)) translateY(0); }\n  57%  { transform: scale(1,1) translateY(var(--#{$fa-css-prefix}-bounce-rebound, -0.125em)); }\n  64%  { transform: scale(1,1) translateY(0); }\n  100% { transform: scale(1,1) translateY(0); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-beat-fade {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-beat-fade-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-shake {\n  0% { transform: rotate(-15deg); }\n  4% { transform: rotate(15deg); }\n  8%, 24% { transform: rotate(-18deg); }\n  12%, 28% { transform: rotate(18deg); }\n  16% { transform: rotate(-22deg); }\n  20% { transform: rotate(22deg); }\n  32% { transform: rotate(-12deg); }\n  36% { transform: rotate(12deg); }\n  40%, 100% { transform: rotate(0deg); }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, 0));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name} {\n    #{$fa-icon-property}: unquote(\"\\\"#{ $icon }\\\"\");\n  }\n}\n\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.#{$fa-css-prefix}-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.#{$fa-css-prefix}-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-regular: normal 400 1em/1 '#{ $fa-style-family }';\n}\n\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-regular-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-regular-400.ttf') format('truetype');\n}\n\n.far,\n.#{$fa-css-prefix}-regular {\n  font-weight: 400;\n}\n","/*!\n * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-solid: normal 900 1em/1 '#{ $fa-style-family }';\n}\n\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.#{$fa-css-prefix}-solid {\n  font-weight: 900;\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n","\n// Colours\n$black: #0000;\n$body-bg: #f7f7f7;\n$h-purple: #37003c;\n$bg-header: #37023b;\n\n$pink-theme-h: #910c45;\n$pink-theme-start: #fd2982;\n$pink-theme-end: #910c45;\n\n$blue-theme-h: #0c4693;\n$blue-theme-start: #29d4fd;\n$blue-theme-end: #0c4591;\n\n$green-theme-h: #0f932e;\n$green-theme-start: #29fd5a;\n$green-theme-end: #0c912c;\n\n$orange-theme-h: #f06f2a;\n$orange-theme-start: #fdb429;\n$orange-theme-end: #f47000;\n\n// Fonts\n$pl-regular: 'PremierLeague-Regular', serif;\n$pl-bold: 'PremierLeague-Bold', serif;\n$pl-bold-italic: 'PremierLeague-BoldItalic', serif;\n$pl-light: 'PremierLeague-Light', serif;\n\n// Spacing\n$spacing-25: 25px;\n\n// Background\n$login-bg: url('../asset/img/login_bg@2x.png');\n\n$min-contrast-ratio:   0.5 !default;\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
